var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAisvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1401.17052 1151.08653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        opacity: .81818;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49, .cls-50, .cls-51, .cls-52, .cls-53, .cls-54, .cls-55, .cls-56, .cls-57, .cls-58, .cls-59, .cls-60, .cls-61, .cls-62, .cls-63, .cls-64, .cls-65, .cls-66, .cls-67, .cls-68, .cls-69, .cls-70, .cls-71, .cls-72, .cls-73, .cls-74, .cls-75, .cls-76, .cls-77, .cls-78, .cls-79, .cls-80, .cls-81, .cls-82, .cls-83, .cls-84, .cls-85, .cls-86, .cls-87, .cls-88, .cls-89, .cls-90, .cls-91, .cls-92, .cls-93, .cls-94, .cls-95, .cls-96, .cls-97, .cls-98, .cls-99, .cls-100, .cls-101, .cls-102, .cls-103, .cls-104, .cls-105, .cls-106, .cls-107, .cls-108, .cls-109, .cls-110, .cls-111, .cls-112, .cls-113, .cls-114, .cls-115, .cls-116, .cls-117, .cls-118, .cls-119, .cls-120, .cls-121, .cls-122, .cls-123, .cls-124, .cls-125, .cls-126, .cls-127, .cls-128, .cls-129, .cls-130, .cls-131, .cls-132, .cls-133, .cls-134, .cls-135, .cls-136, .cls-137, .cls-138, .cls-139, .cls-140, .cls-141, .cls-142, .cls-143, .cls-144, .cls-145, .cls-146, .cls-147, .cls-148, .cls-149, .cls-150, .cls-151, .cls-152, .cls-153, .cls-154, .cls-155, .cls-156, .cls-157, .cls-158, .cls-159, .cls-160, .cls-161, .cls-162, .cls-163, .cls-164, .cls-165, .cls-166, .cls-167, .cls-168, .cls-169, .cls-170, .cls-171, .cls-172, .cls-173, .cls-174, .cls-175, .cls-176, .cls-177, .cls-178, .cls-179, .cls-180, .cls-181, .cls-182, .cls-183, .cls-184, .cls-185, .cls-186, .cls-187, .cls-188, .cls-189, .cls-190, .cls-191, .cls-192, .cls-193, .cls-194, .cls-195, .cls-196, .cls-197, .cls-198, .cls-199, .cls-200, .cls-201, .cls-202, .cls-203, .cls-204, .cls-205, .cls-206, .cls-207, .cls-208, .cls-209, .cls-210, .cls-211, .cls-212, .cls-213, .cls-214, .cls-215, .cls-216, .cls-217, .cls-218, .cls-219, .cls-220, .cls-221, .cls-222, .cls-223, .cls-224, .cls-225, .cls-226, .cls-227, .cls-228, .cls-229, .cls-230, .cls-231, .cls-232, .cls-233, .cls-234, .cls-235, .cls-236, .cls-237, .cls-238, .cls-239, .cls-240, .cls-241, .cls-242, .cls-243, .cls-244, .cls-245, .cls-246, .cls-247, .cls-248, .cls-249, .cls-250, .cls-251, .cls-252, .cls-253, .cls-254, .cls-255, .cls-256, .cls-257, .cls-258, .cls-259, .cls-260, .cls-261, .cls-262, .cls-263, .cls-264, .cls-265, .cls-266, .cls-267, .cls-268, .cls-269, .cls-270, .cls-271, .cls-272, .cls-273, .cls-274, .cls-275, .cls-276, .cls-277, .cls-278, .cls-279, .cls-280, .cls-281, .cls-282, .cls-283, .cls-284, .cls-285, .cls-286, .cls-287, .cls-288, .cls-289, .cls-290, .cls-291, .cls-292, .cls-293, .cls-294, .cls-295, .cls-296, .cls-297, .cls-298, .cls-299, .cls-300, .cls-301, .cls-302, .cls-303, .cls-304, .cls-305, .cls-306, .cls-307, .cls-308, .cls-309, .cls-310, .cls-311, .cls-312, .cls-313, .cls-314, .cls-315, .cls-316, .cls-317, .cls-318, .cls-319, .cls-320, .cls-321, .cls-322, .cls-323, .cls-324, .cls-325, .cls-326, .cls-327, .cls-328, .cls-329, .cls-330, .cls-331, .cls-332, .cls-333, .cls-334, .cls-335, .cls-336, .cls-337, .cls-338, .cls-339, .cls-340, .cls-341, .cls-342, .cls-343, .cls-344, .cls-345, .cls-346, .cls-347, .cls-348, .cls-349, .cls-350, .cls-351, .cls-352, .cls-353, .cls-354, .cls-355, .cls-356, .cls-357, .cls-358, .cls-359, .cls-360, .cls-361, .cls-362, .cls-363, .cls-364, .cls-365, .cls-366, .cls-367, .cls-368, .cls-369, .cls-370, .cls-371, .cls-372, .cls-373, .cls-374, .cls-375, .cls-376, .cls-377, .cls-378, .cls-379, .cls-380, .cls-381, .cls-382, .cls-383, .cls-384, .cls-385, .cls-386, .cls-387, .cls-388, .cls-389, .cls-390, .cls-391, .cls-392, .cls-393, .cls-394, .cls-395, .cls-396, .cls-397, .cls-398, .cls-399, .cls-400, .cls-401, .cls-402, .cls-403, .cls-404, .cls-405, .cls-406, .cls-407, .cls-408, .cls-409, .cls-410, .cls-411, .cls-412, .cls-413, .cls-414, .cls-415, .cls-416, .cls-417, .cls-418, .cls-419, .cls-420, .cls-421, .cls-422, .cls-423, .cls-424, .cls-425, .cls-426, .cls-427, .cls-428, .cls-429, .cls-430, .cls-431, .cls-432, .cls-433, .cls-434, .cls-435, .cls-436, .cls-437, .cls-438, .cls-439, .cls-440, .cls-441, .cls-442, .cls-443, .cls-444, .cls-445, .cls-446, .cls-447, .cls-448, .cls-449, .cls-450, .cls-451, .cls-452, .cls-453, .cls-454, .cls-455, .cls-456, .cls-457, .cls-458, .cls-459, .cls-460, .cls-461, .cls-462, .cls-463, .cls-464, .cls-465, .cls-466, .cls-467, .cls-468, .cls-469, .cls-470, .cls-471, .cls-472, .cls-473, .cls-474, .cls-475, .cls-476, .cls-477, .cls-478, .cls-479, .cls-480, .cls-481, .cls-482, .cls-483, .cls-484, .cls-485, .cls-486, .cls-487, .cls-488, .cls-489, .cls-490, .cls-491, .cls-492, .cls-493, .cls-494, .cls-495, .cls-496, .cls-497, .cls-498, .cls-499, .cls-500, .cls-501, .cls-502, .cls-503, .cls-504, .cls-505, .cls-506, .cls-507, .cls-508, .cls-509, .cls-510, .cls-511, .cls-512, .cls-513, .cls-514, .cls-515, .cls-516, .cls-517, .cls-518, .cls-519, .cls-520, .cls-521, .cls-522, .cls-523, .cls-524, .cls-525, .cls-526, .cls-527, .cls-528, .cls-529, .cls-530, .cls-531, .cls-532, .cls-533, .cls-534, .cls-535, .cls-536, .cls-537, .cls-538, .cls-539, .cls-540, .cls-541, .cls-542, .cls-543 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-1, .cls-60, .cls-62, .cls-369, .cls-373, .cls-398, .cls-420, .cls-423, .cls-447, .cls-455, .cls-526, .cls-531 {\r\n        fill: #000;\r\n      }\r\n\r\n      .cls-2, .cls-370, .cls-544, .cls-543 {\r\n        opacity: .2;\r\n      }\r\n\r\n      .cls-2, .cls-471, .cls-528 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-84);\r\n      }\r\n\r\n      .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-64, .cls-67, .cls-368, .cls-545, .cls-417, .cls-422, .cls-442, .cls-445, .cls-473, .cls-474, .cls-475, .cls-485, .cls-486, .cls-487, .cls-500, .cls-501 {\r\n        mix-blend-mode: multiply;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient-83);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient-86);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#linear-gradient-87);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: url(#linear-gradient-90);\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: url(#linear-gradient-94);\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: url(#linear-gradient-97);\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: url(#linear-gradient-99);\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: url(#linear-gradient-77);\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: url(#linear-gradient-75);\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: url(#radial-gradient-80);\r\n      }\r\n\r\n      .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-52, .cls-53, .cls-54, .cls-55, .cls-56, .cls-57, .cls-58, .cls-59, .cls-249, .cls-250, .cls-251, .cls-252, .cls-253, .cls-254, .cls-255, .cls-256, .cls-257, .cls-258, .cls-259, .cls-260, .cls-261, .cls-262, .cls-263, .cls-264, .cls-265, .cls-266, .cls-267, .cls-268, .cls-269, .cls-270, .cls-271, .cls-272, .cls-273, .cls-274, .cls-275, .cls-276, .cls-277, .cls-278, .cls-279, .cls-280, .cls-281, .cls-282, .cls-283, .cls-284, .cls-285, .cls-286, .cls-287, .cls-288, .cls-418, .cls-430, .cls-431, .cls-432, .cls-433, .cls-527, .cls-529 {\r\n        mix-blend-mode: color-dodge;\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: url(#radial-gradient-75);\r\n      }\r\n\r\n      .cls-15 {\r\n        fill: url(#radial-gradient-78);\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: url(#radial-gradient-77);\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: url(#radial-gradient-64);\r\n      }\r\n\r\n      .cls-18 {\r\n        fill: url(#radial-gradient-63);\r\n      }\r\n\r\n      .cls-19 {\r\n        fill: url(#radial-gradient-66);\r\n      }\r\n\r\n      .cls-20 {\r\n        fill: url(#radial-gradient-62);\r\n      }\r\n\r\n      .cls-21 {\r\n        fill: url(#radial-gradient-61);\r\n      }\r\n\r\n      .cls-22 {\r\n        fill: url(#radial-gradient-65);\r\n      }\r\n\r\n      .cls-23 {\r\n        fill: url(#radial-gradient-60);\r\n      }\r\n\r\n      .cls-24 {\r\n        fill: url(#radial-gradient-72);\r\n      }\r\n\r\n      .cls-25 {\r\n        fill: url(#radial-gradient-73);\r\n      }\r\n\r\n      .cls-26 {\r\n        fill: url(#radial-gradient-74);\r\n      }\r\n\r\n      .cls-27 {\r\n        fill: url(#radial-gradient-76);\r\n      }\r\n\r\n      .cls-28 {\r\n        fill: url(#radial-gradient-71);\r\n      }\r\n\r\n      .cls-29 {\r\n        fill: url(#radial-gradient-79);\r\n      }\r\n\r\n      .cls-30 {\r\n        fill: url(#radial-gradient-69);\r\n      }\r\n\r\n      .cls-31 {\r\n        fill: url(#radial-gradient-68);\r\n      }\r\n\r\n      .cls-32 {\r\n        fill: url(#radial-gradient-67);\r\n      }\r\n\r\n      .cls-33 {\r\n        fill: url(#radial-gradient-14);\r\n      }\r\n\r\n      .cls-34 {\r\n        fill: url(#radial-gradient-13);\r\n      }\r\n\r\n      .cls-35 {\r\n        fill: url(#radial-gradient-12);\r\n      }\r\n\r\n      .cls-36 {\r\n        fill: url(#radial-gradient-15);\r\n      }\r\n\r\n      .cls-37 {\r\n        fill: url(#radial-gradient-10);\r\n      }\r\n\r\n      .cls-38 {\r\n        fill: url(#radial-gradient-17);\r\n      }\r\n\r\n      .cls-39 {\r\n        fill: url(#radial-gradient-11);\r\n      }\r\n\r\n      .cls-40 {\r\n        fill: url(#radial-gradient-16);\r\n      }\r\n\r\n      .cls-41 {\r\n        fill: url(#linear-gradient-100);\r\n      }\r\n\r\n      .cls-42 {\r\n        fill: url(#linear-gradient-101);\r\n      }\r\n\r\n      .cls-43 {\r\n        fill: url(#linear-gradient-109);\r\n      }\r\n\r\n      .cls-44 {\r\n        fill: url(#linear-gradient-106);\r\n      }\r\n\r\n      .cls-45 {\r\n        fill: url(#linear-gradient-107);\r\n      }\r\n\r\n      .cls-46 {\r\n        fill: url(#linear-gradient-102);\r\n      }\r\n\r\n      .cls-47 {\r\n        fill: url(#linear-gradient-104);\r\n      }\r\n\r\n      .cls-48 {\r\n        fill: url(#linear-gradient-103);\r\n      }\r\n\r\n      .cls-49 {\r\n        fill: url(#linear-gradient-105);\r\n      }\r\n\r\n      .cls-50 {\r\n        fill: url(#linear-gradient-111);\r\n      }\r\n\r\n      .cls-51 {\r\n        fill: url(#linear-gradient-110);\r\n      }\r\n\r\n      .cls-52 {\r\n        fill: url(#Radial_Gradient_1-4);\r\n      }\r\n\r\n      .cls-53 {\r\n        fill: url(#Radial_Gradient_1-7);\r\n      }\r\n\r\n      .cls-54 {\r\n        fill: url(#Radial_Gradient_1-8);\r\n      }\r\n\r\n      .cls-55 {\r\n        fill: url(#Radial_Gradient_1-6);\r\n      }\r\n\r\n      .cls-56 {\r\n        fill: url(#Radial_Gradient_1-3);\r\n      }\r\n\r\n      .cls-57 {\r\n        fill: url(#Radial_Gradient_1-2);\r\n      }\r\n\r\n      .cls-58 {\r\n        fill: url(#Radial_Gradient_1-5);\r\n      }\r\n\r\n      .cls-59 {\r\n        fill: url(#Radial_Gradient_1-9);\r\n      }\r\n\r\n      .cls-60 {\r\n        opacity: .45455;\r\n      }\r\n\r\n      .cls-61, .cls-63, .cls-371, .cls-372, .cls-374, .cls-421, .cls-446, .cls-472, .cls-496, .cls-497, .cls-499, .cls-502 {\r\n        fill: #7dffef;\r\n      }\r\n\r\n      .cls-62 {\r\n        opacity: .90909;\r\n      }\r\n\r\n      .cls-63 {\r\n        opacity: .91818;\r\n      }\r\n\r\n      .cls-64 {\r\n        fill: #76d5fa;\r\n      }\r\n\r\n      .cls-65 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-66 {\r\n        fill: url(#radial-gradient-6);\r\n        opacity: .6;\r\n      }\r\n\r\n      .cls-66, .cls-400, .cls-401, .cls-402, .cls-403, .cls-404, .cls-405, .cls-406, .cls-407, .cls-419, .cls-429, .cls-434, .cls-435, .cls-436, .cls-437, .cls-438, .cls-439, .cls-440, .cls-441, .cls-443, .cls-444, .cls-546, .cls-448, .cls-449, .cls-450, .cls-451, .cls-452, .cls-453, .cls-454, .cls-456, .cls-457, .cls-458, .cls-459, .cls-460, .cls-461, .cls-462, .cls-463, .cls-464, .cls-465, .cls-466, .cls-467, .cls-468, .cls-469, .cls-470, .cls-488, .cls-489, .cls-490, .cls-491, .cls-492, .cls-493, .cls-494, .cls-495, .cls-534, .cls-535, .cls-536, .cls-537, .cls-538, .cls-539, .cls-540, .cls-541, .cls-542 {\r\n        mix-blend-mode: screen;\r\n      }\r\n\r\n      .cls-67 {\r\n        fill: #bcf4bc;\r\n      }\r\n\r\n      .cls-68 {\r\n        fill: url(#New_Gradient_Swatch_copy_39-10);\r\n      }\r\n\r\n      .cls-69 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-22);\r\n      }\r\n\r\n      .cls-70 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-20);\r\n      }\r\n\r\n      .cls-71 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-29);\r\n      }\r\n\r\n      .cls-72 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-28);\r\n      }\r\n\r\n      .cls-73 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-27);\r\n      }\r\n\r\n      .cls-74 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-25);\r\n      }\r\n\r\n      .cls-75 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-26);\r\n      }\r\n\r\n      .cls-76 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-23);\r\n      }\r\n\r\n      .cls-77 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-24);\r\n      }\r\n\r\n      .cls-78 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-21);\r\n      }\r\n\r\n      .cls-79 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-19);\r\n      }\r\n\r\n      .cls-80 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-15);\r\n      }\r\n\r\n      .cls-81 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-16);\r\n      }\r\n\r\n      .cls-82 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-17);\r\n      }\r\n\r\n      .cls-83 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-18);\r\n      }\r\n\r\n      .cls-84 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-11);\r\n      }\r\n\r\n      .cls-85 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-13);\r\n      }\r\n\r\n      .cls-86 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-12);\r\n      }\r\n\r\n      .cls-87 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-14);\r\n      }\r\n\r\n      .cls-88 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-10);\r\n      }\r\n\r\n      .cls-89 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-30);\r\n      }\r\n\r\n      .cls-90 {\r\n        fill: url(#New_Gradient_Swatch_copy_18-19);\r\n      }\r\n\r\n      .cls-91 {\r\n        fill: url(#New_Gradient_Swatch_copy_18-14);\r\n      }\r\n\r\n      .cls-92 {\r\n        fill: url(#New_Gradient_Swatch_copy_18-17);\r\n      }\r\n\r\n      .cls-93 {\r\n        fill: url(#New_Gradient_Swatch_copy_18-15);\r\n      }\r\n\r\n      .cls-94 {\r\n        fill: url(#New_Gradient_Swatch_copy_18-11);\r\n      }\r\n\r\n      .cls-95 {\r\n        fill: url(#New_Gradient_Swatch_copy_18-10);\r\n      }\r\n\r\n      .cls-96 {\r\n        fill: url(#New_Gradient_Swatch_copy_18-16);\r\n      }\r\n\r\n      .cls-97 {\r\n        fill: url(#New_Gradient_Swatch_copy_18-22);\r\n      }\r\n\r\n      .cls-98 {\r\n        fill: url(#New_Gradient_Swatch_copy_18-26);\r\n      }\r\n\r\n      .cls-99 {\r\n        fill: url(#New_Gradient_Swatch_copy_18-24);\r\n      }\r\n\r\n      .cls-100 {\r\n        fill: url(#New_Gradient_Swatch_copy_18-20);\r\n      }\r\n\r\n      .cls-101 {\r\n        fill: url(#New_Gradient_Swatch_copy_18-25);\r\n      }\r\n\r\n      .cls-102 {\r\n        fill: url(#New_Gradient_Swatch_copy_18-21);\r\n      }\r\n\r\n      .cls-103 {\r\n        fill: url(#New_Gradient_Swatch_copy_18-23);\r\n      }\r\n\r\n      .cls-104 {\r\n        fill: url(#New_Gradient_Swatch_copy_18-18);\r\n      }\r\n\r\n      .cls-105 {\r\n        fill: url(#New_Gradient_Swatch_copy_18-12);\r\n      }\r\n\r\n      .cls-106 {\r\n        fill: url(#New_Gradient_Swatch_copy_18-13);\r\n      }\r\n\r\n      .cls-107 {\r\n        fill: url(#New_Gradient_Swatch_copy_29-12);\r\n      }\r\n\r\n      .cls-108 {\r\n        fill: url(#New_Gradient_Swatch_copy_29-11);\r\n      }\r\n\r\n      .cls-109 {\r\n        fill: url(#New_Gradient_Swatch_copy_29-10);\r\n      }\r\n\r\n      .cls-110 {\r\n        fill: url(#New_Gradient_Swatch_copy_29-14);\r\n      }\r\n\r\n      .cls-111 {\r\n        fill: url(#New_Gradient_Swatch_copy_29-13);\r\n      }\r\n\r\n      .cls-112 {\r\n        fill: url(#New_Gradient_Swatch_copy_40-10);\r\n      }\r\n\r\n      .cls-113 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-12);\r\n      }\r\n\r\n      .cls-114 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-29);\r\n      }\r\n\r\n      .cls-115 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-27);\r\n      }\r\n\r\n      .cls-116 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-20);\r\n      }\r\n\r\n      .cls-117 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-22);\r\n      }\r\n\r\n      .cls-118 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-24);\r\n      }\r\n\r\n      .cls-119 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-23);\r\n      }\r\n\r\n      .cls-120 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-25);\r\n      }\r\n\r\n      .cls-121 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-26);\r\n      }\r\n\r\n      .cls-122 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-21);\r\n      }\r\n\r\n      .cls-123 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-28);\r\n      }\r\n\r\n      .cls-124 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-37);\r\n      }\r\n\r\n      .cls-125 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-31);\r\n      }\r\n\r\n      .cls-126 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-32);\r\n      }\r\n\r\n      .cls-127 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-35);\r\n      }\r\n\r\n      .cls-128 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-38);\r\n      }\r\n\r\n      .cls-129 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-33);\r\n      }\r\n\r\n      .cls-130 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-34);\r\n      }\r\n\r\n      .cls-131 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-30);\r\n      }\r\n\r\n      .cls-132 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-36);\r\n      }\r\n\r\n      .cls-133 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-39);\r\n      }\r\n\r\n      .cls-134 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-42);\r\n      }\r\n\r\n      .cls-135 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-47);\r\n      }\r\n\r\n      .cls-136 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-41);\r\n      }\r\n\r\n      .cls-137 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-45);\r\n      }\r\n\r\n      .cls-138 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-46);\r\n      }\r\n\r\n      .cls-139 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-48);\r\n      }\r\n\r\n      .cls-140 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-43);\r\n      }\r\n\r\n      .cls-141 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-44);\r\n      }\r\n\r\n      .cls-142 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-40);\r\n      }\r\n\r\n      .cls-143 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-19);\r\n      }\r\n\r\n      .cls-144 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-11);\r\n      }\r\n\r\n      .cls-145 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-10);\r\n      }\r\n\r\n      .cls-146 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-13);\r\n      }\r\n\r\n      .cls-147 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-14);\r\n      }\r\n\r\n      .cls-148 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-15);\r\n      }\r\n\r\n      .cls-149 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-16);\r\n      }\r\n\r\n      .cls-150 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-18);\r\n      }\r\n\r\n      .cls-151 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-17);\r\n      }\r\n\r\n      .cls-152 {\r\n        fill: url(#New_Gradient_Swatch_copy_22-10);\r\n      }\r\n\r\n      .cls-153 {\r\n        fill: url(#New_Gradient_Swatch_copy_22-11);\r\n      }\r\n\r\n      .cls-154 {\r\n        fill: url(#New_Gradient_Swatch_copy_22-12);\r\n      }\r\n\r\n      .cls-155 {\r\n        fill: url(#New_Gradient_Swatch_copy_22-13);\r\n      }\r\n\r\n      .cls-156 {\r\n        fill: url(#New_Gradient_Swatch_copy_22-14);\r\n      }\r\n\r\n      .cls-157 {\r\n        fill: url(#New_Gradient_Swatch_copy_22-15);\r\n      }\r\n\r\n      .cls-158 {\r\n        fill: url(#radial-gradient-58);\r\n      }\r\n\r\n      .cls-159 {\r\n        fill: url(#radial-gradient-59);\r\n      }\r\n\r\n      .cls-160 {\r\n        fill: url(#New_Gradient_Swatch_copy_3-10);\r\n      }\r\n\r\n      .cls-161 {\r\n        fill: url(#New_Gradient_Swatch_copy_41-9);\r\n      }\r\n\r\n      .cls-162 {\r\n        fill: url(#New_Gradient_Swatch_copy_41-4);\r\n      }\r\n\r\n      .cls-163 {\r\n        fill: url(#New_Gradient_Swatch_copy_41-8);\r\n      }\r\n\r\n      .cls-164 {\r\n        fill: url(#New_Gradient_Swatch_copy_41-3);\r\n      }\r\n\r\n      .cls-165 {\r\n        fill: url(#New_Gradient_Swatch_copy_41-5);\r\n      }\r\n\r\n      .cls-166 {\r\n        fill: url(#New_Gradient_Swatch_copy_41-7);\r\n      }\r\n\r\n      .cls-167 {\r\n        fill: url(#New_Gradient_Swatch_copy_40-2);\r\n      }\r\n\r\n      .cls-168 {\r\n        fill: url(#New_Gradient_Swatch_copy_40-3);\r\n      }\r\n\r\n      .cls-169 {\r\n        fill: url(#New_Gradient_Swatch_copy_29-7);\r\n      }\r\n\r\n      .cls-170 {\r\n        fill: url(#New_Gradient_Swatch_copy_29-5);\r\n      }\r\n\r\n      .cls-171 {\r\n        fill: url(#New_Gradient_Swatch_copy_29-3);\r\n      }\r\n\r\n      .cls-172 {\r\n        fill: url(#New_Gradient_Swatch_copy_29-4);\r\n      }\r\n\r\n      .cls-173 {\r\n        fill: url(#New_Gradient_Swatch_copy_29-8);\r\n      }\r\n\r\n      .cls-174 {\r\n        fill: url(#New_Gradient_Swatch_copy_29-2);\r\n      }\r\n\r\n      .cls-175 {\r\n        fill: url(#New_Gradient_Swatch_copy_29-6);\r\n      }\r\n\r\n      .cls-176 {\r\n        fill: url(#New_Gradient_Swatch_copy_29-9);\r\n      }\r\n\r\n      .cls-177 {\r\n        fill: url(#New_Gradient_Swatch_copy_14-2);\r\n      }\r\n\r\n      .cls-178 {\r\n        fill: url(#New_Gradient_Swatch_copy_32-2);\r\n      }\r\n\r\n      .cls-179 {\r\n        fill: url(#New_Gradient_Swatch_copy_18-4);\r\n      }\r\n\r\n      .cls-180 {\r\n        fill: url(#New_Gradient_Swatch_copy_18-3);\r\n      }\r\n\r\n      .cls-181 {\r\n        fill: url(#New_Gradient_Swatch_copy_18-8);\r\n      }\r\n\r\n      .cls-182 {\r\n        fill: url(#New_Gradient_Swatch_copy_18-9);\r\n      }\r\n\r\n      .cls-183 {\r\n        fill: url(#New_Gradient_Swatch_copy_18-2);\r\n      }\r\n\r\n      .cls-184 {\r\n        fill: url(#New_Gradient_Swatch_copy_18-6);\r\n      }\r\n\r\n      .cls-185 {\r\n        fill: url(#New_Gradient_Swatch_copy_18-5);\r\n      }\r\n\r\n      .cls-186 {\r\n        fill: url(#New_Gradient_Swatch_copy_18-7);\r\n      }\r\n\r\n      .cls-187 {\r\n        fill: url(#New_Gradient_Swatch_copy_40-8);\r\n      }\r\n\r\n      .cls-188 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-9);\r\n      }\r\n\r\n      .cls-189 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-4);\r\n      }\r\n\r\n      .cls-190 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-7);\r\n      }\r\n\r\n      .cls-191 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-8);\r\n      }\r\n\r\n      .cls-192 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-2);\r\n      }\r\n\r\n      .cls-193 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-3);\r\n      }\r\n\r\n      .cls-194 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-5);\r\n      }\r\n\r\n      .cls-195 {\r\n        fill: url(#New_Gradient_Swatch_copy_17-6);\r\n      }\r\n\r\n      .cls-196 {\r\n        fill: url(#New_Gradient_Swatch_copy_2-19);\r\n      }\r\n\r\n      .cls-197 {\r\n        fill: url(#New_Gradient_Swatch_copy_2-13);\r\n      }\r\n\r\n      .cls-198 {\r\n        fill: url(#New_Gradient_Swatch_copy_2-11);\r\n      }\r\n\r\n      .cls-199 {\r\n        fill: url(#New_Gradient_Swatch_copy_2-10);\r\n      }\r\n\r\n      .cls-200 {\r\n        fill: url(#New_Gradient_Swatch_copy_2-12);\r\n      }\r\n\r\n      .cls-201 {\r\n        fill: url(#New_Gradient_Swatch_copy_2-14);\r\n      }\r\n\r\n      .cls-202 {\r\n        fill: url(#New_Gradient_Swatch_copy_2-15);\r\n      }\r\n\r\n      .cls-203 {\r\n        fill: url(#New_Gradient_Swatch_copy_2-16);\r\n      }\r\n\r\n      .cls-204 {\r\n        fill: url(#New_Gradient_Swatch_copy_2-20);\r\n      }\r\n\r\n      .cls-205 {\r\n        fill: url(#New_Gradient_Swatch_copy_2-26);\r\n      }\r\n\r\n      .cls-206 {\r\n        fill: url(#New_Gradient_Swatch_copy_2-25);\r\n      }\r\n\r\n      .cls-207 {\r\n        fill: url(#New_Gradient_Swatch_copy_2-24);\r\n      }\r\n\r\n      .cls-208 {\r\n        fill: url(#New_Gradient_Swatch_copy_2-23);\r\n      }\r\n\r\n      .cls-209 {\r\n        fill: url(#New_Gradient_Swatch_copy_2-22);\r\n      }\r\n\r\n      .cls-210 {\r\n        fill: url(#New_Gradient_Swatch_copy_2-21);\r\n      }\r\n\r\n      .cls-211 {\r\n        fill: url(#New_Gradient_Swatch_copy_2-17);\r\n      }\r\n\r\n      .cls-212 {\r\n        fill: url(#New_Gradient_Swatch_copy_2-18);\r\n      }\r\n\r\n      .cls-213 {\r\n        fill: url(#New_Gradient_Swatch_copy_44-3);\r\n      }\r\n\r\n      .cls-214 {\r\n        fill: url(#New_Gradient_Swatch_copy_44-2);\r\n      }\r\n\r\n      .cls-215 {\r\n        fill: url(#New_Gradient_Swatch_copy_44-5);\r\n      }\r\n\r\n      .cls-216 {\r\n        fill: url(#New_Gradient_Swatch_copy_44-4);\r\n      }\r\n\r\n      .cls-217 {\r\n        fill: url(#New_Gradient_Swatch_copy_44-6);\r\n      }\r\n\r\n      .cls-218 {\r\n        fill: url(#New_Gradient_Swatch_copy_30-2);\r\n      }\r\n\r\n      .cls-219 {\r\n        fill: url(#New_Gradient_Swatch_copy_22-2);\r\n      }\r\n\r\n      .cls-220 {\r\n        fill: url(#New_Gradient_Swatch_copy_22-3);\r\n      }\r\n\r\n      .cls-221 {\r\n        fill: url(#New_Gradient_Swatch_copy_22-7);\r\n      }\r\n\r\n      .cls-222 {\r\n        fill: url(#New_Gradient_Swatch_copy_22-6);\r\n      }\r\n\r\n      .cls-223 {\r\n        fill: url(#New_Gradient_Swatch_copy_22-5);\r\n      }\r\n\r\n      .cls-224 {\r\n        fill: url(#New_Gradient_Swatch_copy_22-4);\r\n      }\r\n\r\n      .cls-225 {\r\n        fill: url(#New_Gradient_Swatch_copy_22-9);\r\n      }\r\n\r\n      .cls-226 {\r\n        fill: url(#New_Gradient_Swatch_copy_22-8);\r\n      }\r\n\r\n      .cls-227 {\r\n        fill: url(#New_Gradient_Swatch_copy_43-2);\r\n      }\r\n\r\n      .cls-228 {\r\n        fill: url(#New_Gradient_Swatch_copy_43-5);\r\n      }\r\n\r\n      .cls-229 {\r\n        fill: url(#New_Gradient_Swatch_copy_43-4);\r\n      }\r\n\r\n      .cls-230 {\r\n        fill: url(#New_Gradient_Swatch_copy_43-3);\r\n      }\r\n\r\n      .cls-231 {\r\n        fill: url(#New_Gradient_Swatch_copy_43-7);\r\n      }\r\n\r\n      .cls-232 {\r\n        fill: url(#New_Gradient_Swatch_copy_43-6);\r\n      }\r\n\r\n      .cls-233 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-4);\r\n      }\r\n\r\n      .cls-234 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-9);\r\n      }\r\n\r\n      .cls-235 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-7);\r\n      }\r\n\r\n      .cls-236 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-3);\r\n      }\r\n\r\n      .cls-237 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-6);\r\n      }\r\n\r\n      .cls-238 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-8);\r\n      }\r\n\r\n      .cls-239 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-2);\r\n      }\r\n\r\n      .cls-240 {\r\n        fill: url(#New_Gradient_Swatch_copy_28-5);\r\n      }\r\n\r\n      .cls-241 {\r\n        fill: url(#New_Gradient_Swatch_copy_39-4);\r\n      }\r\n\r\n      .cls-242 {\r\n        fill: url(#New_Gradient_Swatch_copy_39-2);\r\n      }\r\n\r\n      .cls-243 {\r\n        fill: url(#New_Gradient_Swatch_copy_39-7);\r\n      }\r\n\r\n      .cls-244 {\r\n        fill: url(#New_Gradient_Swatch_copy_39-9);\r\n      }\r\n\r\n      .cls-245 {\r\n        fill: url(#New_Gradient_Swatch_copy_39-6);\r\n      }\r\n\r\n      .cls-246 {\r\n        fill: url(#New_Gradient_Swatch_copy_39-8);\r\n      }\r\n\r\n      .cls-247 {\r\n        fill: url(#New_Gradient_Swatch_copy_39-3);\r\n      }\r\n\r\n      .cls-248 {\r\n        fill: url(#New_Gradient_Swatch_copy_39-5);\r\n      }\r\n\r\n      .cls-249 {\r\n        fill: url(#Radial_Gradient_1-50);\r\n      }\r\n\r\n      .cls-250 {\r\n        fill: url(#Radial_Gradient_1-54);\r\n      }\r\n\r\n      .cls-251 {\r\n        fill: url(#Radial_Gradient_1-52);\r\n      }\r\n\r\n      .cls-252 {\r\n        fill: url(#Radial_Gradient_1-55);\r\n      }\r\n\r\n      .cls-253 {\r\n        fill: url(#Radial_Gradient_1-53);\r\n      }\r\n\r\n      .cls-254 {\r\n        fill: url(#Radial_Gradient_1-51);\r\n      }\r\n\r\n      .cls-255 {\r\n        fill: url(#Radial_Gradient_1-56);\r\n      }\r\n\r\n      .cls-256 {\r\n        fill: url(#Radial_Gradient_1-48);\r\n      }\r\n\r\n      .cls-257 {\r\n        fill: url(#Radial_Gradient_1-49);\r\n      }\r\n\r\n      .cls-258 {\r\n        fill: url(#Radial_Gradient_1-46);\r\n      }\r\n\r\n      .cls-259 {\r\n        fill: url(#Radial_Gradient_1-47);\r\n      }\r\n\r\n      .cls-260 {\r\n        fill: url(#Radial_Gradient_1-12);\r\n      }\r\n\r\n      .cls-261 {\r\n        fill: url(#Radial_Gradient_1-10);\r\n      }\r\n\r\n      .cls-262 {\r\n        fill: url(#Radial_Gradient_1-11);\r\n      }\r\n\r\n      .cls-263 {\r\n        fill: url(#Radial_Gradient_1-13);\r\n      }\r\n\r\n      .cls-264 {\r\n        fill: url(#Radial_Gradient_1-14);\r\n      }\r\n\r\n      .cls-265 {\r\n        fill: url(#Radial_Gradient_1-19);\r\n      }\r\n\r\n      .cls-266 {\r\n        fill: url(#Radial_Gradient_1-18);\r\n      }\r\n\r\n      .cls-267 {\r\n        fill: url(#Radial_Gradient_1-15);\r\n      }\r\n\r\n      .cls-268 {\r\n        fill: url(#Radial_Gradient_1-16);\r\n      }\r\n\r\n      .cls-269 {\r\n        fill: url(#Radial_Gradient_1-31);\r\n      }\r\n\r\n      .cls-270 {\r\n        fill: url(#Radial_Gradient_1-30);\r\n      }\r\n\r\n      .cls-271 {\r\n        fill: url(#Radial_Gradient_1-32);\r\n      }\r\n\r\n      .cls-272 {\r\n        fill: url(#Radial_Gradient_1-37);\r\n      }\r\n\r\n      .cls-273 {\r\n        fill: url(#Radial_Gradient_1-36);\r\n      }\r\n\r\n      .cls-274 {\r\n        fill: url(#Radial_Gradient_1-23);\r\n      }\r\n\r\n      .cls-275 {\r\n        fill: url(#Radial_Gradient_1-22);\r\n      }\r\n\r\n      .cls-276 {\r\n        fill: url(#Radial_Gradient_1-27);\r\n      }\r\n\r\n      .cls-277 {\r\n        fill: url(#Radial_Gradient_1-25);\r\n      }\r\n\r\n      .cls-278 {\r\n        fill: url(#Radial_Gradient_1-26);\r\n      }\r\n\r\n      .cls-279 {\r\n        fill: url(#Radial_Gradient_1-28);\r\n      }\r\n\r\n      .cls-280 {\r\n        fill: url(#Radial_Gradient_1-20);\r\n      }\r\n\r\n      .cls-281 {\r\n        fill: url(#Radial_Gradient_1-29);\r\n      }\r\n\r\n      .cls-282 {\r\n        fill: url(#Radial_Gradient_1-21);\r\n      }\r\n\r\n      .cls-283 {\r\n        fill: url(#Radial_Gradient_1-34);\r\n      }\r\n\r\n      .cls-284 {\r\n        fill: url(#Radial_Gradient_1-35);\r\n      }\r\n\r\n      .cls-285 {\r\n        fill: url(#Radial_Gradient_1-33);\r\n      }\r\n\r\n      .cls-286 {\r\n        fill: url(#Radial_Gradient_1-43);\r\n      }\r\n\r\n      .cls-287 {\r\n        fill: url(#Radial_Gradient_1-44);\r\n      }\r\n\r\n      .cls-288 {\r\n        fill: url(#Radial_Gradient_1-45);\r\n      }\r\n\r\n      .cls-289 {\r\n        fill: url(#linear-gradient-38);\r\n      }\r\n\r\n      .cls-290 {\r\n        fill: url(#linear-gradient-33);\r\n      }\r\n\r\n      .cls-291 {\r\n        fill: url(#linear-gradient-29);\r\n      }\r\n\r\n      .cls-292 {\r\n        fill: url(#linear-gradient-32);\r\n      }\r\n\r\n      .cls-293 {\r\n        fill: url(#linear-gradient-30);\r\n      }\r\n\r\n      .cls-294 {\r\n        fill: url(#linear-gradient-31);\r\n      }\r\n\r\n      .cls-295 {\r\n        fill: url(#linear-gradient-36);\r\n      }\r\n\r\n      .cls-296 {\r\n        fill: url(#linear-gradient-39);\r\n      }\r\n\r\n      .cls-297 {\r\n        fill: url(#linear-gradient-34);\r\n      }\r\n\r\n      .cls-298 {\r\n        fill: url(#linear-gradient-37);\r\n      }\r\n\r\n      .cls-299 {\r\n        fill: url(#linear-gradient-35);\r\n      }\r\n\r\n      .cls-300 {\r\n        fill: url(#linear-gradient-28);\r\n      }\r\n\r\n      .cls-301 {\r\n        fill: url(#linear-gradient-25);\r\n      }\r\n\r\n      .cls-302 {\r\n        fill: url(#linear-gradient-11);\r\n      }\r\n\r\n      .cls-303 {\r\n        fill: url(#linear-gradient-12);\r\n      }\r\n\r\n      .cls-304 {\r\n        fill: url(#linear-gradient-13);\r\n      }\r\n\r\n      .cls-305 {\r\n        fill: url(#linear-gradient-10);\r\n      }\r\n\r\n      .cls-306 {\r\n        fill: url(#linear-gradient-17);\r\n      }\r\n\r\n      .cls-307 {\r\n        fill: url(#linear-gradient-16);\r\n      }\r\n\r\n      .cls-308 {\r\n        fill: url(#linear-gradient-19);\r\n      }\r\n\r\n      .cls-309 {\r\n        fill: url(#linear-gradient-15);\r\n      }\r\n\r\n      .cls-310 {\r\n        fill: url(#linear-gradient-23);\r\n      }\r\n\r\n      .cls-311 {\r\n        fill: url(#linear-gradient-21);\r\n      }\r\n\r\n      .cls-312 {\r\n        fill: url(#linear-gradient-18);\r\n      }\r\n\r\n      .cls-313 {\r\n        fill: url(#linear-gradient-14);\r\n      }\r\n\r\n      .cls-314 {\r\n        fill: url(#linear-gradient-22);\r\n      }\r\n\r\n      .cls-315 {\r\n        fill: url(#linear-gradient-20);\r\n      }\r\n\r\n      .cls-316 {\r\n        fill: url(#linear-gradient-27);\r\n      }\r\n\r\n      .cls-317 {\r\n        fill: url(#linear-gradient-24);\r\n      }\r\n\r\n      .cls-318 {\r\n        fill: url(#linear-gradient-26);\r\n      }\r\n\r\n      .cls-319 {\r\n        fill: url(#linear-gradient-45);\r\n      }\r\n\r\n      .cls-320 {\r\n        fill: url(#linear-gradient-46);\r\n      }\r\n\r\n      .cls-321 {\r\n        fill: url(#linear-gradient-44);\r\n      }\r\n\r\n      .cls-322 {\r\n        fill: url(#linear-gradient-48);\r\n      }\r\n\r\n      .cls-323 {\r\n        fill: url(#linear-gradient-49);\r\n      }\r\n\r\n      .cls-324 {\r\n        fill: url(#linear-gradient-47);\r\n      }\r\n\r\n      .cls-325 {\r\n        fill: url(#linear-gradient-42);\r\n      }\r\n\r\n      .cls-326 {\r\n        fill: url(#linear-gradient-43);\r\n      }\r\n\r\n      .cls-327 {\r\n        fill: url(#linear-gradient-40);\r\n      }\r\n\r\n      .cls-328 {\r\n        fill: url(#linear-gradient-41);\r\n      }\r\n\r\n      .cls-329 {\r\n        fill: url(#linear-gradient-57);\r\n      }\r\n\r\n      .cls-330 {\r\n        fill: url(#linear-gradient-58);\r\n      }\r\n\r\n      .cls-331 {\r\n        fill: url(#linear-gradient-55);\r\n      }\r\n\r\n      .cls-332 {\r\n        fill: url(#linear-gradient-56);\r\n      }\r\n\r\n      .cls-333 {\r\n        fill: url(#linear-gradient-53);\r\n      }\r\n\r\n      .cls-334 {\r\n        fill: url(#linear-gradient-51);\r\n      }\r\n\r\n      .cls-335 {\r\n        fill: url(#linear-gradient-52);\r\n      }\r\n\r\n      .cls-336 {\r\n        fill: url(#linear-gradient-50);\r\n      }\r\n\r\n      .cls-337 {\r\n        fill: url(#linear-gradient-54);\r\n      }\r\n\r\n      .cls-338 {\r\n        fill: url(#linear-gradient-60);\r\n      }\r\n\r\n      .cls-339 {\r\n        fill: url(#linear-gradient-61);\r\n      }\r\n\r\n      .cls-340 {\r\n        fill: url(#linear-gradient-62);\r\n      }\r\n\r\n      .cls-341 {\r\n        fill: url(#linear-gradient-65);\r\n      }\r\n\r\n      .cls-342 {\r\n        fill: url(#linear-gradient-79);\r\n      }\r\n\r\n      .cls-343 {\r\n        fill: url(#linear-gradient-78);\r\n      }\r\n\r\n      .cls-344 {\r\n        fill: url(#linear-gradient-76);\r\n      }\r\n\r\n      .cls-345 {\r\n        fill: url(#linear-gradient-74);\r\n      }\r\n\r\n      .cls-346 {\r\n        fill: url(#linear-gradient-67);\r\n      }\r\n\r\n      .cls-347 {\r\n        fill: url(#linear-gradient-68);\r\n      }\r\n\r\n      .cls-348 {\r\n        fill: url(#linear-gradient-66);\r\n      }\r\n\r\n      .cls-349 {\r\n        fill: url(#linear-gradient-69);\r\n      }\r\n\r\n      .cls-350 {\r\n        fill: url(#linear-gradient-64);\r\n      }\r\n\r\n      .cls-351 {\r\n        fill: url(#linear-gradient-71);\r\n      }\r\n\r\n      .cls-352 {\r\n        fill: url(#linear-gradient-72);\r\n      }\r\n\r\n      .cls-353 {\r\n        fill: url(#linear-gradient-70);\r\n      }\r\n\r\n      .cls-354 {\r\n        fill: url(#linear-gradient-73);\r\n      }\r\n\r\n      .cls-355 {\r\n        fill: url(#linear-gradient-85);\r\n      }\r\n\r\n      .cls-356 {\r\n        fill: url(#linear-gradient-82);\r\n      }\r\n\r\n      .cls-357 {\r\n        fill: url(#linear-gradient-89);\r\n      }\r\n\r\n      .cls-358 {\r\n        fill: url(#linear-gradient-88);\r\n      }\r\n\r\n      .cls-359 {\r\n        fill: url(#linear-gradient-80);\r\n      }\r\n\r\n      .cls-360 {\r\n        fill: url(#linear-gradient-81);\r\n      }\r\n\r\n      .cls-361 {\r\n        fill: url(#linear-gradient-98);\r\n      }\r\n\r\n      .cls-362 {\r\n        fill: url(#linear-gradient-91);\r\n      }\r\n\r\n      .cls-363 {\r\n        fill: url(#linear-gradient-92);\r\n      }\r\n\r\n      .cls-364 {\r\n        fill: url(#linear-gradient-93);\r\n      }\r\n\r\n      .cls-365 {\r\n        fill: url(#linear-gradient-96);\r\n      }\r\n\r\n      .cls-366 {\r\n        fill: url(#linear-gradient-95);\r\n      }\r\n\r\n      .cls-367, .cls-409, .cls-410, .cls-411, .cls-412, .cls-413, .cls-414, .cls-415, .cls-417, .cls-471, .cls-534 {\r\n        opacity: .5;\r\n      }\r\n\r\n      .cls-367, .cls-416, .cls-498, .cls-543 {\r\n        fill: #83fff0;\r\n      }\r\n\r\n      .cls-368 {\r\n        fill: #fbfbfb;\r\n      }\r\n\r\n      .cls-369 {\r\n        opacity: .72727;\r\n      }\r\n\r\n      .cls-370, .cls-476 {\r\n        fill: #0567ce;\r\n      }\r\n\r\n      .cls-371 {\r\n        opacity: .59091;\r\n      }\r\n\r\n      .cls-372 {\r\n        opacity: .26364;\r\n      }\r\n\r\n      .cls-373, .cls-498 {\r\n        opacity: 0;\r\n      }\r\n\r\n      .cls-374 {\r\n        opacity: .50909;\r\n      }\r\n\r\n      .cls-375 {\r\n        fill: url(#New_Gradient_Swatch_copy_6-4);\r\n      }\r\n\r\n      .cls-376 {\r\n        fill: url(#New_Gradient_Swatch_copy_6-2);\r\n      }\r\n\r\n      .cls-377 {\r\n        fill: url(#New_Gradient_Swatch_copy_6-3);\r\n      }\r\n\r\n      .cls-378 {\r\n        fill: url(#New_Gradient_Swatch_copy_3-7);\r\n      }\r\n\r\n      .cls-379 {\r\n        fill: url(#New_Gradient_Swatch_copy_3-8);\r\n      }\r\n\r\n      .cls-380 {\r\n        fill: url(#New_Gradient_Swatch_copy_3-9);\r\n      }\r\n\r\n      .cls-381 {\r\n        fill: url(#New_Gradient_Swatch_copy_3-6);\r\n      }\r\n\r\n      .cls-382 {\r\n        fill: url(#New_Gradient_Swatch_copy_3-5);\r\n      }\r\n\r\n      .cls-383 {\r\n        fill: url(#New_Gradient_Swatch_copy_3-4);\r\n      }\r\n\r\n      .cls-384 {\r\n        fill: url(#New_Gradient_Swatch_copy_3-2);\r\n      }\r\n\r\n      .cls-385 {\r\n        fill: url(#New_Gradient_Swatch_copy_3-3);\r\n      }\r\n\r\n      .cls-386 {\r\n        fill: url(#New_Gradient_Swatch_copy_4-2);\r\n      }\r\n\r\n      .cls-387 {\r\n        fill: url(#New_Gradient_Swatch_copy_4-4);\r\n      }\r\n\r\n      .cls-388 {\r\n        fill: url(#New_Gradient_Swatch_copy_4-3);\r\n      }\r\n\r\n      .cls-389 {\r\n        fill: url(#New_Gradient_Swatch_copy_4-5);\r\n      }\r\n\r\n      .cls-390 {\r\n        fill: url(#New_Gradient_Swatch_copy_2-6);\r\n      }\r\n\r\n      .cls-391 {\r\n        fill: url(#New_Gradient_Swatch_copy_2-4);\r\n      }\r\n\r\n      .cls-392 {\r\n        fill: url(#New_Gradient_Swatch_copy_2-5);\r\n      }\r\n\r\n      .cls-393 {\r\n        fill: url(#New_Gradient_Swatch_copy_2-7);\r\n      }\r\n\r\n      .cls-394 {\r\n        fill: url(#New_Gradient_Swatch_copy_2-8);\r\n      }\r\n\r\n      .cls-395 {\r\n        fill: url(#New_Gradient_Swatch_copy_2-9);\r\n      }\r\n\r\n      .cls-396 {\r\n        fill: url(#New_Gradient_Swatch_copy_2-2);\r\n      }\r\n\r\n      .cls-397 {\r\n        fill: url(#New_Gradient_Swatch_copy_2-3);\r\n      }\r\n\r\n      .cls-398 {\r\n        opacity: .18182;\r\n      }\r\n\r\n      .cls-399 {\r\n        fill: #1259d1;\r\n      }\r\n\r\n      .cls-400 {\r\n        fill: url(#radial-gradient-25);\r\n      }\r\n\r\n      .cls-400, .cls-401, .cls-402, .cls-403, .cls-404, .cls-405, .cls-406, .cls-407 {\r\n        opacity: .65;\r\n      }\r\n\r\n      .cls-401 {\r\n        fill: url(#radial-gradient-30);\r\n      }\r\n\r\n      .cls-402 {\r\n        fill: url(#radial-gradient-50);\r\n      }\r\n\r\n      .cls-403 {\r\n        fill: url(#radial-gradient-55);\r\n      }\r\n\r\n      .cls-404 {\r\n        fill: url(#radial-gradient-40);\r\n      }\r\n\r\n      .cls-405 {\r\n        fill: url(#radial-gradient-45);\r\n      }\r\n\r\n      .cls-406 {\r\n        fill: url(#radial-gradient-35);\r\n      }\r\n\r\n      .cls-407 {\r\n        fill: url(#radial-gradient-20);\r\n      }\r\n\r\n      .cls-408 {\r\n        fill: #1a74d2;\r\n      }\r\n\r\n      .cls-409 {\r\n        fill: url(#New_Gradient_Swatch_copy_40-5);\r\n      }\r\n\r\n      .cls-410 {\r\n        fill: url(#New_Gradient_Swatch_copy_40-6);\r\n      }\r\n\r\n      .cls-411 {\r\n        fill: url(#New_Gradient_Swatch_copy_40-9);\r\n      }\r\n\r\n      .cls-412 {\r\n        fill: url(#New_Gradient_Swatch_copy_40-7);\r\n      }\r\n\r\n      .cls-413 {\r\n        fill: url(#New_Gradient_Swatch_copy_40-4);\r\n      }\r\n\r\n      .cls-414 {\r\n        fill: url(#New_Gradient_Swatch_copy_41-6);\r\n      }\r\n\r\n      .cls-415 {\r\n        fill: url(#New_Gradient_Swatch_copy_41-2);\r\n      }\r\n\r\n      .cls-417 {\r\n        fill: #cad4ff;\r\n      }\r\n\r\n      .cls-418 {\r\n        fill: url(#New_Gradient_Swatch_copy_47);\r\n      }\r\n\r\n      .cls-419 {\r\n        fill: #fbfcfb;\r\n      }\r\n\r\n      .cls-421 {\r\n        opacity: .1;\r\n      }\r\n\r\n      .cls-422 {\r\n        fill: #e5fae4;\r\n      }\r\n\r\n      .cls-423 {\r\n        opacity: .27273;\r\n      }\r\n\r\n      .cls-424 {\r\n        fill: url(#New_Gradient_Swatch_copy_4);\r\n      }\r\n\r\n      .cls-425 {\r\n        fill: url(#New_Gradient_Swatch_copy_3);\r\n      }\r\n\r\n      .cls-426 {\r\n        fill: url(#New_Gradient_Swatch_copy_5);\r\n      }\r\n\r\n      .cls-427 {\r\n        fill: url(#New_Gradient_Swatch_copy_2);\r\n      }\r\n\r\n      .cls-428 {\r\n        fill: url(#New_Gradient_Swatch_copy_6);\r\n      }\r\n\r\n      .cls-429 {\r\n        fill: url(#linear-gradient-63);\r\n      }\r\n\r\n      .cls-429, .cls-434, .cls-435, .cls-436, .cls-437, .cls-438, .cls-439, .cls-440, .cls-441 {\r\n        opacity: .3;\r\n      }\r\n\r\n      .cls-430 {\r\n        fill: url(#radial-gradient-3);\r\n      }\r\n\r\n      .cls-431 {\r\n        fill: url(#radial-gradient-8);\r\n      }\r\n\r\n      .cls-432 {\r\n        fill: url(#radial-gradient-7);\r\n      }\r\n\r\n      .cls-433 {\r\n        fill: url(#radial-gradient-2);\r\n      }\r\n\r\n      .cls-434 {\r\n        fill: url(#radial-gradient-47);\r\n      }\r\n\r\n      .cls-435 {\r\n        fill: url(#radial-gradient-37);\r\n      }\r\n\r\n      .cls-436 {\r\n        fill: url(#radial-gradient-52);\r\n      }\r\n\r\n      .cls-437 {\r\n        fill: url(#radial-gradient-32);\r\n      }\r\n\r\n      .cls-438 {\r\n        fill: url(#radial-gradient-22);\r\n      }\r\n\r\n      .cls-439 {\r\n        fill: url(#radial-gradient-27);\r\n      }\r\n\r\n      .cls-440 {\r\n        fill: url(#radial-gradient-42);\r\n      }\r\n\r\n      .cls-441 {\r\n        fill: url(#radial-gradient-57);\r\n      }\r\n\r\n      .cls-442 {\r\n        fill: url(#New_Gradient_Swatch_1);\r\n        opacity: .81818;\r\n      }\r\n\r\n      .cls-443 {\r\n        fill: url(#linear-gradient-59);\r\n      }\r\n\r\n      .cls-444, .cls-534 {\r\n        fill: #32c4f4;\r\n      }\r\n\r\n      .cls-445 {\r\n        fill: #d2f6db;\r\n      }\r\n\r\n      .cls-446 {\r\n        opacity: .34545;\r\n      }\r\n\r\n      .cls-447 {\r\n        opacity: .36364;\r\n      }\r\n\r\n      .cls-448 {\r\n        fill: url(#Radial_Gradient_1-39);\r\n      }\r\n\r\n      .cls-449 {\r\n        fill: url(#Radial_Gradient_1-38);\r\n      }\r\n\r\n      .cls-450 {\r\n        fill: url(#Radial_Gradient_1-24);\r\n      }\r\n\r\n      .cls-451 {\r\n        fill: url(#Radial_Gradient_1-40);\r\n      }\r\n\r\n      .cls-452 {\r\n        fill: url(#Radial_Gradient_1-41);\r\n      }\r\n\r\n      .cls-453 {\r\n        fill: url(#Radial_Gradient_1-42);\r\n      }\r\n\r\n      .cls-454 {\r\n        fill: url(#Radial_Gradient_1-17);\r\n      }\r\n\r\n      .cls-455 {\r\n        opacity: .63636;\r\n      }\r\n\r\n      .cls-456 {\r\n        fill: url(#radial-gradient-43);\r\n      }\r\n\r\n      .cls-457 {\r\n        fill: url(#radial-gradient-18);\r\n      }\r\n\r\n      .cls-458 {\r\n        fill: url(#radial-gradient-53);\r\n      }\r\n\r\n      .cls-459 {\r\n        fill: url(#radial-gradient-33);\r\n      }\r\n\r\n      .cls-460 {\r\n        fill: url(#radial-gradient-38);\r\n      }\r\n\r\n      .cls-461 {\r\n        fill: url(#radial-gradient-28);\r\n      }\r\n\r\n      .cls-462 {\r\n        fill: url(#radial-gradient-23);\r\n      }\r\n\r\n      .cls-463 {\r\n        fill: url(#radial-gradient-48);\r\n      }\r\n\r\n      .cls-464 {\r\n        fill: url(#linear-gradient-108);\r\n      }\r\n\r\n      .cls-465 {\r\n        fill: url(#linear-gradient-117);\r\n      }\r\n\r\n      .cls-466 {\r\n        fill: url(#linear-gradient-115);\r\n      }\r\n\r\n      .cls-467 {\r\n        fill: url(#linear-gradient-114);\r\n      }\r\n\r\n      .cls-468 {\r\n        fill: url(#linear-gradient-116);\r\n      }\r\n\r\n      .cls-469 {\r\n        fill: url(#linear-gradient-119);\r\n      }\r\n\r\n      .cls-470 {\r\n        fill: url(#linear-gradient-120);\r\n      }\r\n\r\n      .cls-472 {\r\n        opacity: .67273;\r\n      }\r\n\r\n      .cls-473 {\r\n        fill: url(#radial-gradient-5);\r\n      }\r\n\r\n      .cls-474 {\r\n        fill: url(#radial-gradient-9);\r\n      }\r\n\r\n      .cls-475 {\r\n        fill: url(#radial-gradient-4);\r\n      }\r\n\r\n      .cls-477 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-478 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-479 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-480 {\r\n        fill: url(#linear-gradient-8);\r\n      }\r\n\r\n      .cls-481 {\r\n        fill: url(#linear-gradient-9);\r\n      }\r\n\r\n      .cls-482 {\r\n        fill: url(#linear-gradient-7);\r\n      }\r\n\r\n      .cls-483 {\r\n        fill: url(#linear-gradient-5);\r\n      }\r\n\r\n      .cls-484 {\r\n        fill: url(#linear-gradient-6);\r\n      }\r\n\r\n      .cls-485 {\r\n        fill: url(#linear-gradient-113);\r\n      }\r\n\r\n      .cls-486 {\r\n        fill: url(#linear-gradient-112);\r\n      }\r\n\r\n      .cls-487 {\r\n        fill: url(#linear-gradient-118);\r\n      }\r\n\r\n      .cls-488 {\r\n        fill: url(#radial-gradient-21);\r\n      }\r\n\r\n      .cls-488, .cls-489, .cls-490, .cls-491, .cls-492, .cls-493, .cls-494, .cls-495 {\r\n        opacity: .475;\r\n      }\r\n\r\n      .cls-489 {\r\n        fill: url(#radial-gradient-41);\r\n      }\r\n\r\n      .cls-490 {\r\n        fill: url(#radial-gradient-31);\r\n      }\r\n\r\n      .cls-491 {\r\n        fill: url(#radial-gradient-46);\r\n      }\r\n\r\n      .cls-492 {\r\n        fill: url(#radial-gradient-36);\r\n      }\r\n\r\n      .cls-493 {\r\n        fill: url(#radial-gradient-26);\r\n      }\r\n\r\n      .cls-494 {\r\n        fill: url(#radial-gradient-56);\r\n      }\r\n\r\n      .cls-495 {\r\n        fill: url(#radial-gradient-51);\r\n      }\r\n\r\n      .cls-496 {\r\n        opacity: .83636;\r\n      }\r\n\r\n      .cls-497 {\r\n        opacity: .42727;\r\n      }\r\n\r\n      .cls-499 {\r\n        opacity: .18182;\r\n      }\r\n\r\n      .cls-547 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-500 {\r\n        fill: url(#radial-gradient-70);\r\n      }\r\n\r\n      .cls-501 {\r\n        fill: #bbbee2;\r\n      }\r\n\r\n      .cls-502 {\r\n        opacity: .75455;\r\n      }\r\n\r\n      .cls-503 {\r\n        fill: url(#New_Gradient_Swatch_copy_14);\r\n      }\r\n\r\n      .cls-504 {\r\n        fill: url(#New_Gradient_Swatch_copy_12);\r\n      }\r\n\r\n      .cls-505 {\r\n        fill: url(#New_Gradient_Swatch_copy_11);\r\n      }\r\n\r\n      .cls-506 {\r\n        fill: url(#New_Gradient_Swatch_copy_18);\r\n      }\r\n\r\n      .cls-507 {\r\n        fill: url(#New_Gradient_Swatch_copy_17);\r\n      }\r\n\r\n      .cls-508 {\r\n        fill: url(#New_Gradient_Swatch_copy_27);\r\n      }\r\n\r\n      .cls-509 {\r\n        fill: url(#New_Gradient_Swatch_copy_22);\r\n      }\r\n\r\n      .cls-510 {\r\n        fill: url(#New_Gradient_Swatch_copy_28);\r\n      }\r\n\r\n      .cls-511 {\r\n        fill: url(#New_Gradient_Swatch_copy_37);\r\n      }\r\n\r\n      .cls-512 {\r\n        fill: url(#New_Gradient_Swatch_copy_31);\r\n      }\r\n\r\n      .cls-513 {\r\n        fill: url(#New_Gradient_Swatch_copy_33);\r\n      }\r\n\r\n      .cls-514 {\r\n        fill: url(#New_Gradient_Swatch_copy_32);\r\n      }\r\n\r\n      .cls-515 {\r\n        fill: url(#New_Gradient_Swatch_copy_30);\r\n      }\r\n\r\n      .cls-516 {\r\n        fill: url(#New_Gradient_Swatch_copy_48);\r\n      }\r\n\r\n      .cls-517 {\r\n        fill: url(#New_Gradient_Swatch_copy_29);\r\n      }\r\n\r\n      .cls-518 {\r\n        fill: url(#New_Gradient_Swatch_copy_44);\r\n      }\r\n\r\n      .cls-519 {\r\n        fill: url(#New_Gradient_Swatch_copy_45);\r\n      }\r\n\r\n      .cls-520 {\r\n        fill: url(#New_Gradient_Swatch_copy_46);\r\n      }\r\n\r\n      .cls-521 {\r\n        fill: url(#New_Gradient_Swatch_copy_40);\r\n      }\r\n\r\n      .cls-522 {\r\n        fill: url(#New_Gradient_Swatch_copy_51);\r\n      }\r\n\r\n      .cls-523 {\r\n        fill: url(#New_Gradient_Swatch_copy_39);\r\n      }\r\n\r\n      .cls-524 {\r\n        fill: url(#New_Gradient_Swatch_copy_41);\r\n      }\r\n\r\n      .cls-525 {\r\n        fill: url(#New_Gradient_Swatch_copy_43);\r\n      }\r\n\r\n      .cls-526 {\r\n        opacity: .54545;\r\n      }\r\n\r\n      .cls-527 {\r\n        fill: url(#Radial_Gradient_1);\r\n      }\r\n\r\n      .cls-529 {\r\n        fill: url(#radial-gradient);\r\n      }\r\n\r\n      .cls-530 {\r\n        fill: #d3e5fa;\r\n      }\r\n\r\n      .cls-531 {\r\n        opacity: .09091;\r\n      }\r\n\r\n      .cls-532 {\r\n        fill: #247ad4;\r\n      }\r\n\r\n      .cls-533 {\r\n        fill: #f2f7fd;\r\n      }\r\n\r\n      .cls-535 {\r\n        fill: url(#radial-gradient-44);\r\n      }\r\n\r\n      .cls-535, .cls-536, .cls-537, .cls-538, .cls-539, .cls-540, .cls-541, .cls-542 {\r\n        opacity: .825;\r\n      }\r\n\r\n      .cls-536 {\r\n        fill: url(#radial-gradient-49);\r\n      }\r\n\r\n      .cls-537 {\r\n        fill: url(#radial-gradient-29);\r\n      }\r\n\r\n      .cls-538 {\r\n        fill: url(#radial-gradient-39);\r\n      }\r\n\r\n      .cls-539 {\r\n        fill: url(#radial-gradient-24);\r\n      }\r\n\r\n      .cls-540 {\r\n        fill: url(#radial-gradient-19);\r\n      }\r\n\r\n      .cls-541 {\r\n        fill: url(#radial-gradient-34);\r\n      }\r\n\r\n      .cls-542 {\r\n        fill: url(#radial-gradient-54);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 529.86489,
    y1: 1046.84487,
    x2: 681.93062,
    y2: 760.70025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a9dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5404,
    stopColor: "#558fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71341,
    stopColor: "#72b2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aaf6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 832.95916,
    y1: 948.24957,
    x2: 743.18054,
    y2: 737.14809,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1035.80297,
    y1: 865.78455,
    x2: 820.86724,
    y2: 690.15153,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1176.2556,
    y1: 965.54655,
    x2: 836.04343,
    y2: 719.90596,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1169.12367,
    y1: 459.26483,
    x2: 1322.889,
    y2: 459.26483,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 189.30022,
    y1: 709.1761,
    x2: 520.96015,
    y2: 709.1761,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 511.63649,
    y1: 857.34831,
    x2: 626.26873,
    y2: 744.35369,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1073.67026,
    y1: 503.37967,
    x2: 965.58827,
    y2: 622.10609,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1192.58524,
    y1: 779.60884,
    x2: 867.11128,
    y2: 694.86256,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 659.07624,
    y1: 907.62273,
    x2: 751.28252,
    y2: 907.62273,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 722.21024,
    y1: 1047.40509,
    x2: 632.14242,
    y2: 597.06456,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 386.69071,
    y1: 790.40813,
    x2: 583.79357,
    y2: 790.40813,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 888.7066,
    y1: 790.39184,
    x2: 790.45023,
    y2: 719.15599,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 261.68265,
    y1: 674.68381,
    x2: 489.54321,
    y2: 674.68381,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 536.02312,
    y1: 220.14057,
    x2: 845.83492,
    y2: 220.14057,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 942.66571,
    y1: 215.81716,
    x2: 860.78553,
    y2: 402.50388,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 69.89344,
    y1: 801.10251,
    x2: 321.49294,
    y2: 801.10251,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 150.49427,
    y1: 794.87451,
    x2: 552.37664,
    y2: 794.87451,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1123.35725,
    y1: 641.0228,
    x2: 953.04635,
    y2: 659.0365,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 924.60324,
    y1: 297.92038,
    x2: 1140.00893,
    y2: 297.92038,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1111.83494,
    y1: 329.97077,
    x2: 905.49683,
    y2: 480.63047,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 683.24641,
    y1: 191.30553,
    x2: 755.30099,
    y2: 413.20113,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 92.01075,
    y1: 563.54821,
    x2: 458.12695,
    y2: 563.54821,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 218.10545,
    y1: 555.36931,
    x2: 426.71069,
    y2: 555.36931,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 428.93911,
    y1: 305.85091,
    x2: 687.26974,
    y2: 305.85091,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 190.66594,
    y1: 458.27903,
    x2: 486.37289,
    y2: 458.27903,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 320.85712,
    y1: 251.92639,
    x2: 476.65666,
    y2: 251.92639,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1219.42555,
    y1: 780.37502,
    x2: 923.42856,
    y2: 632.99044,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 526.85471,
    y1: 985.35933,
    x2: 619.06122,
    y2: 985.35933,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 318.33118,
    y1: 392.8734,
    x2: 410.53768,
    y2: 392.8734,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1092.20247,
    y1: 633.96837,
    x2: 1294.96652,
    y2: 633.96837,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 1018.53197,
    y1: 397.50803,
    x2: 1110.736,
    y2: 397.50803,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 320.86927,
    y1: 409.05125,
    x2: 600.41267,
    y2: 409.05125,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 241.22297,
    y1: 887.25297,
    x2: 375.07334,
    y2: 887.25297,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1228.29418,
    y1: 342.06324,
    x2: 936.80055,
    y2: 515.64908,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 411.3333,
    y1: 565.90831,
    x2: 977.91579,
    y2: 565.90831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03535,
    stopColor: "#94e2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21212,
    stopColor: "#55a2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25459,
    stopColor: "#5fa8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32718,
    stopColor: "#7ab9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42039,
    stopColor: "#a6d5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.50505,
    stopColor: "#d4f3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52206,
    stopColor: "#c9ebff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60612,
    stopColor: "#97ccff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67978,
    stopColor: "#73b5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73949,
    stopColor: "#5da7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77778,
    stopColor: "#55a2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78688,
    stopColor: "#58a5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87583,
    stopColor: "#79c6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95004,
    stopColor: "#8cdaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94e2ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 699.51622,
    y1: 537.28284,
    x2: 575.87686,
    y2: 891.82458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03535,
    stopColor: "#94e2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21212,
    stopColor: "#55a2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25459,
    stopColor: "#5fa8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32718,
    stopColor: "#7ab9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42039,
    stopColor: "#a6d5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.50505,
    stopColor: "#d4f3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52206,
    stopColor: "#c9ebff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60612,
    stopColor: "#97ccff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67978,
    stopColor: "#73b5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73949,
    stopColor: "#5da7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77778,
    stopColor: "#55a2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83005,
    stopColor: "#719ef3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90095,
    stopColor: "#929ae6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96016,
    stopColor: "#a697dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae97db"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_51",
    "data-name": "New Gradient Swatch copy 51",
    x1: 424.27848,
    y1: 542.04314,
    x2: 964.81873,
    y2: 542.04314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03535,
    stopColor: "#2affe4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17256,
    stopColor: "#39ffe6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43702,
    stopColor: "#61ffeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63131,
    stopColor: "#83fff0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87374,
    stopColor: "#2affe4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 410.88001,
    y1: 526.16051,
    x2: 977.4625,
    y2: 526.16051,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 774.63891,
    y1: 297.8889,
    x2: 541.50896,
    y2: 899.69072,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 891.63913,
    y1: -4.13536,
    x2: 672.78575,
    y2: 560.8129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aafdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15b3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 777.72211,
    y1: 289.92994,
    x2: 597.15641,
    y2: 756.04236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#38c4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ac6ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1",
    "data-name": "Radial Gradient 1",
    cx: 694.15166,
    cy: 587.44543,
    fx: 694.15166,
    fy: 587.44543,
    r: 208.89509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 6652.54914,
    cy: 9440.55941,
    fx: 6652.54914,
    fy: 9440.55941,
    r: 104.99517,
    gradientTransform: "translate(-417.83056 -7885.371) rotate(118.64132) scale(.82472 -.53848) skewX(10.97363)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55a7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01522,
    stopColor: "rgba(85, 168, 255, .96852)",
    stopOpacity: 0.96852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13197,
    stopColor: "rgba(85, 180, 255, .74446)",
    stopOpacity: 0.74446
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25201,
    stopColor: "rgba(85, 190, 255, .54585)",
    stopOpacity: 0.54585
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37271,
    stopColor: "rgba(85, 199, 255, .3782)",
    stopOpacity: 0.3782
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49421,
    stopColor: "rgba(85, 206, 255, .24141)",
    stopOpacity: 0.24141
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61671,
    stopColor: "rgba(85, 211, 255, .13541)",
    stopOpacity: 0.13541
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74074,
    stopColor: "rgba(85, 215, 255, .05992)",
    stopOpacity: 0.05992
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86723,
    stopColor: "rgba(85, 218, 255, .01485)",
    stopOpacity: 0.01485
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55dbff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 955.70332,
    y1: 572.69389,
    x2: 987.35838,
    y2: 623.81379,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-2",
    "data-name": "Radial Gradient 1",
    cx: 961.01355,
    cy: 598.96159,
    fx: 961.01355,
    fy: 598.96159,
    r: 21.00409,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 924.22876,
    y1: 590.88104,
    x2: 955.88372,
    y2: 642.00077,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-3",
    "data-name": "Radial Gradient 1",
    cx: 929.53877,
    cy: 617.14851,
    fx: 929.53877,
    fy: 617.14851,
    r: 21.00409,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 892.754,
    y1: 609.06796,
    x2: 924.40906,
    y2: 660.18787,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-4",
    "data-name": "Radial Gradient 1",
    cx: 898.06423,
    cy: 635.33556,
    fx: 898.06423,
    fy: 635.33556,
    r: 21.00414,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 861.27939,
    y1: 627.25493,
    x2: 892.93444,
    y2: 678.37484,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-5",
    "data-name": "Radial Gradient 1",
    cx: 866.58944,
    cy: 653.5226,
    fx: 866.58944,
    fy: 653.5226,
    r: 21.00409,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 829.80468,
    y1: 645.44204,
    x2: 861.45974,
    y2: 696.56194,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-6",
    "data-name": "Radial Gradient 1",
    cx: 835.11489,
    cy: 671.70964,
    fx: 835.11489,
    fy: 671.70964,
    r: 21.00414,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 798.33007,
    y1: 663.629,
    x2: 829.98513,
    y2: 714.74891,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-7",
    "data-name": "Radial Gradient 1",
    cx: 803.64011,
    cy: 689.89668,
    fx: 803.64011,
    fy: 689.89668,
    r: 21.00409,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 766.707,
    y1: 681.81613,
    x2: 798.36195,
    y2: 732.93586,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-8",
    "data-name": "Radial Gradient 1",
    cx: 772.01701,
    cy: 708.08361,
    fx: 772.01701,
    fy: 708.08361,
    r: 21.00409,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 735.23225,
    y1: 700.00305,
    x2: 766.88731,
    y2: 751.12297,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-9",
    "data-name": "Radial Gradient 1",
    cx: 740.54223,
    cy: 726.27065,
    fx: 740.54223,
    fy: 726.27065,
    r: 21.00414,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 7903.89959,
    y1: 572.69291,
    x2: 7935.54414,
    y2: 623.79584,
    gradientTransform: "translate(8337.6221) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-10",
    "data-name": "Radial Gradient 1",
    cx: 7909.20786,
    cy: 598.9518,
    fx: 7909.20786,
    fy: 598.9518,
    r: 20.99717,
    gradientTransform: "translate(8337.6221) rotate(-180) scale(1 -1)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 7872.43526,
    y1: 590.87394,
    x2: 7904.07988,
    y2: 641.97698,
    gradientTransform: "translate(8337.6221) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 7856.71321,
    y1: 617.13287,
    x2: 7898.77411,
    y2: 617.13287,
    gradientTransform: "translate(8337.6221) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 7840.97099,
    y1: 609.05483,
    x2: 7872.61561,
    y2: 660.15787,
    gradientTransform: "translate(8337.6221) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-11",
    "data-name": "Radial Gradient 1",
    cx: 7846.27935,
    cy: 635.31384,
    fx: 7846.27935,
    fy: 635.31384,
    r: 20.99717,
    gradientTransform: "translate(8337.6221) rotate(-180) scale(1 -1)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 7809.50679,
    y1: 627.2359,
    x2: 7841.15134,
    y2: 678.33884,
    gradientTransform: "translate(8337.6221) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-12",
    "data-name": "Radial Gradient 1",
    cx: 7814.81503,
    cy: 653.4948,
    fx: 7814.81503,
    fy: 653.4948,
    r: 20.99717,
    gradientTransform: "translate(8337.6221) rotate(-180) scale(1 -1)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 7778.04258,
    y1: 645.41699,
    x2: 7809.68713,
    y2: 696.51991,
    gradientTransform: "translate(8337.6221) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-13",
    "data-name": "Radial Gradient 1",
    cx: 7783.35083,
    cy: 671.67588,
    fx: 7783.35083,
    fy: 671.67588,
    r: 20.99717,
    gradientTransform: "translate(8337.6221) rotate(-180) scale(1 -1)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 7746.57833,
    y1: 663.59786,
    x2: 7778.22289,
    y2: 714.7008,
    gradientTransform: "translate(8337.6221) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-14",
    "data-name": "Radial Gradient 1",
    cx: 7751.88663,
    cy: 689.85673,
    fx: 7751.88663,
    fy: 689.85673,
    r: 20.99717,
    gradientTransform: "translate(8337.6221) rotate(-180) scale(1 -1)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 7715.33677,
    y1: 681.77892,
    x2: 7746.98132,
    y2: 732.88185,
    gradientTransform: "translate(8337.6221) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-15",
    "data-name": "Radial Gradient 1",
    cx: 7720.64502,
    cy: 708.03781,
    fx: 7720.64502,
    fy: 708.03781,
    r: 20.99717,
    gradientTransform: "translate(8337.6221) rotate(-180) scale(1 -1)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 7683.87242,
    y1: 699.95994,
    x2: 7715.51693,
    y2: 751.06281,
    gradientTransform: "translate(8337.6221) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-16",
    "data-name": "Radial Gradient 1",
    cx: 7689.18082,
    cy: 726.21877,
    fx: 7689.18082,
    fy: 726.21877,
    r: 20.99711,
    gradientTransform: "translate(8337.6221) rotate(-180) scale(1 -1)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 695.42331,
    y1: 663.18105,
    x2: 695.42331,
    y2: 133.19055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6acfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01522,
    stopColor: "rgba(106, 206, 255, .96852)",
    stopOpacity: 0.96852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13197,
    stopColor: "rgba(111, 201, 255, .74446)",
    stopOpacity: 0.74446
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25201,
    stopColor: "rgba(115, 197, 255, .54585)",
    stopOpacity: 0.54585
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37271,
    stopColor: "rgba(119, 193, 255, .3782)",
    stopOpacity: 0.3782
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49421,
    stopColor: "rgba(121, 190, 255, .24141)",
    stopOpacity: 0.24141
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61671,
    stopColor: "rgba(124, 187, 255, .13541)",
    stopOpacity: 0.13541
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74074,
    stopColor: "rgba(125, 186, 255, .05992)",
    stopOpacity: 0.05992
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86723,
    stopColor: "rgba(126, 185, 255, .01485)",
    stopOpacity: 0.01485
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7fb9ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 836.44618,
    y1: 912.41592,
    x2: 973.51246,
    y2: 912.41592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05556,
    stopColor: "#92abf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26648,
    stopColor: "#94acf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37041,
    stopColor: "#9bb2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45068,
    stopColor: "#a8bcf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49495,
    stopColor: "#b4c5f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.50824,
    stopColor: "#b8c8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52274,
    stopColor: "#c5d2f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53782,
    stopColor: "#dbe3fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55321,
    stopColor: "#f9fafe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55556,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56279,
    stopColor: "#eff3fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57697,
    stopColor: "#d7e0fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59008,
    stopColor: "#c9d4fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60101,
    stopColor: "#c4d1fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64598,
    stopColor: "#adbff7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70798,
    stopColor: "#95adf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76532,
    stopColor: "#87a1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81313,
    stopColor: "#829ef4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a0b5f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_48",
    "data-name": "New Gradient Swatch copy 48",
    x1: 833.53044,
    y1: 908.82606,
    x2: 965.39507,
    y2: 908.82606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92abf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15242,
    stopColor: "#98aff5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36657,
    stopColor: "#aabdf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58081,
    stopColor: "#c4d1fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79967,
    stopColor: "#d3ddfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6ecfd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 835.00528,
    y1: 908.82629,
    x2: 963.92032,
    y2: 908.82629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c5cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5078ef"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 1996.59606,
    cy: -317.63468,
    fx: 1996.59606,
    fy: -317.63468,
    r: 24.03328,
    gradientTransform: "translate(-848.08833 1900.7956) rotate(-22.34087) scale(.99996 .66382)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07071,
    stopColor: "#01aeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19192,
    stopColor: "#01bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2998,
    stopColor: "rgba(39, 201, 255, .79896)",
    stopOpacity: 0.79896
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4425,
    stopColor: "rgba(84, 213, 255, .55912)",
    stopOpacity: 0.55912
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57971,
    stopColor: "rgba(122, 223, 255, .35918)",
    stopOpacity: 0.35918
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70757,
    stopColor: "rgba(152, 230, 255, .20351)",
    stopOpacity: 0.20351
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82404,
    stopColor: "rgba(173, 236, 255, .09184)",
    stopOpacity: 0.09184
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92529,
    stopColor: "rgba(186, 239, 255, .02401)",
    stopOpacity: 0.02401
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bff1ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy_47",
    "data-name": "New Gradient Swatch copy 47",
    cx: 1785.83677,
    cy: -927.85329,
    fx: 1785.83677,
    fy: -927.85329,
    r: 18.43093,
    gradientTransform: "translate(-633.89312 1986.74671) rotate(-18.98395) scale(.99999 .59052)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5b80f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10887,
    stopColor: "#4764bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23003,
    stopColor: "#344a8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35427,
    stopColor: "#243360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47928,
    stopColor: "#17203d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60544,
    stopColor: "#0d1222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73311,
    stopColor: "#05080f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86331,
    stopColor: "#010203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -21.6723,
    y1: 830.06387,
    x2: -81.77528,
    y2: 784.62895,
    gradientTransform: "translate(2162.83629 695.47895) rotate(30.00073) skewX(-49.10661)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c5cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c4fea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c4fea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 889.53485,
    y1: 878.52564,
    x2: 923.20513,
    y2: 931.36579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05556,
    stopColor: "#92abf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25523,
    stopColor: "#94acf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3536,
    stopColor: "#9bb2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42983,
    stopColor: "#a8bcf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49469,
    stopColor: "#bbcbf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55172,
    stopColor: "#d3ddfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56061,
    stopColor: "#d8e1fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58171,
    stopColor: "#cfdafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67642,
    stopColor: "#adc0f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7667,
    stopColor: "#95adf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84987,
    stopColor: "#87a1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91919,
    stopColor: "#829ef4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_46",
    "data-name": "New Gradient Swatch copy 46",
    x1: 4820.93602,
    y1: 783.91881,
    x2: 4683.75319,
    y2: 903.07632,
    gradientTransform: "translate(5661.3487) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92abf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15233,
    stopColor: "#95adf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29464,
    stopColor: "#a0b6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43254,
    stopColor: "#b3c4f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5202,
    stopColor: "#c4d1fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67817,
    stopColor: "#d3ddfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98462,
    stopColor: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 957.64303,
    y1: 901.50102,
    x2: 890.08136,
    y2: 808.20148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#295aec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68687,
    stopColor: "#5078ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6789f1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_45",
    "data-name": "New Gradient Swatch copy 45",
    x1: 876.3778,
    y1: 799.46051,
    x2: 971.46309,
    y2: 911.56378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#557bef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10717,
    stopColor: "#4361bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22852,
    stopColor: "#31478b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35298,
    stopColor: "#223160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47824,
    stopColor: "#151f3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60465,
    stopColor: "#0c1122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73258,
    stopColor: "#05070f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86304,
    stopColor: "#010103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 1970.34095,
    y1: 917.04146,
    x2: 1902.90743,
    y2: 809.29189,
    gradientTransform: "translate(-985.5782)",
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-17",
    "data-name": "Radial Gradient 1",
    cx: 1951.09975,
    cy: 850.84293,
    fx: 1951.09975,
    fy: 850.84293,
    r: 11.46023,
    gradientTransform: "translate(-985.5782)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 845.83738,
    cy: 7587.91457,
    fx: 845.83738,
    fy: 7587.91457,
    r: 5.37304,
    gradientTransform: "translate(5303.89143 -1847.771) rotate(67.65913) scale(.99996 .66382)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5b80f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10887,
    stopColor: "#4764bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23003,
    stopColor: "#344a8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35427,
    stopColor: "#243360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47928,
    stopColor: "#17203d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60544,
    stopColor: "#0d1222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73311,
    stopColor: "#05080f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86331,
    stopColor: "#010203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 1829.34137,
    cy: -2930.71697,
    fx: 1829.34137,
    fy: -2930.71697,
    r: 44.15449,
    gradientTransform: "translate(-1013.0685 2371.42552) scale(1.181 .6022)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19192,
    stopColor: "#9550c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_43",
    "data-name": "New Gradient Swatch copy 43",
    x1: 1154.29689,
    y1: 613.92992,
    x2: 1237.22434,
    y2: 613.92992,
    gradientTransform: "translate(-54.8204)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#c0d1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06258,
    stopColor: "#cad8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15191,
    stopColor: "#e5ecff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22222,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26289,
    stopColor: "#f5f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33092,
    stopColor: "#dbe5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35859,
    stopColor: "#cfdcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39224,
    stopColor: "#c2d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47342,
    stopColor: "#aac1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54851,
    stopColor: "#9cb6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61111,
    stopColor: "#97b3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82073,
    stopColor: "#a1bbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afc5ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_44",
    "data-name": "New Gradient Swatch copy 44",
    x1: 4511.37682,
    y1: 542.28388,
    x2: 4578.12621,
    y2: 613.85558,
    gradientTransform: "translate(5702.0572) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a4bdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16829,
    stopColor: "#aac1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40428,
    stopColor: "#bcceff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58081,
    stopColor: "#cfdcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85511,
    stopColor: "#dee7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9efff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-18",
    "data-name": "Radial Gradient 1",
    cx: 1127.68407,
    cy: 616.48151,
    fx: 1127.68407,
    fy: 616.48151,
    r: 31.0717,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 1157.16679,
    y1: 599.07918,
    x2: 1234.39093,
    y2: 599.07918,
    gradientTransform: "translate(-54.8204)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4678ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21717,
    stopColor: "#5886ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41919,
    stopColor: "#4678ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67613,
    stopColor: "#4a7bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94518,
    stopColor: "#5685ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96465,
    stopColor: "#5886ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 1157.16679,
    y1: 597.22146,
    x2: 1234.39093,
    y2: 597.22146,
    gradientTransform: "translate(-54.8204)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7097ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11332,
    stopColor: "#93b1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25758,
    stopColor: "#c7d7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36995,
    stopColor: "#b2c7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59892,
    stopColor: "#8eadff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78512,
    stopColor: "#789cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90404,
    stopColor: "#7097ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_43-2",
    "data-name": "New Gradient Swatch copy 43",
    y1: 590.87317,
    y2: 590.87317,
    xlinkHref: "#New_Gradient_Swatch_copy_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_44-2",
    "data-name": "New Gradient Swatch copy 44",
    x1: 4511.37682,
    y1: 519.22714,
    y2: 590.79883,
    xlinkHref: "#New_Gradient_Swatch_copy_44"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-19",
    "data-name": "Radial Gradient 1",
    cx: 1127.68407,
    cy: 593.42457,
    fx: 1127.68407,
    fy: 593.42457,
    r: 31.0717,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    y1: 576.02244,
    y2: 576.02244,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    y1: 574.16472,
    y2: 574.16472,
    xlinkHref: "#linear-gradient-67"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_43-3",
    "data-name": "New Gradient Swatch copy 43",
    y1: 568.45685,
    y2: 568.45685,
    xlinkHref: "#New_Gradient_Swatch_copy_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_44-3",
    "data-name": "New Gradient Swatch copy 44",
    x1: 4511.37686,
    y1: 496.81087,
    x2: 4578.1262,
    y2: 568.38252,
    xlinkHref: "#New_Gradient_Swatch_copy_44"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-20",
    "data-name": "Radial Gradient 1",
    cx: 1127.68407,
    cy: 571.00837,
    fx: 1127.68407,
    fy: 571.00837,
    r: 31.0717,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    y1: 553.60601,
    y2: 553.60601,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    y1: 551.74829,
    y2: 551.74829,
    xlinkHref: "#linear-gradient-67"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_43-4",
    "data-name": "New Gradient Swatch copy 43",
    y1: 545.79285,
    y2: 545.79285,
    xlinkHref: "#New_Gradient_Swatch_copy_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_44-4",
    "data-name": "New Gradient Swatch copy 44",
    x1: 4511.3768,
    y1: 474.14677,
    x2: 4578.12622,
    y2: 545.71849,
    xlinkHref: "#New_Gradient_Swatch_copy_44"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-21",
    "data-name": "Radial Gradient 1",
    cx: 1127.68407,
    cy: 548.34437,
    fx: 1127.68407,
    fy: 548.34437,
    r: 31.0717,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 1157.16679,
    y1: 530.94201,
    x2: 1234.39093,
    y2: 530.94201,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 1157.16679,
    y1: 529.08429,
    x2: 1234.39093,
    y2: 529.08429,
    xlinkHref: "#linear-gradient-67"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_43-5",
    "data-name": "New Gradient Swatch copy 43",
    y1: 523.12874,
    y2: 523.12874,
    xlinkHref: "#New_Gradient_Swatch_copy_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_44-5",
    "data-name": "New Gradient Swatch copy 44",
    x1: 4511.37686,
    y1: 451.48277,
    x2: 4578.1262,
    y2: 523.05442,
    xlinkHref: "#New_Gradient_Swatch_copy_44"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-22",
    "data-name": "Radial Gradient 1",
    cx: 1127.68407,
    cy: 525.68037,
    fx: 1127.68407,
    fy: 525.68037,
    r: 31.0717,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 1826.82464,
    cy: -3103.02578,
    fx: 1826.82464,
    fy: -3103.02578,
    r: 18.04642,
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_43-6",
    "data-name": "New Gradient Swatch copy 43",
    x1: 1179.3271,
    y1: 504.65518,
    x2: 1212.51239,
    y2: 504.65518,
    xlinkHref: "#New_Gradient_Swatch_copy_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_44-6",
    "data-name": "New Gradient Swatch copy 44",
    x1: 4541.05321,
    y1: 475.24131,
    x2: 4567.76448,
    y2: 503.88234,
    xlinkHref: "#New_Gradient_Swatch_copy_44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 1153.52775,
    y1: 496.51365,
    x2: 1127.4774,
    y2: 496.51365,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_43-7",
    "data-name": "New Gradient Swatch copy 43",
    x1: 1153.52775,
    y1: 494.8882,
    x2: 1127.4774,
    y2: 494.8882,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#New_Gradient_Swatch_copy_43"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-23",
    "data-name": "Radial Gradient 1",
    cx: 1135.79463,
    cy: 504.93316,
    fx: 1135.79463,
    fy: 504.93316,
    r: 12.43408,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 480.25812,
    y1: 208.14984,
    x2: 353.30099,
    y2: 107.49923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3bd961"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_40",
    "data-name": "New Gradient Swatch copy 40",
    x1: 424.2502,
    y1: 111.8789,
    x2: 445.6609,
    y2: 85.50719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09596,
    stopColor: "#6ca6ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81b3f0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_39",
    "data-name": "New Gradient Swatch copy 39",
    x1: 461.85342,
    y1: 165.44978,
    x2: 498.40013,
    y2: 247.4572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afcef5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18915,
    stopColor: "#b5d2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45439,
    stopColor: "#c7ddf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58081,
    stopColor: "#d3e5fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85511,
    stopColor: "#e2eefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edf4fd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_39-2",
    "data-name": "New Gradient Swatch copy 39",
    x1: 391.78594,
    y1: 124.34752,
    x2: 438.40923,
    y2: 149.90064,
    xlinkHref: "#New_Gradient_Swatch_copy_39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_40-2",
    "data-name": "New Gradient Swatch copy 40",
    x1: 442.43177,
    y1: 162.73084,
    x2: 512.77336,
    y2: 127.72509,
    xlinkHref: "#New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_39-3",
    "data-name": "New Gradient Swatch copy 39",
    x1: 367.94701,
    y1: 109.27276,
    x2: 385.53161,
    y2: 201.97036,
    xlinkHref: "#New_Gradient_Swatch_copy_39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_40-3",
    "data-name": "New Gradient Swatch copy 40",
    x1: 378.88046,
    y1: 202.58238,
    x2: 396.11572,
    y2: 82.86698,
    xlinkHref: "#New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_39-4",
    "data-name": "New Gradient Swatch copy 39",
    x1: 404.44609,
    y1: 161.31741,
    x2: 479.1173,
    y2: 117.95364,
    xlinkHref: "#New_Gradient_Swatch_copy_39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_39-5",
    "data-name": "New Gradient Swatch copy 39",
    x1: 385.10691,
    y1: 154.31384,
    x2: 434.36721,
    y2: 105.22827,
    xlinkHref: "#New_Gradient_Swatch_copy_39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_41",
    "data-name": "New Gradient Swatch copy 41",
    x1: 337.28143,
    y1: 153.74282,
    x2: 380.42852,
    y2: 144.07062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8dbaf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afcef5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_41-2",
    "data-name": "New Gradient Swatch copy 41",
    x1: 372.58148,
    y1: 122.95094,
    x2: 354.06521,
    y2: 146.35828,
    xlinkHref: "#New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_40-4",
    "data-name": "New Gradient Swatch copy 40",
    x1: 337.28143,
    y1: 153.74282,
    x2: 380.42852,
    y2: 144.07062,
    xlinkHref: "#New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_39-6",
    "data-name": "New Gradient Swatch copy 39",
    x1: 349.2567,
    y1: 145.00179,
    x2: 394.62514,
    y2: 154.46876,
    xlinkHref: "#New_Gradient_Swatch_copy_39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_41-3",
    "data-name": "New Gradient Swatch copy 41",
    x1: 352.12974,
    y1: 167.19331,
    x2: 395.27613,
    y2: 157.52127,
    xlinkHref: "#New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_41-4",
    "data-name": "New Gradient Swatch copy 41",
    x1: 357.48631,
    y1: 142.44862,
    x2: 377.63282,
    y2: 168.06848,
    xlinkHref: "#New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_41-5",
    "data-name": "New Gradient Swatch copy 41",
    x1: 376.49748,
    y1: 176.04389,
    x2: 419.64457,
    y2: 166.3717,
    xlinkHref: "#New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_41-6",
    "data-name": "New Gradient Swatch copy 41",
    x1: 411.48789,
    y1: 132.09495,
    x2: 389.47799,
    y2: 176.2313,
    xlinkHref: "#New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_41-7",
    "data-name": "New Gradient Swatch copy 41",
    x1: 357.20597,
    y1: 136.97196,
    x2: 389.97459,
    y2: 129.62628,
    xlinkHref: "#New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_40-5",
    "data-name": "New Gradient Swatch copy 40",
    x1: 376.49748,
    y1: 176.04389,
    x2: 419.64457,
    y2: 166.3717,
    xlinkHref: "#New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_41-8",
    "data-name": "New Gradient Swatch copy 41",
    x1: 360.54279,
    y1: 133.63825,
    x2: 378.36003,
    y2: 127.58273,
    xlinkHref: "#New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_40-6",
    "data-name": "New Gradient Swatch copy 40",
    x1: 357.20597,
    y1: 136.97196,
    x2: 389.97459,
    y2: 129.62628,
    xlinkHref: "#New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_40-7",
    "data-name": "New Gradient Swatch copy 40",
    x1: 352.12974,
    y1: 167.19331,
    x2: 395.27613,
    y2: 157.52127,
    xlinkHref: "#New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_40-8",
    "data-name": "New Gradient Swatch copy 40",
    x1: 416.55899,
    y1: 170.52714,
    x2: 453.80206,
    y2: 159.37528,
    xlinkHref: "#New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_41-9",
    "data-name": "New Gradient Swatch copy 41",
    x1: 420.48715,
    y1: 141.65717,
    x2: 441.81622,
    y2: 135.27051,
    xlinkHref: "#New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_40-9",
    "data-name": "New Gradient Swatch copy 40",
    x1: 420.48715,
    y1: 141.65717,
    x2: 441.81622,
    y2: 135.27051,
    xlinkHref: "#New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_40-10",
    "data-name": "New Gradient Swatch copy 40",
    x1: 391.57555,
    y1: 182.34048,
    x2: 384.12247,
    y2: 95.69897,
    xlinkHref: "#New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_39-7",
    "data-name": "New Gradient Swatch copy 39",
    x1: 426.64307,
    y1: 189.43354,
    x2: 429.87565,
    y2: 196.68714,
    xlinkHref: "#New_Gradient_Swatch_copy_39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_39-8",
    "data-name": "New Gradient Swatch copy 39",
    x1: 395.10627,
    y1: 130.13996,
    x2: 410.71116,
    y2: 199.19719,
    xlinkHref: "#New_Gradient_Swatch_copy_39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_39-9",
    "data-name": "New Gradient Swatch copy 39",
    x1: 448.47112,
    y1: 138.20533,
    x2: 418.75659,
    y2: 194.83511,
    xlinkHref: "#New_Gradient_Swatch_copy_39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 428.40191,
    y1: 163.70982,
    x2: 418.09511,
    y2: 169.99872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0202,
    stopColor: "#6ca6ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29293,
    stopColor: "#63a1ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#579aea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#579aea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 404.84151,
    y1: 134.04681,
    x2: 391.91517,
    y2: 123.79891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85e89d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_39-10",
    "data-name": "New Gradient Swatch copy 39",
    x1: 424.21527,
    y1: 161.5155,
    x2: 423.40012,
    y2: 195.28715,
    xlinkHref: "#New_Gradient_Swatch_copy_39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 3.03718,
    y1: 97.31772,
    x2: 53.53327,
    y2: 184.7795,
    gradientTransform: "translate(933.61448)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05556,
    stopColor: "#94b1f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28223,
    stopColor: "#96b2f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39381,
    stopColor: "#9db7fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4801,
    stopColor: "#aac0fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49495,
    stopColor: "#aec3fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5077,
    stopColor: "#b2c6fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52162,
    stopColor: "#bfd0fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53609,
    stopColor: "#d5e0fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55085,
    stopColor: "#f3f6fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55556,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56668,
    stopColor: "#e3ebfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57941,
    stopColor: "#cbd9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59119,
    stopColor: "#bdcefd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60101,
    stopColor: "#b8cbfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64598,
    stopColor: "#a1cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70798,
    stopColor: "#89d2fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76532,
    stopColor: "#7bd4fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81313,
    stopColor: "#76d5fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95b2fb"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 68.34432,
    cy: 126.93021,
    fx: 68.34432,
    fy: 126.93021,
    r: 54.58218,
    gradientTransform: "translate(933.61448)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7be1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f0dc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_37",
    "data-name": "New Gradient Swatch copy 37",
    x1: 898.83588,
    y1: 207.85307,
    x2: 1007.77039,
    y2: 149.75463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#87c0fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15379,
    stopColor: "#8ac0fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29745,
    stopColor: "#95c3fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43665,
    stopColor: "#a8c7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5202,
    stopColor: "#b8cbfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65541,
    stopColor: "#c7d6fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91762,
    stopColor: "#f0f4fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_33",
    "data-name": "New Gradient Swatch copy 33",
    x1: 12.10001,
    y1: 163.26584,
    x2: 66.97634,
    y2: 163.26584,
    gradientTransform: "translate(933.61448)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0086f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d93f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 11.14845,
    y1: 109.13165,
    x2: 81.6108,
    y2: 243.49018,
    gradientTransform: "translate(933.61448)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#1428f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42929,
    stopColor: "#23b6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90404,
    stopColor: "#0042f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 6421.88442,
    y1: 717.99327,
    x2: 6502.03298,
    y2: 717.99327,
    gradientTransform: "translate(6646.9269) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05556,
    stopColor: "#6d92f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28223,
    stopColor: "#6f93f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39381,
    stopColor: "#7699f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4801,
    stopColor: "#83a2f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49495,
    stopColor: "#87a5f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.50527,
    stopColor: "#8ba8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51655,
    stopColor: "#98b2f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52827,
    stopColor: "#aec2fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54031,
    stopColor: "#ccd9fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55246,
    stopColor: "#f3f6fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55556,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56372,
    stopColor: "#dfe7fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57418,
    stopColor: "#bdcefc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58416,
    stopColor: "#a5bbfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59335,
    stopColor: "#97b0fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60101,
    stopColor: "#92adfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65159,
    stopColor: "#77b2f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7115,
    stopColor: "#5fb7ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76693,
    stopColor: "#51b9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81313,
    stopColor: "#4cbbe8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e95f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_32",
    "data-name": "New Gradient Swatch copy 32",
    x1: 6444.69663,
    y1: 723.14687,
    x2: 6481.02819,
    y2: 703.04855,
    gradientTransform: "translate(6646.9269) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#61a9f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15379,
    stopColor: "#64a9f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29745,
    stopColor: "#6faaf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43665,
    stopColor: "#82abf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5202,
    stopColor: "#92adfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61456,
    stopColor: "#a1b8fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79834,
    stopColor: "#cad7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1",
    "data-name": "New Gradient Swatch 1",
    x1: 6463.96474,
    y1: 713.6458,
    x2: 6471.09703,
    y2: 701.68753,
    gradientTransform: "translate(6646.9269) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 7210.95539,
    cy: 2571.73139,
    fx: 7210.95539,
    fy: 2571.73139,
    r: 15.60596,
    gradientTransform: "translate(7495.01523 1900.7956) rotate(-157.65913) scale(.99996 -.66382)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01522,
    stopColor: "rgba(1, 158, 255, .96852)",
    stopOpacity: 0.96852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13197,
    stopColor: "rgba(10, 162, 255, .74446)",
    stopOpacity: 0.74446
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25201,
    stopColor: "rgba(19, 165, 255, .54585)",
    stopOpacity: 0.54585
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37271,
    stopColor: "rgba(26, 167, 255, .3782)",
    stopOpacity: 0.3782
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49421,
    stopColor: "rgba(31, 170, 255, .24141)",
    stopOpacity: 0.24141
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61671,
    stopColor: "rgba(36, 171, 255, .13541)",
    stopOpacity: 0.13541
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74074,
    stopColor: "rgba(39, 173, 255, .05992)",
    stopOpacity: 0.05992
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86723,
    stopColor: "rgba(41, 173, 255, .01485)",
    stopOpacity: 0.01485
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2aaeff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_32-2",
    "data-name": "New Gradient Swatch copy 32",
    x1: 305.11132,
    y1: 550.50053,
    x2: 108.64594,
    y2: 721.15107,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#New_Gradient_Swatch_copy_32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 6511.19828,
    y1: 728.64714,
    x2: 6418.91475,
    y2: 585.58057,
    gradientTransform: "translate(6646.9269) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0088c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68687,
    stopColor: "#0faaf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2413f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 6548.84275,
    y1: 740.94873,
    x2: 6452.30219,
    y2: 586.69007,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-24",
    "data-name": "Radial Gradient 1",
    cx: 6521.72762,
    cy: 646.27683,
    fx: 6521.72762,
    fy: 646.27683,
    r: 16.43274,
    gradientTransform: "translate(6646.9269) rotate(-180) scale(1 -1)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 2393.39271,
    cy: 1101.97849,
    fx: 2393.39271,
    fy: 1101.97849,
    r: 9.88614,
    gradientTransform: "translate(524.41656 -1779.16542) rotate(112.34087) scale(.99996 -.50001)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 1298.2107,
    cy: -2273.58339,
    fx: 1298.2107,
    fy: -2273.58339,
    r: 33.55439,
    gradientTransform: "translate(-1140.1603 2371.42552) scale(1.2106 .6022)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e8e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_29",
    "data-name": "New Gradient Swatch copy 29",
    x1: 7623.98094,
    y1: 1005.32217,
    x2: 7677.86482,
    y2: 1005.32217,
    gradientTransform: "translate(8072.179) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#cacce9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06998,
    stopColor: "#d4d5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17194,
    stopColor: "#efeff8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22222,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26801,
    stopColor: "#f5f5fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34462,
    stopColor: "#dbdcf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35859,
    stopColor: "#d6d7ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4006,
    stopColor: "#b9c6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45965,
    stopColor: "#97b2e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51597,
    stopColor: "#7fa3e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56786,
    stopColor: "#719be2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61111,
    stopColor: "#6c98e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69425,
    stopColor: "#769de2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8399,
    stopColor: "#93abe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bbbee2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28",
    "data-name": "New Gradient Swatch copy 28",
    x1: 7618.94792,
    y1: 960.53372,
    x2: 7662.31975,
    y2: 1007.03894,
    gradientTransform: "translate(8072.179) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7fa5e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10593,
    stopColor: "#85a8e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25482,
    stopColor: "#97b3e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42829,
    stopColor: "#b5c4eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58081,
    stopColor: "#d6d7ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88492,
    stopColor: "#e5e6f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edeef7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_29-2",
    "data-name": "New Gradient Swatch copy 29",
    x1: 7626.26701,
    y1: 982.97484,
    x2: 7675.60759,
    y2: 982.97484,
    xlinkHref: "#New_Gradient_Swatch_copy_29"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-25",
    "data-name": "Radial Gradient 1",
    cx: 7651.09515,
    cy: 959.07532,
    fx: 7651.09515,
    fy: 959.07532,
    r: 20.51152,
    gradientTransform: "translate(8072.179) rotate(-180) scale(1 -1)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-2",
    "data-name": "New Gradient Swatch copy 28",
    x1: 7621.65836,
    y1: 926.82268,
    x2: 7661.37327,
    y2: 969.40679,
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 3981.42998,
    cy: 13138.69813,
    fx: 3981.42998,
    fy: 13138.69813,
    r: 8.38095,
    gradientTransform: "translate(6442.50098 7550.02049) rotate(-90.48928) scale(1.66286 -.45282)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#763ddc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07112,
    stopColor: "#6534bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19744,
    stopColor: "#4a268b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3269,
    stopColor: "#331a60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45721,
    stopColor: "#21113d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58868,
    stopColor: "#120922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72176,
    stopColor: "#08040f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8575,
    stopColor: "#020103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_29-3",
    "data-name": "New Gradient Swatch copy 29",
    x1: 7698.5258,
    y1: 864.51018,
    x2: 7705.20659,
    y2: 875.61208,
    xlinkHref: "#New_Gradient_Swatch_copy_29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_29-4",
    "data-name": "New Gradient Swatch copy 29",
    x1: 7692.37632,
    y1: 865.52412,
    x2: 7701.50205,
    y2: 880.68891,
    xlinkHref: "#New_Gradient_Swatch_copy_29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-3",
    "data-name": "New Gradient Swatch copy 28",
    x1: 7621.37728,
    y1: 981.8143,
    x2: 7666.33577,
    y2: 868.33966,
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-4",
    "data-name": "New Gradient Swatch copy 28",
    x1: 7734.24271,
    y1: 1430.96381,
    x2: 7802.74971,
    y2: 1410.45047,
    gradientTransform: "translate(6013.30035 -1064.53543) rotate(178.29951) scale(.78855 -1.26819) skewX(-22.16934)",
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 7651.19844,
    y1: 906.20916,
    x2: 7647.58772,
    y2: 952.11639,
    gradientTransform: "translate(8072.179) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#cacce9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19544,
    stopColor: "#d4d5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51103,
    stopColor: "#efeff8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66667,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-26",
    "data-name": "Radial Gradient 1",
    cx: 7636.4699,
    cy: 865.8985,
    fx: 7636.4699,
    fy: 865.8985,
    r: 27.83012,
    gradientTransform: "translate(8072.179) rotate(-180) scale(1 -1)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-5",
    "data-name": "New Gradient Swatch copy 28",
    x1: 7655.98137,
    y1: 957.46972,
    x2: 7694.51729,
    y2: 945.93075,
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-6",
    "data-name": "New Gradient Swatch copy 28",
    x1: 7619.49801,
    y1: 962.13948,
    x2: 7669.92373,
    y2: 950.83565,
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-7",
    "data-name": "New Gradient Swatch copy 28",
    x1: 7663.97188,
    y1: 921.10224,
    x2: 7647.31348,
    y2: 952.84971,
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-8",
    "data-name": "New Gradient Swatch copy 28",
    x1: -1746.67386,
    y1: 912.13462,
    x2: -1650.31552,
    y2: 883.28163,
    gradientTransform: "translate(2193.2619)",
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_30",
    "data-name": "New Gradient Swatch copy 30",
    x1: -1747.26188,
    y1: 876.55677,
    x2: -1711.47007,
    y2: 937.70124,
    gradientTransform: "translate(2193.2619)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7fa5e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11731,
    stopColor: "#82a7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22689,
    stopColor: "#8eade7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33342,
    stopColor: "#a0b8e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43742,
    stopColor: "#bbc7eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5202,
    stopColor: "#d6d7ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73466,
    stopColor: "#e5e6f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-27",
    "data-name": "Radial Gradient 1",
    cx: -1724.96156,
    cy: 907.74708,
    fx: -1724.96156,
    fy: 907.74708,
    r: 26.45478,
    gradientTransform: "translate(2193.2619)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-9",
    "data-name": "New Gradient Swatch copy 28",
    x1: 7571.88697,
    y1: 956.29125,
    x2: 7585.8549,
    y2: 921.03637,
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-10",
    "data-name": "New Gradient Swatch copy 28",
    x1: 7661.44199,
    y1: 1448.20779,
    x2: 7689.43608,
    y2: 1439.8254,
    gradientTransform: "translate(6013.30035 -1064.53543) rotate(178.29951) scale(.78855 -1.26819) skewX(-22.16934)",
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-28",
    "data-name": "Radial Gradient 1",
    cx: 7576.24237,
    cy: 920.78938,
    fx: 7576.24237,
    fy: 920.78938,
    r: 8.67959,
    gradientTransform: "translate(8072.179) rotate(-180) scale(1 -1)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_31",
    "data-name": "New Gradient Swatch copy 31",
    x1: -1753.42527,
    y1: 975.32114,
    x2: -1751.77085,
    y2: 975.32114,
    gradientTransform: "translate(2241.584)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#487fdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55909,
    stopColor: "#4ab8a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ce97b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_29-5",
    "data-name": "New Gradient Swatch copy 29",
    x1: 8268.80824,
    y1: 964.4018,
    x2: 8275.11296,
    y2: 964.4018,
    gradientTransform: "translate(8760.972) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_29-6",
    "data-name": "New Gradient Swatch copy 29",
    x1: 8266.28409,
    y1: 952.83494,
    x2: 8277.60501,
    y2: 952.83494,
    gradientTransform: "translate(8760.972) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-11",
    "data-name": "New Gradient Swatch copy 28",
    x1: -1759.34692,
    y1: 937.36645,
    x2: -1750.23451,
    y2: 947.13719,
    gradientTransform: "translate(2241.584)",
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_29-7",
    "data-name": "New Gradient Swatch copy 29",
    x1: 7587.00716,
    y1: 944.55971,
    x2: 7579.06414,
    y2: 944.55971,
    xlinkHref: "#New_Gradient_Swatch_copy_29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 7583.18788,
    y1: 947.01556,
    x2: 7583.18788,
    y2: 942.54808,
    xlinkHref: "#linear-gradient-83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-12",
    "data-name": "New Gradient Swatch copy 28",
    x1: -2068.71757,
    y1: 951.45582,
    x2: -2059.71313,
    y2: 948.75959,
    gradientTransform: "translate(2549.4001)",
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-13",
    "data-name": "New Gradient Swatch copy 28",
    x1: 7673.59305,
    y1: 889.20173,
    x2: 7757.78588,
    y2: 863.99152,
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-14",
    "data-name": "New Gradient Swatch copy 28",
    x1: 7624.18843,
    y1: 899.3933,
    x2: 7684.52305,
    y2: 885.86821,
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-15",
    "data-name": "New Gradient Swatch copy 28",
    x1: 7706.79347,
    y1: 805.43014,
    x2: 7668.87021,
    y2: 877.70406,
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-16",
    "data-name": "New Gradient Swatch copy 28",
    x1: 7649.22741,
    y1: 902.054,
    x2: 7691.55049,
    y2: 889.38102,
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-17",
    "data-name": "New Gradient Swatch copy 28",
    x1: 7613.65041,
    y1: 907.3216,
    x2: 7662.29586,
    y2: 896.41685,
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-18",
    "data-name": "New Gradient Swatch copy 28",
    x1: 7661.91653,
    y1: 858.22334,
    x2: 7644.39616,
    y2: 891.61356,
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 7638.02693,
    y1: 901.5386,
    x2: 7642.75899,
    y2: 896.45602,
    gradientTransform: "translate(8072.179) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#868acc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bbbee2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_29-8",
    "data-name": "New Gradient Swatch copy 29",
    x1: 7610.2772,
    y1: 908.44095,
    x2: 7619.86317,
    y2: 924.37056,
    xlinkHref: "#New_Gradient_Swatch_copy_29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 7636.19028,
    y1: 920.14803,
    x2: 7580.69165,
    y2: 908.96228,
    xlinkHref: "#linear-gradient-83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-19",
    "data-name": "New Gradient Swatch copy 28",
    x1: 5403.18088,
    y1: 932.50339,
    x2: 5431.97885,
    y2: 926.04781,
    gradientTransform: "translate(5899.7931) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_29-9",
    "data-name": "New Gradient Swatch copy 29",
    x1: 7592.49845,
    y1: 933.94239,
    x2: 7586.79853,
    y2: 924.62225,
    xlinkHref: "#New_Gradient_Swatch_copy_29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 7591.84596,
    y1: 927.96483,
    x2: 7586.45416,
    y2: 931.35397,
    xlinkHref: "#linear-gradient-83"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 5420.15129,
    cy: 926.98871,
    fx: 5420.15129,
    fy: 926.98871,
    r: 5.49384,
    gradientTransform: "translate(5899.7931) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01522,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13197,
    stopColor: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25201,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37271,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49421,
    stopColor: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61671,
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74074,
    stopColor: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86723,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 4247.68366,
    cy: 4331.14505,
    fx: 4247.68366,
    fy: 4331.14505,
    r: 4.39369,
    gradientTransform: "translate(16067.58831 7731.18377) rotate(-149.78895) scale(3.98043 -.45278)",
    xlinkHref: "#radial-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-20",
    "data-name": "New Gradient Swatch copy 28",
    x1: 7641.17565,
    y1: 992.61965,
    x2: 7686.13418,
    y2: 879.14491,
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-21",
    "data-name": "New Gradient Swatch copy 28",
    x1: 7763.02743,
    y1: 1439.01701,
    x2: 7831.53438,
    y2: 1418.50369,
    gradientTransform: "translate(6013.30035 -1064.53543) rotate(178.29951) scale(.78855 -1.26819) skewX(-22.16934)",
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-29",
    "data-name": "Radial Gradient 1",
    cx: 7661.67652,
    cy: 887.21863,
    fx: 7661.67652,
    fy: 887.21863,
    r: 27.88501,
    gradientTransform: "translate(8072.179) rotate(-180) scale(1 -1)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_29-10",
    "data-name": "New Gradient Swatch copy 29",
    x1: -2526.42766,
    y1: 884.01062,
    x2: -2520.25186,
    y2: 894.27334,
    gradientTransform: "translate(2913.7515)",
    xlinkHref: "#New_Gradient_Swatch_copy_29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-22",
    "data-name": "New Gradient Swatch copy 28",
    x1: -4707.67215,
    y1: 891.55308,
    x2: -4687.56676,
    y2: 887.0461,
    gradientTransform: "translate(5086.1374)",
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: -4695.82417,
    cy: 887.70301,
    fx: -4695.82417,
    fy: 887.70301,
    r: 3.8355,
    gradientTransform: "translate(5086.1374)",
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_29-11",
    "data-name": "New Gradient Swatch copy 29",
    x1: -2504.55229,
    y1: 956.72321,
    x2: -2498.37648,
    y2: 966.98594,
    gradientTransform: "translate(2913.7515)",
    xlinkHref: "#New_Gradient_Swatch_copy_29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-23",
    "data-name": "New Gradient Swatch copy 28",
    x1: -4685.79681,
    y1: 964.26566,
    x2: -4665.69139,
    y2: 959.75867,
    gradientTransform: "translate(5086.1374)",
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: -4673.94881,
    cy: 960.41557,
    fx: -4673.94881,
    fy: 960.41557,
    r: 3.83553,
    gradientTransform: "translate(5086.1374)",
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-24",
    "data-name": "New Gradient Swatch copy 28",
    x1: -2074.75477,
    y1: 932.80928,
    x2: -2065.75004,
    y2: 930.11295,
    gradientTransform: "translate(2549.4001)",
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-25",
    "data-name": "New Gradient Swatch copy 28",
    x1: 7584.57275,
    y1: 963.39825,
    x2: 7598.54068,
    y2: 928.14337,
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-26",
    "data-name": "New Gradient Swatch copy 28",
    x1: 7679.95143,
    y1: 1453.51258,
    x2: 7707.94553,
    y2: 1445.13019,
    gradientTransform: "translate(6013.30035 -1064.53543) rotate(178.29951) scale(.78855 -1.26819) skewX(-22.16934)",
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-30",
    "data-name": "Radial Gradient 1",
    cx: 7588.92816,
    cy: 927.89639,
    fx: 7588.92816,
    fy: 927.89639,
    r: 8.67959,
    gradientTransform: "translate(8072.179) rotate(-180) scale(1 -1)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-27",
    "data-name": "New Gradient Swatch copy 28",
    x1: -1762.1739,
    y1: 921.064,
    x2: -1665.81545,
    y2: 892.21098,
    gradientTransform: "translate(2193.2619)",
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_30-2",
    "data-name": "New Gradient Swatch copy 30",
    x1: -1762.7618,
    y1: 885.48621,
    x2: -1726.97004,
    y2: 946.63058,
    xlinkHref: "#New_Gradient_Swatch_copy_30"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-31",
    "data-name": "Radial Gradient 1",
    cx: -1740.4616,
    cy: 916.67643,
    fx: -1740.4616,
    fy: 916.67643,
    r: 26.45481,
    gradientTransform: "translate(2193.2619)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_29-12",
    "data-name": "New Gradient Swatch copy 29",
    x1: -2442.69634,
    y1: 930.81054,
    x2: -2439.21884,
    y2: 936.58933,
    gradientTransform: "translate(2913.7515)",
    xlinkHref: "#New_Gradient_Swatch_copy_29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-28",
    "data-name": "New Gradient Swatch copy 28",
    x1: -4620.07002,
    y1: 935.05755,
    x2: -4608.74976,
    y2: 932.51991,
    gradientTransform: "translate(5086.1374)",
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: -4613.39896,
    cy: 932.88977,
    fx: -4613.39896,
    fy: 932.88977,
    r: 2.15962,
    gradientTransform: "translate(5086.1374)",
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_29-13",
    "data-name": "New Gradient Swatch copy 29",
    x1: -2434.76261,
    y1: 949.83605,
    x2: -2431.2851,
    y2: 955.61484,
    gradientTransform: "translate(2913.7515)",
    xlinkHref: "#New_Gradient_Swatch_copy_29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-29",
    "data-name": "New Gradient Swatch copy 28",
    x1: -4612.13635,
    y1: 954.08298,
    x2: -4600.81607,
    y2: 951.54533,
    gradientTransform: "translate(5086.1374)",
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: -4605.46527,
    cy: 951.9152,
    fx: -4605.46527,
    fy: 951.9152,
    r: 2.15969,
    gradientTransform: "translate(5086.1374)",
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_29-14",
    "data-name": "New Gradient Swatch copy 29",
    x1: -2498.09071,
    y1: 898.35959,
    x2: -2494.6132,
    y2: 904.13838,
    gradientTransform: "translate(2913.7515)",
    xlinkHref: "#New_Gradient_Swatch_copy_29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_28-30",
    "data-name": "New Gradient Swatch copy 28",
    x1: -4675.46465,
    y1: 902.6066,
    x2: -4664.14378,
    y2: 900.06882,
    gradientTransform: "translate(5086.1374)",
    xlinkHref: "#New_Gradient_Swatch_copy_28"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: -4668.7934,
    cy: 900.43876,
    fx: -4668.7934,
    fy: 900.43876,
    r: 2.15969,
    gradientTransform: "translate(5086.1374)",
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: -7664.78874,
    cy: 11385.25498,
    fx: -7664.78874,
    fy: 11385.25498,
    r: 24.56365,
    gradientTransform: "translate(14735.56111 -64.13934) rotate(-59.56292) scale(1.00002 -1.00002)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08586,
    stopColor: "#6ad7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12626,
    stopColor: "#2a91ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13026,
    stopColor: "rgba(44, 147, 255, .97881)",
    stopOpacity: 0.97881
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16798,
    stopColor: "rgba(68, 165, 255, .79578)",
    stopOpacity: 0.79578
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.20962,
    stopColor: "rgba(89, 182, 255, .62612)",
    stopOpacity: 0.62612
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25484,
    stopColor: "rgba(109, 197, 255, .47554)",
    stopOpacity: 0.47554
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.30381,
    stopColor: "rgba(125, 211, 255, .34619)",
    stopOpacity: 0.34619
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35769,
    stopColor: "rgba(139, 221, 255, .23765)",
    stopOpacity: 0.23765
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41825,
    stopColor: "rgba(150, 230, 255, .14967)",
    stopOpacity: 0.14967
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48839,
    stopColor: "rgba(159, 237, 255, .08214)",
    stopOpacity: 0.08214
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57429,
    stopColor: "rgba(165, 242, 255, .03482)",
    stopOpacity: 0.03482
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69274,
    stopColor: "rgba(169, 245, 255, .0076)",
    stopOpacity: 0.0076
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aaf6ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: -7664.78877,
    cy: 11406.14383,
    fx: -7664.78877,
    fy: 11406.14383,
    r: 21.49319,
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: -7664.78866,
    cy: 11424.94376,
    fx: -7664.78866,
    fy: 11424.94376,
    r: 18.42275,
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: -7664.78864,
    cy: 11440.26227,
    fx: -7664.78864,
    fy: 11440.26227,
    r: 15.35231,
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: -7664.78872,
    cy: 11453.49172,
    fx: -7664.78872,
    fy: 11453.49172,
    r: 12.28185,
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: -7803.63147,
    cy: 11576.70481,
    fx: -7803.63147,
    fy: 11576.70481,
    r: 24.56368,
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: -7803.6314,
    cy: 11597.59351,
    fx: -7803.6314,
    fy: 11597.59351,
    r: 21.49329,
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-25",
    cx: -7803.63145,
    cy: 11616.39344,
    fx: -7803.63145,
    fy: 11616.39344,
    r: 18.42267,
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-26",
    cx: -7803.63137,
    cy: 11631.71186,
    fx: -7803.63137,
    fy: 11631.71186,
    r: 15.35231,
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-27",
    cx: -7803.63124,
    cy: 11644.94149,
    fx: -7803.63124,
    fy: 11644.94149,
    r: 12.28185,
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-28",
    cx: -7769.64542,
    cy: 4496.38986,
    fx: -7769.64542,
    fy: 4496.38986,
    r: 24.56341,
    gradientTransform: "translate(2674.86801 -8216.32818) rotate(-44.87304)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-29",
    cx: -7769.64614,
    cy: 4517.27843,
    fx: -7769.64614,
    fy: 4517.27843,
    r: 21.49305,
    gradientTransform: "translate(474.41726 -8524.00872) rotate(-59.09029)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-30",
    cx: -7769.64677,
    cy: 4536.07816,
    fx: -7769.64677,
    fy: 4536.07816,
    r: 18.42259,
    gradientTransform: "translate(474.41726 -8524.00872) rotate(-59.09029)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-31",
    cx: -7769.64738,
    cy: 4551.39656,
    fx: -7769.64738,
    fy: 4551.39656,
    r: 15.35212,
    gradientTransform: "translate(474.41726 -8524.00872) rotate(-59.09029)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-32",
    cx: -7769.64776,
    cy: 4564.62592,
    fx: -7769.64776,
    fy: 4564.62592,
    r: 12.28175,
    gradientTransform: "translate(474.41726 -8524.00872) rotate(-59.09029)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-33",
    cx: -4393.68357,
    cy: 5408.911,
    fx: -4393.68357,
    fy: 5408.911,
    r: 24.56451,
    gradientTransform: "translate(-6300.96085 -245.75273) rotate(-119.44639)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-34",
    cx: -4393.68425,
    cy: 5429.80045,
    fx: -4393.68425,
    fy: 5429.80045,
    r: 21.4939,
    gradientTransform: "translate(-107.51571 -6039.03728) rotate(-44.68771)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-35",
    cx: -4393.68481,
    cy: 5448.60097,
    fx: -4393.68481,
    fy: 5448.60097,
    r: 18.42334,
    gradientTransform: "translate(-6300.96085 -245.75273) rotate(-119.44639)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-36",
    cx: -4393.6853,
    cy: 5463.92005,
    fx: -4393.6853,
    fy: 5463.92005,
    r: 15.35283,
    gradientTransform: "translate(-6300.96085 -245.75273) rotate(-119.44639)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-37",
    cx: -4393.68567,
    cy: 5477.15009,
    fx: -4393.68567,
    fy: 5477.15009,
    r: 12.28228,
    gradientTransform: "translate(-6300.96085 -245.75273) rotate(-119.44639)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-38",
    cx: -4160.86193,
    cy: 5339.89544,
    fx: -4160.86193,
    fy: 5339.89544,
    r: 24.56451,
    gradientTransform: "translate(-411.63999 -5968.85439) rotate(-44.76511)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-39",
    cx: -4160.86251,
    cy: 5360.78505,
    fx: -4160.86251,
    fy: 5360.78505,
    r: 21.49403,
    gradientTransform: "translate(-6300.96085 -245.75273) rotate(-119.44639)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-40",
    cx: -4160.86308,
    cy: 5379.58566,
    fx: -4160.86308,
    fy: 5379.58566,
    r: 18.42342,
    gradientTransform: "translate(-6300.96085 -245.75273) rotate(-119.44639)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-41",
    cx: -4160.86346,
    cy: 5394.90459,
    fx: -4160.86346,
    fy: 5394.90459,
    r: 15.35278,
    gradientTransform: "translate(-6300.96085 -245.75273) rotate(-119.44639)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-42",
    cx: -4160.86392,
    cy: 5408.13458,
    fx: -4160.86392,
    fy: 5408.13458,
    r: 12.28225,
    gradientTransform: "translate(-6300.96085 -245.75273) rotate(-119.44639)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-43",
    cx: -7414.10107,
    cy: 3684.67883,
    fx: -7414.10107,
    fy: 3684.67883,
    r: 24.56331,
    gradientTransform: "translate(8014.36993 -3181.81233) rotate(2.17109)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-44",
    cx: -7414.10028,
    cy: 3705.56725,
    fx: -7414.10028,
    fy: 3705.56725,
    r: 21.49288,
    gradientTransform: "translate(1093.68945 -8036.19235) rotate(-59.22392)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-45",
    cx: -7414.09974,
    cy: 3724.36698,
    fx: -7414.09974,
    fy: 3724.36698,
    r: 18.4225,
    gradientTransform: "translate(1093.68945 -8036.19235) rotate(-59.22392)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-46",
    cx: -7414.09924,
    cy: 3739.68524,
    fx: -7414.09924,
    fy: 3739.68524,
    r: 15.35206,
    gradientTransform: "translate(1093.68945 -8036.19235) rotate(-59.22392)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-47",
    cx: -7414.09884,
    cy: 3752.91449,
    fx: -7414.09884,
    fy: 3752.91449,
    r: 12.28163,
    gradientTransform: "translate(1093.68945 -8036.19235) rotate(-59.22392)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-48",
    cx: -3996.52204,
    cy: 9779.51673,
    fx: -3996.52204,
    fy: 9779.51673,
    r: 24.56335,
    gradientTransform: "translate(7520.58775 -8036.19235) rotate(-120.77608) scale(1.00003 -1.00003)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-49",
    cx: -3996.52144,
    cy: 9800.40518,
    fx: -3996.52144,
    fy: 9800.40518,
    r: 21.49291,
    gradientTransform: "translate(11616.56978 1953.69732) rotate(-59.442) scale(1.00003 -1.00003)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-50",
    cx: -3996.52095,
    cy: 9819.20493,
    fx: -3996.52095,
    fy: 9819.20493,
    r: 18.42244,
    gradientTransform: "translate(7520.58775 -8036.19235) rotate(-120.77608) scale(1.00003 -1.00003)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-51",
    cx: -3996.52051,
    cy: 9834.52303,
    fx: -3996.52051,
    fy: 9834.52303,
    r: 15.35207,
    gradientTransform: "translate(7520.58775 -8036.19235) rotate(-120.77608) scale(1.00003 -1.00003)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-52",
    cx: -3996.51999,
    cy: 9847.75249,
    fx: -3996.51999,
    fy: 9847.75249,
    r: 12.28163,
    gradientTransform: "translate(7520.58775 -8036.19235) rotate(-120.77608) scale(1.00003 -1.00003)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-53",
    cx: -3878.86402,
    cy: 9951.17399,
    fx: -3878.86402,
    fy: 9951.17399,
    r: 24.56328,
    gradientTransform: "translate(7520.58775 -8036.19235) rotate(-120.77608) scale(1.00003 -1.00003)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-54",
    cx: -3878.86333,
    cy: 9972.06234,
    fx: -3878.86333,
    fy: 9972.06234,
    r: 21.49292,
    gradientTransform: "translate(7520.58775 -8036.19235) rotate(-120.77608) scale(1.00003 -1.00003)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-55",
    cx: -3878.86269,
    cy: 9990.86207,
    fx: -3878.86269,
    fy: 9990.86207,
    r: 18.4225,
    gradientTransform: "translate(7520.58775 -8036.19235) rotate(-120.77608) scale(1.00003 -1.00003)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-56",
    cx: -3878.86219,
    cy: 10006.18024,
    fx: -3878.86219,
    fy: 10006.18024,
    r: 15.35211,
    gradientTransform: "translate(7520.58775 -8036.19235) rotate(-120.77608) scale(1.00003 -1.00003)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-57",
    cx: -3878.86199,
    cy: 10019.40964,
    fx: -3878.86199,
    fy: 10019.40964,
    r: 12.28166,
    gradientTransform: "translate(7520.58775 -8036.19235) rotate(-120.77608) scale(1.00003 -1.00003)",
    xlinkHref: "#radial-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18",
    "data-name": "New Gradient Swatch copy 18",
    x1: 1211.83441,
    y1: 264.28358,
    x2: 1295.69586,
    y2: 239.1726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85a7d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1036,
    stopColor: "#8babd8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24923,
    stopColor: "#9db8e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41886,
    stopColor: "#bce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58081,
    stopColor: "#dfe5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95459,
    stopColor: "#eef1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18-2",
    "data-name": "New Gradient Swatch copy 18",
    x1: 1168.60062,
    y1: 274.56216,
    x2: 1253.53635,
    y2: 255.52229,
    xlinkHref: "#New_Gradient_Swatch_copy_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18-3",
    "data-name": "New Gradient Swatch copy 18",
    x1: 1229.57091,
    y1: 182.3237,
    x2: 1215.55968,
    y2: 209.02621,
    xlinkHref: "#New_Gradient_Swatch_copy_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18-4",
    "data-name": "New Gradient Swatch copy 18",
    x1: 1282.93455,
    y1: 314.97279,
    x2: 1295.32852,
    y2: 311.26161,
    xlinkHref: "#New_Gradient_Swatch_copy_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18-5",
    "data-name": "New Gradient Swatch copy 18",
    x1: 1251.75829,
    y1: 316.59991,
    x2: 1298.81249,
    y2: 306.05186,
    xlinkHref: "#New_Gradient_Swatch_copy_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18-6",
    "data-name": "New Gradient Swatch copy 18",
    x1: 1280.61965,
    y1: 297.63214,
    x2: 1276.18054,
    y2: 306.09218,
    xlinkHref: "#New_Gradient_Swatch_copy_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18-7",
    "data-name": "New Gradient Swatch copy 18",
    x1: 1216.29129,
    y1: 315.37468,
    x2: 1260.3667,
    y2: 302.17699,
    xlinkHref: "#New_Gradient_Swatch_copy_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18-8",
    "data-name": "New Gradient Swatch copy 18",
    x1: 1199.4342,
    y1: 320.67919,
    x2: 1217.65701,
    y2: 316.59422,
    xlinkHref: "#New_Gradient_Swatch_copy_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18-9",
    "data-name": "New Gradient Swatch copy 18",
    x1: 1236.17578,
    y1: 272.72631,
    x2: 1216.2548,
    y2: 310.6916,
    xlinkHref: "#New_Gradient_Swatch_copy_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17",
    "data-name": "New Gradient Swatch copy 17",
    x1: 1216.61365,
    y1: 310.7645,
    x2: 1256.44781,
    y2: 298.83679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#064baa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f5db2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-2",
    "data-name": "New Gradient Swatch copy 17",
    x1: 1202.18421,
    y1: 315.54908,
    x2: 1214.78492,
    y2: 312.72441,
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-3",
    "data-name": "New Gradient Swatch copy 17",
    x1: 1236.17569,
    y1: 272.23404,
    x2: 1216.25471,
    y2: 310.19932,
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18-10",
    "data-name": "New Gradient Swatch copy 18",
    x1: 1271.22412,
    y1: 348.70557,
    x2: 1303.63376,
    y2: 339.00102,
    xlinkHref: "#New_Gradient_Swatch_copy_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18-11",
    "data-name": "New Gradient Swatch copy 18",
    x1: 1173.76988,
    y1: 352.96674,
    x2: 1311.33622,
    y2: 322.12878,
    xlinkHref: "#New_Gradient_Swatch_copy_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18-12",
    "data-name": "New Gradient Swatch copy 18",
    x1: 1265.82885,
    y1: 299.70984,
    x2: 1247.33368,
    y2: 334.95782,
    xlinkHref: "#New_Gradient_Swatch_copy_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_22",
    "data-name": "New Gradient Swatch copy 22",
    x1: 1227.37282,
    y1: 239.11545,
    x2: 1242.18671,
    y2: 234.67967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03535,
    stopColor: "#9eb5ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58081,
    stopColor: "#edf0f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7f9fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_22-2",
    "data-name": "New Gradient Swatch copy 22",
    x1: 1209.98354,
    y1: 241.01989,
    x2: 1239.20865,
    y2: 234.46856,
    xlinkHref: "#New_Gradient_Swatch_copy_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_22-3",
    "data-name": "New Gradient Swatch copy 22",
    x1: 1228.02473,
    y1: 223.17501,
    x2: 1225.32319,
    y2: 228.32358,
    xlinkHref: "#New_Gradient_Swatch_copy_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18-13",
    "data-name": "New Gradient Swatch copy 18",
    x1: 1275.87255,
    y1: 349.84322,
    x2: 1319.94853,
    y2: 336.64537,
    xlinkHref: "#New_Gradient_Swatch_copy_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18-14",
    "data-name": "New Gradient Swatch copy 18",
    x1: 1259.01562,
    y1: 355.14772,
    x2: 1277.23837,
    y2: 351.06277,
    xlinkHref: "#New_Gradient_Swatch_copy_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18-15",
    "data-name": "New Gradient Swatch copy 18",
    x1: 1295.75709,
    y1: 307.19491,
    x2: 1275.83611,
    y2: 345.1602,
    xlinkHref: "#New_Gradient_Swatch_copy_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-4",
    "data-name": "New Gradient Swatch copy 17",
    x1: 1276.19492,
    y1: 344.98671,
    x2: 1316.02954,
    y2: 333.05886,
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-5",
    "data-name": "New Gradient Swatch copy 17",
    x1: 1261.76555,
    y1: 349.77129,
    x2: 1274.36636,
    y2: 346.94659,
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-6",
    "data-name": "New Gradient Swatch copy 17",
    x1: 1295.75709,
    y1: 306.45623,
    x2: 1275.83611,
    y2: 344.42152,
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-7",
    "data-name": "New Gradient Swatch copy 17",
    x1: 1224.63881,
    y1: 261.47292,
    x2: 1221.93947,
    y2: 261.47292,
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_27",
    "data-name": "New Gradient Swatch copy 27",
    x1: 1246.29909,
    y1: 272.50828,
    x2: 1244.31895,
    y2: 272.50828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03535,
    stopColor: "#298bf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19018,
    stopColor: "#3893f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48882,
    stopColor: "#60a9f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63131,
    stopColor: "#76b5f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87374,
    stopColor: "#298bf3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-8",
    "data-name": "New Gradient Swatch copy 17",
    x1: 1247.79991,
    y1: 265.20029,
    x2: 1242.64203,
    y2: 265.20029,
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_22-4",
    "data-name": "New Gradient Swatch copy 22",
    x1: 1223.89842,
    y1: 240.95802,
    x2: 1249.69106,
    y2: 233.23482,
    xlinkHref: "#New_Gradient_Swatch_copy_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_22-5",
    "data-name": "New Gradient Swatch copy 22",
    x1: 1211.00534,
    y1: 244.05998,
    x2: 1230.83337,
    y2: 239.61517,
    xlinkHref: "#New_Gradient_Swatch_copy_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_22-6",
    "data-name": "New Gradient Swatch copy 22",
    x1: 1232.43484,
    y1: 215.4665,
    x2: 1223.98354,
    y2: 231.57293,
    xlinkHref: "#New_Gradient_Swatch_copy_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18-16",
    "data-name": "New Gradient Swatch copy 18",
    x1: 1279.82007,
    y1: 249.95121,
    x2: 1297.53771,
    y2: 244.64594,
    xlinkHref: "#New_Gradient_Swatch_copy_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18-17",
    "data-name": "New Gradient Swatch copy 18",
    x1: 1159.07622,
    y1: 252.80436,
    x2: 1337.0177,
    y2: 212.91558,
    xlinkHref: "#New_Gradient_Swatch_copy_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18-18",
    "data-name": "New Gradient Swatch copy 18",
    x1: 1258.64194,
    y1: 210.00842,
    x2: 1248.72523,
    y2: 228.90762,
    xlinkHref: "#New_Gradient_Swatch_copy_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-9",
    "data-name": "New Gradient Swatch copy 17",
    x1: -907.05098,
    y1: 244.52568,
    x2: -855.88326,
    y2: 229.20431,
    gradientTransform: "translate(334.6099) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-10",
    "data-name": "New Gradient Swatch copy 17",
    x1: -918.34261,
    y1: 250.44017,
    x2: -913.70372,
    y2: 249.40028,
    gradientTransform: "translate(334.6099) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-11",
    "data-name": "New Gradient Swatch copy 17",
    x1: -879.79318,
    y1: 196.43959,
    x2: -905.66389,
    y2: 245.74383,
    gradientTransform: "translate(334.6099) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-12",
    "data-name": "New Gradient Swatch copy 17",
    x1: -907.05098,
    y1: 252.24487,
    x2: -855.88326,
    y2: 236.92351,
    gradientTransform: "translate(334.6099) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-13",
    "data-name": "New Gradient Swatch copy 17",
    x1: -918.34256,
    y1: 258.15935,
    x2: -913.70382,
    y2: 257.1195,
    gradientTransform: "translate(334.6099) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-14",
    "data-name": "New Gradient Swatch copy 17",
    x1: -879.79302,
    y1: 204.15849,
    x2: -905.66395,
    y2: 253.46314,
    gradientTransform: "translate(334.6099) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18-19",
    "data-name": "New Gradient Swatch copy 18",
    x1: 1244.82508,
    y1: 336.83106,
    x2: 1371.26351,
    y2: 298.97107,
    xlinkHref: "#New_Gradient_Swatch_copy_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18-20",
    "data-name": "New Gradient Swatch copy 18",
    x1: 1306.76645,
    y1: 212.34636,
    x2: 1241.44662,
    y2: 336.83251,
    xlinkHref: "#New_Gradient_Swatch_copy_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-15",
    "data-name": "New Gradient Swatch copy 17",
    x1: 681.38315,
    y1: 328.63977,
    x2: 807.43029,
    y2: 290.89695,
    gradientTransform: "translate(553.40929)",
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-16",
    "data-name": "New Gradient Swatch copy 17",
    x1: 657.51841,
    y1: 343.3799,
    x2: 662.42357,
    y2: 342.28032,
    gradientTransform: "translate(553.40929)",
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-17",
    "data-name": "New Gradient Swatch copy 17",
    x1: 750.11313,
    y1: 210.52151,
    x2: 685.7093,
    y2: 333.26195,
    gradientTransform: "translate(553.40929)",
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-18",
    "data-name": "New Gradient Swatch copy 17",
    x1: 686.97958,
    y1: 331.87222,
    x2: 813.02711,
    y2: 294.12928,
    gradientTransform: "translate(553.40929)",
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-19",
    "data-name": "New Gradient Swatch copy 17",
    x1: 663.11498,
    y1: 346.61234,
    x2: 668.02014,
    y2: 345.51276,
    gradientTransform: "translate(553.40929)",
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-20",
    "data-name": "New Gradient Swatch copy 17",
    x1: 755.70968,
    y1: 213.75398,
    x2: 691.30587,
    y2: 336.49439,
    gradientTransform: "translate(553.40929)",
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-21",
    "data-name": "New Gradient Swatch copy 17",
    x1: 1257.96114,
    y1: 338.45172,
    x2: 1333.2935,
    y2: 315.89463,
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-22",
    "data-name": "New Gradient Swatch copy 17",
    x1: 1177.35601,
    y1: 347.76907,
    x2: 1279.37308,
    y2: 324.90011,
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-23",
    "data-name": "New Gradient Swatch copy 17",
    x1: 1282.26382,
    y1: 254.46115,
    x2: 1242.39173,
    y2: 330.44915,
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_22-7",
    "data-name": "New Gradient Swatch copy 22",
    x1: 1257.96114,
    y1: 336.54538,
    x2: 1333.2935,
    y2: 313.9883,
    xlinkHref: "#New_Gradient_Swatch_copy_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_22-8",
    "data-name": "New Gradient Swatch copy 22",
    x1: 1177.35601,
    y1: 345.86273,
    x2: 1279.37308,
    y2: 322.99377,
    xlinkHref: "#New_Gradient_Swatch_copy_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_22-9",
    "data-name": "New Gradient Swatch copy 22",
    x1: 1282.26382,
    y1: 252.55482,
    x2: 1242.39173,
    y2: 328.54282,
    xlinkHref: "#New_Gradient_Swatch_copy_22"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-32",
    "data-name": "Radial Gradient 1",
    cx: 1235.67903,
    cy: 342.15366,
    fx: 1235.67903,
    fy: 342.15366,
    r: 26.82834,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_22-10",
    "data-name": "New Gradient Swatch copy 22",
    x1: 1257.2287,
    y1: 259.72509,
    x2: 1282.11782,
    y2: 252.27244,
    xlinkHref: "#New_Gradient_Swatch_copy_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_22-11",
    "data-name": "New Gradient Swatch copy 22",
    x1: 1223.00093,
    y1: 262.88735,
    x2: 1273.30081,
    y2: 251.61172,
    xlinkHref: "#New_Gradient_Swatch_copy_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_22-12",
    "data-name": "New Gradient Swatch copy 22",
    x1: 1260.74819,
    y1: 230.46895,
    x2: 1251.05454,
    y2: 248.94305,
    xlinkHref: "#New_Gradient_Swatch_copy_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18-21",
    "data-name": "New Gradient Swatch copy 18",
    x1: 1222.08838,
    y1: 351.19585,
    x2: 1234.48202,
    y2: 347.48477,
    xlinkHref: "#New_Gradient_Swatch_copy_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18-22",
    "data-name": "New Gradient Swatch copy 18",
    x1: 1190.91233,
    y1: 352.82295,
    x2: 1237.96637,
    y2: 342.27494,
    xlinkHref: "#New_Gradient_Swatch_copy_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18-23",
    "data-name": "New Gradient Swatch copy 18",
    x1: 1219.77359,
    y1: 333.8552,
    x2: 1215.33447,
    y2: 342.31525,
    xlinkHref: "#New_Gradient_Swatch_copy_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-24",
    "data-name": "New Gradient Swatch copy 17",
    x1: 1222.37456,
    y1: 345.69364,
    x2: 1231.00303,
    y2: 343.10998,
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-25",
    "data-name": "New Gradient Swatch copy 17",
    x1: 1193.35368,
    y1: 346.85927,
    x2: 1235.41668,
    y2: 337.4301,
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-26",
    "data-name": "New Gradient Swatch copy 17",
    x1: 1219.77354,
    y1: 332.00871,
    x2: 1215.33443,
    y2: 340.46875,
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-27",
    "data-name": "New Gradient Swatch copy 17",
    x1: 1283.22073,
    y1: 308.8862,
    x2: 1291.84942,
    y2: 306.30247,
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-28",
    "data-name": "New Gradient Swatch copy 17",
    x1: 1254.19974,
    y1: 310.05171,
    x2: 1296.26274,
    y2: 300.62253,
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-29",
    "data-name": "New Gradient Swatch copy 17",
    x1: 1280.61965,
    y1: 295.20117,
    x2: 1276.18054,
    y2: 303.66121,
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-30",
    "data-name": "New Gradient Swatch copy 17",
    x1: -941.27579,
    y1: 264.30942,
    x2: -885.74449,
    y2: 247.68144,
    gradientTransform: "translate(334.6099) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-31",
    "data-name": "New Gradient Swatch copy 17",
    x1: -953.27237,
    y1: 270.79968,
    x2: -948.63363,
    y2: 269.75983,
    gradientTransform: "translate(334.6099) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-32",
    "data-name": "New Gradient Swatch copy 17",
    x1: -911.50522,
    y1: 211.96727,
    x2: -939.72229,
    y2: 265.74321,
    gradientTransform: "translate(334.6099) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-33",
    "data-name": "New Gradient Swatch copy 17",
    x1: -941.27579,
    y1: 272.02861,
    x2: -885.74449,
    y2: 255.40064,
    gradientTransform: "translate(334.6099) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-34",
    "data-name": "New Gradient Swatch copy 17",
    x1: -953.27247,
    y1: 278.5189,
    x2: -948.63358,
    y2: 277.47901,
    gradientTransform: "translate(334.6099) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-35",
    "data-name": "New Gradient Swatch copy 17",
    x1: -911.50522,
    y1: 219.68647,
    x2: -939.72229,
    y2: 273.4624,
    gradientTransform: "translate(334.6099) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_22-13",
    "data-name": "New Gradient Swatch copy 22",
    x1: 1247.44413,
    y1: 265.02284,
    x2: 1265.16165,
    y2: 259.71761,
    xlinkHref: "#New_Gradient_Swatch_copy_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_22-14",
    "data-name": "New Gradient Swatch copy 22",
    x1: 1228.69049,
    y1: 267.18519,
    x2: 1255.09658,
    y2: 261.26579,
    xlinkHref: "#New_Gradient_Swatch_copy_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_22-15",
    "data-name": "New Gradient Swatch copy 22",
    x1: 1251.80198,
    y1: 245.44796,
    x2: 1244.39299,
    y2: 259.56796,
    xlinkHref: "#New_Gradient_Swatch_copy_22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-36",
    "data-name": "New Gradient Swatch copy 17",
    x1: 1247.63442,
    y1: 262.22272,
    x2: 1262.84824,
    y2: 257.66718,
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-37",
    "data-name": "New Gradient Swatch copy 17",
    x1: 1230.31385,
    y1: 264.07814,
    x2: 1253.40118,
    y2: 258.9027,
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-38",
    "data-name": "New Gradient Swatch copy 17",
    x1: 1251.80202,
    y1: 245.07865,
    x2: 1244.39304,
    y2: 259.19864,
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18-24",
    "data-name": "New Gradient Swatch copy 18",
    x1: 1278.55568,
    y1: 302.44516,
    x2: 1362.41712,
    y2: 277.33418,
    xlinkHref: "#New_Gradient_Swatch_copy_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18-25",
    "data-name": "New Gradient Swatch copy 18",
    x1: 1235.32195,
    y1: 312.72373,
    x2: 1320.25758,
    y2: 293.68388,
    xlinkHref: "#New_Gradient_Swatch_copy_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18-26",
    "data-name": "New Gradient Swatch copy 18",
    x1: 1296.29194,
    y1: 220.48576,
    x2: 1282.28093,
    y2: 247.18785,
    xlinkHref: "#New_Gradient_Swatch_copy_18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-39",
    "data-name": "New Gradient Swatch copy 17",
    x1: 1210.47287,
    y1: 344.2482,
    x2: 1212.48656,
    y2: 344.2482,
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-40",
    "data-name": "New Gradient Swatch copy 17",
    x1: 1215.35597,
    y1: 347.03854,
    x2: 1217.36966,
    y2: 347.03854,
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-41",
    "data-name": "New Gradient Swatch copy 17",
    x1: 4533.91178,
    y1: 249.79814,
    x2: 4535.9257,
    y2: 249.79814,
    gradientTransform: "translate(5822.2169) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-42",
    "data-name": "New Gradient Swatch copy 17",
    x1: 4537.91261,
    y1: 252.15758,
    x2: 4539.92653,
    y2: 252.15758,
    gradientTransform: "translate(5822.2169) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-43",
    "data-name": "New Gradient Swatch copy 17",
    x1: 4533.91178,
    y1: 254.64011,
    x2: 4535.9257,
    y2: 254.64011,
    gradientTransform: "translate(5822.2169) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-44",
    "data-name": "New Gradient Swatch copy 17",
    x1: 4537.91261,
    y1: 256.99956,
    x2: 4539.92653,
    y2: 256.99956,
    gradientTransform: "translate(5822.2169) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-45",
    "data-name": "New Gradient Swatch copy 17",
    x1: 4533.91178,
    y1: 344.23782,
    x2: 4535.9257,
    y2: 344.23782,
    gradientTransform: "translate(5822.2169) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-46",
    "data-name": "New Gradient Swatch copy 17",
    x1: 4537.91261,
    y1: 346.5973,
    x2: 4539.92653,
    y2: 346.5973,
    gradientTransform: "translate(5822.2169) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-47",
    "data-name": "New Gradient Swatch copy 17",
    x1: 4533.91178,
    y1: 349.07986,
    x2: 4535.9257,
    y2: 349.07986,
    gradientTransform: "translate(5822.2169) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_17-48",
    "data-name": "New Gradient Swatch copy 17",
    x1: 4537.91261,
    y1: 351.43932,
    x2: 4539.92653,
    y2: 351.43932,
    gradientTransform: "translate(5822.2169) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_17"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-33",
    "data-name": "Radial Gradient 1",
    cx: 1279.65612,
    cy: 245.03837,
    fx: 1279.65612,
    fy: 245.03837,
    r: 14.37118,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-34",
    "data-name": "Radial Gradient 1",
    cx: 1246.57598,
    cy: 246.38714,
    fx: 1246.57598,
    fy: 246.38714,
    r: 3.62006,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-35",
    "data-name": "Radial Gradient 1",
    cx: 1241.98323,
    cy: 262.96385,
    fx: 1241.98323,
    fy: 262.96385,
    r: 6.60965,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-36",
    "data-name": "Radial Gradient 1",
    cx: 1215.07334,
    cy: 345.93931,
    fx: 1215.07334,
    fy: 345.93931,
    r: 9.14991,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-37",
    "data-name": "Radial Gradient 1",
    cx: 1212.91434,
    cy: 207.36922,
    fx: 1212.91434,
    fy: 207.36922,
    r: 10.31275,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 6019.31411,
    y1: 943.50295,
    x2: 6002.71639,
    y2: 921.26198,
    gradientTransform: "translate(7241.5346) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#010002"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01997,
    stopColor: "#010711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0908,
    stopColor: "#022042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16333,
    stopColor: "#03366d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23631,
    stopColor: "#034790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.30995,
    stopColor: "#0455ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38451,
    stopColor: "#045fbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46056,
    stopColor: "#0465ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5404,
    stopColor: "#0567ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59902,
    stopColor: "#0350a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67067,
    stopColor: "#023870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74196,
    stopColor: "#012347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81149,
    stopColor: "#001428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87873,
    stopColor: "#000912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94272,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 5997.10534,
    y1: 935.29756,
    x2: 6016.02329,
    y2: 935.29756,
    gradientTransform: "translate(7241.5346) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0064cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0869ce"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-38",
    "data-name": "Radial Gradient 1",
    cx: 6008.51184,
    cy: 934.97826,
    fx: 6008.51184,
    fy: 934.97826,
    r: 10.21907,
    gradientTransform: "translate(7241.5346) rotate(-180) scale(1 -1)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 5999.59393,
    y1: 935.45322,
    x2: 6014.16265,
    y2: 935.45322,
    gradientTransform: "translate(7241.5346) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 5999.13996,
    y1: 935.63485,
    x2: 6013.70891,
    y2: 935.63485,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 5939.84566,
    y1: 898.85858,
    x2: 5923.24797,
    y2: 876.61764,
    xlinkHref: "#linear-gradient-88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 5917.63684,
    y1: 890.65318,
    x2: 5936.55476,
    y2: 890.65318,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-39",
    "data-name": "Radial Gradient 1",
    cx: 5929.04334,
    cy: 890.33382,
    fx: 5929.04334,
    fy: 890.33382,
    r: 10.21905,
    gradientTransform: "translate(7241.5346) rotate(-180) scale(1 -1)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 5920.12543,
    y1: 890.80893,
    x2: 5934.69414,
    y2: 890.80893,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 5919.67146,
    y1: 890.99043,
    x2: 5934.24041,
    y2: 890.99043,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy_6",
    "data-name": "New Gradient Swatch copy 6",
    cx: 6036.3942,
    cy: 867.48577,
    fx: 6036.3942,
    fy: 867.48577,
    r: 8.47459,
    gradientTransform: "translate(7241.5346) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8ab8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458eda"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy_6-2",
    "data-name": "New Gradient Swatch copy 6",
    cx: 6004.30129,
    cy: 855.06497,
    fx: 6004.30129,
    fy: 855.06497,
    r: 99.49685,
    xlinkHref: "#New_Gradient_Swatch_copy_6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-40",
    "data-name": "Radial Gradient 1",
    cx: 5973.40599,
    cy: 898.39508,
    fx: 5973.40599,
    fy: 898.39508,
    r: 53.45679,
    gradientTransform: "translate(7241.5346) rotate(-180) scale(1 -1)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_14",
    "data-name": "New Gradient Swatch copy 14",
    x1: 5945.84794,
    y1: 819.07013,
    x2: 5954.85481,
    y2: 875.15831,
    gradientTransform: "translate(7241.5346) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0303,
    stopColor: "#458eda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36004,
    stopColor: "#68a3e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b8d4f1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_14-2",
    "data-name": "New Gradient Swatch copy 14",
    x1: 5992.62329,
    y1: 911.50949,
    x2: 6048.81595,
    y2: 838.87624,
    xlinkHref: "#New_Gradient_Swatch_copy_14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_12",
    "data-name": "New Gradient Swatch copy 12",
    x1: 5938.80885,
    y1: 870.74108,
    x2: 6011.68225,
    y2: 889.98295,
    gradientTransform: "translate(7241.5346) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5799de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ab8e8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-41",
    "data-name": "Radial Gradient 1",
    cx: 6058.58444,
    cy: 922.70108,
    fx: 6058.58444,
    fy: 922.70108,
    r: 12.47589,
    gradientTransform: "translate(7241.5346) rotate(-180) scale(1 -1)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 6034.30055,
    y1: 928.16607,
    x2: 6033.37575,
    y2: 936.32114,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 6034.04915,
    y1: 934.67172,
    x2: 6033.881,
    y2: 922.06089,
    gradientTransform: "translate(7241.5346) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46244,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 6072.43362,
    y1: 912.43224,
    x2: 6077.81297,
    y2: 912.19835,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 6075.74577,
    y1: 902.83506,
    x2: 6072.59787,
    y2: 917.20238,
    xlinkHref: "#linear-gradient-97"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy_11",
    "data-name": "New Gradient Swatch copy 11",
    cx: 5913.88782,
    cy: 851.89167,
    fx: 5913.88782,
    fy: 851.89167,
    r: 5.28806,
    gradientTransform: "translate(7241.5346) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff6db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eea796"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 6032.63587,
    y1: 932.78808,
    x2: 6039.38411,
    y2: 932.78808,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: -5098.96315,
    y1: 933.2758,
    x2: -5095.94568,
    y2: 933.2758,
    gradientTransform: "translate(6300.472)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 6028.33761,
    y1: 932.69359,
    x2: 6035.14358,
    y2: 932.69359,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: -5094.72805,
    y1: 933.1854,
    x2: -5091.6849,
    y2: 933.1854,
    xlinkHref: "#linear-gradient-101"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-58",
    cx: 6028.78375,
    cy: 930.32894,
    fx: 6028.78375,
    fy: 930.32894,
    r: 2.62519,
    gradientTransform: "translate(7241.5346) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1594,
    stopColor: "#ffd86b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28844,
    stopColor: "#fed468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41496,
    stopColor: "#fbc861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54052,
    stopColor: "#f6b455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66554,
    stopColor: "#ef9844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79017,
    stopColor: "#e7752e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91282,
    stopColor: "#dc4a14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99495,
    stopColor: "#d52900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-59",
    cx: -5089.95029,
    cy: 930.76258,
    fx: -5089.95029,
    fy: 930.76258,
    r: 1.54431,
    gradientTransform: "translate(6300.472)",
    xlinkHref: "#radial-gradient-58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 6072.52423,
    y1: 912.8938,
    x2: 6075.75414,
    y2: 912.8938,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: -5135.26209,
    y1: 913.05292,
    x2: -5132.57926,
    y2: 913.05292,
    xlinkHref: "#linear-gradient-101"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 6073.96541,
    y1: 909.85248,
    x2: 6076.64249,
    y2: 909.85248,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: -5136.01877,
    y1: 909.82121,
    x2: -5133.95463,
    y2: 909.82121,
    xlinkHref: "#linear-gradient-101"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 5966.05737,
    y1: 887.26496,
    x2: 5960.69005,
    y2: 896.29776,
    gradientTransform: "translate(7241.5346) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#458eda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.20696,
    stopColor: "#306499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40831,
    stopColor: "#1f4062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5937,
    stopColor: "#112438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75989,
    stopColor: "#081019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90092,
    stopColor: "#020406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 5910.02033,
    y1: 884.5778,
    x2: 5915.06464,
    y2: 873.81658,
    xlinkHref: "#linear-gradient-97"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 6034.76167,
    y1: 951.60473,
    x2: 6039.80602,
    y2: 940.84345,
    xlinkHref: "#linear-gradient-97"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 5962.0026,
    y1: 913.96454,
    x2: 5967.94504,
    y2: 903.67205,
    xlinkHref: "#linear-gradient-97"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy_6-3",
    "data-name": "New Gradient Swatch copy 6",
    cx: 6050.97718,
    cy: 922.18569,
    fx: 6050.97718,
    fy: 922.18569,
    r: 24.18782,
    xlinkHref: "#New_Gradient_Swatch_copy_6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-60",
    cx: 6066.89237,
    cy: 936.20126,
    fx: 6066.89237,
    fy: 936.20126,
    r: 23.47624,
    gradientTransform: "translate(7241.5346) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 6052.058,
    y1: 948.69522,
    x2: 6049.74361,
    y2: 933.13885,
    xlinkHref: "#linear-gradient-97"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 6035.88307,
    y1: 955.03524,
    x2: 6041.59998,
    y2: 945.28285,
    xlinkHref: "#linear-gradient-97"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 6039.84898,
    y1: 843.11147,
    x2: 6009.41493,
    y2: 885.65187,
    gradientTransform: "translate(7241.5346) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05182,
    stopColor: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2515,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44153,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61655,
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77343,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90651,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 6092.54955,
    y1: 915.57543,
    x2: 6016.01611,
    y2: 898.56801,
    gradientTransform: "translate(7241.5346) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe59c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0941,
    stopColor: "#dbc586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2848,
    stopColor: "#998a5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46636,
    stopColor: "#62583c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63361,
    stopColor: "#383222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78352,
    stopColor: "#19160f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91068,
    stopColor: "#060604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-42",
    "data-name": "Radial Gradient 1",
    cx: 6031.72803,
    cy: 929.53767,
    fx: 6031.72803,
    fy: 929.53767,
    r: 5.61349,
    gradientTransform: "translate(7241.5346) rotate(-180) scale(1 -1)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 6012.72196,
    y1: 882.44965,
    x2: 5945.12792,
    y2: 814.35116,
    gradientTransform: "translate(7241.5346) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d936ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05182,
    stopColor: "#c831db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2515,
    stopColor: "#8c2299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44153,
    stopColor: "#5a1662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61655,
    stopColor: "#330c38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77343,
    stopColor: "#170519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90651,
    stopColor: "#060106"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 5983.58424,
    y1: 875.08435,
    x2: 5940.28694,
    y2: 927.62967,
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 5992.59817,
    y1: 901.42734,
    x2: 5977.4651,
    y2: 906.15642,
    gradientTransform: "translate(7241.5346) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01833,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59423,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy_6-4",
    "data-name": "New Gradient Swatch copy 6",
    cx: 5986.28698,
    cy: 895.39783,
    fx: 5986.28698,
    fy: 895.39783,
    r: 8.38409,
    xlinkHref: "#New_Gradient_Swatch_copy_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 5986.16049,
    y1: 894.85882,
    x2: 5986.83307,
    y2: 900.99613,
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 5965.98279,
    y1: 842.4114,
    x2: 5943.38895,
    y2: 873.99285,
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-61",
    cx: 5665.96127,
    cy: 222.35603,
    fx: 5665.96127,
    fy: 222.35603,
    r: 62.05058,
    gradientTransform: "translate(3379.50391 5355.03752) rotate(-112.90464) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12121,
    stopColor: "#01aeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14962,
    stopColor: "#008eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23737,
    stopColor: "#0031ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24086,
    stopColor: "rgba(4, 53, 255, .97881)",
    stopOpacity: 0.97881
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27378,
    stopColor: "rgba(47, 90, 255, .79578)",
    stopOpacity: 0.79578
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31013,
    stopColor: "rgba(87, 124, 255, .62612)",
    stopOpacity: 0.62612
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3496,
    stopColor: "rgba(122, 155, 255, .47554)",
    stopOpacity: 0.47554
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39235,
    stopColor: "rgba(152, 181, 255, .34619)",
    stopOpacity: 0.34619
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43937,
    stopColor: "rgba(177, 203, 255, .23765)",
    stopOpacity: 0.23765
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49223,
    stopColor: "rgba(198, 221, 255, .14967)",
    stopOpacity: 0.14967
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55345,
    stopColor: "rgba(213, 235, 255, .08214)",
    stopOpacity: 0.08214
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62843,
    stopColor: "rgba(224, 244, 255, .03482)",
    stopOpacity: 0.03482
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73181,
    stopColor: "rgba(231, 250, 255, .0076)",
    stopOpacity: 0.0076
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9fcff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-62",
    cx: 5409.67617,
    cy: 336.16951,
    fx: 5409.67617,
    fy: 336.16951,
    r: 62.05058,
    gradientTransform: "translate(6635.457) rotate(-180) scale(1 -1)",
    xlinkHref: "#radial-gradient-61"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-63",
    cx: 5523.48964,
    cy: 616.19996,
    fx: 5523.48964,
    fy: 616.19996,
    r: 62.05063,
    gradientTransform: "translate(6635.457) rotate(-180) scale(1 -1)",
    xlinkHref: "#radial-gradient-61"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-64",
    cx: 5457.16675,
    cy: 934.71407,
    fx: 5457.16675,
    fy: 934.71407,
    r: 62.05063,
    gradientTransform: "translate(6635.457) rotate(-180) scale(1 -1)",
    xlinkHref: "#radial-gradient-61"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-65",
    cx: 5761.76123,
    cy: 920.79445,
    fx: 5761.76123,
    fy: 920.79445,
    r: 62.05063,
    gradientTransform: "translate(6635.457) rotate(-180) scale(1 -1)",
    xlinkHref: "#radial-gradient-61"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-66",
    cx: 6428.63111,
    cy: 730.64442,
    fx: 6428.63111,
    fy: 730.64442,
    r: 62.05063,
    gradientTransform: "translate(6635.457) rotate(-180) scale(1 -1)",
    xlinkHref: "#radial-gradient-61"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-67",
    cx: 6196.54521,
    cy: 1006.76868,
    fx: 6196.54521,
    fy: 1006.76868,
    r: 62.05052,
    gradientTransform: "translate(5532.42384 4676.49488) rotate(-135) scale(1 -1)",
    xlinkHref: "#radial-gradient-61"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-68",
    cx: 6199.0016,
    cy: 178.95946,
    fx: 6199.0016,
    fy: 178.95946,
    r: 62.05057,
    gradientTransform: "translate(6635.457) rotate(-180) scale(1 -1)",
    xlinkHref: "#radial-gradient-61"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-69",
    cx: 6426.62866,
    cy: 346.81392,
    fx: 6426.62866,
    fy: 346.81392,
    r: 62.05063,
    gradientTransform: "translate(6635.457) rotate(-180) scale(1 -1)",
    xlinkHref: "#radial-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_4",
    "data-name": "New Gradient Swatch copy 4",
    x1: 314.90778,
    y1: 283.44551,
    x2: 327.45629,
    y2: 283.44551,
    gradientTransform: "translate(-54.8204)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00354d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00628a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00354d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2",
    "data-name": "New Gradient Swatch copy 2",
    x1: 5428.16885,
    y1: 269.1344,
    x2: 5438.26937,
    y2: 279.96464,
    gradientTransform: "translate(5702.0572) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#589ec8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14318,
    stopColor: "#5ea0cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34435,
    stopColor: "#70a6d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57902,
    stopColor: "#8eb0e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58081,
    stopColor: "#8fb1e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77619,
    stopColor: "#9ebde9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b6cff3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-43",
    "data-name": "Radial Gradient 1",
    cx: 264.35574,
    cy: 280.36192,
    fx: 264.35574,
    fy: 280.36192,
    r: 4.70176,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_4-2",
    "data-name": "New Gradient Swatch copy 4",
    x1: 10420.05962,
    x2: 10432.60813,
    gradientTransform: "translate(10576.1259) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-2",
    "data-name": "New Gradient Swatch copy 2",
    x1: -4676.98294,
    y1: 269.1344,
    x2: -4666.88241,
    y2: 279.96464,
    gradientTransform: "translate(4819.2483)",
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-44",
    "data-name": "Radial Gradient 1",
    cx: 10369.50753,
    cy: 280.36192,
    fx: 10369.50753,
    fy: 280.36192,
    r: 4.70184,
    gradientTransform: "translate(10521.3056) rotate(-180) scale(1 -1)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_4-3",
    "data-name": "New Gradient Swatch copy 4",
    y1: 349.27213,
    y2: 349.27213,
    xlinkHref: "#New_Gradient_Swatch_copy_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-3",
    "data-name": "New Gradient Swatch copy 2",
    x1: 5428.16893,
    y1: 334.96103,
    x2: 5438.26934,
    y2: 345.79114,
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-45",
    "data-name": "Radial Gradient 1",
    cx: 264.35574,
    cy: 346.18854,
    fx: 264.35574,
    fy: 346.18854,
    r: 4.70176,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-4",
    "data-name": "New Gradient Swatch copy 2",
    x1: 8622.81272,
    y1: 299.1987,
    x2: 8642.91466,
    y2: 293.17949,
    gradientTransform: "translate(8851.6625) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-5",
    "data-name": "New Gradient Swatch copy 2",
    x1: 8544.87331,
    y1: 301.62993,
    x2: 8657.9486,
    y2: 276.28207,
    gradientTransform: "translate(8851.6625) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-6",
    "data-name": "New Gradient Swatch copy 2",
    x1: 8614.11754,
    y1: 264.50243,
    x2: 8603.21784,
    y2: 285.275,
    gradientTransform: "translate(8851.6625) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-7",
    "data-name": "New Gradient Swatch copy 2",
    x1: -154.31709,
    y1: 299.1987,
    x2: -134.21515,
    y2: 293.17949,
    gradientTransform: "translate(341.80079)",
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-8",
    "data-name": "New Gradient Swatch copy 2",
    x1: -232.25649,
    y1: 301.62993,
    x2: -119.1812,
    y2: 276.28207,
    gradientTransform: "translate(341.80079)",
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-9",
    "data-name": "New Gradient Swatch copy 2",
    x1: -163.01227,
    y1: 264.50242,
    x2: -173.91196,
    y2: 285.275,
    gradientTransform: "translate(341.80079)",
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_4-4",
    "data-name": "New Gradient Swatch copy 4",
    x1: 236.64578,
    y1: 328.41296,
    x2: 288.7091,
    y2: 328.41296,
    xlinkHref: "#New_Gradient_Swatch_copy_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3",
    "data-name": "New Gradient Swatch copy 3",
    x1: 232.9593,
    y1: 319.95801,
    x2: 292.34848,
    y2: 319.95801,
    gradientTransform: "translate(-54.8204)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0101,
    stopColor: "#7ea1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04049,
    stopColor: "#88a8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09242,
    stopColor: "#a3bce1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15911,
    stopColor: "#cfdcef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22222,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24373,
    stopColor: "#f5f8fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27981,
    stopColor: "#dbe6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32575,
    stopColor: "#b1c8eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35859,
    stopColor: "#8fb1e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4188,
    stopColor: "#74b1d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49013,
    stopColor: "#5cb1cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55611,
    stopColor: "#4eb1c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61111,
    stopColor: "#49b1c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77496,
    stopColor: "#51a6c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6490cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-10",
    "data-name": "New Gradient Swatch copy 2",
    x1: 5458.60189,
    y1: 265.76815,
    x2: 5506.405,
    y2: 317.0248,
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-46",
    "data-name": "Radial Gradient 1",
    cx: 198.34005,
    cy: 318.90523,
    fx: 198.34005,
    fy: 318.90523,
    r: 22.25231,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-70",
    cx: 1035.89164,
    cy: -3435.59949,
    fx: 1035.89164,
    fy: -3435.59949,
    r: 12.92401,
    gradientTransform: "translate(-1013.0685 2371.42552) scale(1.181 .6022)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19192,
    stopColor: "#524c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-2",
    "data-name": "New Gradient Swatch copy 3",
    x1: 250.88497,
    y1: 303.84802,
    x2: 274.65075,
    y2: 303.84802,
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-11",
    "data-name": "New Gradient Swatch copy 2",
    x1: 5479.85492,
    y1: 282.78304,
    x2: 5498.98435,
    y2: 303.29447,
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_5",
    "data-name": "New Gradient Swatch copy 5",
    x1: 5487.7415,
    y1: 291.36226,
    x2: 5496.23069,
    y2: 300.46476,
    gradientTransform: "translate(5702.0572) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03535,
    stopColor: "#37bd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.30048,
    stopColor: "#46cb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81191,
    stopColor: "#6eef00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7fff00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-47",
    "data-name": "Radial Gradient 1",
    cx: 204.14847,
    cy: 304.04697,
    fx: 204.14847,
    fy: 304.04697,
    r: 8.90471,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-12",
    "data-name": "New Gradient Swatch copy 2",
    x1: -73.10074,
    y1: 344.61868,
    x2: -54.27312,
    y2: 338.98104,
    gradientTransform: "translate(341.80079)",
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-13",
    "data-name": "New Gradient Swatch copy 2",
    x1: -156.14028,
    y1: 347.49512,
    x2: -35.90564,
    y2: 320.54237,
    gradientTransform: "translate(341.80079)",
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-14",
    "data-name": "New Gradient Swatch copy 2",
    x1: -82.33396,
    y1: 310.07047,
    x2: -93.5422,
    y2: 331.43107,
    gradientTransform: "translate(341.80079)",
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-3",
    "data-name": "New Gradient Swatch copy 3",
    x1: 315.53152,
    y1: 336.00532,
    x2: 326.84071,
    y2: 336.00532,
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-15",
    "data-name": "New Gradient Swatch copy 2",
    x1: 5428.90817,
    y1: 323.10744,
    x2: 5438.01112,
    y2: 332.86803,
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-48",
    "data-name": "Radial Gradient 1",
    cx: 264.55792,
    cy: 333.22626,
    fx: 264.55792,
    fy: 333.22626,
    r: 4.2374,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-4",
    "data-name": "New Gradient Swatch copy 3",
    x1: 318.18185,
    y1: 328.5884,
    x2: 324.22385,
    y2: 328.5884,
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-16",
    "data-name": "New Gradient Swatch copy 2",
    x1: 5432.05076,
    y1: 321.69786,
    x2: 5436.91398,
    y2: 326.91241,
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-49",
    "data-name": "Radial Gradient 1",
    cx: 265.41663,
    cy: 327.10363,
    fx: 265.41663,
    fy: 327.10363,
    r: 2.26386,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_4-5",
    "data-name": "New Gradient Swatch copy 4",
    x1: 10420.05962,
    y1: 349.27213,
    x2: 10432.60813,
    y2: 349.27213,
    gradientTransform: "translate(10576.1259) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-17",
    "data-name": "New Gradient Swatch copy 2",
    x1: -4676.98285,
    y1: 334.96103,
    x2: -4666.88244,
    y2: 345.79115,
    gradientTransform: "translate(4819.2483)",
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-50",
    "data-name": "Radial Gradient 1",
    cx: 10369.50753,
    cy: 346.18854,
    fx: 10369.50753,
    fy: 346.18854,
    r: 4.70184,
    gradientTransform: "translate(10521.3056) rotate(-180) scale(1 -1)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-18",
    "data-name": "New Gradient Swatch copy 2",
    x1: 10032.05105,
    y1: 344.61869,
    x2: 10050.87906,
    y2: 338.98093,
    gradientTransform: "translate(10179.5048) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-19",
    "data-name": "New Gradient Swatch copy 2",
    x1: 9949.01144,
    y1: 347.49512,
    x2: 10069.24606,
    y2: 320.54237,
    gradientTransform: "translate(10179.5048) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-20",
    "data-name": "New Gradient Swatch copy 2",
    x1: 10022.81784,
    y1: 310.07051,
    x2: 10011.6096,
    y2: 331.43111,
    gradientTransform: "translate(10179.5048) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-5",
    "data-name": "New Gradient Swatch copy 3",
    x1: 10420.68313,
    y1: 336.00532,
    x2: 10431.99232,
    y2: 336.00532,
    gradientTransform: "translate(10576.1259) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-21",
    "data-name": "New Gradient Swatch copy 2",
    x1: -4676.24344,
    y1: 323.10744,
    x2: -4667.14049,
    y2: 332.86803,
    gradientTransform: "translate(4819.2483)",
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-51",
    "data-name": "Radial Gradient 1",
    cx: 10369.70964,
    cy: 333.22626,
    fx: 10369.70964,
    fy: 333.22626,
    r: 4.2374,
    gradientTransform: "translate(10521.3056) rotate(-180) scale(1 -1)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-6",
    "data-name": "New Gradient Swatch copy 3",
    x1: 10423.33369,
    y1: 328.5884,
    x2: 10429.37569,
    y2: 328.5884,
    gradientTransform: "translate(10576.1259) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-22",
    "data-name": "New Gradient Swatch copy 2",
    x1: -4673.10102,
    y1: 321.69786,
    x2: -4668.23781,
    y2: 326.91242,
    gradientTransform: "translate(4819.2483)",
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-52",
    "data-name": "Radial Gradient 1",
    cx: 10370.56849,
    cy: 327.10363,
    fx: 10370.56849,
    fy: 327.10363,
    r: 2.26377,
    gradientTransform: "translate(10521.3056) rotate(-180) scale(1 -1)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-7",
    "data-name": "New Gradient Swatch copy 3",
    x1: 315.53152,
    y1: 270.1787,
    x2: 326.84071,
    y2: 270.1787,
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-23",
    "data-name": "New Gradient Swatch copy 2",
    x1: 5428.90821,
    y1: 257.28089,
    x2: 5438.01111,
    y2: 267.04143,
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-53",
    "data-name": "Radial Gradient 1",
    cx: 264.55792,
    cy: 267.39965,
    fx: 264.55792,
    fy: 267.39965,
    r: 4.2374,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-8",
    "data-name": "New Gradient Swatch copy 3",
    x1: 318.18185,
    y1: 262.76178,
    x2: 324.22385,
    y2: 262.76178,
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-24",
    "data-name": "New Gradient Swatch copy 2",
    x1: 5432.05076,
    y1: 255.87124,
    x2: 5436.91398,
    y2: 261.0858,
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-54",
    "data-name": "Radial Gradient 1",
    cx: 265.41663,
    cy: 261.27701,
    fx: 265.41663,
    fy: 261.27701,
    r: 2.26386,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-9",
    "data-name": "New Gradient Swatch copy 3",
    x1: 10420.68313,
    y1: 270.1787,
    x2: 10431.99232,
    y2: 270.1787,
    gradientTransform: "translate(10576.1259) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-25",
    "data-name": "New Gradient Swatch copy 2",
    x1: -4676.2434,
    y1: 257.28089,
    x2: -4667.1405,
    y2: 267.04143,
    gradientTransform: "translate(4819.2483)",
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-55",
    "data-name": "Radial Gradient 1",
    cx: 10369.70964,
    cy: 267.39965,
    fx: 10369.70964,
    fy: 267.39965,
    r: 4.2374,
    gradientTransform: "translate(10521.3056) rotate(-180) scale(1 -1)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_3-10",
    "data-name": "New Gradient Swatch copy 3",
    x1: 10423.33369,
    y1: 262.76178,
    x2: 10429.37569,
    y2: 262.76178,
    gradientTransform: "translate(10576.1259) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_copy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-26",
    "data-name": "New Gradient Swatch copy 2",
    x1: -4673.10102,
    y1: 255.87124,
    x2: -4668.23781,
    y2: 261.0858,
    gradientTransform: "translate(4819.2483)",
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-56",
    "data-name": "Radial Gradient 1",
    cx: 10370.56849,
    cy: 261.27701,
    fx: 10370.56849,
    fy: 261.27701,
    r: 2.26377,
    gradientTransform: "translate(10521.3056) rotate(-180) scale(1 -1)",
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-71",
    cx: 623.85125,
    cy: 795.46329,
    fx: 623.85125,
    fy: 795.46329,
    r: 21.49466,
    gradientTransform: "translate(815.32464 -197.15449) rotate(49.02383)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-72",
    cx: 766.32287,
    cy: 950.21694,
    fx: 766.32287,
    fy: 950.21694,
    r: 21.49466,
    gradientTransform: "translate(896.35564 -263.55995) rotate(45)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-73",
    cx: 920.25771,
    cy: 729.54968,
    fx: 920.25771,
    fy: 729.54968,
    r: 21.4946,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-74",
    cx: 1063.38429,
    cy: 657.49507,
    fx: 1063.38429,
    fy: 657.49507,
    r: 21.49466,
    gradientTransform: "translate(1457.82475 -528.88714) rotate(76.66191)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-75",
    cx: 337.10666,
    cy: 804.0607,
    fx: 337.10666,
    fy: 804.0607,
    r: 21.4946,
    gradientTransform: "translate(331.26869 -67.78815) rotate(22.36247)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-76",
    cx: 400.97326,
    cy: 659.13267,
    fx: 400.97326,
    fy: 659.13267,
    r: 21.49466,
    gradientTransform: "translate(949.82319 116.91564) rotate(76.66191)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-77",
    cx: 324.82464,
    cy: 536.31238,
    fx: 324.82464,
    fy: 536.31238,
    r: 21.49454,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-78",
    cx: 1047.82718,
    cy: 449.51934,
    fx: 1047.82718,
    fy: 449.51934,
    r: 21.4946,
    gradientTransform: "translate(1309.59488 -660.2046) rotate(80.05322)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-79",
    cx: 404.24847,
    cy: 338.98096,
    fx: 404.24847,
    fy: 338.98096,
    r: 21.49466,
    gradientTransform: "translate(643.30267 -131.31475) rotate(76.96312)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-80",
    cx: 1100.63986,
    cy: 890.44434,
    fx: 1100.63986,
    fy: 890.44434,
    r: 21.49454,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#radial-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-547"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M695.31303,832.79223l-104.09038-61.28292,28.97314-16.45075c2.4564.74903,5.15161,1.18926,7.96902,1.18926,4.6344,0,9.04125-1.06998,12.41143-3.01773,3.8453-2.21896,6.04986-5.47886,6.04986-8.93817-.00225-3.49262-2.12533-6.63976-5.98254-8.86592-3.32496-1.92164-7.68836-2.98171-12.28699-2.98171-4.6344,0-9.0435,1.07223-12.41391,3.01773-3.84283,2.21873-6.04738,5.47886-6.04986,8.94042,0,2.74247,1.33016,5.26729,3.76383,7.30732l-34.70159,19.70344,103.95601,61.2064-156.73515,86.44677,137.60428,82.31608-121.31379,68.24926-83.13735-48.01893c2.14536-1.98916,3.33935-4.41203,3.33935-6.94878,0-3.49285-2.12308-6.63999-5.98031-8.86614-3.32494-1.92141-7.68836-2.98171-12.28697-2.98171-4.63687,0-9.0435,1.07223-12.41391,3.01773-3.8453,2.22121-6.04986,5.47886-6.04986,8.94042,0,3.49262,2.12308,6.63999,5.98031,8.8684,3.3272,1.91916,7.69308,2.97699,12.2917,2.97699,3.3578,0,6.58237-.57798,9.39371-1.62747l-.15822.26491,88.93513,51.47036,133.63429-75.18206-137.51313-82.26318,156.8119-86.48998ZM619.01328,740.78243c2.41544-1.3961,5.82186-2.19712,9.34329-2.19712,3.48564,0,6.8439.78662,9.21635,2.15886,1.84962,1.0675,2.90992,2.36052,2.91217,3.54776,0,1.20682-1.08663,2.52843-2.97924,3.62001-4.80498,2.7778-13.78863,2.79693-18.55987.03826-1.84939-1.0675-2.91217-2.3603-2.91217-3.54776,0-1.20907,1.08663-2.52843,2.97946-3.62001ZM434.98805,1018.32204c-1.84939-1.06728-2.90969-2.3603-2.90969-3.54776,0-1.20907,1.08663-2.52843,2.97946-3.62226,2.41544-1.39363,5.81939-2.19487,9.34329-2.19487,3.48564,0,6.8439.78684,9.21635,2.15886,1.84962,1.0675,2.90992,2.36052,2.90992,3.54799,0,1.20885-1.08438,2.5282-2.97698,3.61979-4.80501,2.78028-13.79089,2.79941-18.56236.03826Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M775.99353,751.59655c2.34544-2.01932,3.61934-4.50138,3.61934-7.19411,0-3.46156-2.20455-6.71921-6.04761-8.94042-3.37018-1.9455-7.77929-3.01773-12.41391-3.01773-4.59861,0-8.96202,1.06008-12.28922,2.97924-3.85498,2.22863-5.98031,5.37577-5.98031,8.86614,0,3.46156,2.20455,6.71899,6.04986,8.94042,3.36793,1.9455,7.77704,3.01773,12.41166,3.01773,2.90542,0,5.68344-.46657,8.19904-1.26129l85.88567,49.00541-108.52086,61.38848,45.16753,30.69784-62.50392,35.36375,69.90442,42.12347,59.24807-33.12274c2.66459.9086,5.64878,1.43099,8.76374,1.43099,4.59613,0,8.95955-1.05805,12.28427-2.97699,3.85746-2.22863,5.98279-5.37825,5.98279-8.86862-.00248-3.46134-2.207-6.72146-6.04986-8.93794-3.37041-1.94797-7.77951-3.0202-12.41388-3.0202-4.59638,0-8.9598,1.05782-12.28699,2.97699-3.85721,2.22863-5.98256,5.37577-5.98256,8.86862,0,2.56714,1.21785,5.01994,3.4134,7.02373l-52.85836,29.516-57.82856-34.84541,61.957-35.0518-45.16753-30.69784,109.32211-61.84447-91.8653-52.41926ZM752.00229,747.91419c-1.89283-1.09384-2.97946-2.41544-2.97946-3.62451,0-1.18499,1.0603-2.47801,2.90969-3.54799,2.37245-1.36977,5.73343-2.15639,9.21883-2.15639,3.52143,0,6.92785.80102,9.34354,2.19487,1.89258,1.09384,2.97697,2.41319,2.97697,3.62226,0,1.18746-1.0603,2.48026-2.90992,3.54776-4.76874,2.75867-13.75014,2.73706-18.55964-.03601ZM858.07395,926.36761c2.37245-1.37225,5.73071-2.15661,9.21638-2.15661,3.52141,0,6.92763.80125,9.34327,2.19735,1.89283,1.09158,2.97946,2.41094,2.97946,3.61979,0,1.18746-1.06278,2.48049-2.91217,3.54799-4.77371,2.75394-13.75487,2.73706-18.55987-.04074-1.89258-1.09158-2.97924-2.41094-2.97924-3.61979,0-1.18746,1.06255-2.48049,2.91217-3.54799Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-479",
    d: "M1028.25923,871.1521c0-2.58717-1.23608-5.06158-3.46696-7.07302l37.05312-22.71824-221.94508-126.37177c1.65516-1.80865,2.54508-3.90945,2.54508-6.15721,0-3.46156-2.20455-6.71921-6.04738-8.94042-3.37041-1.9455-7.77951-3.01773-12.41391-3.01773-4.59861,0-8.96202,1.0603-12.28922,2.97924-3.85498,2.22863-5.98031,5.37577-5.98031,8.86614,0,3.46156,2.20455,6.71921,6.04986,8.94109,3.36906,1.9455,7.77704,3.01705,12.41143,3.01705,3.61393,0,7.06222-.67408,9.99667-1.8854l215.60668,122.76571-31.14345,19.09418c-2.68262-.92593-5.69425-1.45552-8.84029-1.45552-4.59613,0-8.95977,1.05782-12.28694,2.97699-3.85726,2.22841-5.98034,5.37577-5.98034,8.8684,0,3.46156,2.20455,6.71921,6.04761,8.94064,3.37041,1.94527,7.78176,3.01773,12.41638,3.01773,4.59613,0,8.95955-1.05805,12.28674-2.97946,3.85723-2.22841,5.98031-5.37825,5.98031-8.8684ZM814.83482,712.34383c-1.89261-1.09406-2.97924-2.41567-2.97924-3.62474,0-1.18499,1.06032-2.47801,2.90969-3.54776,2.37245-1.36977,5.73321-2.15661,9.21883-2.15661,3.52143,0,6.92785.80125,9.34352,2.19487,1.89263,1.09384,2.97676,2.41319,2.97676,3.62226,0,1.18746-1.0603,2.48049-2.90969,3.54799-4.76764,2.75912-13.75014,2.73751-18.55987-.03601ZM1019.20853,874.70233c-4.76899,2.7562-13.75507,2.73706-18.56234-.03849-1.89261-1.09384-2.97699-2.41319-2.97699-3.62226,0-1.18724,1.0603-2.48026,2.90992-3.54776,2.37245-1.37225,5.73318-2.15661,9.21635-2.15661,2.88946,0,5.66589.56267,7.91478,1.52574l.69456,1.1321.7425-.45509c1.88653,1.09023,2.97091,2.40734,2.97091,3.61438,0,1.18746-1.0603,2.48049-2.90969,3.54799Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-477",
    d: "M1190.88354,933.45211c-3.37041-1.94775-7.77951-3.01998-12.41413-3.01998-4.59613,0-8.95955,1.05782-12.28674,2.97676-3.85723,2.22863-5.98279,5.37825-5.98279,8.86862.00135,2.14221.85057,4.20632,2.40554,5.99471l-60.10694,34.56475-75.12692-44.01383,126.94411-78.62652-282.77651-163.23672c1.51426-1.75284,2.32319-3.76676,2.32319-5.91369,0-3.46156-2.20435-6.71899-6.0474-8.94042-3.37041-1.9455-7.77951-3.01773-12.41391-3.01773-4.59861,0-8.96202,1.0603-12.28922,2.97946-3.85498,2.22841-5.98031,5.37577-5.98031,8.86592,0,3.46156,2.20455,6.71921,6.04986,8.94177,3.36861,1.9455,7.77704,3.0166,12.41143,3.0166,3.77216,0,7.35145-.74543,10.36488-2.06073l276.39738,159.55257-126.88152,78.58353,86.99613,50.97026,65.72376-37.79292c3.05081,1.33421,6.6695,2.09112,10.47269,2.09112,4.59613,0,8.95977-1.05782,12.28449-2.97924,3.85723-2.22863,5.98279-5.37825,5.98279-8.86862-.00244-3.46156-2.20703-6.71921-6.04986-8.93569ZM846.25175,694.5582c-1.89261-1.09384-2.97924-2.41567-2.97924-3.62474,0-1.18499,1.0603-2.47801,2.90969-3.54776,2.37245-1.36977,5.73318-2.15661,9.21883-2.15661,3.52143,0,6.92785.80125,9.34352,2.19487,1.89261,1.09406,2.97676,2.41342,2.97676,3.62226,0,1.18746-1.0603,2.48049-2.90969,3.54799-4.76831,2.7598-13.75127,2.73819-18.55987-.03601ZM1187.88022,945.93804c-2.37245,1.36977-5.73093,2.15661-9.2141,2.15661-3.52391,0-6.9301-.80125-9.34577-2.19735-1.89261-1.09136-2.97946-2.41071-2.97946-3.61979,0-1.18746,1.06278-2.48049,2.91217-3.54799,2.37245-1.37202,5.73093-2.15639,9.21635-2.15639,3.52166,0,6.92785.80102,9.34352,2.19735,1.89261,1.09136,2.97699,2.41071,2.97946,3.61731,0,1.18746-1.06278,2.48274-2.91217,3.55024Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-483",
    d: "M1316.83915,499.61082c-3.37041-1.94775-7.77951-3.0202-12.41413-3.0202-4.59298,0-8.95347,1.05737-12.28022,2.97406l-110.55681-61.41684,32.90416-18.97174c3.29906,1.76679,7.47117,2.76047,11.87734,2.76047,4.59839,0,8.96202-1.05782,12.28925-2.97699,3.8572-2.22841,5.98253-5.37577,5.98253-8.8684,0-3.46156-2.20455-6.71921-6.04986-8.94042-3.37041-1.9455-7.77704-3.01548-12.41143-3.01548-4.59861,0-8.96202,1.05782-12.28922,2.97699-3.85746,2.22863-5.98279,5.37825-5.98279,8.8684.00113,1.74519.56492,3.43815,1.61333,4.9729l-40.39764,23.2951,118.31719,65.72871c-.83073,1.3835-1.28537,2.88268-1.28537,4.45884.00248,3.46156,2.20703,6.72146,6.04986,8.94042,3.37041,1.9455,7.78199,3.01773,12.41638,3.01773,4.59636,0,8.95977-1.05782,12.28453-2.97946,3.85742-2.22593,5.98275-5.37577,5.98275-8.8684,0-3.45909-2.20455-6.71674-6.04986-8.93569ZM1216.96116,406.43291c2.37245-1.37225,5.73318-2.15661,9.21883-2.15661,3.52143,0,6.92537.79877,9.34104,2.1951,1.89261,1.09136,2.97924,2.41071,2.97924,3.61979,0,1.18746-1.06255,2.48026-2.91217,3.54776-4.76651,2.76115-13.75239,2.74202-18.55964-.03826-1.89283-1.09158-2.97946-2.41094-2.97946-3.62001,0-1.18724,1.06278-2.48026,2.91217-3.54776ZM1313.83583,512.09675c-2.37245,1.36977-5.73093,2.15661-9.2141,2.15661-3.52391,0-6.9301-.80125-9.34577-2.19735-1.89261-1.09136-2.97946-2.41094-2.97946-3.61979,0-.47737.21472-.97095.54039-1.46092l1.08371.60206,1.56761-2.82034c2.35445-1.28154,5.57609-2.02517,8.93682-2.02517,3.52166,0,6.92785.80102,9.34352,2.19712,1.89261,1.09158,2.97946,2.41094,2.97946,3.62001,0,1.18499-1.06278,2.48026-2.91217,3.54776Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-484",
    d: "M514.91029,682.08915c3.8453-2.21896,6.04986-5.47908,6.04986-8.93817-.00225-3.49262-2.12533-6.63999-5.98256-8.86614-3.32494-1.92141-7.68836-2.98171-12.28697-2.98171-4.6344,0-9.0435,1.07223-12.41391,3.01773-3.84463,2.22008-6.04918,5.47886-6.04986,8.94042,0,1.98263.70694,3.84665,2.00537,5.50181l-112.93176,63.66753-65.07083-34.03472-65.91979,41.42778-18.96882-11.58993c1.74519-1.84174,2.69273-3.9934,2.69273-6.30283,0-3.46156-2.20454-6.71921-6.04986-8.94064-3.3704-1.94527-7.7795-3.01773-12.41413-3.01773-4.59861,0-8.96202,1.0603-12.28674,2.97946-3.85746,2.22841-5.98279,5.37825-5.98279,8.8684.00248,3.46156,2.20703,6.72169,6.04986,8.94064,3.37042,1.94527,7.77704,3.01525,12.41166,3.01525,4.38029,0,8.51954-.98535,11.78056-2.73459l-.91873,1.50391,23.72925,14.50345,66.15522-41.57655,64.90293,33.94334,118.11623-66.58668-.05582-.09836c3.14063,1.51111,6.97039,2.37605,11.02748,2.37605,4.6344,0,9.04102-1.06998,12.41143-3.01773ZM216.98034,735.47868c-4.76877,2.76115-13.74992,2.74202-18.55965-.03826-1.89261-1.09158-2.97946-2.41094-2.97946-3.62001,0-1.18724,1.06277-2.48026,2.91216-3.55024,2.37246-1.36977,5.73093-2.15661,9.21635-2.15661,3.52166,0,6.92785.80125,9.34352,2.19735,1.89261,1.09158,2.97947,2.41094,2.97947,3.62001,0,1.18724-1.06278,2.48026-2.91239,3.54776ZM490.36787,673.26127c0-1.20885,1.08663-2.5282,2.97946-3.61979,2.41544-1.3961,5.82186-2.19735,9.34329-2.19735,3.48564,0,6.8439.78684,9.21635,2.15886,1.84962,1.0675,2.90992,2.36052,2.91217,3.54799,0,1.2066-1.08663,2.52843-2.97924,3.61979-4.805,2.77915-13.78863,2.79828-18.55987.03849-1.84939-1.0675-2.91217-2.36052-2.91217-3.54799Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-482",
    d: "M609.15998,735.44447c3.8453-2.21896,6.04986-5.47886,6.04986-8.93794-.00248-3.49285-2.12533-6.63999-5.98279-8.86614-3.32472-1.92141-7.68813-2.98171-12.28674-2.98171-4.63462,0-9.0435,1.07223-12.41391,3.01773-3.84349,2.21941-6.04806,5.47886-6.04986,8.94042,0,2.80841,1.39612,5.3859,3.94186,7.45024l-68.3062,38.69927,97.47425,56.19501-40.16605,23.51566-38.93447-23.18459c1.75891-1.84714,2.71433-4.0078,2.71433-6.32579,0-3.45909-2.2068-6.71674-6.04986-8.93569-3.36793-1.94775-7.77704-3.0202-12.41391-3.0202-4.59612,0-8.95977,1.05805-12.28697,2.97699-3.85723,2.22863-5.98031,5.37577-5.98031,8.86862,0,3.46156,2.20455,6.71899,6.04761,8.94042,3.37041,1.9455,7.78176,3.01773,12.41638,3.01773,3.53111,0,6.91277-.63559,9.80515-1.79605l44.65796,26.58808,52.41453-30.68839-97.32075-56.10386,61.51092-34.85037-.6428-1.13457c2.79873,1.05535,6.02645,1.63288,9.39012,1.63288,4.63461,0,9.04123-1.06975,12.41164-3.01773ZM507.58724,826.47859c-1.89262-1.09384-2.97678-2.41319-2.97678-3.62226,0-1.18746,1.06008-2.48049,2.90969-3.54799,2.37245-1.37202,5.73318-2.15639,9.21635-2.15639,3.52391,0,6.92785.80102,9.34352,2.19712,1.89261,1.09158,2.97924,2.41094,2.97924,3.62001,0,1.18746-1.0603,2.48026-2.90969,3.54776-4.76899,2.75394-13.75509,2.73481-18.56233-.03826ZM584.61755,726.61681c0-1.20907,1.08665-2.52843,2.97924-3.61979,2.41567-1.3961,5.82209-2.19735,9.34352-2.19735,3.48542,0,6.8439.78684,9.21635,2.15886,1.84939,1.0675,2.90971,2.36052,2.91217,3.54799,0,1.2066-1.08663,2.52843-2.97946,3.61979-4.80477,2.77848-13.78839,2.79761-18.55964.03849-1.84962-1.0675-2.91217-2.36052-2.91217-3.54799Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-480",
    d: "M981.06698,607.94713c-4.59861,0-8.962,1.0603-12.28922,2.97924-3.85498,2.22863-5.98031,5.37577-5.98031,8.86614,0,3.46156,2.20455,6.71921,6.04986,8.94289,3.37041,1.9455,7.77706,3.01525,12.41166,3.01525,4.59839,0,8.96202-1.05782,12.28922-2.97699,3.85723-2.22841,5.98031-5.37577,5.98031-8.8684,0-2.06793-.80192-4.05777-2.25497-5.80228l60.3858-38.05085-57.89833-33.44458,52.18316-31.59564c3.0004,1.26669,6.53333,1.97723,10.23456,1.97723,4.59613,0,8.95977-1.05782,12.28697-2.97699,3.85723-2.22841,5.98031-5.37577,5.98031-8.8684,0-3.46156-2.20455-6.71921-6.04986-8.93817-3.36816-1.94775-7.77704-3.01998-12.41413-3.01998-4.59611,0-8.95955,1.05782-12.28672,2.97676-3.85749,2.22863-5.98034,5.37577-5.98034,8.86862,0,2.22976.92529,4.36994,2.60337,6.20808l-58.61856,35.49316,58.07569,33.55014-53.85677,33.93749c-3.12621-1.44652-6.88531-2.27275-10.8517-2.27275ZM1052.76565,497.48302c2.37245-1.37202,5.73318-2.15639,9.21635-2.15639,3.52391,0,6.92785.80102,9.34352,2.19735,1.89261,1.09136,2.97924,2.41071,2.97924,3.61979,0,1.18746-1.06008,2.48026-2.90969,3.54776-4.76876,2.75642-13.75239,2.73706-18.56212-.03826-1.89283-1.09384-2.97699-2.41319-2.97699-3.62226,0-1.18746,1.0603-2.48049,2.90969-3.54799ZM990.47757,623.45304c-4.76651,2.76115-13.75262,2.73954-18.55987-.03601-1.89261-1.09384-2.97924-2.41544-2.97924-3.62451,0-1.18499,1.0603-2.47801,2.90969-3.54799,2.37248-1.36955,5.73318-2.15639,9.21883-2.15639,3.52143,0,6.92788.80125,9.34352,2.19487,1.89261,1.09384,2.97676,2.41319,2.97676,3.62226,0,1.18746-1.06008,2.48026-2.90969,3.54776Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-481",
    d: "M899.2312,664.32085c-3.37018-1.9455-7.77929-3.01773-12.41388-3.01773-4.59863,0-8.96205,1.0603-12.28924,2.97946-3.85496,2.22841-5.98031,5.37577-5.98031,8.86592,0,3.46156,2.20455,6.71921,6.04986,8.94177,3.36973,1.9455,7.77704,3.0166,12.41166,3.0166,4.46537,0,8.69037-1.01484,11.97862-2.82957l207.69888,119.26521,1.59754.91896,72.57013-45.49276c3.16942,1.51832,7.01855,2.38551,11.08446,2.38551,4.5961,0,8.95974-1.05782,12.28694-2.97676,3.85726-2.22863,5.98256-5.37825,5.98256-8.86862-.00225-3.46156-2.2068-6.72146-6.04986-8.94042-3.37041-1.9455-7.78176-3.01773-12.41638-3.01773-4.59613,0-8.95955,1.05782-12.28427,2.97699-3.85746,2.22841-5.98279,5.37577-5.98279,8.8684,0,1.99771.75511,3.92025,2.11565,5.62177l-67.44554,42.28057-204.30282-117.31386c.93494-1.45372,1.43639-3.04698,1.43639-4.7233,0-3.46156-2.20455-6.71899-6.04761-8.94042ZM1182.5283,743.84832c2.37245-1.36977,5.73093-2.15661,9.21388-2.15661,3.52391,0,6.93033.80125,9.34599,2.19735,1.89264,1.09136,2.97924,2.41071,2.97924,3.61979,0,1.18746-1.06255,2.48049-2.91217,3.54799-4.76651,2.76092-13.75239,2.73932-18.55987-.04096-1.89261-1.09136-2.97924-2.41071-2.97924-3.61979,0-1.18746,1.06278-2.48026,2.91217-3.54776ZM877.66826,676.77324c-1.89283-1.09384-2.97949-2.41567-2.97949-3.62474,0-1.18499,1.0603-2.47801,2.90992-3.54776,2.37245-1.36977,5.73318-2.15661,9.21863-2.15661,3.52141,0,6.92783.80125,9.34349,2.19487,1.89261,1.09406,2.97699,2.41342,2.97699,3.62226,0,1.18746-1.06028,2.48049-2.90992,3.54799-4.76696,2.7598-13.75127,2.73819-18.55962-.03601Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "M733.01299,904.08555c4.59861,0,8.96202-1.0603,12.28922-2.97924,3.85746-2.22863,5.98031-5.37577,5.98031-8.86862,0-3.46134-2.20455-6.71899-6.04986-8.94042-3.37041-1.9455-7.77704-3.01525-12.41166-3.01525-4.59839,0-8.96202,1.05782-12.2892,2.97699-3.85725,2.22841-5.98033,5.37577-5.98033,8.8684,0,1.67924.52846,3.30671,1.50121,4.79532l-27.07513,16.26889.51811.86246c-3.33665-1.8593-7.62826-2.89439-12.1499-2.89439-4.59636,0-8.95977,1.05805-12.28697,2.97699-3.85723,2.22863-5.98256,5.37825-5.98256,8.86862.00225,3.46156,2.2068,6.72146,6.04986,8.93794,3.37018,1.94797,7.77929,3.0202,12.41391,3.0202,4.59613,0,8.95955-1.05782,12.28674-2.97699,3.85746-2.22841,5.98279-5.37577,5.98279-8.8684,0-1.99164-.75083-3.90787-2.10259-5.60489l27.15728-16.31863c3.33665,1.85592,7.62759,2.89101,12.14878,2.89101ZM723.60241,888.57964c2.37245-1.37225,5.73318-2.15661,9.2186-2.15661,3.52166,0,6.9256.79877,9.34127,2.19487,1.89261,1.09158,2.97924,2.41094,2.97924,3.61979,0,1.18746-1.0603,2.48049-2.90969,3.55046-4.76651,2.7562-13.75507,2.73706-18.56234-.03849-1.89261-1.09384-2.97676-2.41319-2.97676-3.62226,0-1.18746,1.06008-2.48026,2.90969-3.54776ZM686.75635,926.66582c-4.76651,2.76115-13.75262,2.73954-18.55985-.04074-1.89262-1.09158-2.97926-2.41094-2.97926-3.61979,0-1.18746,1.06255-2.48049,2.91217-3.54799,2.37245-1.37202,5.73071-2.15661,9.21635-2.15661,3.52143,0,6.92762.80125,9.34329,2.19735,1.89283,1.09158,2.97946,2.41094,2.97946,3.62001,0,1.18724-1.06276,2.48026-2.91217,3.54776Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-302",
    d: "M784.61682,1013.81796c-3.37039-1.94797-7.77704-3.0202-12.41413-3.0202-3.81762,0-7.43628.76704-10.47021,2.1134l-154.03702-88.48094,172.65136-97.87015-70.68406-42.07846c1.3889-1.69837,2.14221-3.62586,2.14221-5.67759-.00248-3.46156-2.20701-6.72146-6.04986-8.94042-3.37041-1.9455-7.77704-3.01525-12.41164-3.01525-4.59863,0-8.96204,1.05782-12.28924,2.97699-3.85721,2.22841-5.98256,5.37802-5.98256,8.8684.00225,3.46156,2.2068,6.72146,6.04986,8.94042,3.37018,1.9455,7.77683,3.01548,12.41143,3.01548,3.92881,0,7.64402-.81272,10.72994-2.23471l63.85951,38.01574-172.81926,97.9658,160.89218,92.4183c-1.46925,1.73371-2.25969,3.71634-2.25969,5.82839,0,3.46156,2.2021,6.71921,6.04738,8.94289,3.37043,1.9455,7.77704,3.01548,12.41166,3.01548,4.59861,0,8.9645-1.05805,12.2917-2.97699,3.85723-2.22863,5.98031-5.37577,5.98031-8.86862,0-3.46134-2.20453-6.71899-6.04986-8.93794ZM684.19192,782.31352c-1.89259-1.09136-2.97924-2.41071-2.97924-3.61979,0-1.18746,1.06255-2.48049,2.91217-3.54799,2.37245-1.37202,5.73318-2.15639,9.21862-2.15639,3.52141,0,6.92537.79877,9.34102,2.19487,1.89283,1.09136,2.97946,2.41071,2.97946,3.61979,0,1.18746-1.06278,2.48049-2.91217,3.54799-4.76899,2.76092-13.75014,2.74179-18.55987-.03849ZM781.61575,1026.30389c-4.77124,2.75867-13.75487,2.73954-18.56212-.03601-1.89261-1.09384-2.97699-2.41567-2.97699-3.62474,0-1.18499,1.0603-2.47779,2.90994-3.54776,2.37243-1.36977,5.73069-2.15661,9.21611-2.15661,3.52391,0,6.92785.80125,9.34352,2.19735,1.89283,1.09158,2.97948,2.41094,2.97948,3.61979,0,1.18746-1.06032,2.48049-2.90994,3.54799Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M478.818,871.9844c0,3.46156,2.20455,6.71921,6.04761,8.94042,3.37041,1.9455,7.78176,3.01773,12.41638,3.01773,4.59613,0,8.95955-1.05782,12.28674-2.97924,3.85723-2.22863,5.98031-5.37825,5.98031-8.86862,0-3.45909-2.20703-6.71674-6.04986-8.93569-3.36793-1.94775-7.77704-3.01998-12.41391-3.01998-4.41023,0-8.58121.99616-11.85326,2.7706l-86.35021-49.34414,156.57175-93.10836-1.33421-2.24394c3.17302,1.56806,7.07595,2.46406,11.21271,2.46406,4.63462,0,9.04125-1.06975,12.41166-3.01773,3.8453-2.21896,6.04986-5.47886,6.04986-8.93794-.00246-3.49285-2.12555-6.63999-5.98279-8.86614-3.32472-1.92141-7.68836-2.98171-12.28674-2.98171-4.63462,0-9.04372,1.07223-12.41413,3.01773-3.84395,2.21941-6.04851,5.47886-6.04986,8.94042,0,2.72446,1.3099,5.23376,3.71161,7.26613l-164.08095,97.57306,93.61815,53.49644c-.97389,1.47848-1.49087,3.10528-1.49087,4.81693ZM556.18053,705.21207c2.41567-1.3961,5.82186-2.19735,9.34352-2.19735,3.48542,0,6.8439.78684,9.21635,2.15886,1.84939,1.0675,2.90969,2.36052,2.91217,3.54799,0,1.2066-1.08686,2.5282-2.97946,3.61979-4.80476,2.77848-13.7884,2.79761-18.55987.03849-1.84939-1.0675-2.91217-2.36052-2.91217-3.54799,0-1.20907,1.08686-2.52843,2.97946-3.61979ZM497.08528,866.28003c3.52391,0,6.92786.80125,9.34329,2.19735,1.89283,1.09136,2.97948,2.41071,2.97948,3.61979,0,1.18746-1.06031,2.48049-2.90971,3.54799-4.76651,2.7562-13.75509,2.73706-18.56234-.03849-1.89261-1.09384-2.97699-2.41319-2.97699-3.62226,0-1.18746,1.0603-2.48049,2.90993-3.54776,2.37244-1.37225,5.73317-2.15661,9.21634-2.15661Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-304",
    d: "M888.72858,766.79546c-3.37041-1.94775-7.77951-3.01998-12.41391-3.01998-4.25313,0-8.26994.94034-11.48797,2.59662l-56.16461-33.78466c1.54553-1.76544,2.36703-3.80097,2.36703-5.97063,0-3.46156-2.20455-6.71921-6.04738-8.94042-3.37041-1.9455-7.77951-3.01773-12.41413-3.01773-4.59836,0-8.96202,1.0603-12.28922,2.97924-3.85476,2.22863-5.98031,5.37577-5.98031,8.86614,0,3.46156,2.20455,6.71921,6.04986,8.94109,3.36861,1.9455,7.77704,3.01705,12.41166,3.01705,3.76315,0,7.33455-.74115,10.34372-2.05038l56.6582,34.0804c-1.11544,1.56153-1.71638,3.29524-1.71638,5.12865.00225,3.46156,2.2068,6.72146,6.04986,8.93794,3.37041,1.94797,7.77929,3.0202,12.41391,3.0202,4.59616,0,8.95977-1.05782,12.28677-2.97699,3.85743-2.22841,5.98276-5.37577,5.98276-8.8684,0-3.46156-2.20455-6.71921-6.04986-8.93817ZM783.41855,730.12879c-1.89261-1.09384-2.97946-2.41567-2.97946-3.62474,0-1.18499,1.0603-2.47801,2.90992-3.54776,2.37245-1.36977,5.73318-2.15661,9.2186-2.15661,3.52166,0,6.92785.80125,9.34352,2.19487,1.89261,1.09384,2.97699,2.41319,2.97699,3.62226,0,1.18746-1.0603,2.48049-2.90969,3.54799-4.76831,2.75912-13.75014,2.73751-18.55987-.03601ZM885.72526,779.28139c-4.76649,2.75867-13.75262,2.73706-18.55987-.04074-1.89261-1.09136-2.97924-2.41071-2.97924-3.61979,0-1.18746,1.06255-2.48049,2.91217-3.54799,2.37245-1.37202,5.73071-2.15639,9.21635-2.15639,3.52143,0,6.92785.80102,9.34354,2.19712,1.89258,1.09158,2.97922,2.41094,2.97922,3.62001,0,1.18746-1.06278,2.48026-2.91217,3.54776Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-313",
    d: "M292.36631,640.86393c-3.37041-1.9455-7.77704-3.01548-12.41165-3.01548-4.59862,0-8.96203,1.05805-12.28923,2.97699-3.85723,2.22863-5.98279,5.37825-5.98279,8.86862.00248,3.46134,2.20703,6.72146,6.04986,8.94042,3.37041,1.9455,7.77704,3.01525,12.41166,3.01525,3.79917,0,7.40162-.75736,10.42767-2.09044l93.84974,51.95989,78.47054-45.07885-.26446-.46004c2.57997.84806,5.45072,1.34096,8.45427,1.34096,4.6344,0,9.04102-1.06998,12.41143-3.01773,3.8453-2.21896,6.04986-5.47908,6.04986-8.93817-.00225-3.49262-2.12533-6.63999-5.98256-8.86592-3.32494-1.92164-7.68836-2.98194-12.28697-2.98194-4.6344,0-9.0435,1.07245-12.41389,3.01773-3.84418,2.22076-6.04874,5.47908-6.04986,8.94064,0,2.79761,1.38529,5.36542,3.91124,7.42548l-72.35722,41.5653-88.20568-48.83548c1.4679-1.73326,2.25789-3.71589,2.25789-5.82681-.00248-3.46156-2.20702-6.72146-6.04986-8.94042ZM461.93017,651.85585c2.41567-1.3961,5.8221-2.19735,9.34352-2.19735,3.48564,0,6.8439.78684,9.21635,2.15909,1.84962,1.0675,2.90992,2.3603,2.91217,3.54776,0,1.2066-1.08663,2.52843-2.97924,3.62001-4.805,2.7796-13.78863,2.79873-18.55987.03826-1.84939-1.0675-2.91217-2.36052-2.91217-3.54776,0-1.20907,1.08663-2.52843,2.97924-3.62001ZM270.80312,653.31385c-1.8926-1.09158-2.97946-2.41094-2.97946-3.61979,0-1.18746,1.06278-2.48049,2.91218-3.54799,2.37244-1.37202,5.7334-2.15661,9.21883-2.15661,3.52142,0,6.92537.799,9.34103,2.1951,1.89261,1.09136,2.97946,2.41071,2.97946,3.61979,0,.89825-.61174,1.85547-1.70805,2.73099l-.07675-.04186-.08328.15057c-.31802.24285-.65315.48277-1.0441.70807-4.76899,2.76115-13.75014,2.74202-18.55987-.03826Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-309",
    d: "M645.22774,253.71119c0,3.46134,2.20455,6.71899,6.04986,8.93794,3.37018,1.94797,7.77929,3.0202,12.41391,3.0202,4.59613,0,8.95955-1.05805,12.28674-2.97699,3.85746-2.22863,5.98279-5.37825,5.98279-8.86862-.00248-3.46134-2.20703-6.72146-6.04986-8.94042-3.37041-1.9455-7.78176-3.01773-12.41637-3.01773-4.54709,0-8.85896,1.04229-12.16995,2.92252l-103.02445-56.87472,88.47374-53.374,196.93248,108.78712-79.05978,49.2253c-.25905-.17083-.50843-.34728-.78549-.50731-3.37041-1.9455-7.77704-3.01548-12.41164-3.01548-4.59863,0-8.96204,1.05805-12.28924,2.97699-3.85721,2.22863-5.98279,5.37577-5.98279,8.86862,0,3.46156,2.20455,6.71899,6.04986,8.94042,3.37041,1.9455,7.78199,3.01773,12.41638,3.01773,4.59636,0,8.95977-1.05782,12.28449-2.97946,3.85746-2.22841,5.98279-5.37802,5.98279-8.8684-.00133-1.33849-.33828-2.64344-.9651-3.87299l86.8888-54.1021-207.64307-114.70261-1.55208-.85886-100.61666,60.70022,110.53478,61.02499c-.86066,1.40466-1.33016,2.93152-1.33016,4.53762ZM750.85804,304.53516c-2.37245,1.36977-5.73093,2.15661-9.2141,2.15661-3.52391,0-6.9301-.80125-9.34577-2.19735-1.89259-1.09136-2.97946-2.41094-2.97946-3.61979,0-1.18746,1.06278-2.48049,2.91239-3.54799,2.37245-1.37202,5.73318-2.15661,9.21862-2.15661,3.52141,0,6.92537.799,9.34102,2.19262,1.89283,1.09384,2.97946,2.41567,2.97946,3.62226,0,1.18746-1.06278,2.48274-2.91217,3.55024ZM672.84056,250.20394c1.89283,1.09158,2.97946,2.41094,2.97946,3.61979,0,1.18746-1.06276,2.48049-2.91217,3.54799-4.76899,2.76115-13.75012,2.73954-18.55985-.04074-1.89262-1.09158-2.97926-2.41094-2.97926-3.61979,0-.50686.23092-1.03217.59666-1.55208l.45151.24938.86605-1.56873c.30699-.2316.62434-.46072.99796-.67656,2.37245-1.36977,5.73071-2.15661,9.21389-2.15661,3.52389,0,6.93031.80125,9.34575,2.19735Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M950.66173,236.02797l-122.67635,76.16426,106.70005,58.63949-106.46258,61.98109,3.08973,5.30623,115.84213-67.44081-107.00727-58.80739,116.57136-72.3777-.06595-.10601c2.71613.95519,5.78112,1.49738,8.98003,1.49738,4.59861,0,8.96202-1.05782,12.28922-2.97699,3.85723-2.22841,5.98279-5.37577,5.98279-8.8684,0-3.46156-2.20455-6.71921-6.04986-8.94042-3.37041-1.9455-7.77704-3.01548-12.41166-3.01548-4.59859,0-8.96202,1.05782-12.28919,2.97699-3.85748,2.22863-5.98281,5.37825-5.98281,8.8684.0018,2.59865,1.24511,5.08318,3.49037,7.09935ZM956.22453,225.38085c2.37245-1.37225,5.73318-2.15661,9.21883-2.15661,3.52143,0,6.92537.79877,9.34104,2.19487,1.89261,1.09158,2.97924,2.41094,2.97924,3.62001,0,1.18746-1.06255,2.48026-2.91217,3.54776-4.76629,2.76115-13.75237,2.74202-18.55964-.03826-1.89283-1.09158-2.97946-2.41094-2.97946-3.62001,0-1.18724,1.06278-2.48026,2.91217-3.54776Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "M171.75272,848.50947l120.29084-73.4398c3.1863,1.54487,7.07054,2.42714,11.17738,2.42714,4.59861,0,8.9645-1.05805,12.2917-2.97699,3.85723-2.22863,5.98031-5.37577,5.98031-8.86862,0-3.46156-2.20455-6.71899-6.04986-8.93794-3.36793-1.9455-7.77704-3.01773-12.41166-3.01773-4.5986,0-8.96202,1.05782-12.28921,2.97699-3.85724,2.22841-5.98032,5.37577-5.98032,8.8684,0,1.96215.73057,3.85138,2.04453,5.53107l-115.13991,70.29379-65.72939-37.99638c.44024-1.0477.68961-2.14648.68961-3.28758,0-3.46156-2.20433-6.71921-6.04986-8.94064-3.37018-1.94527-7.77704-3.01525-12.41143-3.01525-4.59861,0-8.96202,1.05782-12.28922,2.97699-3.85746,2.22841-5.98279,5.37825-5.98279,8.8684.00248,3.46156,2.20703,6.72169,6.04986,8.94064,3.37041,1.94527,7.77704,3.01525,12.41166,3.01525,4.59861,0,8.96202-1.05782,12.28922-2.97699.44744-.25838.86652-.53251,1.26646-.8143l69.84207,40.37356ZM290.90291,765.54092c0-1.18746,1.0603-2.48049,2.90992-3.54799,2.37245-1.37202,5.73318-2.15639,9.2186-2.15639,3.52143,0,6.92537.79877,9.34104,2.19487,1.89283,1.09136,2.97946,2.41071,2.97946,3.61979,0,1.18746-1.0603,2.48049-2.90992,3.54799-4.77371,2.76092-13.75486,2.73932-18.56212-.03601-.29934-.17285-.54152-.35989-.79945-.54287l-.61354-1.00448-.34346.20999c-.76343-.75263-1.22055-1.53767-1.22055-2.2849ZM79.01392,803.59132c-1.89283-1.09158-2.97946-2.41094-2.97946-3.62001,0-1.18724,1.06278-2.48026,2.91217-3.54776,2.37245-1.37225,5.73318-2.15661,9.21883-2.15661,3.52143,0,6.92537.79877,9.34104,2.19487,1.89261,1.09158,2.97924,2.41094,2.97924,3.62001,0,1.18724-1.06255,2.48026-2.91217,3.54776-4.76651,2.75867-13.75239,2.73954-18.55964-.03826Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-312",
    d: "M523.5732,701.70302l-.67768-1.18364c3.13949,1.50886,6.96611,2.37245,11.01961,2.37245,4.63462,0,9.04125-1.06998,12.41166-3.01773,3.8453-2.21896,6.04986-5.47908,6.04986-8.93817-.00248-3.49262-2.12555-6.63999-5.98279-8.86614-3.32472-1.92141-7.68836-2.98171-12.28673-2.98171-4.63464,0-9.04374,1.07223-12.41415,3.01773-3.8435,2.22008-6.04806,5.47886-6.04986,8.94042,0,2.38326,1.01169,4.59794,2.86738,6.47816l-336.67424,192.77569c-.21944-.14157-.42628-.29079-.65833-.42516-3.37041-1.9455-7.77703-3.01525-12.41165-3.01525-4.59861,0-8.9645,1.05782-12.2917,2.97699-3.85723,2.22841-5.98031,5.37577-5.98031,8.8684,0,3.46156,2.20455,6.71921,6.04986,8.93794,3.36793,1.9455,7.77704,3.01795,12.41166,3.01795,4.59861,0,8.96202-1.05805,12.28921-2.97699,3.85723-2.22863,5.98031-5.37577,5.98031-8.86862,0-1.36549-.35493-2.69633-1.00696-3.94726l337.35485-193.16506ZM524.76359,687.42644c2.41567-1.3961,5.82186-2.19735,9.34353-2.19735,3.4854,0,6.84388.78684,9.21634,2.15909,1.84939,1.06728,2.90969,2.3603,2.91217,3.54776,0,1.2066-1.08686,2.52843-2.97945,3.61979-4.80479,2.77915-13.78842,2.79828-18.55988.03849-1.84938-1.0675-2.91217-2.36052-2.91217-3.54799,0-1.20885,1.08686-2.5282,2.97946-3.61979ZM178.17438,902.36332c-4.76876,2.76092-13.74991,2.74179-18.55964-.03849-1.89261-1.09136-2.97946-2.41071-2.97946-3.61979,0-1.18746,1.0603-2.48049,2.90992-3.54799,2.3747-1.37202,5.73566-2.15639,9.22108-2.15639,3.52143,0,6.92537.79877,9.34103,2.1924,1.89261,1.09384,2.97699,2.41342,2.97699,3.62226,0,1.18746-1.06029,2.48049-2.90992,3.54799Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M1023.86701,685.37426l78.12532-46.54338c2.79086,1.02857,5.98141,1.59889,9.305,1.59889,4.59861,0,8.9645-1.05805,12.2917-2.97699,3.85723-2.22863,5.98031-5.37577,5.98031-8.86862,0-3.46156-2.20455-6.71899-6.04986-8.94042-3.37041-1.9455-7.77704-3.01525-12.41166-3.01525-4.59861,0-8.96202,1.05782-12.28922,2.97699-3.85743,2.22841-5.98031,5.37577-5.98031,8.8684,0,2.46428,1.13525,4.81805,3.16582,6.7748l-72.11324,42.96275-57.82384-34.96605c1.32408-1.66776,2.04498-3.55091,2.04498-5.55515,0-3.46156-2.20455-6.71921-6.04735-8.94042-3.37043-1.9455-7.77954-3.01773-12.41393-3.01773-4.59861,0-8.96225,1.0603-12.28944,2.97924-3.85476,2.22863-5.98008,5.37577-5.98008,8.86614,0,3.46156,2.20433,6.71921,6.04986,8.94289,3.36973,1.9455,7.77681,3.01525,12.41143,3.01525,4.59861,0,8.96202-1.05782,12.28922-2.97699.13437-.0772.2496-.1643.37969-.24397l-.86536,1.43144,62.22098,37.62817ZM1101.88899,624.92589c2.37245-1.37202,5.73318-2.15639,9.21883-2.15639,3.52143,0,6.92537.79877,9.34104,2.19487,1.89261,1.09158,2.97924,2.41094,2.97924,3.61979,0,1.18746-1.06008,2.48049-2.90969,3.54799-4.77371,2.75867-13.75236,2.73706-18.56209-.03601-1.89283-1.09384-2.97702-2.41319-2.97702-3.62226,0-1.18746,1.0603-2.48049,2.90969-3.54799ZM959.0613,641.23799c-4.76719,2.76115-13.75262,2.73954-18.55987-.03579-1.89261-1.09406-2.97924-2.41567-2.97924-3.62474,0-1.18499,1.06008-2.47801,2.90969-3.54799,2.37245-1.36955,5.73318-2.15639,9.21883-2.15639,3.52146,0,6.92762.80125,9.34329,2.19487,1.89283,1.09384,2.97699,2.41319,2.97699,3.62226,0,1.18746-1.0603,2.48026-2.90969,3.54776Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-315",
    d: "M959.02934,302.16878c1.50234-1.74811,2.30718-3.75415,2.30718-5.89028-.00248-3.46156-2.20703-6.72169-6.04986-8.94064-3.37038-1.94527-7.78174-3.01773-12.41638-3.01773-4.59613,0-8.95952,1.05805-12.28449,2.97946-3.85723,2.22616-5.98256,5.37577-5.98256,8.86614,0,3.46134,2.20455,6.72146,6.04986,8.94267,3.37041,1.9455,7.77706,3.01548,12.41143,3.01548,3.80052,0,7.4041-.75803,10.43082-2.09179l54.99269,32.54498,100.45011-60.77562c.13189.08147.2505.1715.38734.2505,3.37041,1.9455,7.77704,3.01548,12.41143,3.01548,4.59861,0,8.9645-1.05782,12.29173-2.97699,3.85743-2.22863,5.98028-5.37577,5.98028-8.8684,0-3.46156-2.20455-6.71921-6.04986-8.93817-3.37041-1.94775-7.77951-3.0202-12.41391-3.0202-4.59861,0-8.96202,1.05805-12.28697,2.97946-3.85723,2.22616-5.98031,5.37577-5.98031,8.86614,0,1.4697.41998,2.89641,1.17126,4.22972l-95.99464,58.07997-49.42516-29.2502ZM933.72348,299.79025c-1.89261-1.09384-2.97924-2.41567-2.97924-3.62451,0-1.18746,1.06255-2.48049,2.91219-3.54799,2.37243-1.36977,5.73068-2.15661,9.21385-2.15661,3.52391,0,6.93035.80125,9.34577,2.19735,1.89283,1.09158,2.97949,2.41094,2.97949,3.62001,0,.87372-.58408,1.80325-1.62525,2.65964l-.46904-.27774-.60386,1.02069c-.07742.04681-.13369.09903-.21404.14517-4.76899,2.76115-13.75014,2.73954-18.55987-.03601ZM1112.32882,265.5613c2.37245-1.36977,5.73071-2.15661,9.21635-2.15661,3.52143,0,6.92785.80125,9.34352,2.19735,1.89261,1.09158,2.97924,2.41094,2.97924,3.62001,0,1.18724-1.0603,2.48026-2.90969,3.54776-4.77146,2.76115-13.75509,2.73954-18.56234-.03601-1.89261-1.09384-2.97676-2.41567-2.97676-3.62451,0-1.18746,1.06008-2.48049,2.90969-3.54799Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-311",
    d: "M974.48461,410.15105l110.59937-67.26571c2.75687.99548,5.89028,1.55455,9.15761,1.55455,4.59861,0,8.96202-1.05805,12.28922-2.97699,3.85723-2.22863,5.98031-5.37577,5.98031-8.86862,0-3.46134-2.20455-6.71899-6.04738-8.94042-3.37041-1.9455-7.77704-3.01525-12.41166-3.01525-4.59861,0-8.9645,1.05782-12.2917,2.97699-3.8572,2.22841-5.98031,5.37577-5.98031,8.8684,0,2.50862,1.17126,4.9038,3.27205,6.88059l-116.83514,71.05992,38.02136,20.8675-106.45788,61.97861,3.08975,5.30623,115.84686-67.44306-38.23248-20.98274ZM1084.83101,328.93624c2.3747-1.37225,5.73566-2.15661,9.22108-2.15661,3.52143,0,6.92537.79877,9.34104,2.1924,1.89261,1.09406,2.97699,2.41342,2.97699,3.62226,0,1.18746-1.06027,2.48049-2.90992,3.54799-4.76629,2.76092-13.75239,2.74179-18.55961-.03849-1.89263-1.09136-2.97949-2.41071-2.97949-3.61979,0-1.18746,1.0603-2.48049,2.90992-3.54776Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-314",
    d: "M716.88569,473.5332l115.86372-67.45297-178.87405-97.45512,102.99159-64.23358-79.09738-42.06045c.69749-1.28514,1.08011-2.66279,1.08011-4.10503-.00225-3.46156-2.2068-6.72146-6.04986-8.94042-3.37041-1.9455-7.77704-3.01548-12.41143-3.01548-4.59861,0-8.96225,1.05805-12.28922,2.97699-3.85746,2.22863-5.98279,5.37577-5.98279,8.86862,0,3.46134,2.20455,6.71899,6.04986,8.94042,3.37041,1.9455,7.77704,3.01525,12.41167,3.01525,4.59837,0,8.96201-1.05782,12.2892-2.97699.12469-.0718.2325-.1535.35381-.22777l71.36401,37.94709-102.88605,64.17124,178.53826,97.27281-106.44122,61.96916,3.08977,5.30623ZM651.23663,201.73555c-1.89261-1.09158-2.97924-2.41094-2.97924-3.61979,0-1.18746,1.06278-2.48049,2.91217-3.54799,2.37245-1.37202,5.73318-2.15661,9.21883-2.15661,3.52143,0,6.92537.799,9.34104,2.1951,1.89262,1.09136,2.97924,2.41071,2.97924,3.61979,0,1.18746-1.06255,2.48049-2.91217,3.54776-4.76876,2.75867-13.75239,2.74202-18.55987-.03826Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M97.99106,473.98401c3.3272,1.91916,7.69308,2.97699,12.2917,2.97699,3.72467,0,7.27311-.71955,10.28363-2.00176l158.68312,93.02081-37.64032,22.09323,141.5817,83.86568,46.35387-26.34748c2.96191,1.24621,6.4534,1.94415,10.12068,1.94415,4.63463,0,9.04125-1.06975,12.41166-3.01773,3.8453-2.21896,6.04986-5.47886,6.04986-8.93794-.00248-3.49285-2.12533-6.63999-5.98279-8.86614-3.32471-1.92141-7.68813-2.98171-12.28674-2.98171-4.63462,0-9.04372,1.07223-12.41391,3.01773-3.84485,2.22121-6.04941,5.47886-6.04986,8.94042,0,2.21175.85751,4.28306,2.46226,6.07191l-40.60268,23.07633-129.55379-76.74112,37.68804-22.12204-165.18424-96.82853c1.63895-1.82238,2.53855-3.93938,2.53855-6.14146,0-3.49285-2.12308-6.63999-5.98031-8.86614-3.32494-1.92141-7.68836-2.98171-12.28697-2.98171-4.63687,0-9.0435,1.07223-12.41391,3.01773-3.8453,2.22121-6.04986,5.47886-6.04986,8.94042,0,3.49262,2.12285,6.63999,5.98031,8.8684ZM430.51391,634.07044c2.41568-1.3961,5.82209-2.19735,9.34352-2.19735,3.48542,0,6.8439.78684,9.21636,2.15886,1.84938,1.0675,2.90968,2.36052,2.91216,3.54799,0,1.2066-1.08663,2.5282-2.97946,3.61979-4.80477,2.78028-13.7884,2.79941-18.55964.03826-1.84962-1.0675-2.91216-2.3603-2.91216-3.54776,0-1.20907,1.08662-2.52843,2.97923-3.61979ZM101.131,461.49335c2.41567-1.39363,5.81961-2.19487,9.34352-2.19487,3.48564,0,6.8439.78684,9.21635,2.15886,1.84962,1.0675,2.90992,2.36052,2.90992,3.54799,0,.95654-.70064,1.97723-1.92029,2.90429l-.02768-.0162-.03354.05694c-.30767.23047-.62254.46004-.99548.67476-4.805,2.7778-13.79336,2.79693-18.56234.03826-1.84939-1.06728-2.90969-2.3603-2.90969-3.54776,0-1.20907,1.08663-2.52843,2.97924-3.62226Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M224.08824,492.81734c3.32472,1.91916,7.68814,2.97699,12.28449,2.97699,4.48157,0,8.73403-1.02181,12.0583-2.84735l133.30141,81.55062-54.97176,32.81619,54.03142,31.43427,15.9655-9.59469c3.21804,1.65628,7.23552,2.5973,11.49157,2.5973,4.63462,0,9.04125-1.06975,12.41143-3.01773,3.84553-2.21896,6.05008-5.47886,6.05008-8.93794-.00248-3.49285-2.12555-6.63999-5.98279-8.86614-3.32472-1.92141-7.68836-2.98171-12.28674-2.98171-4.63462,0-9.04372,1.07223-12.41413,3.01773-3.8453,2.22121-6.04986,5.47886-6.04986,8.94042,0,1.83386.60026,3.56824,1.71593,5.12865l-10.95388,6.58012-41.88355-24.36755,54.75097-32.68633-140.32041-85.84246c1.00875-1.51111,1.55139-3.17122,1.55252-4.88152,0-3.49037-2.12533-6.63999-5.98256-8.86862-3.3272-1.91894-7.69061-2.97699-12.28697-2.97699-4.6344,0-9.0435,1.07245-12.41391,3.01773-3.8453,2.22143-6.04986,5.47908-6.04986,8.94064,0,3.49262,2.12533,6.63999,5.98279,8.8684ZM399.09764,616.28549c2.41567-1.3961,5.82186-2.19735,9.34352-2.19735,3.48542,0,6.84367.78684,9.21613,2.15886,1.84962,1.0675,2.90992,2.36052,2.91217,3.54799,0,1.2066-1.08663,2.5282-2.97924,3.61979-4.80477,2.78028-13.7884,2.79941-18.55987.03826-1.84939-1.0675-2.91217-2.3603-2.91217-3.54776,0-1.20907,1.08663-2.52843,2.97946-3.61979ZM227.22593,480.32668c2.41567-1.39385,5.82186-2.1951,9.34329-2.1951,3.48564,0,6.8439.78459,9.21635,2.15661,1.84962,1.0675,2.91217,2.36052,2.91217,3.54799,0,1.20885-1.08663,2.5282-2.97924,3.61979-4.80973,2.77555-13.78863,2.79693-18.55987.04074-1.84939-1.0675-2.91217-2.36052-2.91217-3.54776,0-1.20907,1.08663-2.52843,2.97946-3.62226Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M434.91941,195.36902c3.3272,1.91916,7.69061,2.97699,12.28922,2.97699,2.785,0,5.45612-.43011,7.90172-1.16113l103.95826,58.80514-94.09664,52.26823,219.18393,128.90132,3.11383-5.29182-209.92459-123.456,94.2839-52.37379-109.91652-62.17307c2.5291-2.08099,3.95761-4.70754,3.95761-7.47477,0-3.49262-2.12308-6.63999-5.98031-8.86614-3.3272-1.92141-7.69083-2.98171-12.28922-2.98171-4.63462,0-9.04372,1.07245-12.41413,3.0202-3.84283,2.21896-6.04737,5.4766-6.04737,8.93817,0,3.49262,2.12306,6.63976,5.9803,8.8684ZM438.0571,182.88061c2.41567-1.3961,5.82186-2.19735,9.34352-2.19735,3.48542,0,6.84615.78684,9.2186,2.15909,1.84962,1.0675,2.90992,2.3603,2.90992,3.54776,0,1.20907-1.08686,2.52843-2.97946,3.62226-4.80477,2.77555-13.7884,2.79716-18.55987.03601-1.84939-1.0675-2.90969-2.36052-2.90969-3.54776,0-1.20907,1.08438-2.52843,2.97699-3.62001Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-318",
    d: "M196.64872,370.59202c3.3272,1.91894,7.69061,2.97676,12.28922,2.97676,3.46089,0,6.79281-.59891,9.66311-1.71142l93.34536,54.841-34.39708,19.65595,205.7194,120.43602,3.10415-5.3015-196.56067-115.07217,34.38245-19.6465-99.74587-58.60055c1.8908-1.91309,2.94885-4.18291,2.95066-6.55649,0-3.49037-2.12532-6.63999-5.98279-8.86862-3.3272-1.91894-7.69061-2.97676-12.28922-2.97676-4.63462,0-9.04125,1.06975-12.41166,3.01525-3.84283,2.21896-6.04738,5.47886-6.04986,8.94042,0,3.49037,2.12555,6.63999,5.98279,8.86862ZM199.78641,358.10361c2.41567-1.3961,5.81961-2.19487,9.34104-2.19487,3.48542,0,6.84638.78437,9.21883,2.15639,1.84939,1.0675,2.91217,2.36052,2.91217,3.54799,0,1.20907-1.08686,2.52843-2.97946,3.61979-4.80478,2.78028-13.78841,2.79716-18.55987.03849-1.84939-1.0675-2.91217-2.36052-2.91217-3.54799,0-1.20907,1.08686-2.52843,2.97946-3.61979Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M326.83743,246.43291c3.32494,1.91916,7.68836,2.97699,12.28697,2.97699,4.61954,0,9.01289-1.0675,12.37902-3.00085l54.20765,31.80856,1.55455-2.64839,1.50414,2.6772,40.80164-22.90168c2.62138.88385,5.55449,1.39363,8.62397,1.39363,4.6344,0,9.04102-1.06975,12.41143-3.01525,3.8453-2.22143,6.04986-5.47908,6.04986-8.94042,0-3.49285-2.12531-6.63999-5.98256-8.86862-3.3272-1.91894-7.69083-2.97699-12.28921-2.97699-4.63463,0-9.04126,1.06998-12.41167,3.01548-3.84282,2.21896-6.04738,5.47886-6.04986,8.94042,0,2.58222,1.17013,4.97628,3.338,6.95058l-35.96153,20.18509-51.09585-29.98257c.89127-1.43391,1.38417-2.98959,1.38417-4.59433,0-3.49262-2.12308-6.63999-5.98031-8.8684-3.3272-1.91916-7.69307-2.97699-12.2917-2.97699-4.6344,0-9.04125,1.06975-12.41143,3.01773-3.84305,2.22121-6.04761,5.47886-6.04761,8.94042,0,3.49037,2.12308,6.63999,5.98031,8.8684ZM449.04384,241.2732c2.41544-1.3961,5.81939-2.1951,9.34105-2.1951,3.48541,0,6.84614.78459,9.21859,2.15661,1.84962,1.0675,2.91217,2.36052,2.91217,3.54799,0,1.20885-1.08662,2.5282-2.97924,3.61979-4.805,2.78028-13.78863,2.79941-18.55987.03826-1.84939-1.0675-2.91217-2.3603-2.91217-3.54776,0-1.20907,1.08663-2.52843,2.97946-3.61979ZM329.97512,233.94225c2.41567-1.3961,5.81961-2.19487,9.34104-2.19487,3.48564,0,6.84638.78437,9.22108,2.15661,1.84962,1.0675,2.90992,2.3603,2.90992,3.54776,0,1.20907-1.08663,2.52843-2.97946,3.62226-4.80477,2.77308-13.7884,2.78996-18.55964.04074-1.84962-1.06975-2.90992-2.36277-2.90992-3.55024,0-1.20907,1.08438-2.53068,2.97699-3.62226Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-300",
    d: "M1086.88431,746.23022l-153.4595-83.86928c2.1224-1.96148,3.27093-4.32853,3.27093-6.88509,0-3.46156-2.20455-6.71921-6.04761-8.94064-3.37016-1.94527-7.77926-3.01773-12.41391-3.01773-4.59861,0-8.96202,1.0603-12.28922,2.97946-3.85498,2.22841-5.98031,5.37577-5.98031,8.86614,0,3.46134,2.20458,6.71899,6.04986,8.94222,3.36928,1.9455,7.77704,3.01593,12.41166,3.01593,4.59861,0,8.96205-1.05782,12.28922-2.97699.02701-.01553.04974-.03421.07675-.04974l-1.52574,2.79108,157.69957,86.18771,107.89224-62.34097,92.3312,51.57502-113.1969,69.42097c-3.34205-1.86987-7.6492-2.90857-12.18771-2.90857-4.59858,0-8.96202,1.05782-12.28919,2.97699-3.85749,2.22841-5.98282,5.37825-5.98282,8.8684.00248,3.46156,2.20703,6.72169,6.04986,8.94064,3.37041,1.94527,7.78176,3.01773,12.41638,3.01773,4.59613,0,8.95955-1.05805,12.28449-2.97946,3.85723-2.22616,5.98256-5.37577,5.98256-8.86614,0-1.67249-.52531-3.29524-1.49131-4.77957l120.56228-73.94058-104.53151-58.38764-107.92128,62.3601ZM927.64484,659.02362c-4.76766,2.76047-13.75242,2.73887-18.55967-.03601-1.89283-1.09384-2.97944-2.41567-2.97944-3.62451,0-1.18521,1.06028-2.47801,2.90989-3.54799,2.37248-1.36977,5.73318-2.15661,9.2186-2.15661,3.52143,0,6.92785.80125,9.34352,2.1951,1.89261,1.09384,2.97699,2.41319,2.97699,3.62226,0,1.18724-1.0603,2.48026-2.90989,3.54776ZM1174.12512,820.9779c0,1.18746-1.06255,2.48049-2.91217,3.54799-2.37245,1.36977-5.73071,2.15661-9.21388,2.15661-3.52391,0-6.93033-.80125-9.34577-2.19735-1.89283-1.09158-2.97946-2.41094-2.97946-3.62001,0-1.18724,1.06278-2.48026,2.91217-3.54776,2.37245-1.37225,5.73318-2.15661,9.21883-2.15661,3.52143,0,6.92537.79877,9.34104,2.19262.10848.06302.18703.13302.29011.19716l1.40331,2.28805.68849-.42223c.36461.52351.59733,1.05242.59733,1.56153Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M557.60544,960.99561c-3.3272-1.91916-7.69061-2.97699-12.28697-2.97699-4.6344,0-9.0435,1.07223-12.41391,3.01773-3.8453,2.22143-6.04986,5.47886-6.04986,8.94042,0,3.49285,2.12534,6.63999,5.98279,8.86862,3.3272,1.91894,7.69061,2.97699,12.28676,2.97699h.00246c4.51871,0,8.80965-1.03509,12.14653-2.89124l27.15773,16.31863c-1.35107,1.6977-2.10192,3.61393-2.10327,5.60489,0,3.49037,2.12555,6.63999,5.9828,8.8684,3.32718,1.91916,7.69061,2.97699,12.2892,2.97699,4.63462,0,9.04125-1.06975,12.41166-3.01525,3.84283-2.21896,6.04738-5.47908,6.04986-8.94042,0-3.49037-2.12533-6.63999-5.98279-8.86614-3.32472-1.92141-7.68813-2.98171-12.28674-2.98171-4.52074,0-8.811,1.03509-12.14765,2.89056l.51563-.85886-27.07445-16.26889c.97275-1.48793,1.50166-3.11676,1.50279-4.79532,0-3.49015-2.12533-6.63999-5.98256-8.8684ZM545.12671,975.68136h-.00246c-3.48543,0-6.84391-.78684-9.21637-2.15661-1.84939-1.0675-2.91217-2.36052-2.91217-3.54799,0-1.20885,1.08665-2.5282,2.97948-3.62226,2.41565-1.39363,5.82185-2.19487,9.34328-2.19487,3.48566,0,6.8439.78437,9.21635,2.15661,1.84963,1.0675,2.91217,2.36052,2.91217,3.54776,0,1.20907-1.08663,2.52843-2.97924,3.62226-2.41567,1.39385-5.82209,2.1951-9.34104,2.1951ZM591.44817,997.23487c2.41567-1.3961,5.82209-2.19735,9.34352-2.19735,3.48542,0,6.8439.78684,9.21635,2.15886,1.84939,1.0675,2.91217,2.36052,2.91217,3.54799,0,1.20885-1.08663,2.5282-2.97946,3.61979-4.80477,2.7778-13.7884,2.79693-18.55964.03826-1.84962-1.0675-2.91217-2.3603-2.91217-3.54776,0-1.20907,1.08663-2.52843,2.97924-3.61979Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "M324.31396,386.35698c3.3272,1.91916,7.69061,2.97699,12.28922,2.97699,4.52119,0,8.80965-1.03329,12.14653-2.88944l27.15953,16.31638c-1.35176,1.6977-2.10259,3.61438-2.10259,5.60557,0,3.49262,2.12308,6.63976,5.98031,8.86592,3.3272,1.92164,7.69061,2.97946,12.28922,2.98171,4.63462,0,9.04125-1.07223,12.41166-3.01773,3.8453-2.22121,6.04986-5.47886,6.04986-8.94042,0-3.49262-2.12308-6.63999-5.9803-8.8684-3.32721-1.91916-7.6931-2.97699-12.29171-2.97699-4.51826,0-8.80852,1.03509-12.14337,2.88876l.51631-.85931-27.07581-16.26596c.97342-1.48793,1.5019-3.11676,1.5019-4.79577,0-3.49285-2.12309-6.63999-5.98032-8.86862-3.3272-1.91894-7.69308-2.97699-12.2917-2.97699-4.63462,0-9.04125,1.06998-12.41165,3.01548-3.84284,2.21896-6.04739,5.47886-6.04986,8.94042,0,3.49037,2.12532,6.63999,5.98278,8.8684ZM382.92711,404.74422c2.41567-1.39385,5.81961-2.19262,9.33856-2.19262,3.48564,0,6.84638.78437,9.22108,2.15661,1.84962,1.0675,2.90992,2.3603,2.90992,3.54776,0,1.20907-1.08663,2.52843-2.97946,3.62226-2.41567,1.39385-5.81961,2.19487-9.34104,2.19487-3.48542-.00225-6.84615-.78662-9.2186-2.15886-1.84962-1.0675-2.90992-2.36052-2.90992-3.54776,0-1.20907,1.08663-2.52843,2.97946-3.62226ZM327.45164,373.8688c2.41567-1.3961,5.81962-2.1951,9.34104-2.1951,3.48542,0,6.84615.78459,9.22108,2.15661,1.84962,1.0675,2.90969,2.36052,2.90969,3.54799,0,1.20885-1.08663,2.5282-2.97924,3.61979-4.80477,2.78028-13.7884,2.79941-18.55987.03826-1.84939-1.06728-2.91217-2.3603-2.91217-3.54776,0-1.20907,1.08663-2.52843,2.97946-3.61979Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-294",
    d: "M1276.69944,599.08098c4.59613,0,8.95955-1.05782,12.28674-2.97699,3.85746-2.22841,5.98034-5.37577,5.98034-8.8684,0-3.46156-2.20459-6.71921-6.04741-8.94064-3.37041-1.94527-7.78199-3.01773-12.41638-3.01773-4.59613,0-8.95977,1.05805-12.28697,2.97699-3.85723,2.22863-5.98031,5.37577-5.98031,8.86862,0,1.67902.52846,3.30784,1.50166,4.79577l-137.63534,78.96907.51814.86246c-3.3351-1.85682-7.62604-2.89191-12.14791-2.89191-4.59839,0-8.96202,1.05782-12.28922,2.97699-3.85723,2.22841-5.98031,5.37577-5.98031,8.8684,0,3.46156,2.20455,6.71921,6.04761,8.94064,3.37041,1.94527,7.77704,3.01525,12.41143,3.01525,4.59864,0,8.9645-1.05782,12.2917-2.97699,3.85749-2.22841,5.98031-5.37577,5.98031-8.8684,0-1.99119-.75083-3.90787-2.10257-5.60489l137.72129-79.02062c3.33507,1.85727,7.62421,2.89236,12.1472,2.89236ZM1267.28637,583.57485c2.37245-1.36977,5.73071-2.15661,9.21635-2.15661,3.52146,0,6.9301.80125,9.34577,2.1951,1.89261,1.09384,2.97699,2.41319,2.97699,3.62226,0,1.18724-1.0603,2.48026-2.90969,3.54776-4.77371,2.76115-13.75509,2.73459-18.55987-.04074-1.89261-1.09158-2.97946-2.41094-2.97946-3.61979,0-1.18746,1.0603-2.48049,2.90992-3.54799ZM1119.88281,684.3619c-4.77371,2.76115-13.75262,2.73954-18.56234-.03601-1.89261-1.09384-2.97676-2.41319-2.97676-3.62226,0-1.18724,1.06008-2.48026,2.90969-3.54776,2.37245-1.37225,5.73321-2.15661,9.2186-2.15661,3.52166,0,6.9256.79877,9.34129,2.19487,1.89258,1.09158,2.97921,2.41094,2.97921,3.62001,0,1.18724-1.0603,2.48026-2.90969,3.54776Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M1092.46895,393.97107c4.59613,0,8.95955-1.05805,12.28674-2.97699,3.85723-2.22863,5.98031-5.37577,5.98031-8.86862,0-3.46156-2.20455-6.71899-6.04761-8.94042-3.37018-1.9455-7.78176-3.01773-12.41616-3.01773-4.59636,0-8.95977,1.05782-12.28697,2.97699-3.85723,2.22841-5.98028,5.37577-5.98028,8.8684,0,1.67924.52843,3.30806,1.50163,4.796l-27.07558,16.26822.51811.86246c-3.33485-1.85682-7.62579-2.89191-12.14765-2.89191-4.59858,0-8.96202,1.05805-12.28919,2.97699-3.85749,2.22863-5.98034,5.37577-5.98034,8.86862,0,3.46134,2.20455,6.71899,6.04738,8.94042,3.37041,1.9455,7.77704,3.01525,12.41166,3.01525,4.59861,0,8.9645-1.05782,12.2917-2.97699,3.85723-2.22841,5.98031-5.37577,5.98031-8.8684,0-1.99096-.75083-3.90765-2.10259-5.60489l27.16133-16.31998c3.33507,1.85749,7.62402,2.89259,12.1472,2.89259ZM1083.05589,378.46493c2.37245-1.36977,5.73071-2.15661,9.21635-2.15661,3.52143,0,6.9301.80125,9.34577,2.19487,1.89261,1.09384,2.97699,2.41342,2.97699,3.62226,0,1.18746-1.0603,2.48049-2.90992,3.54799-4.77124,2.76092-13.75712,2.73706-18.55964-.04074-1.89283-1.09158-2.97946-2.41094-2.97946-3.62001,0-1.18724,1.0603-2.48026,2.90992-3.54776ZM1046.21209,416.55112c-4.77371,2.76115-13.75239,2.73954-18.56212-.03601-1.89283-1.09384-2.97699-2.41319-2.97699-3.62204,0-1.18746,1.0603-2.48049,2.90969-3.54799,2.37245-1.37202,5.73341-2.15661,9.21883-2.15661,3.52143,0,6.92537.799,9.34104,2.1951,1.89261,1.09136,2.97946,2.41071,2.97946,3.61979,0,1.18746-1.0603,2.48026-2.90992,3.54776Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M597.3182,528.80228l3.09447-5.30623-166.66158-97.24626,61.28561-37.92098-139.57813-81.52181c1.37876-1.71097,2.144-3.64702,2.144-5.65891,0-3.49285-2.12533-6.63999-5.98279-8.86614-3.32472-1.92141-7.68813-2.98171-12.28674-2.98171-4.63462,0-9.04372,1.07223-12.41391,3.01773-3.84305,2.21896-6.04761,5.47886-6.04986,8.94042,0,3.49037,2.12534,6.63999,5.98256,8.8684,3.3272,1.91916,7.69061,2.97699,12.28923,2.97699,4.01027,0,7.80651-.84311,10.95186-2.31956l133.02637,77.69833-61.29035,37.92076,175.48925,102.39899ZM329.92245,304.80636c-1.84962-1.0675-2.91217-2.36052-2.91217-3.54799,0-1.20907,1.08664-2.52843,2.97924-3.61979,2.41567-1.3961,5.82209-2.19735,9.34352-2.19735,3.48542,0,6.8439.78684,9.21635,2.15886,1.84939,1.0675,2.91217,2.36052,2.91217,3.54799,0,1.20907-1.08663,2.52843-2.97946,3.61979-4.80477,2.78028-13.78839,2.79941-18.55964.03849Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M369.02348,827.33723c-3.37042-1.94527-7.77705-3.01525-12.41167-3.01525-4.59861,0-8.96202,1.05782-12.28922,2.97699-3.85723,2.22841-5.98278,5.37825-5.98278,8.8684.00134,1.73506.55659,3.4197,1.59349,4.94769l-98.71034,55.69491,67.56325,36.85461c-.87012,1.41051-1.34321,2.9457-1.34321,4.56125,0,3.46156,2.20433,6.71921,6.04738,8.94042,3.37041,1.9455,7.77951,3.01773,12.41391,3.01773,4.59862,0,8.96202-1.0603,12.28923-2.97924,3.85745-2.22863,5.9803-5.37577,5.9803-8.86862,0-3.46134-2.20455-6.71899-6.04986-8.93794-3.36793-1.9455-7.77704-3.01773-12.41143-3.01773-4.53154,0-8.82428,1.03622-12.13212,2.90249l-59.70114-32.56411,91.03345-51.36143c3.30131,1.77039,7.47769,2.76587,11.8886,2.76587,4.59861,0,8.96202-1.05782,12.28922-2.97699,3.85746-2.22863,5.9828-5.37577,5.9828-8.86862,0-3.46134-2.20456-6.71899-6.04986-8.94042ZM335.05358,934.71632c1.89261,1.09158,2.97924,2.41094,2.97924,3.61979,0,1.18746-1.0603,2.48049-2.90969,3.55046-2.37245,1.36955-5.73318,2.15639-9.21883,2.15639-3.52143,0-6.92785-.80125-9.34352-2.19487-1.89261-1.09384-2.97676-2.41319-2.97676-3.62226,0-.52351.23857-1.06615.62727-1.60249l.03466.01936.16205-.29687c.49403-.58293,1.19264-1.15213,2.08571-1.66776,2.37245-1.37225,5.73318-2.15661,9.21883-2.15661,3.52143,0,6.92537.79877,9.34104,2.19487ZM366.02015,839.82564c-4.76899,2.76115-13.75014,2.74179-18.55987-.03849-1.89261-1.09136-2.97946-2.41071-2.97946-3.61979,0-1.18746,1.06278-2.48026,2.91239-3.54776,2.37245-1.37225,5.73318-2.15661,9.2186-2.15661,3.52144,0,6.92537.79877,9.34104,2.19487,1.89261,1.09158,2.97946,2.41094,2.97946,3.61979,0,1.18746-1.06278,2.48049-2.91217,3.54799Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-299",
    d: "M915.0414,526.03888l3.14737,5.27269,291.19207-173.95654-.71594-1.19939c3.2599,1.68284,7.32172,2.63646,11.61626,2.63646,4.59861,0,8.96202-1.05805,12.28922-2.97699,3.85746-2.22863,5.98279-5.37825,5.98279-8.86862-.00244-3.46134-2.20703-6.72146-6.04986-8.94042-3.37041-1.9455-7.77704-3.01525-12.41166-3.01525-4.59861,0-8.96202,1.05782-12.28922,2.97699-3.85723,2.22841-5.98279,5.37577-5.98279,8.8684,0,2.26104.95542,4.42823,2.67832,6.28258l-289.45656,172.92009ZM1210.87304,343.28844c2.37245-1.37225,5.73318-2.15661,9.2186-2.15661,3.52143,0,6.92537.79877,9.34104,2.19487,1.89283,1.09158,2.97946,2.41094,2.97946,3.61979,0,1.18746-1.06278,2.48049-2.91217,3.54799-4.76651,2.75867-13.75262,2.73954-18.55987-.03849-1.89261-1.09136-2.97946-2.41071-2.97946-3.61979,0-1.18746,1.06278-2.48026,2.91239-3.54776Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-544"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-421",
    d: "M686.20359,811.16264c14.12623,0,26.94596-3.08952,37.07315-8.93704l245.61716-142.12345c13.51832-7.80607,21.2715-20.15741,21.26925-33.88459,0-15.04834-9.33564-29.06879-25.61421-38.46362l-222.80147-128.63731c-12.78392-7.37956-28.77123-11.44409-45.02033-11.44409-14.12601,0-26.94594,3.08952-37.07292,8.93704l-245.61739,142.12345c-13.51832,7.80584-21.26925,20.15516-21.26925,33.88234,0,15.04632,9.33586,29.06677,25.61218,38.46587l222.80349,128.63731c12.78392,7.37956,28.77148,11.44409,45.02033,11.44409Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-499",
    d: "M661.67417,457.6122l-239.73487,138.71964c-12.28938,7.09622-21.24821,19.73886-21.76433,32.20744-.59621,14.4033,7.44516,28.31366,23.61752,37.65256l219.67057,126.82837c12.45837,7.19173,28.08999,11.10793,43.86129,11.05239,9.60507-.03579,18.5745-1.59951,26.43429-4.45624,3.18803-1.15873,6.80738-2.86889,9.58972-4.47544l239.20586-138.41366c12.28938-7.09643,21.17135-19.69576,21.68637-32.16438.59502-14.40517-7.44498-28.31549-23.61936-37.65051l-218.53964-126.17649c-4.63235-2.67404-10.86989-5.47853-16.24483-7.19445-8.72163-2.78433-18.18714-4.39721-27.76882-4.47874-13.83039-.11551-26.48902,2.83036-36.39378,8.54952Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-372",
    d: "M663.69412,458.61482l-233.85236,135.31584c-11.06044,6.3866-21.29262,19.3429-22.25941,30.53254-1.19583,13.84063,5.55446,27.56056,21.62285,36.83924l216.53765,125.01943c12.13281,7.00389,27.40851,10.77177,42.70224,10.66069,9.35306-.07157,18.07014-1.69441,25.67667-4.51221,2.86275-1.0605,6.7941-2.96822,9.29821-4.41412l232.79456-134.70388c11.06044-6.38678,21.13776-19.25444,22.1035-30.44417,1.19467-13.84233-5.55432-27.56218-21.62451-36.8374l-214.27781-123.71567c-4.16912-2.40664-11.03787-5.6077-15.86234-7.19207-8.50191-2.79205-17.75357-4.54716-27.14462-4.71022-13.53477-.23101-26.0321,2.57119-35.71464,8.16199Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-446",
    d: "M665.71408,459.61744l-227.96984,131.91204c-9.83151,5.67698-21.4198,18.96385-22.75449,28.85764-1.80328,13.36741,3.66376,26.80746,19.62819,36.02592l213.40473,123.21049c11.80725,6.81605,26.72702,10.43561,41.54319,10.26899,9.10104-.10736,17.56486-1.78896,24.91906-4.56818,2.53844-.9593,6.78082-3.06755,9.0067-4.35279l226.38325-130.99409c9.83151-5.67714,21.18691-18.83004,22.52063-28.72396,1.80215-13.36892-3.66365-26.80887-19.62966-36.02428l-210.01599-121.25485c-3.70588-2.13923-11.20382-5.7442-15.47985-7.18969-8.28401-2.80038-17.32001-4.69712-26.52042-4.9417-13.23915-.34652-25.57519,2.31202-35.0355,7.77447Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-497",
    d: "M667.73403,460.62007l-222.08733,128.50824c-8.60257,4.96736-23.24957,18.44726-23.24957,27.18274-4.76557,12.32634,1.77305,26.05436,17.63352,35.2126l210.27181,121.40155c11.4817,6.62822,26.04554,10.09945,40.38415,9.8773,8.84903-.14314,17.05857-1.88314,24.16144-4.62415,2.21523-.85486,6.76754-3.16688,8.71519-4.29147l219.97195-127.28431c8.60257-4.9675,22.93919-18.26827,22.93775-27.00375,4.76549-12.32754-1.77299-26.05557-17.63481-35.21117l-205.75416-118.79403c-3.24265-1.87183-11.36749-5.88855-15.09737-7.18732-8.06808-2.80936-16.88644-4.84707-25.89622-5.17318-12.94353-.46202-25.11827,2.05286-34.35636,7.38695Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-374",
    d: "M669.75398,461.62269l-216.20481,125.10443c-7.37363,4.25773-23.74465,18.02029-23.74465,25.50784-5.95696,11.64634-.11765,25.30126,15.63886,34.39929l207.13889,119.5926c11.15614,6.44038,25.36405,9.7633,39.2251,9.4856,8.59701-.17893,16.55118-1.97689,23.40382-4.68012,1.89326-.74685,6.75427-3.26621,8.42367-4.23014l213.56065-123.57452c7.37363-4.25786,23.35611-17.79598,23.35488-25.28354,5.95686-11.64734.11767-25.30226-15.63997-34.39806l-201.49234-116.33321c-2.77941-1.60443-11.52859-6.0413-14.71488-7.18494-7.85425-2.81908-16.45287-4.99702-25.27201-5.40465-12.64791-.57753-24.66135,1.79369-33.67722,6.99942Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-371",
    d: "M671.77394,462.62531l-210.32229,121.70063c-6.14469,3.54811-24.23973,17.59331-24.23973,23.83294-7.14836,10.96635-2.00835,24.54816,13.6442,33.58597l204.00597,117.78366c10.83058,6.25254,24.68257,9.42714,38.06605,9.0939,8.345-.21472,16.04256-2.07016,22.6462-4.73609,1.57271-.63492,6.74099-3.36554,8.13216-4.16882l207.14935-119.86474c6.14469-3.54821,23.77303-17.3237,23.772-23.56333,7.14823-10.96714,2.00833-24.54896-13.64512-33.58495l-197.23051-113.87239c-2.31618-1.33702-11.6868-6.20306-14.3324-7.18256-7.64266-2.8296-16.01931-5.14697-24.64781-5.63613-12.35229-.69303-24.20443,1.53452-32.99808,6.6119Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-472",
    d: "M673.79389,463.62793l-204.43978,118.29683c-4.91575,2.83849-24.7348,17.16634-24.7348,22.15804-8.33975,10.28635-3.89906,23.79506,11.64953,32.77265l200.87305,115.97472c10.50503,6.06471,24.00109,9.09098,36.90701,8.70221,8.09298-.2505,15.5326-2.16288,21.88858-4.79206,1.2538-.51864,6.72771-3.46487,7.84065-4.10749l200.73804-116.15495c4.91575-2.83857,24.18995-16.85142,24.18913-21.84312,8.33961-10.28694,3.89899-23.79565-11.65027-32.77183l-192.96869-111.41157c-1.85294-1.06962-11.84176-6.37446-13.94991-7.18018-7.43346-2.84101-15.58574-5.29692-24.02361-5.86761-12.05667-.80854-23.74751,1.27535-32.31894,6.22437Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-502",
    d: "M675.81385,464.63055l-198.55726,114.89302c-3.68681,2.12887-25.22988,16.73936-25.22988,20.48314-9.53114,9.60636-5.78976,23.04195,9.65487,31.95933l197.74013,114.16578c10.17947,5.87687,23.3196,8.75482,35.74796,8.31051,7.84097-.28629,15.02116-2.25499,21.13097-4.84803.93675-.39756,6.71443-3.5642,7.54913-4.04617l194.32674-112.44517c3.68681-2.12893,24.60687-16.37913,24.60626-20.12291,9.53098-9.60674,5.78966-23.04234-9.65542-31.95872l-188.70686-108.95075c-1.38971-.80221-11.99304-6.55619-13.56742-7.17781-7.22683-2.8534-15.15217-5.44688-23.39941-6.09909-11.76105-.92404-23.2906,1.01619-31.63979,5.83685Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-496",
    d: "M677.8338,465.63317l-192.67475,111.48922c-2.45788,1.41924-25.72496,16.31239-25.72496,18.80824-10.72253,8.92636-7.68046,22.28885,7.6602,31.14602l194.60721,112.35684c9.85392,5.68903,22.63812,8.41867,34.58891,7.91881,7.58896-.32207,14.50807-2.3464,20.37335-4.904.62186-.27117,6.70115-3.66353,7.25762-3.98484l187.91544-108.73538c2.45788-1.41929,25.02379-15.90685,25.02338-18.4027,10.72235-8.92655,7.68032-22.28904-7.66057-31.14561l-184.44504-106.48993c-.92647-.53481-12.1402-6.74895-13.18494-7.17543-7.02295-2.86688-14.71861-5.59683-22.77521-6.33057-11.46543-1.03955-22.83368.75702-30.96065,5.44933Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M679.85375,466.63579l-186.79223,108.08542c-1.22894.70962-26.22004,15.88541-26.22004,17.13334-11.91393,8.24637-9.57116,21.53575,5.66554,30.3327l191.47429,110.5479c9.52836,5.50119,21.95663,8.08251,33.42987,7.52712,7.33694-.35786,13.99314-2.43701,19.61573-4.95997.30948-.13887,6.68787-3.76286,6.96611-3.92352l181.50413-105.0256c1.22894-.70964,25.44071-15.43456,25.44051-16.68249,11.91372-8.24635,9.57098-21.53573-5.66572-30.33249l-180.18321-104.0291c-.46324-.2674-12.2827-6.95351-12.80245-7.17305-6.822-2.88155-14.28504-5.74678-22.15101-6.56205-11.16981-1.15505-22.37676.49785-30.28151,5.0618Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M717.39005,728.15628l207.62506-120.14028c13.10509-7.56615,11.46164-20.78243-3.67088-29.51938l-188.34135-108.73896c-15.13276-8.73673-38.02408-9.68562-51.12918-2.11925l-207.62484,120.14005c-13.10532,7.56637-11.46187,20.78265,3.67088,29.51938l188.34137,108.73896c15.13252,8.73696,38.02384,9.68585,51.12893,2.11948Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-295",
    d: "M977.91579,550.548h-5.64136c-2.86738-3.6585-6.80224-7.04894-11.90818-9.99599l-219.65275-126.81605c-25.99523-15.00873-71.40158-13.12648-101.41812,4.20294l-203.13112,117.2783c-7.97735,4.60559-14.00515,9.84767-18.15609,15.3308h-6.67487v17.51307h.17803c.83658,8.71107,6.518,16.9378,17.37152,23.20327l219.65274,126.81718c25.99525,15.00783,71.40158,13.12535,101.41813-4.20406l203.13111-117.27808c14.2507-8.22762,22.39099-18.45611,24.31308-28.5383h.51788v-17.51307Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-298",
    d: "M648.53558,704.73582l-219.65274-126.8165c-25.99526-15.0085-22.73514-41.22387,7.28142-58.55396l203.13112-117.27785c30.01676-17.33009,75.42332-19.21234,101.41836-4.20406l219.65273,126.81673c25.99525,15.00828,22.73512,41.22365-7.28143,58.55374l-203.13111,117.27785c-30.01678,17.33009-75.42333,19.21234-101.41836,4.20406Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-522",
    d: "M970.82319,520.28589h-5.50924c-2.80008-3.57275-6.64291-6.88396-11.62909-9.76169l-214.50475-123.84379c-25.38599-14.65717-69.72819-12.81903-99.0414,4.10436l-198.37,114.52953c-7.79076,4.49778-13.677,9.61675-17.73071,14.97159h-6.51867v30.61659h.17398c.817,8.50693,6.36518,16.54055,16.96458,22.6595l214.50454,123.84492c25.38597,14.65605,69.72817,12.81768,99.04139-4.10548l198.37022-114.52953c13.91692-8.03496,21.86613-18.02353,23.74343-27.8694h.50573v-30.61659Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M977.4625,504.84615h-5.64136c-2.86713-3.6585-6.80226-7.04916-11.90815-9.99599l-219.65255-126.81605c-25.99547-15.00895-71.40158-13.12648-101.41836,4.20294l-203.13088,117.27808c-7.97757,4.60581-14.00537,9.84767-18.15608,15.33103h-6.67511v29.42125h.17803c.83659,8.71107,6.518,16.9378,17.3715,23.20327l219.65275,126.81718c25.99527,15.00783,71.40158,13.12535,101.41815-4.20406l203.13109-117.27808c14.2507-8.22762,22.39099-18.45611,24.31308-28.5383h.51788v-29.42125Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M648.08229,659.03398l-219.65275-126.81673c-25.99525-15.00828-22.73512-41.22365,7.28143-58.55374l203.13111-117.27785c30.01678-17.33032,75.42333-19.21234,101.41836-4.20406l219.65275,126.8165c25.99527,15.00828,22.73535,41.22387-7.28143,58.55396l-203.13111,117.27785c-30.01678,17.33009-75.42333,19.21234-101.41836,4.20406Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-327",
    d: "M692.12875,659.33962c-15.39088,0-29.28733-3.13049-39.13455-8.81325l-219.65185-126.81673c-5.76424-3.32967-12.63695-8.96698-12.63695-16.92384,0-8.21119,7.44597-17.41314,19.91748-24.61445l203.13088-117.27673c14.3306-8.27354,33.45179-13.02092,52.45774-13.02092,15.3909,0,29.28983,3.13296,39.13703,8.81573l219.65162,126.81695c5.76447,3.32945,12.6372,8.96675,12.6372,16.92384,0,8.21119-7.44598,17.41314-19.91751,24.61445l-203.13111,117.2765c-14.33285,8.27354-33.45404,13.01844-52.45999,13.01844Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-328",
    d: "M658.47395,624.44064l-170.12698-98.22306c-20.134-11.62437-17.60918-31.92897,5.63955-45.35164l157.33091-90.83494c23.24873-13.42267,58.41734-14.88044,78.55134-3.25607l170.12721,98.22306c20.134,11.62437,17.60895,31.92897-5.63978,45.35164l-157.33068,90.83494c-23.24873,13.42267-58.41757,14.88044-78.55157,3.25607Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-527",
    d: "M952.63153,533.01917l-203.13109,117.2783c-30.01658,17.33054-75.42289,19.21167-101.41815,4.20384l-219.65275-126.81695c-10.43195-6.02217-16.07218-13.8593-17.24299-22.19428-1.60474,10.80174,4.00578,21.35095,17.24299,28.99317l219.65275,126.81718c25.99527,15.00783,71.40158,13.12648,101.41815-4.20406l203.13109-117.27808c17.97131-10.37568,26.27073-23.92596,24.52442-36.3599-1.5469,10.41102-9.7923,21.05543-24.52442,29.56079Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-529",
    cx: 690.29197,
    cy: 691.42079,
    rx: 69.69901,
    ry: 94.60155,
    transform: "translate(-71.70868 79.93022) rotate(-6.30045)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-546"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "692.54898 393.31251 701.35726 388.22708 692.6041 383.1736 683.79604 388.25881 692.54898 393.31251"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "676.00301 402.86534 684.8111 397.78013 676.05792 392.72643 667.24985 397.81187 676.00301 402.86534"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "659.45683 412.4184 668.26491 407.33296 659.51175 402.27949 650.70367 407.3647 659.45683 412.4184"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "642.91066 421.97123 651.71873 416.88602 642.96557 411.83232 634.1575 416.91775 642.91066 421.97123"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "626.36448 431.52429 635.17256 426.43885 626.4194 421.38515 617.61132 426.47059 626.36448 431.52429"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "609.81831 441.07712 618.62661 435.99168 609.87345 430.93821 601.06537 436.02342 609.81831 441.07712"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "593.27235 450.62995 602.08043 445.54474 593.32729 440.49104 584.51919 445.57647 593.27235 450.62995"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "576.7262 460.183 585.53426 455.09757 576.7811 450.04387 567.97302 455.1293 576.7262 460.183"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "560.18 469.73583 568.98808 464.6504 560.23492 459.59692 551.42684 464.68213 560.18 469.73583"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "543.63383 479.28866 552.44191 474.20345 543.68875 469.14975 534.88067 474.23519 543.63383 479.28866"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "527.08765 488.84172 535.89596 483.75628 527.1428 478.70258 518.33472 483.78802 527.08765 488.84172"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "510.5417 498.39455 519.34978 493.30911 510.59662 488.25564 501.78854 493.34085 510.5417 498.39455"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "493.99553 507.94738 502.80361 502.86217 494.05045 497.80847 485.24238 502.8939 493.99553 507.94738"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "708.18743 402.34138 716.9955 397.25595 708.24257 392.20247 699.43427 397.28768 708.18743 402.34138"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "691.64125 411.89421 700.44955 406.809 691.69639 401.7553 682.88832 406.84074 691.64125 411.89421"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "675.0953 421.44727 683.90338 416.36183 675.15022 411.30813 666.34214 416.39357 675.0953 421.44727"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "658.54913 431.0001 667.3572 425.91466 658.60406 420.86119 649.79597 425.9464 658.54913 431.0001"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "642.00297 440.55293 650.81103 435.46772 642.05787 430.41402 633.24979 435.49945 642.00297 440.55293"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "625.45678 450.10599 634.26485 445.02055 625.51192 439.96708 616.70362 445.05229 625.45678 450.10599"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "608.9106 459.65882 617.7189 454.57361 608.96574 449.51991 600.15767 454.60534 608.9106 459.65882"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "592.36465 469.21187 601.17273 464.12644 592.41957 459.07274 583.61149 464.15817 592.36465 469.21187"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "575.81848 478.7647 584.62655 473.67927 575.87339 468.62579 567.06532 473.711 575.81848 478.7647"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "559.2723 488.31753 568.08038 483.23232 559.32722 478.17862 550.51916 483.26406 559.2723 488.31753"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "542.72613 497.87059 551.53422 492.78515 542.78128 487.73145 533.97297 492.81689 542.72613 497.87059"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "526.17995 507.42342 534.98825 502.33798 526.23509 497.28451 517.42702 502.36972 526.17995 507.42342"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "509.634 516.97625 518.44208 511.89104 509.68892 506.83734 500.88084 511.92277 509.634 516.97625"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "723.8259 411.37025 732.63398 406.28482 723.88084 401.23134 715.07274 406.31655 723.8259 411.37025"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "707.27974 420.92308 716.0878 415.83787 707.33487 410.78417 698.52656 415.86961 707.27974 420.92308"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "690.73377 430.47614 699.54187 425.3907 690.78869 420.337 681.98061 425.42244 690.73377 430.47614"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "674.1876 440.02897 682.99568 434.94353 674.24252 429.89006 665.43444 434.97527 674.1876 440.02897"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "657.64142 449.5818 666.4495 444.49659 657.69634 439.44289 648.88826 444.52832 657.64142 449.5818"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "641.09525 459.13486 649.90333 454.04942 641.15017 448.99595 632.34209 454.08115 641.09525 459.13486"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "624.54907 468.68769 633.35715 463.60248 624.60422 458.54878 615.79593 463.63421 624.54907 468.68769"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "608.00312 478.24074 616.8112 473.15531 608.05806 468.10161 599.24996 473.18704 608.00312 478.24074"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "591.45696 487.79357 600.26502 482.70814 591.51186 477.65466 582.70379 482.73987 591.45696 487.79357"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "574.91077 497.3464 583.71885 492.26119 574.96569 487.20749 566.15761 492.29293 574.91077 497.3464"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "558.3646 506.89946 567.17267 501.81402 558.41951 496.76032 549.61144 501.84576 558.3646 506.89946"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "541.81842 516.45229 550.6265 511.36685 541.87356 506.31338 533.06526 511.39859 541.81842 516.45229"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "525.27247 526.00512 534.08055 520.91991 525.32739 515.86621 516.51931 520.95164 525.27247 526.00512"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "739.46437 420.39912 748.27245 415.31369 739.51929 410.26021 730.71121 415.34542 739.46437 420.39912"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "722.9182 429.95195 731.72627 424.86674 722.97311 419.81304 714.16504 424.89848 722.9182 429.95195"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-471",
    points: "706.37202 439.50501 715.1801 434.41957 706.42716 429.36587 697.61909 434.45131 706.37202 439.50501"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "689.82607 449.05784 698.63415 443.9724 689.88099 438.91893 681.07291 444.00414 689.82607 449.05784"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "673.2799 458.61067 682.08797 453.52546 673.33483 448.47176 664.52674 453.55719 673.2799 458.61067"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "656.73374 468.16372 665.5418 463.07829 656.78864 458.02459 647.98056 463.11002 656.73374 468.16372"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-498",
    points: "640.18755 477.71656 648.99562 472.63112 640.24246 467.57765 631.43439 472.66286 640.18755 477.71656"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "623.64137 487.26939 632.44945 482.18418 623.69651 477.13048 614.88844 482.21591 623.64137 487.26939"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-471",
    points: "607.09542 496.82244 615.9035 491.73701 607.15034 486.68353 598.34226 491.76874 607.09542 496.82244"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-498",
    points: "590.54924 506.37527 599.35732 501.29006 590.60416 496.23636 581.79608 501.3218 590.54924 506.37527"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "574.00307 515.92833 582.81115 510.84289 574.05799 505.78919 565.24992 510.87463 574.00307 515.92833"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "557.45689 525.48116 566.26499 520.39572 557.51181 515.34225 548.70373 520.42746 557.45689 525.48116"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "540.91072 535.03399 549.7188 529.94878 540.96586 524.89508 532.15778 529.98051 540.91072 535.03399"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "755.10284 429.42799 763.91092 424.34256 755.15776 419.28908 746.34968 424.37429 755.10284 429.42799"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "738.55667 438.98082 747.36475 433.89561 738.61161 428.84191 729.80351 433.92735 738.55667 438.98082"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "722.01051 448.53388 730.81857 443.44844 722.06541 438.39474 713.25733 443.48018 722.01051 448.53388"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "705.46432 458.08671 714.27239 453.00127 705.51946 447.9478 696.71138 453.03301 705.46432 458.08671"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-498",
    points: "688.91837 467.63954 697.72644 462.55433 688.97328 457.50063 680.16521 462.58606 688.91837 467.63954"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "672.37219 477.19259 681.18027 472.10716 672.42711 467.05346 663.61903 472.13889 672.37219 477.19259"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-498",
    points: "655.82602 486.74543 664.63409 481.65999 655.88093 476.60651 647.07286 481.69172 655.82602 486.74543"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "639.27984 496.29826 648.08792 491.21305 639.33476 486.15935 630.5267 491.24478 639.27984 496.29826"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "622.73367 505.85131 631.54176 500.76588 622.78883 495.71218 613.98073 500.79761 622.73367 505.85131"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-498",
    points: "606.18773 515.40414 614.99579 510.31871 606.24263 505.26523 597.43456 510.35067 606.18773 515.40414"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "589.64154 524.9572 598.44962 519.87176 589.69646 514.81806 580.88838 519.9035 589.64154 524.9572"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "573.09537 534.51003 581.90344 529.42459 573.15028 524.37112 564.34221 529.45633 573.09537 534.51003"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "556.54919 544.06286 565.35727 538.97765 556.60411 533.92395 547.79603 539.00938 556.54919 544.06286"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "770.74132 438.45686 779.54941 433.37143 770.79623 428.31773 761.98816 433.40316 770.74132 438.45686"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "754.19514 448.00969 763.00322 442.92426 754.25006 437.87078 745.44198 442.95622 754.19514 448.00969"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "737.64897 457.56275 746.45704 452.47731 737.70388 447.42361 728.89581 452.50905 737.64897 457.56275"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-471",
    points: "721.10279 467.11558 729.91087 462.03014 721.15771 456.97667 712.34963 462.06188 721.10279 467.11558"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-498",
    points: "704.55661 476.66841 713.36492 471.5832 704.61176 466.5295 695.80368 471.61493 704.55661 476.66841"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-498",
    points: "688.01066 486.22146 696.81874 481.13603 688.0656 476.08233 679.2575 481.16776 688.01066 486.22146"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-471",
    points: "671.46451 495.77429 680.27257 490.68886 671.51941 485.63538 662.71133 490.72059 671.46451 495.77429"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "654.91831 505.32713 663.72639 500.24192 654.97323 495.18821 646.16515 500.27365 654.91831 505.32713"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "638.37214 514.88018 647.18022 509.79475 638.42706 504.74105 629.61898 509.82648 638.37214 514.88018"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-471",
    points: "621.82596 524.43301 630.63427 519.34758 621.88111 514.2941 613.07303 519.37931 621.82596 524.43301"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-498",
    points: "605.28001 533.98584 614.08809 528.90063 605.33493 523.84693 596.52685 528.93237 605.28001 533.98584"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "588.73384 543.5389 597.54191 538.45346 588.78875 533.39999 579.98069 538.4852 588.73384 543.5389"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "572.18766 553.09173 580.99576 548.00652 572.24258 542.95282 563.4345 548.03825 572.18766 553.09173"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "786.37956 447.48573 795.18786 442.4003 786.4347 437.3466 777.62663 442.43203 786.37956 447.48573"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "769.83361 457.03856 778.64169 451.95313 769.88853 446.89965 761.08045 451.98486 769.83361 457.03856"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "753.28744 466.59139 762.09551 461.50618 753.34237 456.45248 744.53428 461.53792 753.28744 466.59139"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "736.74128 476.14445 745.54934 471.05901 736.79618 466.00554 727.9881 471.09075 736.74128 476.14445"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-498",
    points: "720.19509 485.69728 729.00316 480.61207 720.25023 475.55837 711.44193 480.6438 720.19509 485.69728"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-498",
    points: "703.64891 495.25033 712.45721 490.1649 703.70405 485.1112 694.89598 490.19663 703.64891 495.25033"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "687.10296 504.80316 695.91104 499.71773 687.15788 494.66425 678.3498 499.74946 687.10296 504.80316"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-498",
    points: "670.55679 514.35599 679.36486 509.27078 670.6117 504.21708 661.80363 509.30252 670.55679 514.35599"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-498",
    points: "654.01061 523.90905 662.81869 518.82362 654.06553 513.76992 645.25747 518.85535 654.01061 523.90905"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "637.46444 533.46188 646.27253 528.37645 637.51959 523.32297 628.71128 528.40818 637.46444 533.46188"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-498",
    points: "620.91826 543.01471 629.72656 537.9295 620.9734 532.8758 612.16532 537.96124 620.91826 543.01471"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "604.37231 552.56777 613.18039 547.48233 604.42723 542.42863 595.61915 547.51407 604.37231 552.56777"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "587.82613 562.1206 596.63421 557.03516 587.88105 551.98169 579.07297 557.0669 587.82613 562.1206"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "802.01806 456.5146 810.82611 451.42917 802.07318 446.37547 793.26487 451.4609 802.01806 456.5146"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "785.47208 466.06743 794.28018 460.982 785.527 455.92852 776.71892 461.01373 785.47208 466.06743"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-471",
    points: "768.92591 475.62026 777.73399 470.53505 768.98083 465.48135 760.17275 470.56679 768.92591 475.62026"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "752.37973 485.17332 761.18781 480.08788 752.43465 475.03418 743.62657 480.11962 752.37973 485.17332"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-498",
    points: "735.83356 494.72615 744.64163 489.64071 735.88848 484.58724 727.0804 489.67245 735.83356 494.72615"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-498",
    points: "719.28738 504.27898 728.09546 499.19377 719.34252 494.14007 710.53424 499.2255 719.28738 504.27898"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "702.74143 513.83203 711.54951 508.7466 702.79637 503.69312 693.98827 508.77833 702.74143 513.83203"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "686.19528 523.38486 695.00333 518.29965 686.25017 513.24595 677.4421 518.33139 686.19528 523.38486"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "669.64908 532.93792 678.45716 527.85249 669.704 522.79878 660.89592 527.88422 669.64908 532.93792"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "653.10291 542.49075 661.91098 537.40532 653.15782 532.35184 644.34975 537.43705 653.10291 542.49075"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-498",
    points: "636.55673 552.04358 645.36481 546.95837 636.61187 541.90467 627.80357 546.99011 636.55673 552.04358"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "620.01078 561.59664 628.81886 556.5112 620.0657 551.4575 611.25762 556.54294 620.01078 561.59664"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "603.46461 571.14947 612.27268 566.06403 603.51952 561.01056 594.71146 566.09577 603.46461 571.14947"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "817.65651 465.54347 826.46458 460.45804 817.71142 455.40434 808.90335 460.48977 817.65651 465.54347"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "801.11033 475.0963 809.91841 470.01087 801.16547 464.95739 792.3574 470.0426 801.11033 475.0963"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "784.56438 484.64913 793.37246 479.56392 784.6193 474.51022 775.81122 479.59566 784.56438 484.64913"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-471",
    points: "768.01821 494.20219 776.82628 489.11675 768.07314 484.06305 759.26505 489.14849 768.01821 494.20219"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-498",
    points: "751.47205 503.75502 760.28011 498.66958 751.52695 493.61611 742.71887 498.70132 751.47205 503.75502"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-471",
    points: "734.92585 513.30785 743.73393 508.22264 734.98077 503.16894 726.17269 508.25437 734.92585 513.30785"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "718.37968 522.8609 727.18776 517.77547 718.43482 512.72199 709.62674 517.8072 718.37968 522.8609"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "701.83373 532.41373 710.64181 527.3283 701.88865 522.27482 693.08057 527.36026 701.83373 532.41373"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "685.28755 541.96679 694.09563 536.88135 685.34247 531.82765 676.53439 536.91309 685.28755 541.96679"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "668.74138 551.51962 677.54946 546.43419 668.7963 541.38071 659.98824 546.46592 668.74138 551.51962"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-471",
    points: "652.1952 561.07245 661.0033 555.98724 652.25012 550.93354 643.44204 556.01898 652.1952 561.07245"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "635.64903 570.62551 644.4571 565.54007 635.70417 560.48637 626.89609 565.57181 635.64903 570.62551"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "619.10308 580.17834 627.91115 575.0929 619.15799 570.03943 610.34992 575.12464 619.10308 580.17834"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "833.29498 474.57234 842.10305 469.48691 833.34992 464.43321 824.54182 469.51864 833.29498 474.57234"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "816.74882 484.12517 825.55688 479.03974 816.80372 473.98626 807.99564 479.07147 816.74882 484.12517"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "800.20263 493.678 809.0107 488.59279 800.25777 483.53909 791.44969 488.62453 800.20263 493.678"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "783.65668 503.23106 792.46475 498.14562 783.71159 493.09192 774.90352 498.17736 783.65668 503.23106"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-498",
    points: "767.1105 512.78389 775.91858 507.69845 767.16542 502.64498 758.35734 507.73019 767.1105 512.78389"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-471",
    points: "750.56433 522.33672 759.3724 517.25151 750.61924 512.19781 741.81117 517.28324 750.56433 522.33672"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "734.01815 531.88977 742.82623 526.80434 734.07307 521.75064 725.26501 526.83607 734.01815 531.88977"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-498",
    points: "717.47198 541.4426 726.28007 536.35717 717.52714 531.30369 708.71904 536.3889 717.47198 541.4426"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-498",
    points: "700.92604 550.99543 709.7341 545.91022 700.98094 540.85652 692.17287 545.94196 700.92604 550.99543"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "684.37985 560.54849 693.18793 555.46305 684.43477 550.40958 675.62669 555.49479 684.37985 560.54849"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "667.83368 570.10132 676.64175 565.01611 667.88859 559.96241 659.08052 565.04785 667.83368 570.10132"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "651.2875 579.65438 660.09558 574.56894 651.34242 569.51524 642.53434 574.60068 651.2875 579.65438"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "634.74132 589.20721 643.5494 584.12177 634.79647 579.0683 625.98839 584.15351 634.74132 589.20721"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "848.93345 483.60099 857.74153 478.51578 848.98837 473.46208 840.18029 478.54751 848.93345 483.60099"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "832.38727 493.15404 841.19535 488.06861 832.44219 483.01513 823.63411 488.10034 832.38727 493.15404"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "815.8411 502.70687 824.64918 497.62166 815.89624 492.56796 807.08794 497.6534 815.8411 502.70687"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "799.29492 512.25993 808.10323 507.17449 799.35007 502.12079 790.54199 507.20623 799.29492 512.25993"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-498",
    points: "782.74897 521.81276 791.55705 516.72732 782.80391 511.67385 773.99581 516.75906 782.74897 521.81276"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "766.20282 531.36559 775.01088 526.28038 766.25772 521.22668 757.44964 526.31211 766.20282 531.36559"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "749.65662 540.91864 758.4647 535.83321 749.71154 530.77951 740.90346 535.86494 749.65662 540.91864"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-498",
    points: "733.11045 550.47147 741.91852 545.38604 733.16559 540.33256 724.35729 545.41777 733.11045 550.47147"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-498",
    points: "716.56427 560.0243 725.37257 554.93909 716.61941 549.88539 707.81134 554.97083 716.56427 560.0243"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-471",
    points: "700.01832 569.57736 708.8264 564.49192 700.07324 559.43822 691.26516 564.52366 700.01832 569.57736"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "683.47215 579.13019 692.28022 574.04475 683.52706 568.99128 674.71901 574.07671 683.47215 579.13019"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "666.92597 588.68302 675.73407 583.59781 666.98089 578.54411 658.17281 583.62955 666.92597 588.68302"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "650.3798 598.23608 659.18787 593.15064 650.43494 588.09717 641.62664 593.18238 650.3798 598.23608"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "864.57192 492.62986 873.38 487.54465 864.62684 482.49094 855.81876 487.57638 864.57192 492.62986"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "848.02575 502.18291 856.83382 497.09748 848.08069 492.04378 839.27259 497.12921 848.02575 502.18291"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "831.47959 511.73574 840.28765 506.65031 831.53449 501.59683 822.72641 506.68227 831.47959 511.73574"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "814.9334 521.28857 823.74147 516.20336 814.98854 511.14966 806.18024 516.2351 814.9334 521.28857"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "798.38722 530.84163 807.19552 525.75619 798.44236 520.70272 789.63429 525.78793 798.38722 530.84163"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "781.84127 540.39446 790.64935 535.30925 781.89619 530.25555 773.08811 535.34098 781.84127 540.39446"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "765.2951 549.94751 774.10317 544.86208 765.35001 539.80838 756.54194 544.89381 765.2951 549.94751"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "748.74892 559.50034 757.557 554.41491 748.80384 549.36143 739.99578 554.44664 748.74892 559.50034"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "732.20274 569.05317 741.01084 563.96796 732.25791 558.91426 723.44958 563.9997 732.20274 569.05317"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-498",
    points: "715.65657 578.60623 724.46487 573.52079 715.71171 568.46709 706.90363 573.55253 715.65657 578.60623"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "699.11062 588.15906 707.9187 583.07362 699.16554 578.02015 690.35746 583.10536 699.11062 588.15906"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "682.56444 597.71189 691.37252 592.62668 682.61936 587.57298 673.81128 592.65841 682.56444 597.71189"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "666.01827 607.26495 674.82635 602.17951 666.07319 597.12604 657.26511 602.21125 666.01827 607.26495"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "880.21039 501.65872 889.01849 496.57351 880.26531 491.51981 871.45723 496.60525 880.21039 501.65872"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "863.66422 511.21178 872.47229 506.12635 863.71914 501.07265 854.91106 506.15808 863.66422 511.21178"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "847.11804 520.76461 855.92612 515.67918 847.17296 510.6257 838.36488 515.71091 847.11804 520.76461"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "830.57187 530.31744 839.37994 525.23223 830.62678 520.17853 821.81871 525.26397 830.57187 530.31744"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "814.02569 539.8705 822.83377 534.78506 814.08083 529.73159 805.27255 534.8168 814.02569 539.8705"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "797.47974 549.42333 806.28782 544.33812 797.53468 539.28442 788.72658 544.36985 797.47974 549.42333"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "780.93359 558.97638 789.74164 553.89095 780.98848 548.83725 772.18041 553.92268 780.93359 558.97638"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "764.38739 568.52921 773.19547 563.44378 764.44231 558.3903 755.63423 563.47551 764.38739 568.52921"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "747.84122 578.08204 756.64929 572.99683 747.89613 567.94313 739.08806 573.02857 747.84122 578.08204"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "731.29504 587.6351 740.10312 582.54966 731.35018 577.49596 722.54188 582.5814 731.29504 587.6351"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "714.74909 597.18793 723.55717 592.10249 714.80401 587.04902 705.99593 592.13423 714.74909 597.18793"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "698.20292 606.74076 707.01099 601.65555 698.25783 596.60185 689.44977 601.68728 698.20292 606.74076"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "681.65674 616.29382 690.46484 611.20838 681.71166 606.15468 672.90358 611.24011 681.65674 616.29382"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "895.84864 510.68759 904.65672 505.60238 895.90378 500.54868 887.09571 505.63412 895.84864 510.68759"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "879.30269 520.24065 888.11077 515.15522 879.35761 510.10151 870.54953 515.18695 879.30269 520.24065"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "862.75651 529.79348 871.56459 524.70805 862.81145 519.65457 854.00335 524.73978 862.75651 529.79348"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "846.21036 539.34631 855.01842 534.2611 846.26526 529.2074 837.45718 534.29284 846.21036 539.34631"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "829.66416 548.89937 838.47224 543.81393 829.71908 538.76023 820.911 543.84567 829.66416 548.89937"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "813.11799 558.4522 821.92607 553.36676 813.17313 548.31329 804.36505 553.3985 813.11799 558.4522"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "796.57204 568.00503 805.38012 562.91982 796.62696 557.86612 787.81888 562.95155 796.57204 568.00503"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "780.02586 577.55808 788.83394 572.47265 780.08078 567.41917 771.2727 572.50438 780.02586 577.55808"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "763.47969 587.11091 772.28776 582.0257 763.53461 576.972 754.72655 582.05744 763.47969 587.11091"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "746.93351 596.66397 755.74161 591.57853 746.98843 586.52483 738.18035 591.61027 746.93351 596.66397"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "730.38734 606.2168 739.19541 601.13136 730.44248 596.07789 721.6344 601.1631 730.38734 606.2168"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "713.84139 615.76963 722.64946 610.68442 713.8963 605.63072 705.08823 610.71615 713.84139 615.76963"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "697.29521 625.32268 706.10329 620.23725 697.35013 615.18355 688.54205 620.26898 697.29521 625.32268"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M939.97568,579.20559l16.37332-9.63656,26.39002,15.95965c1.92932,1.16698,2.89036,3.44176,2.38146,5.63843l-3.19778,28.76517-9.93475-20.15516c-1.95182-2.40891-4.32495-4.44309-7.00395-6.00349l-25.00832-14.56804Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M973.25798,598.08415c-1.95247-2.40869-4.3256-4.44286-7.00437-6.00349l-24.18794-14.08977-2.08954,1.2147,25.00787,14.56804c2.67877,1.5604,5.0519,3.5948,7.00437,6.00327l9.93432,20.15538.12829-.55299-8.793-21.29513Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M908.50112,597.39274l16.37332-9.63656,26.38979,15.95942c1.92952,1.16698,2.89034,3.44176,2.38168,5.63843l-3.19778,28.76517-9.93477-20.15516c-1.95202-2.40869-4.32515-4.44286-7.00415-6.00349l-25.0081-14.56782Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M941.7832,616.27108c-1.95225-2.40846-4.32535-4.44264-7.00437-6.00327l-24.18794-14.09-2.08954,1.21492,25.00787,14.56782c2.679,1.56063,5.05212,3.5948,7.00437,6.00349l9.93455,20.15516.12806-.55277-8.793-21.29536Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-321",
    d: "M877.02634,615.57967l16.37332-9.63656,26.39002,15.95965c1.92929,1.16676,2.89034,3.44176,2.38148,5.63843l-3.19781,28.76517-9.93477-20.15538c-1.9518-2.40869-4.32493-4.44286-7.00392-6.00349l-25.00832-14.56782Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M910.30865,634.45824c-1.95247-2.40869-4.3256-4.44286-7.00437-6.00349l-24.18794-14.09-2.08952,1.21492,25.00785,14.56804c2.67877,1.5604,5.0519,3.59458,7.00437,6.00327l9.93432,20.15538.12829-.55299-8.793-21.29513Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-319",
    d: "M845.55179,633.7666l16.37332-9.63656,26.38979,15.95965c1.92952,1.16698,2.89034,3.44176,2.38168,5.63843l-3.19778,28.76517-9.93477-20.15516c-1.95202-2.40891-4.32513-4.44309-7.00415-6.00349l-25.0081-14.56804Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M878.83387,652.64517c-1.95225-2.40869-4.32538-4.44286-7.00437-6.00327l-24.18794-14.09-2.08954,1.2147,25.00787,14.56804c2.67902,1.56063,5.05212,3.5948,7.00437,6.00327l9.93455,20.15538.12806-.55299-8.793-21.29513Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M814.07701,651.95375l16.37332-9.63656,26.39004,15.95965c1.92927,1.16676,2.89031,3.44153,2.38143,5.63843l-3.19778,28.76517-9.93477-20.15538c-1.95178-2.40869-4.32493-4.44286-7.00392-6.00349l-25.00832-14.56782Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M847.35932,670.8321c-1.95245-2.40846-4.3256-4.44264-7.00437-6.00327l-24.18794-14.09-2.08954,1.21492,25.00787,14.56782c2.67877,1.56063,5.0519,3.5948,7.00437,6.00349l9.93432,20.15538.12829-.55299-8.793-21.29536Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-324",
    d: "M782.60245,670.14068l16.37332-9.63656,26.38979,15.95965c1.92952,1.16676,2.89034,3.44176,2.38168,5.63843l-3.19778,28.76517-9.93477-20.15538c-1.95202-2.40869-4.32515-4.44286-7.00415-6.00327l-25.0081-14.56804Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M815.88456,689.01925c-1.95227-2.40869-4.3254-4.44286-7.0044-6.00349l-24.18792-14.08977-2.08956,1.2147,25.00787,14.56804c2.679,1.5604,5.05212,3.59458,7.00437,6.00327l9.93455,20.15538.12806-.55299-8.79298-21.29513Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-322",
    d: "M750.97935,688.32784l16.3731-9.63678,26.39002,15.95965c1.92952,1.16698,2.89034,3.44176,2.38168,5.63843l-3.19778,28.76517-9.93477-20.15516c-1.95202-2.40869-4.32515-4.44286-7.00415-6.00349l-25.0081-14.56782Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M784.26144,707.20618c-1.95225-2.40869-4.32538-4.44286-7.00437-6.00327l-24.18794-14.09-2.08954,1.21492,25.00787,14.56782c2.679,1.56063,5.05212,3.5948,7.00437,6.00349l9.93455,20.15516.12806-.55299-8.793-21.29513Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-323",
    d: "M719.50457,706.51477l16.37332-9.63656,26.39002,15.95965c1.92929,1.16676,2.89034,3.44153,2.38146,5.63843l-3.19776,28.76517-9.93479-20.15538c-1.9518-2.40869-4.32493-4.44286-7.0039-6.00349l-25.00834-14.56782Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M752.78688,725.39333c-1.95247-2.40869-4.3256-4.44286-7.00437-6.00349l-24.18794-14.09-2.08977,1.21492,25.00812,14.56782c2.67875,1.56063,5.05188,3.5948,7.00435,6.00349l9.93434,20.15538.12804-.55299-8.79277-21.29513Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-336",
    d: "M449.44491,579.20244l-16.3677-9.63341-26.38124,15.95447c-1.92884,1.16631-2.88944,3.44041-2.38078,5.6364l3.19666,28.75572,9.9314-20.14863c1.95135-2.40801,4.3238-4.44151,7.0019-6.00147l24.99977-14.56309Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M416.17386,598.0747c1.95157-2.40779,4.32403-4.44129,7.00212-6.00147l24.17984-14.08527,2.08887,1.21447-24.99954,14.56309c-2.6781,1.56018-5.05032,3.59368-7.00212,6.00147l-9.93117,20.14863-.12806-.55277,8.79007-21.28816Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-334",
    d: "M480.90934,597.38351l-16.36792-9.63341-26.38123,15.95424c-1.92884,1.16653-2.88945,3.44063-2.38079,5.63663l3.19666,28.75572,9.93162-20.14863c1.95112-2.40801,4.32358-4.44151,7.00167-6.00147l24.99999-14.56309Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-335",
    d: "M447.63806,616.25578c1.9518-2.40779,4.32403-4.44151,7.00212-6.00147l24.17984-14.08527,2.08887,1.21447-24.99954,14.56309c-2.6781,1.55995-5.05032,3.59345-7.00211,6.00147l-9.93118,20.14863-.12806-.55277,8.79007-21.28816Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-333",
    d: "M512.37354,615.56437l-16.36792-9.63341-26.38124,15.95447c-1.92884,1.16653-2.88921,3.44063-2.38077,5.63663l3.19664,28.7555,9.93163-20.14863c1.95111-2.40779,4.32358-4.44129,7.00166-6.00147l24.99999-14.56309Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M479.10226,634.43663c1.9518-2.40779,4.32403-4.44129,7.00214-6.00124l24.17983-14.08527,2.08909,1.21425-24.99977,14.56309c-2.67808,1.56018-5.05031,3.59368-7.00212,6.00147l-9.93117,20.14863-.12806-.55277,8.79007-21.28816Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-337",
    d: "M543.83774,633.74544l-16.36791-9.63341-26.38126,15.95447c-1.92862,1.16631-2.88921,3.44041-2.38078,5.6364l3.19688,28.75572,9.9314-20.14863c1.95135-2.40801,4.32358-4.44151,7.00167-6.00147l24.99999-14.56309Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M510.56646,652.61771c1.9518-2.40779,4.32403-4.44129,7.00212-6.00147l24.18007-14.08527,2.08887,1.21447-24.99977,14.56309c-2.67787,1.55995-5.05032,3.59368-7.0019,6.00147l-9.93117,20.14863-.12806-.55277,8.78985-21.28816Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-331",
    d: "M575.30194,651.92652l-16.3677-9.63341-26.38124,15.95424c-1.92884,1.16653-2.88944,3.44063-2.38101,5.63663l3.1969,28.75572,9.93138-20.14863c1.95135-2.40801,4.3238-4.44151,7.00167-6.00147l24.99999-14.56309Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M542.03089,670.79879c1.95157-2.40801,4.32403-4.44151,7.0019-6.00147l24.18008-14.08527,2.08885,1.21447-24.99977,14.56309c-2.67787,1.55995-5.05032,3.59345-7.0019,6.00124l-9.93116,20.14886-.12808-.55299,8.79007-21.28793Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M606.76616,670.10737l-16.36771-9.63341-26.38124,15.95447c-1.92884,1.16653-2.88944,3.44041-2.38078,5.6364l3.19666,28.75572,9.9314-20.14863c1.95135-2.40779,4.3238-4.44129,7.0019-6.00147l24.99978-14.56309Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M573.49509,688.97964c1.9518-2.40779,4.32403-4.44129,7.00212-6.00147l24.17984-14.08527,2.08887,1.21447-24.99954,14.56309c-2.6781,1.56018-5.05032,3.59368-7.00212,6.00147l-9.93117,20.14863-.12806-.55277,8.79007-21.28816Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-329",
    d: "M638.00775,688.28845l-16.3677-9.63341-26.38124,15.95424c-1.92884,1.16653-2.88944,3.44063-2.38078,5.63663l3.19666,28.75572,9.9314-20.14863c1.95135-2.40801,4.3238-4.44151,7.0019-6.00147l24.99977-14.56309Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M604.7367,707.16071c1.9518-2.40779,4.32403-4.44129,7.00212-6.00147l24.17984-14.08527,2.08887,1.21447-24.99954,14.56309c-2.6781,1.55995-5.05032,3.59345-7.00212,6.00147l-9.93117,20.14863-.12806-.55277,8.79007-21.28816Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-330",
    d: "M669.47218,706.46953l-16.36792-9.63341-26.38122,15.95424c-1.92884,1.16653-2.88945,3.44063-2.3808,5.63663l3.19666,28.7555,9.93162-20.14841c1.95112-2.40801,4.32358-4.44151,7.00167-6.00147l24.99999-14.56309Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M636.2009,725.34157c1.9518-2.40779,4.32403-4.44129,7.00212-6.00124l24.17984-14.08527,2.08887,1.21447-24.99954,14.56309c-2.6781,1.55995-5.05032,3.59345-7.00211,6.00124l-9.93119,20.14863-.12806-.55277,8.79007-21.28816Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-443",
    points: "904.63128 206.62495 696.82459 85.60982 486.21534 204.05083 486.21534 503.81376 696.05216 626.00509 904.63128 506.01381 904.63128 206.62495"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-544"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-373",
    d: "M914.27302,954.61355c-2.65671,0-5.06765-.5809-6.97216-1.68059l-73.83415-42.62808c-2.54238-1.46813-4.00038-3.79084-3.99993-6.3726,0-2.83002,1.75576-5.46693,4.81717-7.23372l41.90176-24.19245c2.40419-1.388,5.41088-2.15234,8.46687-2.15234,2.65649,0,5.06765.58113,6.97221,1.68082l73.8341,42.62785c2.54238,1.46813,3.99993,3.79061,3.99993,6.37238,0,2.82957-1.75576,5.46648-4.8167,7.23417l-41.90223,24.19245c-2.40419,1.38778-5.41088,2.15211-8.46687,2.15211Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-531",
    d: "M876.37045,872.82606c2.39798-1.38442,5.41925-2.12605,8.44234-2.09208,1.21979.01499,2.38064.17143,3.45912.42286,1.16192.27088,2.51274.81925,3.44711,1.35875l73.55513,42.46682c2.52943,1.46062,3.85017,3.77406,3.69869,6.28899-.04266.70828-.21116,1.39613-.45691,2.07261-.64766,1.78283-2.46115,3.68246-4.516,4.86913l-41.30913,23.85c-.52658.30396-1.22187.65025-1.80374.88971-1.98453.81671-4.24034,1.27577-6.52441,1.28808-2.61519.01406-5.00445-.54668-6.8771-1.62795l-73.8341-42.62808c-2.53534-1.46403-3.8488-3.78502-3.68435-6.30262.03971-.60797.17347-1.20032.35887-1.78644.59865-1.89253,2.47813-3.91685,4.63662-5.16255l41.40786-23.90725Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-398",
    d: "M876.55519,873.146c2.39178-1.38084,5.42762-2.09976,8.41781-2.03182,1.21668.02998,2.36694.21959,3.43101.48237,1.04245.25744,2.56831.91448,3.40925,1.40004l73.27616,42.30579c2.51648,1.45312,3.70321,3.75508,3.39746,6.2056-.08433.67588-.30155,1.32348-.56153,1.97659-.63137,1.5861-2.71822,3.60472-4.56758,4.67273l-40.71603,23.50756c-.47392.27356-1.2501.66851-1.7726.8869-1.94827.81431-4.16841,1.29195-6.41685,1.31658-2.57367.02811-4.94125-.51245-6.78204-1.57531l-73.83406-42.62808c-2.5283-1.45993-3.70065-3.77631-3.36878-6.23263.07839-.58019.25794-1.13829.45752-1.70427.59412-1.68477,2.77365-3.83886,4.71628-4.95999l40.91397-23.62206Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-423",
    d: "M876.73993,873.46595c2.38557-1.37727,5.43598-2.07347,8.39328-1.97156,1.21358.04496,2.35268.26761,3.40289.54188.92349.24118,2.62389,1.00972,3.37138,1.44132l72.99719,42.14475c2.50353,1.44562,3.55978,3.73419,3.09623,6.12221-.12482.64304-.39119,1.24893-.66616,1.88057-.60568,1.39134-2.97528,3.52699-4.61916,4.47633l-40.12294,23.16511c-.42126.24317-1.27812.68733-1.74145.88408-1.9122.81198-4.09648,1.30814-6.30928,1.34508-2.53214.04217-4.87805-.47822-6.68697-1.52267l-73.83402-42.62808c-2.52127-1.45583-3.55659-3.76534-3.0532-6.16264.1159-.55198.34174-1.07437.55617-1.6221.5789-1.47868,3.06916-3.76086,4.79595-4.75742l40.42008-23.33687Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-447",
    d: "M876.92467,873.78589c2.37936-1.37369,5.44435-2.04718,8.36874-1.91131,1.21047.05995,2.33784.31548,3.37478.6014.80511.22199,2.67946,1.10495,3.33352,1.4826l72.71822,41.98372c2.49057,1.43811,3.42059,3.71212,2.795,6.03882-.164.60996-.47996,1.1724-.77078,1.78455-.56976,1.19932-3.23235,3.44925-4.67074,4.27992l-39.52984,22.82267c-.3686.21277-1.3059.70674-1.7103.88127-1.87632.80974-4.02455,1.32432-6.20172,1.37358-2.49062.05622-4.81484-.444-6.59191-1.47004l-73.83397-42.62808c-2.51423-1.45173-3.41742-3.75307-2.73763-6.09265.15212-.52354.42476-1.00846.65482-1.53994.55198-1.27512,3.36468-3.68287,4.87562-4.55486l39.92619-23.05167Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M877.10941,874.10584c2.37316-1.37011,5.45272-2.02089,8.34421-1.85105,1.20736.07494,2.32242.36319,3.34666.66091.6874.19981,2.73503,1.20018,3.29566,1.52389l72.43925,41.82269c2.47762,1.43061,3.28622,3.6899,2.49377,5.95544-.20179.5769-.56776,1.09381-.8754,1.68853-.52291,1.01085-3.48941,3.37152-4.72232,4.08352l-38.93674,22.48022c-.31595.18237-1.33343.72677-1.67915.87845-1.84064.80758-3.95262,1.3405-6.09415,1.40208-2.44909.07028-4.75164-.40977-6.49684-1.4174l-73.83393-42.62808c-2.50719-1.44763-3.28376-3.74078-2.42205-6.02266.18698-.49515.50689-.94049.75348-1.45777.51249-1.07507,3.66019-3.60487,4.95528-4.35229l39.4323-22.76648Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-526",
    d: "M877.29415,874.42579c2.36695-1.36653,5.46108-1.9946,8.31968-1.79079,1.20426.08993,2.30641.41073,3.31855.72042.57043.17454,2.79061,1.29542,3.25779,1.56517l72.16027,41.66165c2.46467,1.42311,3.15703,3.66876,2.19253,5.87205-.2382.54413-.54971,1.08607-.98003,1.59251-.29794.9004-3.74648,3.29378-4.7739,3.88712l-38.34365,22.13778c-.26329.15198-1.3607.74743-1.64801.87564-1.80516.80551-3.88069,1.35669-5.98658,1.43058-2.40757.08433-4.68844-.37554-6.40178-1.36476l-73.83389-42.62808c-2.50015-1.44353-3.1559-3.72994-2.10648-5.95268.22053-.4671.49011-.93529.85213-1.37561.26984-.95509,3.95571-3.52688,5.03495-4.14973l38.93841-22.48129Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-455",
    d: "M877.47889,874.74573c2.36075-1.36295,5.46945-1.96831,8.29515-1.73053,1.20115.10492,2.28978.45808,3.29043.77993.45431.14613,2.84618,1.39065,3.21993,1.60645l71.8813,41.50062c2.45172,1.4156,3.03305,3.65007,1.8913,5.78866-.27333.51197-.62131,1.02258-1.08465,1.49649-.23835.72032-4.00354,3.21605-4.82548,3.69072l-37.75055,21.79533c-.21063.12158-1.38768.76877-1.61686.87282-1.76991.80355-3.80876,1.37287-5.87902,1.45909-2.36604.09839-4.62523-.34132-6.30672-1.31212l-73.83384-42.62808c-2.49311-1.43943-3.03372-3.72213-1.7909-5.88269.25291-.43968.55705-.88108.95078-1.29344.21587-.76407,4.25122-3.44888,5.11462-3.94716l38.44451-22.19609Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-369",
    d: "M877.66364,875.06568c2.35454-1.35937,5.47781-1.94202,8.27062-1.67028,1.19804.1199,2.27254.50523,3.26232.83945.33911.11451,2.90175,1.48589,3.18207,1.64774l71.60233,41.33959c2.43877,1.4081,2.91392,3.63517,1.59007,5.70527-.30739.48067-.69291.95909-1.18928,1.40047-.17876.54024-4.26061,3.13831-4.87706,3.49431l-37.15745,21.45289c-.15797.09119-1.41435.79082-1.58571.87-1.73488.80168-3.73684,1.38906-5.77145,1.48759-2.32452.11244-4.56203-.30709-6.21165-1.25948l-73.8338-42.62808c-2.48607-1.43533-2.91663-3.71877-1.47533-5.8127.28435-.41311.624-.82686,1.04943-1.21128.1619-.57305,4.54674-3.37089,5.19428-3.7446l37.95062-21.9109Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M877.84838,875.38562c2.34834-1.35579,5.48618-1.91573,8.24608-1.61002,1.19494.13489,2.25467.55217,3.2342.89896.22493.07964,2.95733,1.58112,3.1442,1.68902l71.32336,41.17855c2.42582,1.4006,2.7989,3.6252,1.28884,5.62188-.34066.45044-.76451.8956-1.2939,1.30445-.11918.36016-4.51767,3.06058-4.92864,3.29791l-36.56436,21.11045c-.10532.06079-1.44069.81361-1.55456.86719-1.7001.79993-3.66491,1.40524-5.66389,1.51609-2.28299.1265-4.49883-.27286-6.11659-1.20684l-73.83376-42.62808c-2.47904-1.43123-2.80364-3.721-1.15975-5.74271.31515-.38758.69094-.77265,1.14808-1.12911.10793-.38204,4.84225-3.29289,5.27395-3.54203l37.45673-21.62571Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M878.03312,875.70557c2.34213-1.35222,5.49455-1.88945,8.22155-1.54976,1.19183.14988,2.23616.59888,3.20609.95847.11187.04147,3.0129,1.67635,3.10634,1.7303l71.04439,41.01752c2.41286,1.39309,2.68692,3.62098.98761,5.53849-.37347.42142-.83611.83211-1.39852,1.20843-.05959.18008-4.77474,2.98284-4.98022,3.10151l-35.97126,20.768c-.05266.0304-1.46667.83718-1.52341.86437-1.66557.79829-3.59298,1.42142-5.55632,1.54459-2.24147.14056-4.43563-.23864-6.02152-1.1542l-73.83372-42.62808c-2.472-1.42714-2.69346-3.7295-.84418-5.67272.34561-.36316.75789-.71844,1.24673-1.04694.05397-.19102,5.13777-3.2149,5.35361-3.33947l36.96284-21.34051Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-420",
    d: "M909.33253,949.41333l-73.83367-42.62808c-2.91577-1.68329-2.55003-4.62359.81678-6.56751l41.90223-24.19222c3.36661-1.9437,8.45944-2.15481,11.37499-.47152l73.8339,42.62808c2.91554,1.68329,2.55003,4.62359-.81678,6.56751l-41.90223,24.19222c-3.36656,1.9437-8.45944,2.15481-11.37521.47152Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-338",
    d: "M909.33253,949.34558l-73.83367-42.62808c-1.29932-.75016-1.94685-1.74969-1.96778-2.79963-.00068-.03376-.00068-3.62406-.00023-3.65782.02341-1.27614.96622.93989,2.78478-.10983l41.90223-24.19245c3.36661-1.9437,8.45944-2.15481,11.37499-.47152l73.8339,42.62808c.9732.562,1.67924-1.82328,1.93154-1.06503.08418.25275.03064,3.59885.03624,3.86106.02791,1.3072-.91626,2.69273-2.78455,3.77148l-41.90223,24.19222c-3.36656,1.9437-8.45944,2.15481-11.37521.47152Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-516",
    d: "M909.33253,945.75573l-73.83367-42.62808c-2.91577-1.68329-2.55003-4.62359.81678-6.56729l41.90223-24.19245c3.36661-1.9437,8.45944-2.15481,11.37499-.47152l73.8339,42.62808c2.91554,1.68329,2.55003,4.62359-.81678,6.56751l-41.90223,24.19222c-3.36656,1.9437-8.45944,2.15481-11.37521.47152Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-339",
    d: "M914.27324,945.4179c-1.66191,0-3.15434-.33378-4.20316-.93899l-73.83412-42.62785c-.45979-.26536-1.23068-.8233-1.23068-1.57548,0-.78662.76501-1.6977,2.04768-2.43795l41.902-24.19267c1.55253-.89622,3.62946-1.41028,5.69785-1.41028,1.66191,0,3.15412.33355,4.20294.93876l73.83367,42.62785c.46007.26558,1.2309.8233,1.2309,1.57548,0,.78617-.76568,1.6977-2.0479,2.4384l-41.902,24.19245c-1.5523.89622-3.62924,1.41028-5.69717,1.41028Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-528",
    d: "M962.60997,920.48228l-41.90223,24.19222c-3.36656,1.94392-8.45944,2.15504-11.37521.47152l-73.83367-42.62785c-1.20952-.69839-1.84579-1.61397-1.94595-2.58402-.15147,1.19107.48502,2.35017,1.94595,3.1935l73.83367,42.62808c2.91577,1.68329,8.00866,1.47218,11.37521-.47152l41.90223-24.19222c1.97003-1.1375,2.90407-2.61508,2.76272-3.9835-.1508,1.18611-1.08281,2.40396-2.76272,3.37378Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-433",
    d: "M940.65291,937.72662c3.34903,8.14952-3.88807,18.84593-16.16468,23.89108s-24.94395,2.52843-28.29298-5.6211c-3.34903-8.14952,3.88807-18.84571,16.16491-23.89085,12.27662-5.04515,24.94373-2.52865,28.29275,5.62087Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-418",
    d: "M893.98282,881.70536c1.95517,5.68389-4.26348,12.97568-13.88946,16.2869-9.62598,3.31099-19.01428,1.38755-20.96923-4.29634-1.95515-5.68389,4.26326-12.97568,13.88946-16.28667,9.62598-3.31122,19.01428-1.38755,20.96923,4.29612Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-340",
    d: "M922.4536,930.05334l-59.95659-34.61607c-1.20052-.69321-1.04995-1.90386.33625-2.7042l22.51028-12.99639c1.3862-.80035,3.48339-.88722,4.68391-.19401l59.95659,34.61584c1.20052.69321,1.04997,1.90386-.33625,2.7042l-22.51028,12.99639c-1.3862.80035-3.48339.88722-4.68391.19423Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-429",
    d: "M886.65637,882.266l3.84193,2.21828c.48862.28201,1.27839.28359,1.76387.00315.48572-.28044.48322-.7362-.0054-1.01844l-3.84215-2.21806c-.48862-.28224-1.27839-.28359-1.76384-.00338-.4855.28044-.48302.73643.0056,1.01844ZM893.23446,886.06404l1.82013,1.05062c.4884.28224,1.27817.28359,1.76387.00315.48547-.28021.483-.7362-.00563-1.01821l-1.81991-1.05085c-.48862-.28201-1.27839-.28336-1.76387-.00315-.48547.28044-.483.7362.0054,1.01844ZM897.79076,888.69443l1.81991,1.05085c.48862.28201,1.27839.28336,1.76387.00315.48547-.28044.483-.7362-.00563-1.01844l-1.81991-1.05062c-.48862-.28224-1.27817-.28359-1.76387-.00315-.48547.28021-.483.7362.00563,1.01821ZM902.34683,891.32503l1.81991,1.05062c.48862.28224,1.27839.28359,1.76387.00315.48572-.28021.48322-.7362-.0054-1.01821l-1.81991-1.05085c-.48862-.28201-1.27839-.28336-1.76387-.00315-.4857.28044-.48322.7362.0054,1.01844ZM906.90291,893.95542l1.82013,1.05085c.4884.28201,1.27817.28336,1.76387.00315.48547-.28044.483-.7362-.00563-1.01844l-1.81991-1.05062c-.48862-.28224-1.27839-.28359-1.76387-.00315-.48547.28021-.483.7362.0054,1.01821ZM911.4592,896.58602l1.81991,1.05062c.48862.28224,1.27839.28359,1.76387.00315.48547-.28021.483-.7362-.00563-1.01821l-1.81991-1.05085c-.48862-.28201-1.27817-.28336-1.76387-.00315-.48547.28044-.483.7362.00563,1.01844ZM916.01528,899.2164l1.81991,1.05085c.48862.28201,1.27839.28336,1.76387.00315.48572-.28044.48322-.7362-.0054-1.01844l-1.81991-1.05062c-.48862-.28224-1.27839-.28359-1.76387-.00315-.4857.28021-.48322.7362.0054,1.01821ZM920.57135,901.84701l1.82013,1.05062c.4884.28224,1.27817.28359,1.76387.00315.48547-.28021.483-.7362-.00563-1.01821l-1.81991-1.05085c-.48862-.28201-1.27839-.28336-1.76387-.00315-.48547.28044-.483.7362.0054,1.01844ZM925.12765,904.47739l1.81991,1.05085c.48862.28201,1.27839.28336,1.76387.00315.48547-.28044.483-.7362-.00563-1.01844l-1.81991-1.05062c-.48862-.28224-1.27817-.28359-1.76387-.00315-.48547.28021-.483.7362.00563,1.01821ZM929.68372,907.108l1.81991,1.05062c.48862.28224,1.27839.28359,1.76387.00315.48572-.28021.48322-.7362-.0054-1.01821l-1.81991-1.05085c-.48862-.28201-1.27839-.28336-1.76387-.00315-.4857.28044-.48322.7362.0054,1.01844ZM934.23979,909.73838l1.82013,1.05085c.4884.28201,1.27817.28336,1.76387.00315.48547-.28044.483-.7362-.00563-1.01844l-1.81991-1.05062c-.48862-.28224-1.27839-.28359-1.76387-.00315-.48547.28021-.483.7362.0054,1.01821ZM938.79609,912.36899l1.81991,1.05062c.48862.28224,1.27839.28359,1.76387.00315.48547-.28021.483-.7362-.00563-1.01821l-1.81991-1.05085c-.48862-.28201-1.27817-.28359-1.76387-.00315-.48547.28044-.483.7362.00563,1.01844ZM943.44694,915.05406l1.81988,1.05085c.48862.28201,1.27839.28359,1.76387.00315.4857-.28044.48325-.7362-.0054-1.01844l-1.81991-1.05062c-.48862-.28224-1.27839-.28359-1.76387-.00315-.4857.28021-.48322.7362.00543,1.01821ZM882.55854,884.77305l1.57548.9095c.55615.32117,1.45485.32275,2.00739.0036l1.56581-.90388c.55254-.31915.54984-.83793-.0063-1.15888l-1.57548-.90973c-.55615-.32117-1.45485-.32275-2.00762-.0036l-1.56556.90388c-.55279.31915-.54987.83793.00628,1.15911ZM890.69771,888.31676l1.56558-.9041c.55277-.31892.54987-.83793-.0063-1.15888l-1.57548-.90973c-.55615-.32095-1.45485-.32252-2.00737-.0036l-1.56583.9041c-.55254.31892-.54982.83793.0063,1.15888l1.57548.90973c.55615.32095,1.45485.32275,2.00762.0036ZM891.67068,890.03404l1.57571.9095c.55592.32117,1.45485.32275,2.00739.0036l1.56581-.90388c.55254-.31915.54962-.83793-.0063-1.15888l-1.57571-.90973c-.55592-.32117-1.45485-.32275-2.00739-.0036l-1.56581.90388c-.55254.31915-.54962.83793.0063,1.15911ZM896.22698,892.66442l1.57548.90973c.55615.32095,1.45485.32275,2.00739.0036l1.56581-.9041c.55254-.31892.54984-.83793-.0063-1.15888l-1.57548-.90973c-.55615-.32095-1.45485-.32252-2.00762-.0036l-1.56556.9041c-.55279.31892-.54987.83793.00628,1.15888ZM905.92543,894.14515l-1.57548-.9095c-.55615-.32117-1.45485-.32275-2.00737-.0036l-1.56583.90388c-.55254.31915-.54982.83793.0063,1.15911l1.57548.9095c.55615.32117,1.45485.32275,2.00762.0036l1.56558-.90388c.55277-.31915.54987-.83793-.0063-1.15911ZM910.48173,896.77576l-1.57571-.90973c-.55592-.32095-1.45485-.32252-2.00739-.0036l-1.56581.9041c-.55254.31892-.54962.83793.0063,1.15888l1.57571.90973c.55592.32095,1.45485.32275,2.00739.0036l1.56581-.9041c.55254-.31892.54962-.83793-.0063-1.15888ZM915.0378,899.40614l-1.57548-.9095c-.55615-.32117-1.45485-.32275-2.00762-.0036l-1.56556.90388c-.55279.31915-.54987.83793.00628,1.15911l1.57548.9095c.55615.32117,1.45485.32275,2.00739.0036l1.56581-.90388c.55254-.31915.54984-.83793-.0063-1.15911ZM919.59387,902.03674l-1.57548-.90973c-.55615-.32095-1.45485-.32252-2.00737-.0036l-1.56583.9041c-.55254.31892-.54982.83793.0063,1.15888l1.57548.90973c.55615.32095,1.45485.32252,2.00762.0036l1.56558-.9041c.55277-.31892.54987-.83793-.0063-1.15888ZM924.15017,904.66713l-1.57571-.9095c-.55592-.32117-1.45485-.32275-2.00739-.0036l-1.56581.90388c-.55254.31915-.54962.83793.0063,1.15911l1.57571.9095c.55592.32117,1.45485.32275,2.00739.0036l1.56581-.90388c.55254-.31915.54962-.83793-.0063-1.15911ZM928.70624,907.29773l-1.57548-.90973c-.55615-.32095-1.45485-.32252-2.00762-.0036l-1.56556.9041c-.55279.31892-.54987.83793.00628,1.15888l1.57548.90973c.55615.32095,1.45485.32252,2.00739.0036l1.56581-.9041c.55254-.31892.54984-.83793-.0063-1.15888ZM928.11994,911.07799l1.57548.9095c.55615.32117,1.45485.32275,2.00762.0036l1.56558-.90388c.55277-.31915.54987-.83793-.0063-1.15911l-1.57548-.9095c-.55615-.32117-1.45485-.32275-2.00737-.0036l-1.56583.90388c-.55254.31915-.54982.83793.0063,1.15911ZM937.81861,912.55872l-1.57571-.90973c-.55592-.32095-1.45485-.32252-2.00739-.0036l-1.56581.9041c-.55254.31892-.54962.83793.0063,1.15888l1.57571.90973c.55592.32095,1.45485.32252,2.00739.0036l1.56581-.9041c.55254-.31892.54962-.83793-.0063-1.15888ZM944.49169,916.41145l-3.59773-2.07716c-.55615-.32117-1.45485-.32275-2.00739-.0036l-1.56581.90388c-.55254.31915-.54984.83793.0063,1.15911l3.59773,2.07716c.55592.32095,1.45485.32252,2.00739.0036l1.56583-.9041c.55252-.31892.54982-.83793-.00633-1.15888ZM878.33849,887.20942l3.59773,2.07716c.55592.32095,1.45485.32252,2.00739.0036l1.56581-.9041c.55254-.31892.54984-.83793-.0063-1.15888l-3.59773-2.07716c-.55615-.32095-1.45485-.32275-2.00739-.0036l-1.56578.90388c-.55257.31915-.54987.83793.00628,1.15911ZM884.91681,891.00746l1.57548.9095c.55615.32117,1.45487.32275,2.00739.0036l1.56581-.90388c.55254-.31915.54984-.83793-.0063-1.15911l-1.57548-.9095c-.55615-.32117-1.45482-.32275-2.00739-.0036l-1.56581.90388c-.55277.31915-.54984.83793.0063,1.15911ZM891.04862,894.54757c.55592.32095,1.4546.32252,2.00737.0036l1.56558-.9041c.55277-.31892.54984-.83793-.00608-1.15888l-1.57571-.90973c-.55615-.32095-1.45485-.32252-2.00739-.0036l-1.56581.9041c-.55254.31892-.54984.83793.0063,1.15888l1.57573.90973ZM895.60467,897.17795c.55592.32117,1.45485.32275,2.00739.0036l1.56581-.90388c.55254-.31915.54984-.83793-.0063-1.15911l-1.57568-.9095c-.55592-.32117-1.45487-.32275-2.00741-.0036l-1.56581.90388c-.55254.31915-.54962.83793.0063,1.15911l1.57571.9095ZM900.14476,896.83585l-1.56581.9041c-.55277.31892-.54984.83793.0063,1.15888l1.57548.90973c.55615.32095,1.45487.32252,2.00739.0036l1.56581-.9041c.55254-.31892.54984-.83793-.0063-1.15888l-1.57548-.90973c-.55615-.32095-1.45482-.32252-2.00739-.0036ZM904.79716,899.41086l-1.75846,1.01506c-.49943.28831-.49673.75736.00563,1.04747l1.76952,1.02159c.50256.29011,1.31483.29169,1.81426.00315l1.75824-1.01506c.49943-.28831.49695-.75736-.00563-1.04747l-1.76927-1.02159c-.50258-.29011-1.31485-.29169-1.81428-.00315ZM909.35323,902.04125l-1.75824,1.01529c-.49943.28831-.49695.75713.00563,1.04725l1.76927,1.02159c.50258.29034,1.31485.29169,1.81428.00338l1.75846-1.01529c.49943-.28831.49673-.75713-.00585-1.04747l-1.76924-1.02136c-.5026-.29034-1.31488-.29169-1.81431-.00338ZM913.90931,904.67185l-1.75822,1.01506c-.49945.28831-.49698.75736.0056,1.04747l1.76949,1.02159c.5026.29011,1.31485.29169,1.81428.00315l1.75826-1.01506c.4994-.28831.49693-.75736-.00565-1.04747l-1.76949-1.02159c-.50255-.29011-1.31485-.29169-1.81428-.00315ZM918.4656,907.30223l-1.75846,1.01529c-.49943.28831-.49673.75713.00563,1.04725l1.76952,1.02159c.50255.29011,1.31483.29169,1.81426.00338l1.75824-1.01529c.49943-.28831.49695-.75713-.00563-1.04747l-1.76927-1.02136c-.50258-.29034-1.31485-.29169-1.81428-.00338ZM923.02168,909.93284l-1.75824,1.01506c-.49943.28831-.49695.75736.00563,1.04747l1.76927,1.02159c.50258.29011,1.31485.29169,1.81428.00315l1.75846-1.01506c.49943-.28831.49673-.75736-.00585-1.04747l-1.76924-1.02159c-.5026-.29011-1.31488-.29169-1.81431-.00315ZM929.40891,915.65072l1.75826-1.01529c.4994-.28831.49693-.75713-.00565-1.04747l-1.76949-1.02136c-.50255-.29034-1.31485-.29169-1.81428-.00338l-1.75821,1.01529c-.49945.28831-.49698.75713.0056,1.04725l1.76949,1.02159c.5026.29011,1.31485.29169,1.81428.00338ZM933.96498,918.2811l1.75824-1.01506c.49943-.28831.49695-.75736-.00563-1.04747l-1.76927-1.02159c-.50258-.29011-1.31485-.29169-1.81428-.00315l-1.75846,1.01506c-.49943.28831-.49673.75736.00563,1.04747l1.76952,1.02159c.50255.29011,1.31483.29169,1.81426.00315ZM940.36865,918.90387l-1.76949-1.02159c-.50258-.29011-1.31485-.29169-1.81426-.00338l-1.75826,1.01529c-.49943.28831-.49693.75713.00563,1.04747l1.76927,1.02136c.50258.29034,1.31485.29169,1.81428.00338l1.75846-1.01506c.49943-.28854.49673-.75736-.00563-1.04747ZM874.02145,889.58998l5.7127,3.29794c.50258.29034,1.31485.29169,1.81431.00338l1.75822-1.01506c.49943-.28854.49698-.75736-.00563-1.04747l-5.71248-3.29816c-.50258-.29034-1.31485-.29169-1.81428-.00338l-1.75846,1.01529c-.49943.28831-.49673.75713.00563,1.04747ZM882.52095,894.49693l1.76927,1.02159c.50258.29011,1.31485.29169,1.81428.00338l1.75824-1.01529c.49943-.28831.49695-.75736-.0056-1.04747l-1.76929-1.02159c-.50258-.29011-1.31485-.29146-1.81428-.00315l-1.75846,1.01506c-.49943.28831-.49673.75736.00585,1.04747ZM887.07702,897.12754l1.76949,1.02136c.50235.29034,1.31463.29169,1.81406.00338l1.75846-1.01506c.49943-.28854.49673-.75736-.00563-1.04747l-1.76949-1.02159c-.50258-.29011-1.31483-.29169-1.81428-.00338l-1.75824,1.01529c-.4994.28831-.49695.75713.00563,1.04747ZM891.6331,899.75792l1.76949,1.02159c.50258.29011,1.31485.29169,1.81431.00338l1.75822-1.01529c.49943-.28831.49698-.75736-.00563-1.04747l-1.76949-1.02159c-.50258-.29011-1.31463-.29146-1.81406-.00315l-1.75846,1.01506c-.49943.28831-.49695.75736.00563,1.04747ZM899.77294,903.41327l1.75824-1.01529c.49943-.28831.49695-.75713-.0056-1.04725l-1.76929-1.02159c-.50258-.29011-1.31485-.29169-1.81428-.00338l-1.75846,1.01529c-.49943.28831-.49673.75713.00585,1.04747l1.76927,1.02136c.50258.29034,1.31485.29169,1.81428.00338ZM904.32902,906.04365l1.75846-1.01506c.49943-.28831.49673-.75736-.00563-1.04747l-1.76949-1.02159c-.50258-.29011-1.31483-.29146-1.81428-.00315l-1.75824,1.01506c-.4994.28831-.49695.75736.00563,1.04747l1.76949,1.02159c.50235.29011,1.31463.29169,1.81406.00315ZM908.88534,908.67426l1.75822-1.01529c.49943-.28831.49698-.75713-.00563-1.04725l-1.76949-1.02159c-.50258-.29011-1.31463-.29169-1.81406-.00338l-1.75846,1.01529c-.49943.28831-.49695.75713.00563,1.04747l1.76949,1.02136c.50258.29034,1.31485.29169,1.81431.00338ZM913.44139,911.30464l1.75824-1.01506c.49943-.28831.49695-.75736-.0056-1.04747l-1.76929-1.02159c-.50258-.29011-1.31485-.29169-1.81428-.00315l-1.75846,1.01506c-.49943.28831-.49673.75736.00585,1.04747l1.76927,1.02159c.50258.29011,1.31485.29169,1.81428.00315ZM917.99746,913.93524l1.75846-1.01529c.49943-.28831.49673-.75713-.00563-1.04725l-1.76949-1.02159c-.50258-.29011-1.31483-.29169-1.81428-.00338l-1.75824,1.01529c-.4994.28831-.49695.75713.00563,1.04747l1.76949,1.02136c.50235.29034,1.31463.29169,1.81406.00338ZM922.55378,916.56563l1.75821-1.01506c.49943-.28831.49698-.75736-.00563-1.04747l-1.76949-1.02159c-.50258-.29011-1.31463-.29169-1.81406-.00315l-1.75846,1.01506c-.49943.28831-.49695.75736.00563,1.04747l1.76949,1.02159c.50258.29011,1.31485.29169,1.81431.00315ZM923.52628,918.17149l1.76927,1.02136c.50258.29034,1.31485.29169,1.81428.00338l1.75824-1.01529c.49943-.28831.49695-.75713-.0056-1.04725l-1.76929-1.02159c-.50258-.29034-1.31485-.29169-1.81428-.00338l-1.75846,1.01529c-.49943.28831-.49673.75713.00585,1.04747ZM936.1486,921.34024l-4.49936-2.59775c-.50258-.29011-1.31483-.29169-1.81428-.00315l-1.75824,1.01506c-.4994.28831-.49695.75736.00563,1.04747l4.49936,2.59775c.50258.29011,1.31485.29146,1.81428.00315l1.75824-1.01506c.49943-.28831.49695-.75736-.00563-1.04747ZM869.81896,892.15239l8.10541,4.67964c.56785.32793,1.48546.3295,2.04948.00383l1.52394-.87979c.56425-.3259.56132-.85549-.0063-1.18341l-8.10564-4.67964c-.56762-.3277-1.48523-.32928-2.04925-.0036l-1.52394.87979c-.56422.32567-.56132.85549.0063,1.18319ZM880.94727,898.57721l1.5334.88542c.56762.3277,1.48523.32928,2.04948.0036l1.52372-.87979c.56425-.32567.56132-.85549-.00628-1.18319l-1.53342-.88542c-.56785-.3277-1.48546-.32928-2.04948-.0036l-1.52392.87979c-.56427.32567-.56135.85549.0065,1.18319ZM885.50334,901.20782l1.5334.8852c.56762.32793,1.48523.3295,2.04948.00383l1.52394-.87979c.56402-.3259.56132-.85549-.00653-1.18341l-1.53337-.8852c-.56787-.32793-1.48525-.3295-2.0495-.00383l-1.52394.87979c-.56402.3259-.56132.85549.00653,1.18341ZM890.05941,903.8382l1.5334.88542c.56785.3277,1.48546.32928,2.04948.0036l1.52394-.87979c.56425-.32567.56132-.85549-.0063-1.18319l-1.53362-.88542c-.56762-.3277-1.48523-.32928-2.04948-.0036l-1.52372.87979c-.56422.32567-.56132.85549.0063,1.18319ZM894.61549,906.4688l1.53362.8852c.56762.3277,1.48523.3295,2.04948.00383l1.52372-.87979c.56425-.3259.56132-.85549-.00628-1.18341l-1.53342-.8852c-.56785-.32793-1.48546-.3295-2.04948-.00383l-1.52392.87979c-.56427.3259-.56135.85549.00628,1.18341ZM899.17178,909.09919l1.5334.88542c.56762.3277,1.48523.32928,2.04948.0036l1.52394-.87979c.56402-.32567.56132-.85549-.00653-1.18319l-1.53337-.88542c-.56787-.3277-1.48525-.3295-2.0495-.0036l-1.52394.87979c-.56402.32567-.56132.85549.00653,1.18319ZM903.72786,911.72979l1.5334.8852c.56785.3277,1.48546.3295,2.04948.00383l1.52394-.87979c.56425-.3259.56132-.85549-.0063-1.18341l-1.53362-.8852c-.56762-.32793-1.48523-.3295-2.04948-.00383l-1.52372.87979c-.56422.32567-.56132.85549.0063,1.18341ZM908.28393,914.36017l1.53362.88542c.56762.3277,1.48523.32928,2.04948.0036l1.52372-.87979c.56425-.32567.56132-.85549-.00628-1.18319l-1.53342-.88542c-.56785-.3277-1.48546-.3295-2.04948-.0036l-1.52392.87979c-.56427.32567-.56135.85549.00628,1.18319ZM912.84023,916.99078l1.5334.8852c.56762.3277,1.48523.3295,2.04948.00383l1.52394-.87979c.56402-.3259.56132-.85549-.00653-1.18341l-1.53337-.8852c-.56787-.32793-1.48525-.3295-2.0495-.00383l-1.52394.87979c-.56402.32567-.56132.85549.00653,1.18341ZM917.3963,919.62116l1.5334.88542c.56785.3277,1.48546.32928,2.04948.0036l1.52394-.87979c.56425-.32567.56132-.85549-.0063-1.18319l-1.53362-.88542c-.56762-.3277-1.48523-.3295-2.04948-.0036l-1.52372.87979c-.56422.32567-.56132.85549.0063,1.18319ZM921.95237,922.25155l1.53362.88542c.56762.3277,1.48523.3295,2.04948.00383l1.52372-.87979c.56425-.3259.56132-.85549-.00628-1.18341l-1.53342-.8852c-.56785-.32793-1.48546-.3295-2.04948-.00383l-1.52392.87979c-.56427.32567-.56135.85549.00628,1.18319ZM931.71002,923.76649l-1.5334-.88542c-.56762-.3277-1.48521-.32928-2.04948-.0036l-1.52372.87979c-.56425.32567-.56132.85549.0063,1.18319l1.5334.88542c.56785.3277,1.48523.3295,2.0495.0036l1.52392-.87979c.56425-.32567.56132-.85549-.00653-1.18319ZM872.72145,894.58223l-3.55542-2.05285c-.56785-.3277-1.48546-.32928-2.04948-.0036l-1.52394.87979c-.56422.32567-.56132.85549.00653,1.18319l3.55542,2.05285c.56785.3277,1.48546.3295,2.04948.00383l1.52397-.88002c.56422-.32567.5613-.85526-.00655-1.18319ZM877.27774,897.21284l-1.5334-.88542c-.56785-.3277-1.48546-.3295-2.04948-.0036l-1.52394.87979c-.56425.32567-.56132.85549.0063,1.18319l1.53362.88542c.56762.3277,1.48523.32928,2.04948.0036l1.52372-.87979c.56427-.32567.56132-.85549-.0063-1.18319ZM881.83382,899.84322l-1.5334-.8852c-.56785-.32793-1.48523-.3295-2.04948-.00383l-1.52394.87979c-.56402.32567-.56132.85549.00653,1.18319l1.53342.88542c.5676.3277,1.48521.3295,2.04946.00383l1.52394-.88002c.56402-.32567.56112-.85526-.00653-1.18319ZM913.72677,918.2568l-28.87028-16.66839c-.56762-.3277-1.48523-.3295-2.04948-.0036l-1.52372.87979c-.56425.32567-.56132.85549.00633,1.18319l28.87026,16.66839c.56785.3277,1.48546.32928,2.04948.0036l1.52397-.87979c.56422-.32567.5613-.85549-.00655-1.18319ZM918.28307,920.88718l-1.53362-.8852c-.56762-.32793-1.48523-.3295-2.04925-.00383l-1.52394.87979c-.56425.32567-.56132.85549.0063,1.18319l1.53362.88542c.56762.3277,1.48523.3295,2.04948.00383l1.52372-.88002c.56427-.32567.56132-.85549-.0063-1.18319ZM922.83914,923.51778l-1.5334-.88542c-.56785-.3277-1.48523-.3295-2.04948-.0036l-1.52394.87979c-.56402.32567-.56132.85549.00653,1.18319l1.53342.88542c.5676.3277,1.48521.32928,2.04945.0036l1.52394-.87979c.56402-.32567.56112-.85549-.00653-1.18319ZM927.4902,926.20286l-1.53362-.8852c-.56762-.32793-1.48521-.3295-2.04925-.00383l-1.52394.87979c-.56425.3259-.56132.85549.0063,1.18341l1.53362.8852c.56762.32793,1.48523.3295,2.04928.00383l1.52392-.87979c.56425-.3259.56132-.85549-.0063-1.18341Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-520",
    d: "M962.25683,913.9582l-71.13937-41.09648c-2.75417-1.59011-4.98685-5.85607-4.98685-9.5283v-55.80744c0-3.67223,2.23268-5.36002,4.98685-3.76991l71.13937,41.09648c2.75417,1.59011,4.98685,5.85607,4.98685,9.5283v55.80722c0,3.67245-2.23268,5.36024-4.98685,3.77013Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-350",
    d: "M962.89896,911.08992l-70.38021-40.65332c-2.21625-1.40848-3.58715-4.2232-3.58715-7.1034v-56.07798c0-.68241.74228-1.10621,1.33128-.76141.06865.04006.12289.0718.1562.09115l70.43648,40.69248c2.63871,1.52102,3.58738,4.22342,3.58738,7.10363v55.94721c0,.73192-.79134,1.19062-1.42739.82825-.05019-.02858-.09025-.05154-.11659-.06662Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-519",
    d: "M960.85556,847.27745l-70.43648-40.69248c-.03331-.01936-.08778-.05109-.1562-.09115-.58901-.34481-1.33128.079-1.33128.76141v56.07798c0,2.88021,1.3709,5.6947,3.58715,7.1034l70.38021,40.65332c.02633.01508.0664.03804.11681.06662.63562.36236,1.42716-.09633,1.42716-.82825v-55.94721c0-2.88021-.94867-5.58261-3.58738-7.10363ZM963.88251,910.32829c0,.24375-.20526.39477-.39567.39477-.06685,0-.13212-.01778-.19401-.05312l-70.49387-40.71837c-2.00131-1.27254-3.30739-3.87501-3.30739-6.61838v-56.07798c0-.19986.16903-.32387.32592-.32387.05579,0,.11049.0153.16225.04569l70.59538,40.78521c2.73391,1.57571,3.30739,4.4692,3.30739,6.61861v55.94744Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "M963.67004,844.10172l-71.13915-41.09648c-1.08978-.62907-2.09764-.7452-2.91822-.42831-.10423.04029-1.49471.77919-1.59261.83343l-.00473.00293c.84964-.41278,1.92727-.33558,3.10213.34278l71.13937,41.09648c2.75417,1.59011,4.98685,5.85607,4.98685,9.5283v55.80744c0,2.29165-.86989,3.81019-2.19307,4.24165.10781.00608.24217-.03601.43686-.14855.06302-.03646,1.57211-.8879,1.63243-.92999.94734-.6635,1.53702-2.02652,1.53702-3.91418v-55.80722c0-3.67223-2.23268-7.93819-4.98688-9.5283Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-454",
    d: "M962.49608,844.73282l-71.13937-41.09648c-1.1294-.65203-2.16741-.74498-3.00355-.38374.71347-.11321,1.53272.05942,2.40531.56335l71.13937,41.09648c2.75417,1.59011,4.98685,5.85607,4.98685,9.5283v55.80722c0,2.16629-.78054,3.63419-1.98331,4.15387,1.5386-.24397,2.58154-1.82441,2.58154-4.33325v-55.80722c0-3.67245-2.23268-7.93841-4.98685-9.52852Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-430",
    d: "M968.45704,853.94444c-1.82193.7488-4.21329-.86922-5.34131-3.61393-1.12785-2.74472-.56517-5.57654,1.25676-6.32534,1.82193-.7488,4.21329.86922,5.34111,3.61393,1.12805,2.74472.56537,5.57654-1.25656,6.32534Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-475",
    cx: 1147.38371,
    cy: 606.54782,
    rx: 52.14619,
    ry: 26.58994
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-525",
    d: "M1183.3363,595.16388h-84.26157v12.99819c0,13.54961,18.86259,24.53388,42.13067,24.53388s42.1309-10.98427,42.1309-24.53388c0-.11343-.01215-.22529-.01485-.33828h.01485v-12.65991Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-518",
    cx: 1141.20546,
    cy: 595.33308,
    rx: 42.13084,
    ry: 24.53393
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1141.2054,619.76933c-23.01533,0-41.70799-10.7484-42.11154-24.09522-.00473.14675-.01913.29191-.01913.43888,0,13.54961,18.86281,24.5341,42.13067,24.5341s42.13067-10.98449,42.13067-24.5341c0-.14697-.0144-.29214-.01891-.43888-.40352,13.34682-19.09598,24.09522-42.11177,24.09522Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M1180.43876,582.13779h-78.46649v10.72094h.01373c-.00248.10533-.01373.20954-.01373.3151,0,12.61782,17.56529,22.84676,39.23313,22.84676s39.23336-10.22894,39.23336-22.84676c0-.10556-.01125-.20976-.01373-.3151h.01373v-10.72094Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-346",
    d: "M1180.43876,580.28007h-78.46649v10.72094h.01373c-.00248.10533-.01373.20954-.01373.3151,0,12.61782,17.56529,22.84676,39.23313,22.84676s39.23336-10.22894,39.23336-22.84676c0-.10556-.01125-.20976-.01373-.3151h.01373v-10.72094Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-227",
    d: "M1183.3363,572.10714h-84.26157v12.99819c0,13.54961,18.86259,24.53388,42.13067,24.53388s42.1309-10.98427,42.1309-24.53388c0-.11343-.01215-.22529-.01485-.3385h.01485v-12.65968Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-214",
    cx: 1141.20546,
    cy: 572.27633,
    rx: 42.13084,
    ry: 24.53393
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M1141.2054,596.71258c-23.01533,0-41.70799-10.7484-42.11154-24.09522-.00473.14675-.01913.29191-.01913.43888,0,13.54961,18.86281,24.53388,42.13067,24.53388s42.13067-10.98427,42.13067-24.53388c0-.14697-.0144-.29214-.01891-.43888-.40352,13.34682-19.09598,24.09522-42.11177,24.09522Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-347",
    d: "M1180.43876,559.08104h-78.46649v10.72094h.01373c-.00248.10533-.01373.20954-.01373.3151,0,12.61782,17.56529,22.84676,39.23313,22.84676s39.23336-10.22894,39.23336-22.84676c0-.10556-.01125-.20976-.01373-.3151h.01373v-10.72094Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-349",
    d: "M1180.43876,557.22332h-78.46649v10.72094h.01373c-.00248.10533-.01373.20954-.01373.3151,0,12.61782,17.56529,22.84676,39.23313,22.84676s39.23336-10.22894,39.23336-22.84676c0-.10556-.01125-.20976-.01373-.3151h.01373v-10.72094Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M1183.3363,549.69071h-84.26157v12.99819c0,13.54983,18.86259,24.5341,42.13067,24.5341s42.1309-10.98427,42.1309-24.5341c0-.11343-.01215-.22529-.01485-.33828h.01485v-12.65991Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-213",
    cx: 1141.20546,
    cy: 549.85996,
    rx: 42.13084,
    ry: 24.53388
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M1141.2054,574.29638c-23.01533,0-41.70799-10.74862-42.11154-24.09522-.00473.14652-.01913.29169-.01913.43866,0,13.54983,18.86281,24.5341,42.13067,24.5341s42.13067-10.98427,42.13067-24.5341c0-.14697-.0144-.29214-.01891-.43866-.40352,13.34659-19.09598,24.09522-42.11177,24.09522Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-353",
    d: "M1180.43876,536.66461h-78.46649v10.72094h.01373c-.00248.10556-.01373.20954-.01373.3151,0,12.61805,17.56529,22.84676,39.23313,22.84676s39.23336-10.22871,39.23336-22.84676c0-.10556-.01125-.20954-.01373-.3151h.01373v-10.72094Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-351",
    d: "M1180.43876,534.80689h-78.46649v10.72094h.01373c-.00248.10556-.01373.20954-.01373.31532,0,12.61782,17.56529,22.84653,39.23313,22.84653s39.23336-10.22871,39.23336-22.84653c0-.10578-.01125-.20976-.01373-.31532h.01373v-10.72094Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M1183.3363,527.02671h-84.26157v12.99819c0,13.54983,18.86259,24.5341,42.13067,24.5341s42.1309-10.98427,42.1309-24.5341c0-.11343-.01215-.22529-.01485-.33828h.01485v-12.65991Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-216",
    cx: 1141.20546,
    cy: 527.19596,
    rx: 42.13084,
    ry: 24.53388
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M1141.2054,551.63238c-23.01533,0-41.70799-10.74862-42.11154-24.09522-.00473.14652-.01913.29169-.01913.43866,0,13.54983,18.86281,24.5341,42.13067,24.5341s42.13067-10.98427,42.13067-24.5341c0-.14697-.0144-.29214-.01891-.43866-.40352,13.34659-19.09598,24.09522-42.11177,24.09522Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-352",
    d: "M1180.43876,514.00061h-78.46649v10.72094h.01373c-.00248.10533-.01373.20954-.01373.3151,0,12.61805,17.56529,22.84676,39.23313,22.84676s39.23336-10.22871,39.23336-22.84676c0-.10556-.01125-.20976-.01373-.3151h.01373v-10.72094Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-354",
    d: "M1180.43876,512.14289h-78.46649v10.72094h.01373c-.00248.10556-.01373.20954-.01373.3151,0,12.61805,17.56529,22.84676,39.23313,22.84676s39.23336-10.22871,39.23336-22.84676c0-.10556-.01125-.20954-.01373-.3151h.01373v-10.72094Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M1183.3363,504.3627h-84.26157v12.99819c0,13.54961,18.86259,24.53388,42.13067,24.53388s42.1309-10.98427,42.1309-24.53388c0-.11343-.01215-.22529-.01485-.33828h.01485v-12.65991Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-215",
    cx: 1141.20546,
    cy: 504.53196,
    rx: 42.13084,
    ry: 24.53388
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M1141.2054,528.96815c-23.01533,0-41.70799-10.7484-42.11154-24.09499-.00473.14652-.01913.29169-.01913.43866,0,13.54961,18.86281,24.5341,42.13067,24.5341s42.13067-10.98449,42.13067-24.5341c0-.14697-.0144-.29214-.01891-.43866-.40352,13.34659-19.09598,24.09499-42.11177,24.09499Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-473",
    cx: 1144.41145,
    cy: 502.78339,
    rx: 21.31263,
    ry: 10.86768
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M1158.0651,496.40246h-33.71917v6.6877c0,5.42214,7.54837,9.81774,16.85947,9.81774s16.8597-4.3956,16.8597-9.81774c0-.04546-.00495-.09025-.00582-.13549h.00582v-6.55221Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M1124.34593,496.47021c0,5.42214,7.54837,9.81774,16.85947,9.81774s16.8597-4.3956,16.8597-9.81774-7.54837-9.81796-16.8597-9.81796-16.85947,4.3956-16.85947,9.81796Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-345",
    d: "M1130.59835,496.51365c0,3.41137,4.74896,6.17679,10.60705,6.17679s10.60728-2.76542,10.60728-6.17679-4.74896-6.17679-10.60728-6.17679-10.60705,2.76542-10.60705,6.17679Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M1141.20562,496.18842c4.03976,0,7.55084,1.31575,9.34194,3.25112.8062-.87102,1.26511-1.86717,1.26511-2.9259,0-3.41137-4.74896-6.17679-10.60705-6.17679s-10.60728,2.76542-10.60728,6.17679c0,1.05872.45869,2.05488,1.26489,2.9259,1.79132-1.93537,5.30218-3.25112,9.34239-3.25112Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1141.2054,506.24878c-9.21005,0-16.69022-4.30129-16.85182-9.64218-.0018.05874-.00765.11681-.00765.17555,0,5.42236,7.54837,9.81796,16.85947,9.81796s16.8597-4.3956,16.8597-9.81796c0-.05874-.00582-.11681-.00765-.17555-.1616,5.34089-7.64177,9.64218-16.85204,9.64218Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "347.09477 159.46645 362.35783 168.20498 362.46676 173.14975 382.72972 184.93864 411.85096 196.50337 467.51616 183.22744 462.62496 180.95672 482.36419 151.43554 421.74949 114.92709 347.09477 159.46645"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-521",
    points: "380.94943 88.50129 439.8734 122.78335 473.75012 127.62099 414.78968 94.0166 380.94943 88.50129"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-523",
    points: "439.8545 122.78335 439.8545 180.61012 445.94149 177.16993 445.95139 175.89694 467.60348 163.08084 468.92171 163.57036 473.75012 160.70816 473.75012 127.62099 439.8545 122.78335"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-242",
    points: "439.8734 122.78335 439.8734 180.61012 380.94943 146.30712 380.94943 88.50129 439.8734 122.78335"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-530",
    points: "444.5544 147.50268 470.33897 132.01231 470.33897 162.73153 468.92171 163.57036 467.60258 163.08084 445.95139 175.89694 445.94149 177.16993 444.5544 177.99076 444.5544 147.50268"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "467.60258 163.08084 467.60258 135.28684 445.95139 148.2938 445.95139 175.89694 467.60258 163.08084"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-445",
    points: "467.60258 137.40271 467.60258 135.28684 445.95139 148.2938 445.95139 150.21859 467.60258 137.40271"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-445",
    points: "467.60258 137.81031 467.60258 136.68429 445.95139 149.69126 445.95139 150.62619 467.60258 137.81031"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-445",
    points: "467.60258 140.00177 467.60258 138.87575 445.95139 151.88271 445.95139 152.81767 467.60258 140.00177"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-445",
    points: "467.60258 142.19322 467.60258 141.0672 445.95139 154.07417 445.95139 155.00915 467.60258 142.19322"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-445",
    points: "467.60258 144.38468 467.60258 143.25866 445.95139 156.26562 445.95139 157.20062 467.60258 144.38468"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-445",
    points: "467.60258 146.57614 467.60258 145.45012 445.95139 158.45708 445.95139 159.3921 467.60258 146.57614"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-445",
    points: "467.60258 148.76759 467.60258 147.64157 445.95139 160.64854 445.95139 161.58358 467.60258 148.76759"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-445",
    points: "467.60258 150.95905 467.60258 149.83303 445.95139 162.83999 445.95139 163.77505 467.60258 150.95905"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-445",
    points: "467.60258 153.15051 467.60258 152.02448 445.95139 165.03145 445.95139 165.96653 467.60258 153.15051"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-445",
    points: "467.60258 155.34196 467.60258 154.21594 445.95139 167.22291 445.95139 168.15801 467.60258 155.34196"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-445",
    points: "467.60258 157.53342 467.60258 156.4074 445.95139 169.41436 445.95139 170.34948 467.60258 157.53342"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-445",
    points: "467.60258 159.72487 467.60258 158.59885 445.95139 171.60582 445.95139 172.54096 467.60258 159.72487"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-445",
    points: "467.60258 161.91633 467.60258 160.79031 445.95139 173.79728 445.95139 174.73244 467.60258 161.91633"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-247",
    points: "407.38469 157.05259 407.38469 193.87861 347.09477 159.46645 347.09477 122.43382 407.38469 157.05259"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "407.38469 157.4019 435.66056 108.77123 375.37064 74.35907 347.09477 122.78335 407.38469 157.4019"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-533",
    points: "351.31324 161.71129 351.31324 129.44562 364.18786 136.99286 364.18786 169.20137 351.31324 161.71129"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-530",
    points: "362.79018 137.79366 362.79018 166.77175 352.71048 160.90735 352.71048 131.88469 362.79018 137.79366"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-241",
    points: "407.38469 193.87861 407.38469 157.4019 435.5379 108.40302 435.5379 178.11995 407.38469 193.87861"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-248",
    points: "408.77674 111.44977 382.72972 126.68447 382.72972 184.93864 386.97138 182.45411 386.97138 145.59635 408.77674 111.44977"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-524",
    points: "353.99156 160.26702 362.79018 165.38577 362.79018 137.79366 353.99156 132.63575 353.99156 160.26702"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-415",
    points: "353.99156 160.26702 362.79018 137.79366 353.99156 132.63575 353.99156 160.26702"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-413",
    d: "M353.99156,132.63575v27.63128l8.79862,5.11875v-27.59211l-8.79862-5.15791ZM362.09179,164.17085l-7.40162-4.30602v-26.00965l7.40162,4.33866v25.97702Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-245",
    points: "382.72972 126.68447 382.72972 184.93864 362.46676 173.14975 362.46676 114.80623 382.72972 126.68447"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-533",
    points: "366.16127 175.16187 366.16127 142.8962 379.03589 150.44344 379.03589 182.65194 366.16127 175.16187"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-530",
    points: "377.63821 151.24401 377.63821 180.2221 367.5585 174.35792 367.5585 145.33527 377.63821 151.24401"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-533",
    points: "390.52927 184.01226 390.52927 151.74659 403.40389 159.29383 403.40389 191.50233 390.52927 184.01226"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-530",
    points: "402.00621 160.09462 402.00621 189.07271 391.92651 183.20854 391.92651 154.18588 402.00621 160.09462"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-533",
    points: "366.16127 138.65545 366.16127 121.23578 379.03589 128.78279 379.03589 146.14597 366.16127 138.65545"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-530",
    points: "377.63821 129.58359 377.63821 143.7159 367.5585 137.85172 367.5585 123.67485 377.63821 129.58359"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "368.83959 173.71738 377.63799 178.83635 377.63799 151.24401 368.83959 146.08632 368.83959 173.71738"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-162",
    points: "368.83959 173.71738 377.63799 151.24401 368.83959 146.08632 368.83959 173.71738"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "393.20759 182.56799 402.00621 187.68696 402.00621 160.09462 393.20759 154.93671 393.20759 182.56799"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-414",
    points: "393.20759 182.56799 402.00621 160.09462 393.20759 154.93671 393.20759 182.56799"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "368.83959 137.21118 377.63799 142.33015 377.63799 129.58359 368.83959 124.42568 368.83959 137.21118"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-409",
    d: "M393.20759,154.93671v27.63128l8.79862,5.11897v-27.59234l-8.79862-5.15791ZM401.30782,186.47181l-7.40162-4.30557v-26.01033l7.40162,4.33888v25.97702Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-163",
    points: "368.83959 137.21118 377.63799 129.58359 368.83959 124.42568 368.83959 137.21118"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-410",
    d: "M368.83959,124.42568v12.7855l8.7984,5.11897v-12.74656l-8.7984-5.15791ZM376.9396,141.11522l-7.4014-4.3058v-11.16432l7.4014,4.33866v11.13146Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-412",
    d: "M368.83959,146.08632v27.63105l8.7984,5.11897v-27.59234l-8.7984-5.15768ZM376.9396,177.62142l-7.4014-4.30602v-26.00988l7.4014,4.33888v25.97702Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-530",
    points: "414.9371 153.53161 417.14953 152.26154 430.12634 144.71273 430.12634 125.87377 414.9371 153.53161"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-533",
    points: "418.64895 149.77318 428.72866 143.90878 428.72866 131.47867 418.64895 149.77318"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-530",
    points: "415.16982 157.36611 430.12634 148.80763 430.12634 181.07308 415.16982 189.57439 415.16982 157.36611"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-533",
    points: "416.56773 158.16691 416.56773 187.14499 428.72866 180.26936 428.72866 151.24671 416.56773 158.16691"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-187",
    points: "427.56415 179.62881 427.56415 151.92934 416.56773 158.16691 416.56773 185.82699 427.56415 179.62881"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-445",
    d: "M416.56773,158.16691v27.66008l10.99642-6.19818v-27.69947l-10.99642,6.23756ZM426.86509,179.22054l-9.59852,5.41066v-26.05737l9.59852-5.44465v26.09135Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "427.56415 133.59229 419.71779 147.83331 427.56415 143.26846 427.56415 133.59229"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-411",
    d: "M419.71779,147.83331l7.84636-4.56508v-9.67594l-7.84636,14.24102ZM426.86509,142.86649l-5.31816,3.09425,5.31816-9.65231v6.55806Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "382.72972 126.68447 408.77674 111.44977 388.51377 99.66111 362.46676 114.80623 382.72972 126.68447"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-243",
    points: "411.84218 194.80499 411.84218 196.50337 439.89456 180.58558 439.89456 178.88699 411.84218 194.80499"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "411.85096 194.80499 411.85096 196.50337 407.37636 193.87568 407.37636 192.18699 411.85096 194.80499"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-244",
    points: "407.37636 192.18699 411.85096 194.80499 439.89456 178.88699 435.52754 176.34956 407.37636 192.18699"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-344",
    d: "M419.10561,169.40595c0,.45531-.32185,1.01011-.71865,1.23923-.3968.22935-.71865.04591-.71865-.40963,0-.45531.32185-1.01033.71865-1.23946s.71865-.04569.71865.40985Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "386.97138 145.59635 408.77674 111.44977 393.10181 149.1063 386.97138 145.59635"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "407.37636 192.18699 439.89456 178.88699 435.52754 176.34956 407.37636 192.18699"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-533",
    points: "467.60258 135.28684 467.60258 163.08084 468.92171 163.57036 468.92171 134.57517 467.60258 135.28684"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-544"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-373",
    d: "M999.86542,245.57945c-3.06702,0-5.85044-.67093-8.04914-1.94055l-24.30487-14.04059-24.30487-14.04059c-2.93513-1.69477-4.61842-4.37647-4.61797-7.35683,0-3.2671,2.027-6.31116,5.56123-8.35096l6.04873-3.58625c2.77558-1.60204,6.24657-2.48454,9.77452-2.48454,3.06702,0,5.85044.67071,8.04917,1.94032l24.30485,14.04059,24.30485,14.04059c2.9349,1.69477,4.61797,4.37602,4.61797,7.35638,0,3.26665-2.02697,6.31094-5.56101,8.35141l-6.04896,3.58625c-2.77555,1.60227-6.24679,2.48476-9.77452,2.48476Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-531",
    d: "M944.36303,200.21928l1.25348-.71268c.11159-.06443,4.58872-2.6883,4.72355-2.71591,2.77638-1.50825,6.20317-2.29655,9.61455-2.21323.45298.01282.89782.04829,1.33522.08499,2.29234.19233,4.81427.99657,6.51089,1.97625l23.8653,13.78668,23.85031,13.77802c2.11321,1.22028,3.90618,3.28137,4.45768,5.30068.15387.56339.26964,1.13701.30138,1.72887.16895,3.15031-1.72982,6.17105-5.24755,8.2021l-1.2535.71267c-.11159.06443-4.58891,2.68831-4.72374,2.71593-2.77636,1.50845-6.20337,2.29675-9.61454,2.21341-.45288-.01282-.89763-.04829-1.33495-.08498-2.29243-.19236-4.81447-.99675-6.51113-1.97647l-23.86531-13.78667-23.85029-13.77799c-2.11346-1.22033-3.90665-3.28178-4.45796-5.30131-.15379-.56333-.26943-1.1369-.30112-1.72866-.16873-3.15073,1.72982-6.17125,5.24774-8.20168Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-398",
    d: "M944.57625,200.58863l1.24044-.67445c.22318-.12885,4.39523-2.54125,4.66488-2.59649,2.77719-1.41446,6.1604-2.12073,9.45457-1.94193.44232.02401.87431.08122,1.29976.12423,2.05985.20825,4.81633,1.17621,6.34329,2.05793l23.42575,13.53277,23.39576,13.51544c1.90189,1.09826,3.95748,3.25893,4.51189,5.05945.16647.54064.32518,1.07964.38826,1.64327.33973,3.03549-1.43266,6.03117-4.93409,8.0528l-1.24046.67444c-.22319.12886-4.3954,2.54127-4.66506,2.5965-2.77718,1.41464-6.15996,2.10874-9.45456,1.94206-.44214-.02564-.87413-.08122-1.29949-.12422-2.05994-.20828-4.81652-1.17638-6.34352-2.05813l-23.42576-13.53275-23.3957-13.51539c-1.90211-1.0983-3.95794-3.25933-4.51219-5.06004-.16639-.54059-.32498-1.07953-.38801-1.64307-.33955-3.03587,1.43264-6.03133,4.93424-8.05241Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-423",
    d: "M944.78947,200.95799l1.2274-.63623c.33478-.19328,4.20173-2.39421,4.60622-2.47706,2.778-1.32067,6.11771-1.93713,9.29459-1.67062.43168.03621.85042.11411,1.2643.16347,1.82736.21795,4.81838,1.35586,6.17568,2.13961l22.9862,13.27885,22.94121,13.25286c1.69057.97623,4.01902,3.23548,4.5661,4.81821.17963.51967.3812,1.02248.47513,1.55767.51284,2.92194-1.1355,5.89129-4.62063,7.90349l-1.22742.63622c-.33478.19328-4.2019,2.39423-4.60639,2.47708-2.77799,1.32083-6.11654,1.92073-9.29457,1.67072-.43139-.03846-.85023-.1141-1.26404-.16346-1.82744-.21799-4.81857-1.35602-6.1759-2.1398l-22.9862-13.27883-22.94112-13.25279c-1.69077-.97627-4.01948-3.23586-4.56643-4.81877-.17955-.51962-.38101-1.02238-.47489-1.55748-.51269-2.92229,1.13546-5.89141,4.62075-7.90313Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-447",
    d: "M945.00269,201.32735l1.21437-.598c.44637-.2577,4.00824-2.24717,4.54755-2.35764,2.7788-1.22688,6.07517-1.75228,9.13462-1.39932.42106.04858.8261.14694,1.22885.20271,1.59506.22087,4.82044,1.53551,6.00808,2.22129l22.54665,13.02494,22.48666,12.99029c1.47925.8542,4.09217,3.21019,4.62032,4.57698.19344.50061.4378.96546.56201,1.47207.68879,2.80929-.83835,5.75141-4.30717,7.75418l-1.21438.59799c-.44638.25771-4.0084,2.24719-4.54771,2.35765-2.7788,1.22702-6.07312,1.73271-9.13459,1.39937-.42065-.05128-.82592-.14694-1.22858-.2027-1.59512-.2209-4.82062-1.53566-6.00829-2.22146l-22.54665-13.02491-22.48654-12.99019c-1.47942-.85423-4.09262-3.21055-4.62066-4.5775-.19336-.50056-.43762-.96536-.56178-1.47189-.68868-2.80959.83828-5.7515,4.30725-7.75385Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M945.21592,201.69671l1.20133-.55977c.55796-.32213,3.81475-2.10013,4.48889-2.23821,2.77961-1.13309,6.03268-1.56606,8.97464-1.12801.41045.06111.80133.17972,1.19339.24195,1.36317.21638,4.8225,1.71516,5.84047,2.30297l22.1071,12.77103,22.03212,12.72771c1.26793.73217,4.17818,3.18203,4.67453,4.33575.20805.48358.49503.90847.64889,1.38647.86806,2.69691-.54119,5.61153-3.99371,7.60487l-1.20134.55976c-.55797.32214-3.81489,2.10014-4.48904,2.23823-2.77961,1.1332-6.02971,1.5447-8.97461,1.12802-.4099-.0641-.80115-.17971-1.19313-.24194-1.36322-.21642-4.82268-1.7153-5.84068-2.30313l-22.10709-12.77099-22.03196-12.72759c-1.26808-.7322-4.17862-3.18237-4.67489-4.33623-.20797-.48353-.49486-.90838-.64866-1.3863-.86797-2.69717.5411-5.61158,3.99376-7.60458Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-526",
    d: "M945.42914,202.06607l1.18829-.52154c.66955-.38656,3.62126-1.95308,4.43022-2.11879,2.78042-1.0393,5.9901-1.37839,8.81466-.85671.39983.07385.77607.21242,1.15793.28119,1.13198.20388,4.82455,1.89481,5.67287,2.38465l21.66755,12.51711,21.57757,12.46513c1.05661.61014,4.48343,3.07703,4.72874,4.09452.31573.41225.55294.85138.73576,1.30087,1.05099,2.58403-.24403,5.47164-3.68026,7.45557l-1.1883.52154c-.66957.38657-3.62139,1.9531-4.43037,2.1188-2.78042,1.03939-5.98629,1.35669-8.81462.85667-.39916-.07692-.7759-.21241-1.15768-.28118-1.13203-.20392-4.82473-1.89494-5.67306-2.3848l-21.66754-12.51707-21.57737-12.46499c-1.05673-.61017-4.48391-3.07738-4.72913-4.09496-.31565-.41221-.55278-.85129-.73555-1.30071-1.05093-2.58424.24392-5.47167,3.68026-7.4553Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-455",
    d: "M945.64236,202.43543l1.17525-.48331c.78115-.45098,3.42777-1.80604,4.37156-1.99936,2.78122-.94551,5.94727-1.18921,8.65469-.5854.38917.08679.7503.24502,1.12248.32044.90183.18274,4.82661,2.07446,5.50526,2.46633l21.228,12.2632,21.12302,12.20255c.84529.48811,4.58671,3.0393,4.78296,3.85328.34474.383.61153.79403.82264,1.21527,1.23775,2.46967.05312,5.33176-3.3668,7.30626l-1.17526.48331c-.78116.45099-3.42788,1.80606-4.37169,1.99937-2.78124.94558-5.94288,1.16868-8.65464.58532-.38841-.08974-.75013-.24501-1.12222-.32042-.90186-.18277-4.82678-2.07457-5.50545-2.46646l-21.22798-12.26315-21.12279-12.20238c-.84538-.48813-4.58719-3.03963-4.78336-3.85369-.34465-.38296-.61137-.79395-.82243-1.21512-1.23772-2.46983-.05326-5.33175,3.36677-7.30602Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-369",
    d: "M945.85558,202.80479l1.16221-.44509c.89274-.51541,3.23427-1.659,4.31289-1.87993,2.78203-.85172,5.904-.99845,8.49471-.3141.37845.09997.72398.27752,1.08702.35968.6731.15233,4.82867,2.2541,5.33766,2.54801l20.78845,12.00929,20.66847,11.93998c.63396.36609,4.68998,3.00156,4.83717,3.61205.37374.35375.67071.73627.90952,1.12967,1.4282,2.3528.35028,5.19188-3.05334,7.15695l-1.16222.44508c-.89276.51542-3.23438,1.65902-4.31302,1.87995-2.78205.85176-5.89946.98067-8.49465.31397-.37767-.10256-.72381-.27751-1.08677-.35966-.67312-.15236-4.82884-2.25421-5.33784-2.54813l-20.78842-12.00923-20.66821-11.93978c-.63404-.3661-4.69047-3.00187-4.83759-3.61242-.37366-.35371-.67056-.73619-.90932-1.12953-1.42819-2.3529-.35044-5.19184,3.05327-7.15674Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M946.06881,203.17415l1.14917-.40686c1.00433-.57984,3.04078-1.51195,4.25423-1.76051,2.78284-.75793,5.86006-.8061,8.33473-.04279.36763.11339.71853.24833,1.05156.39892.45903.03105,4.83073,2.43375,5.17005,2.62969l20.3489,11.75537,20.21393,11.6774c.42264.24406,4.79326,2.96382,4.89138,3.37082.40274.32449.73039.67793.9964,1.04407,1.62188,2.2324.64743,5.052-2.73988,7.00764l-1.14918.40685c-1.00435.57985-3.04087,1.51198-4.25434,1.76052-2.78286.75795-5.85604.79266-8.33467.04262-.36693-.11538-.71836-.24832-1.05132-.3989-.45905-.03105-4.83089-2.43385-5.17022-2.62979l-20.34887-11.75531-20.21362-11.67718c-.42269-.24407-4.79374-2.96412-4.89183-3.37116-.40266-.32446-.73024-.67786-.9962-1.04394-1.62188-2.23245-.64762-5.05192,2.73978-7.00747Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M946.28203,203.5435l1.13613-.36863c1.11592-.64426,2.84729-1.36491,4.19556-1.64108,2.78364-.66414,5.81521-.61217,8.17475.22851.35667.12708.69604.27422,1.01611.43816.22951.01552,4.83278,2.6134,5.00245,2.71137l19.90935,11.50146,19.75938,11.41482c.21132.12203,4.89654,2.92609,4.9456,3.12958.43175.29524.79039.61892,1.08327.95847,1.81799,2.10767.94459,4.91212-2.42642,6.85834l-1.13614.36863c-1.11595.64428-2.84737,1.36493-4.19567,1.6411-2.78367.66414-5.81263.60464-8.17469-.22873-.35618-.1282-.69587-.27421-1.01586-.43814-.22952-.01553-4.83294-2.61349-5.00261-2.71146l-19.90931-11.50139-19.75904-11.41458c-.21135-.12203-4.89702-2.92637-4.94606-3.12989-.43166-.29521-.79025-.61885-1.08309-.95835-1.818-2.10768-.9448-4.912,2.42628-6.85819Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-420",
    d: "M994.16195,239.57573l-24.30476-14.04059-24.30476-14.04059c-3.36588-1.94325-2.9439-5.33774.94281-7.58168l1.12309-.3304c3.88672-2.24394,9.7662-2.48769,13.13233-.54444l24.30464,14.04059,24.30464,14.04059c3.36613,1.94325,2.9439,5.33796-.94281,7.5819l-1.12309.3304c-3.88672,2.24394-9.7662,2.48769-13.1321.54422Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-343",
    d: "M999.09028,238.13191l-44.91028-26.11138c-4.11471-2.3756-7.45024-8.74888-7.45024-14.23494v-97.14295c0-2.78996-2.29345-3.40665-.90433-4.40888.05289-.03826,3.25652-1.49356,3.31684-1.51674,1.49513-.5728,3.09515-.82803,5.03772.29349l44.91028,26.11138c4.11474,2.3756,7.45026,8.74866,7.45026,14.23494v97.14272c0,2.91509-.94172,4.99316-2.4418,5.9443-.08868.05627-3.94839,1.89171-4.04742,1.92479-1.32968.44316.83793-1.19827-.96104-2.23674Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M996.25689,239.42741l-44.9105-26.11138c-4.11449-2.3756-7.45001-8.74866-7.45001-14.23494v-97.14272c0-5.48628,3.33552-8.00796,7.45001-5.63235l44.9105,26.11138c4.11471,2.3756,7.45024,8.74866,7.45024,14.23494v97.14272c0,5.48628-3.33552,8.00796-7.45024,5.63235Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-528",
    d: "M995.60779,239.77807l-44.91028-26.11138c-4.11471-2.3756-7.45024-8.74866-7.45024-14.23494v-97.14272c0-5.48628,3.33552-8.00796,7.45024-5.63235l44.91028,26.11138c4.11471,2.3756,7.45024,8.74888,7.45024,14.23494v97.14295c0,5.48606-3.33552,8.00773-7.45024,5.63213Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-511",
    d: "M944.26324,200.07814v-97.26246c0-4.80928,2.9241-7.01968,6.53105-4.93734l44.71672,25.99953c3.60718,2.08256,6.53105,7.66945,6.53105,12.47873v97.26246c0,4.80928-2.92387,7.0199-6.53105,4.93734l-44.71672-25.99953c-3.60696-2.08256-6.53105-7.66945-6.53105-12.47873Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-513",
    d: "M945.71449,190.76658v-86.86652c0-4.02558,2.44765-5.87588,5.4667-4.13272l43.94293,25.55254c3.0191,1.74316,5.4667,6.41964,5.4667,10.44523v86.86652c0,4.02558-2.4476,5.87588-5.4667,4.13272l-43.94293-25.55254c-3.01905-1.74316-5.4667-6.41964-5.4667-10.44523Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-342",
    d: "M951.59239,100.83732c-2.84532-1.64278-5.15203-.3277-5.15203,2.9376v87.95473c0,3.26508,2.30671,7.24385,5.15203,8.88685l43.12053,25.07787c2.84555,1.64278,5.15228.3277,5.15228-2.9376v-87.95473c0-3.2653-2.30673-7.24407-5.15228-8.88685l-43.12053-25.07787Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-422",
    d: "M994.71292,125.91519l-43.12053-25.07787c-2.84532-1.64278-5.15203-.3277-5.15203,2.93738v87.95496c0,3.2653,2.30671,7.24385,5.15203,8.88685l43.12053,25.07787c2.84532,1.64278,5.15228.32748,5.15228-2.9376v-87.95473c0-3.26508-2.30696-7.24407-5.15228-8.88685ZM999.41711,222.75677c0,1.01349-.23857,1.84669-.68964,2.40914-.41368.51541-1.00223.78819-1.70152.78819h-.00045c-.63289,0-1.35492-.22417-2.08842-.64775l-43.1203-25.07787c-2.71771-1.56896-4.92854-5.38118-4.92854-8.49883v-87.95496c0-1.97183.91623-3.19666,2.39156-3.19666.63289,0,1.35492.22394,2.08887.64752l43.1203,25.07787c2.71726,1.56896,4.92814,5.38163,4.92814,8.49883v87.95451Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M975.82422,221.51844c0,1.91129-1.35041,2.68125-3.01593,1.71953-1.66574-.96172-3.01593-3.29073-3.01593-5.20202s1.35019-2.68102,3.01593-1.7193c1.66551.96149,3.01593,3.29051,3.01593,5.2018Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-528",
    d: "M971.45453,215.90229c.40712,0,.86694.13324,1.35376.41435,1.66551.96149,3.0157,3.29051,3.0157,5.2018,0,1.35266-.67633,2.13388-1.66213,2.13388-.40712,0-.86674-.13324-1.35357-.41435-1.66574-.96149-3.01593-3.29073-3.01593-5.2018,0-1.35266.67656-2.13388,1.66216-2.13388h0ZM971.45453,215.24216c-1.38915,0-2.32229,1.12287-2.32229,2.79401,0,2.15436,1.4697,4.69044,3.34588,5.77347.57775.33355,1.14425.5028,1.68374.5028,1.38913,0,2.32249-1.12287,2.32249-2.79401,0-2.15414-1.4697-4.69044-3.34588-5.77347-.57775-.33355-1.14425-.5028-1.68394-.5028h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-544"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-373",
    d: "M180.60445,743.85079c2.21468,0,4.22432-.48435,5.81196-1.40105l40.35938-23.43982c2.11925-1.2237,3.33485-3.15997,3.3344-5.31208,0-2.35917-1.46362-4.5572-4.01546-6.03005l-35.41934-13.625c-2.00423-1.15685-4.51061-1.79403-7.05794-1.79403-2.21468,0-4.22455.48435-5.81218,1.40105l-27.12464,15.89145c-2.11925,1.22393-3.3344,3.15974-3.3344,5.31185,0,2.35895,1.46362,4.55697,4.01523,6.0305l22.18506,21.17315c2.00401,1.15685,4.5106,1.79403,7.05793,1.79403Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-531",
    d: "M177.95926,693.91653l-26.83248,15.72031c-.01031.00595-.31223.18327-.32145.18962-2.11515,1.24238-3.0619,3.20076-2.94008,5.30819.12375,2.14093,1.73124,4.52509,4.05088,5.86466l21.78439,20.79073c2.07696,1.19898,4.74163,1.79423,7.27834,1.66666,2.01334,0,4.25961-.68384,5.70291-1.51721l39.94004-23.19627c2.03478-1.17492,3.18844-3.02047,3.17947-5.06503-.00892-2.23652-1.41046-4.32956-3.86051-5.74369l-35.19966-13.54047c-.71142-.41064-1.71454-.82631-2.53781-1.09399-1.39945-.45502-2.92208-.72145-4.46401-.73634-2.19576-.02083-4.20787.44506-5.78003,1.35282Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-398",
    d: "M178.11324,694.18323l-26.8617,15.73744c-.02061.0119-.30308.17826-.32153.19096-2.11105,1.26084-2.79066,3.22005-2.54576,5.30453.22521,1.91686,1.99885,4.49321,4.08653,5.69883l21.38372,20.40832c2.1499,1.24111,4.97265,1.79443,7.49874,1.53929,1.81201,0,4.29489-.88334,5.59387-1.63337l39.52071-22.95272c1.95032-1.12614,3.04203-2.88097,3.02455-4.81797-.01784-2.11386-1.3573-4.10193-3.70557-5.45733l-34.97999-13.45593c-.64028-.36957-1.78703-.82983-2.52572-1.07756-1.38142-.46328-2.88882-.7593-4.41998-.78908-2.17683-.04166-4.1912.40576-5.74787,1.30459Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-423",
    d: "M178.26723,694.44994l-26.89092,15.75458c-.03092.01785-.29394.17325-.32161.19229-2.10695,1.2793-2.88112,3.31442-2.15145,5.30087,0,1.7156,2.26646,4.46133,4.12218,5.53299l20.98305,20.02591c2.22284,1.28324,5.20367,1.79464,7.71915,1.41192,1.61068,0,4.33018-1.08284,5.48482-1.74953l39.10137-22.70917c1.86585-1.07737,2.89563-2.74147,2.86963-4.57092-.02676-1.9912-1.30414-3.87429-3.55062-5.17097l-34.76031-13.37139c-.56914-.32851-1.85911-.83476-2.51363-1.06113-1.36374-.47167-2.85557-.79715-4.37595-.84182-2.15791-.06249-4.17453.36647-5.71571,1.25636Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-447",
    d: "M178.42122,694.71665l-26.92013,15.77172c-.04122.0238-.28479.16824-.32169.19363-2.10286,1.29775-2.73003,3.36598-1.75713,5.29721,0,1.50115,2.53408,4.42945,4.15783,5.36715l20.58238,19.6435c2.29578,1.32537,5.4347,1.79484,7.93955,1.28455,1.40934,0,4.36546-1.28233,5.37578-1.86569l38.68204-22.46562c1.78138-1.02859,2.74922-2.60197,2.7147-4.32386-.03568-1.86854-1.25098-3.64665-3.39568-4.88461l-34.54063-13.28685c-.49799-.28745-1.93076-.84115-2.50153-1.0447-1.34644-.48018-2.82232-.835-4.33192-.89455-2.13899-.08332-4.15786.32718-5.68356,1.20813Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M178.57521,694.98335l-26.94935,15.78885c-.05153.02975-.27564.16323-.32177.19497-2.09876,1.31621-2.57894,3.41754-1.36281,5.29355,0,1.2867,2.80169,4.39757,4.19348,5.20132l20.18171,19.26109c2.36873,1.3675,5.66572,1.79505,8.15995,1.15718,1.20801,0,4.40075-1.48183,5.26673-1.98185l38.2627-22.22208c1.69692-.97981,2.60281-2.46247,2.55978-4.07681-.0446-1.74589-1.19781-3.41902-3.24073-4.59825l-34.32095-13.20231c-.42685-.24638-2.00194-.84903-2.48944-1.02827-1.32951-.48883-2.78907-.87285-4.28788-.94729-2.12007-.10415-4.14119.28789-5.6514,1.1599Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-526",
    d: "M178.7292,695.25006l-26.97856,15.80599c-.06183.0357-.2665.15822-.32185.19631-2.09466,1.33467-2.42785,3.4691-.96849,5.28989,0,1.07225,3.0693,4.36569,4.22912,5.03548l19.78104,18.87868c2.44167,1.40963,5.89674,1.79525,8.38036,1.02981,1.00667,0,4.43603-1.68132,5.15769-2.09801l37.84337-21.97853c1.61245-.93103,2.45641-2.32297,2.40485-3.82975-.05352-1.62323-1.14465-3.19138-3.08579-4.31189l-34.10128-13.11777c-.35571-.20532-2.0726-.85844-2.47735-1.01184-1.31298-.49762-2.75581-.9107-4.24385-1.00003-2.10114-.12498-4.12452.2486-5.61924,1.11167Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-455",
    d: "M178.88318,695.51677l-27.00778,15.82313c-.07214.04165-.25735.15321-.32194.19764-2.09056,1.35313-2.27676,3.52066-.57418,5.28623,0,.8578,3.33692,4.33381,4.26477,4.86964l19.38037,18.49627c2.51461,1.45176,6.12776,1.79546,8.60076.90245.80534,0,4.47132-1.88082,5.04864-2.21417l37.42403-21.73498c1.52799-.88225,2.31-2.18347,2.24993-3.5827-.06244-1.50057-1.09149-2.96375-2.93084-4.02553l-33.8816-13.03324c-.28457-.16425-2.14272-.86942-2.46526-.99541-1.29683-.50656-2.72256-.94855-4.19982-1.05276-2.08222-.1458-4.10785.2093-5.58709,1.06344Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-369",
    d: "M179.03717,695.78347l-27.03699,15.84026c-.08245.0476-.24821.1482-.32202.19898-2.08646,1.37158-2.12566,3.57222-.17986,5.28257,0,.64335,3.60453,4.30193,4.30042,4.7038l18.9797,18.11386c2.58755,1.49389,6.35879,1.79566,8.82117.77508.604,0,4.50661-2.08032,4.9396-2.33033l37.0047-21.49143c1.44352-.83347,2.16359-2.04397,2.095-3.33564-.07136-1.37792-1.03833-2.73611-2.7759-3.73918l-33.66192-12.9487c-.21343-.12319-2.21225-.88201-2.45317-.97899-1.28109-.51566-2.68931-.9864-4.15579-1.1055-2.0633-.16663-4.09118.17001-5.55493,1.01521Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.19116,696.05018l-27.06621,15.8574c-.09275.05355-.23906.14319-.3221.20032-2.08236,1.39004-1.97457,3.62377.21446,5.27891,0,.4289,3.87214,4.27005,4.33607,4.53797l18.57903,17.73145c2.6605,1.53601,6.58981,1.79587,9.04157.64771.40267,0,4.54189-2.27981,4.83055-2.44649l36.58536-21.24788c1.35905-.78469,2.01719-1.90447,1.94008-3.08859-.08028-1.25526-.98517-2.50847-2.62096-3.45282l-33.44225-12.86416c-.14228-.08213-2.28115-.89623-2.44108-.96256-1.26577-.52493-2.65605-1.02425-4.11176-1.15824-2.04438-.18746-4.07451.13072-5.52278.96698Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M179.34515,696.31689l-27.09542,15.87454c-.10306.0595-.22992.13818-.32218.20166-2.07826,1.4085-1.82348,3.67533.60877,5.27525,0,.21445,4.13976,4.23817,4.37172,4.37213l18.17836,17.34904c2.73344,1.57814,6.82083,1.79607,9.26197.52034.20133,0,4.57718-2.47931,4.72151-2.56264l36.16603-21.00433c1.27459-.73592,1.87078-1.76498,1.78516-2.84154-.0892-1.1326-.932-2.28084-2.46601-3.16646l-33.22257-12.77962c-.07114-.04106-2.34938-.91212-2.42899-.94613-1.25087-.53437-2.6228-1.0621-4.06773-1.21097-2.02545-.20829-4.05784.09143-5.49062.91875Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-420",
    d: "M184.72276,739.51574l40.35915-23.43959c2.43052-1.40331,2.12556-3.85431-.68083-5.47458l-35.41979-13.62478c-2.80639-1.6205-7.05186-1.7965-9.48216-.3932l-27.12464,15.89167c-2.4303,1.40308-2.12555,3.85431.68083,5.47458l22.18506,21.17292c2.80638,1.62027,7.05186,1.79628,9.48238.39297Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-359",
    d: "M184.72276,739.45925l40.35915-23.43959c1.08303-.62524,1.62297-1.45867,1.6403-2.33397.00068-.02791.00068-3.02088,0-3.04901-.01936-1.0639-.8053.78347-2.32114-.0916l-35.41979-13.62478c-2.80639-1.62027-7.05186-1.79628-9.48216-.3932l-27.12464,15.89167c-.81115.46837-1.3997-1.51989-1.61014-.8879-.07022.21089-.02543,3.00017-.03016,3.21871-.02318,1.08978.76388,2.24461,2.32114,3.14376l22.18506,21.17292c2.80638,1.62027,7.05186,1.79628,9.48238.39297Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-514",
    d: "M184.72276,736.46695l40.35915-23.43982c2.43052-1.40331,2.12556-3.85431-.68083-5.47458l-35.41979-13.62478c-2.80639-1.62027-7.05186-1.79628-9.48216-.3932l-27.12464,15.89167c-2.4303,1.40331-2.12555,3.85431.68083,5.47458l22.18506,21.17292c2.80638,1.62027,7.05186,1.79628,9.48238.3932Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-442",
    d: "M152.3745,709.42626l27.12464-15.89167c2.43052-1.40308,6.67577-1.22708,9.48216.3932l17.8446,6.86416c-.16745.13347-.34706.26288-.55412.38239l-40.35892,23.43982c-.55952.32297-1.21785.55817-1.93019.71549l-10.92733-10.4288c-2.80639-1.62027-3.11135-4.0715-.68083-5.47458Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-528",
    d: "M153.05533,714.39263l22.18506,21.17292c2.80638,1.6205,7.05186,1.79628,9.48238.3932l40.35915-23.43982c1.00831-.58203,1.53857-1.34524,1.62207-2.15391.12626.99278-.40422,1.959-1.62207,2.66212l-40.35915,23.43982c-2.43052,1.40308-6.676,1.22708-9.48238-.3932l-22.18506-21.17292c-1.6421-.94799-2.42062-2.17979-2.30291-3.32044.12559.98873.90275,2.00379,2.30291,2.81224Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-432",
    d: "M162.32052,733.02272c-2.17484,5.29182,2.52482,12.23745,10.49654,15.51356,7.97171,3.2761,16.19731,1.64188,18.37193-3.64994,2.17462-5.29182-2.52482-12.23768-10.49654-15.51356-7.97195-3.2761-16.19732-1.64188-18.37194,3.64994Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M131.99404,736.59682l99.11995-57.27332c5.06743-2.92567,9.17561-10.77496,9.17561-17.53175v-75.80618c0-6.7568-4.10819-9.86253-9.17561-6.93663l-99.11995,57.27332c-5.06765,2.92567-9.17561,10.77496-9.17561,17.53175v75.80618c0,6.7568,4.10796,9.86253,9.17561,6.93663Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-360",
    d: "M130.81221,731.31918l97.7234-56.45789c4.07803-2.59144,6.60037-7.77028,6.60037-13.06953v-76.30448c0-1.25566-1.36594-2.03552-2.44943-1.40105-.12626.07382-.22619.13212-.28764.16768l-97.82693,56.53014c-4.85474,2.79851-6.60037,7.77073-6.60037,13.07021v76.06388c0,1.34659,1.4562,2.19082,2.62611,1.52394.0925-.05267.1661-.09498.21449-.12289Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M127.97184,653.85424v76.06388c0,1.34659,1.45597,2.19082,2.62588,1.52394.0925-.05267.1661-.09475.21449-.12289l97.72362-56.45789c4.07781-2.59167,6.60015-7.77028,6.60015-13.06976v-76.30426c0-1.25566-1.36594-2.03552-2.44943-1.40105-.12626.07382-.22619.13212-.28764.16768l-97.82693,56.52992c-4.85474,2.79873-6.60015,7.77096-6.60015,13.07043ZM129.00265,653.85401c0-3.95514,1.05512-9.2787,6.08542-12.17804l98.11907-56.70052c.09565-.05582.19626-.08395.29889-.08395.28831,0,.59936.22777.59936.59576v76.30426c0,5.04762-2.40306,9.83619-6.08541,12.17736l-97.93249,56.57786c-.11366.06504-.23385.09768-.35673.09768-.35021,0-.7281-.27774-.7281-.7263v-76.06411Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-356",
    d: "M129.39337,634.94079l99.12017-57.27332c2.00491-1.15753,3.85948-1.37112,5.36902-.78797.19198.07427,2.75012,1.43346,2.93062,1.53317l.00855.0054c-1.5631-.75916-3.54619-.61736-5.70775.63064l-99.11995,57.27354c-5.06765,2.92567-9.17584,10.77496-9.17584,17.53175v75.80618c0,4.21667,1.60047,7.01068,4.03526,7.80494-.19851.0108-.44586-.0664-.80395-.27368-.11591-.06685-2.89259-1.63333-3.00332-1.71097-1.74293-1.22077-2.82844-3.72894-2.82844-7.20176v-75.8064c0-6.7568,4.10819-14.60586,9.17561-17.53153Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-450",
    d: "M131.55358,636.10214l99.11996-57.27332c2.07806-1.19984,3.98822-1.3709,5.52656-.70627-1.31283-.20819-2.82034.10938-4.42576,1.03644l-99.11995,57.27332c-5.06743,2.9259-9.17539,10.77496-9.17539,17.53175v75.80618c0,3.98597,1.43594,6.6868,3.64882,7.64289-2.83092-.44879-4.74986-3.3569-4.74986-7.97307v-75.80618c0-6.7568,4.10819-14.60608,9.17561-17.53175Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-431",
    d: "M120.58575,653.05097c3.3524,1.37765,7.75228-1.59934,9.82764-6.64944,2.07536-5.0501,1.04027-10.26067-2.31213-11.63832s-7.75228,1.59934-9.82764,6.64944-1.04027,10.26067,2.31213,11.63832Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-474",
    cx: 431.45357,
    cy: 1002.27366,
    rx: 40.62023,
    ry: 20.20675
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-517",
    d: "M393.70837,994.3245h54.75074v5.83401h-.00945c.0018.07337.00945.14607.00945.21989,0,8.80425-12.25636,15.94142-27.37537,15.94142s-27.37537-7.13716-27.37537-15.94142c0-.07382.00788-.14652.00969-.21989h-.00969v-5.83401Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-510",
    cx: 421.08374,
    cy: 995.00354,
    rx: 27.37537,
    ry: 15.94142
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M396.01667,958.28555h50.13435v34.57983h-.00878c.00158.0673.00878.13392.00878.20144,0,8.06175-11.22307,14.5973-25.06729,14.5973s-25.06706-6.53555-25.06706-14.5973c0-.06752.0072-.13414.00878-.20144h-.00878v-34.57983Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-277",
    cx: 421.0838,
    cy: 959.07532,
    rx: 25.06723,
    ry: 14.5973
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-239",
    cx: 421.0838,
    cy: 958.38616,
    rx: 25.06723,
    ry: 14.5973
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M436.64299,967.00337c-2.09584.01801-3.74155,6.272-3.6756,13.96891.06595,7.69669,1.81833,13.92165,3.91418,13.90364,2.09584-.01778,3.74132-6.272,3.67538-13.96869-.06572-7.69691-1.81811-13.92187-3.91395-13.90387Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M364.86149,870.22053c0,1.18499.40895,2.02427,1.0738,2.43052.01981.01215,5.64968,3.329,5.67016,3.34025.69164.38689.24939-.49065,1.29955-1.09721,2.11407-1.22055,3.82775-4.17638,3.82775-6.60218,0-1.19939,1.10893-1.20907.42966-1.60969-.01891-.01125-5.7818-3.3488-5.80115-3.35938-.68984-.37339-1.63243-.30474-2.67202.29552-2.11385,1.22055-3.82775,4.17638-3.82775,6.60218Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M367.79369,873.32424c0,1.6187.5584,2.76497,1.46655,3.31999.02723.01666,7.71739,4.54729,7.7453,4.56282.94461.52824.34053-.67048,1.77534-1.49873,2.88741-1.66731,5.22835-5.70483,5.22835-9.01852,0-1.63828,1.51471-1.65156.58698-2.1987-.02588-.0153-7.89789-4.5743-7.92423-4.58871-.94214-.51023-2.22998-.41638-3.64994.40355-2.88764,1.66709-5.22835,5.70483-5.22835,9.01829Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M405.08966,867.76368l-.22642-.56492,1.43301-.7245c.34638-.24758.72877-.44271,1.14628-.57955l.21809-.11028.0153.03961c.49515-.13257,1.03464-.18861,1.61691-.15642h0c4.52433.2487,9.86161,5.6229,11.92122,12.00361l20.43042,70.04239c1.66326,5.15251.67903,9.38425-2.14333,10.6919l-1.38913.79697-.15912-.39702c-.24825.02071-.50505.02566-.77109.01103h-.00023c-4.52411-.2487-9.86162-5.6229-11.92101-12.00361l-20.43042-70.04239c-1.20906-3.7456-1.01821-7.0037.2595-9.00681Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M435.47173,959.73679h0c4.52434.2487,6.5225-4.72217,4.46289-11.10288l-20.4304-70.04239c-2.05962-6.38071-7.39691-11.75491-11.92124-12.00361h0c-4.52434-.2487-6.52228,4.7224-4.46267,11.10311l20.43019,70.04216c2.05961,6.38071,7.39712,11.75491,11.92123,12.00361Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M435.47173,959.73679h0c4.52434.2487,6.5225-4.72217,4.46289-11.10288l-20.4304-70.04239c-2.05962-6.38071-7.39691-11.75491-11.92124-12.00361h0c-4.52434-.2487-6.52228,4.7224-4.46267,11.10311l20.43019,70.04216c2.05961,6.38071,7.39712,11.75491,11.92123,12.00361Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-278",
    d: "M439.73318,948.88554l-20.43042-70.04239c-2.05961-6.38071-7.39688-11.75468-11.92123-12.00361-1.14538-.06302-2.12803.20976-2.92477.75421.87079-.8098,2.0281-1.23383,3.42825-1.15685,4.52434.2487,9.86162,5.6229,11.92123,12.00361l20.43042,70.04239c1.5379,4.76516.81227,8.74303-1.5379,10.34867,1.94325-1.80708,2.45663-5.53985,1.03442-9.94603Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-240",
    points: "420.66061 953.42991 420.66061 968.44292 405.87672 959.87769 405.87672 944.74247 420.66061 953.42991"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-237",
    points: "420.64307 953.42991 420.64307 968.44292 435.36167 959.90695 435.36167 944.77173 420.64307 953.42991"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "435.36167 944.77173 420.64307 953.42991 405.87672 944.74247 420.62595 936.12773 435.36167 944.77173"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M489.98075,919.70646l-58.2895-33.85421c-1.86717-1.07808-3.38076.06617-3.38076,2.55588v1.16226c0,2.48949,1.51359,5.38185,3.38076,6.45971l58.2895,33.85421c1.86717,1.07808,3.38099-.06617,3.38099-2.55588v-1.16226c0-2.48949-1.51381-5.38163-3.38099-6.45971Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-515",
    d: "M491.72301,918.68488l-58.2895-33.85399c-.79945-.46184-1.53317-.51316-2.11205-.22845l-.01846-.02003-1.84759,1.08483.00675.02273c.59554-.35448,1.37405-.33153,2.22908.16227l58.2895,33.85399c1.86741,1.07831,3.38099,3.97022,3.38099,6.45993v1.16226c0,1.20997-.35966,2.09854-.94146,2.57231l1.03014-.67858c.86607-.4965,1.65336-1.26826,1.65336-2.91532v-1.16226c0-2.48949-1.51358-5.38163-3.38076-6.45971Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M490.17071,919.54824l-58.28973-33.85421c-.9275-.53544-1.767-.52148-2.37785-.06797.55458-.21021,1.23225-.13459,1.96665.28944l58.28974,33.85421c1.86716,1.07808,3.38075,3.96999,3.38075,6.45971v1.16226c0,1.25296-.38397,2.16426-1.00291,2.62385.85504-.32432,1.41411-1.33488,1.41411-2.84532v-1.16203c0-2.48971-1.51359-5.38185-3.38076-6.45993Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M484.56784,921.63463l-.11591-.28944.73419-.37114c.17757-.12694,1.13929-.51091,1.3531-.5809l.11186-.05649.00788.02026c.25365-.06797.53004-.09655.82825-.08012h0c2.31776.12739,5.05212,2.88066,6.10725,6.14934l5.41111,16.63823c.85211,2.63983.34796,4.8077-1.09789,5.47751l-1.47758.69231-.08147-.20346c-.12738.01058-.25883.01305-.39521.00563h0c-2.31777-.12739-5.05214-2.88066-6.10704-6.14934l-5.41133-16.63823c-.61939-1.91894-.52171-3.58805.13279-4.61414Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M495.07744,949.50786h0c2.31776.12739,3.34137-2.41927,2.28625-5.68794l-5.41133-16.63823c-1.05512-3.2689-3.78926-6.02195-6.10702-6.14956h0c-2.31776-.12739-3.34137,2.41927-2.28625,5.68817l5.41133,16.63823c1.05512,3.26868,3.78928,6.02195,6.10702,6.14934Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "M497.2606,943.94888l-5.41133-16.63845c-1.05512-3.26868-3.78926-6.02195-6.10702-6.14934-.58698-.03218-1.09046.10758-1.49851.38644.44609-.41503,1.03892-.63199,1.75621-.59261,2.31776.12739,5.05212,2.88043,6.10725,6.14934l5.41133,16.63823c.78797,2.4411.41615,4.4791-.78774,5.30173.99548-.92593,1.25836-2.83812.52981-5.09534Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-512",
    d: "M489.83175,965.57464h-1.68104v18.99673h.00023l-.00023.00675c0,.27053.37632.48953.84041.48953.46432,0,.84063-.21899.84063-.48953l-.00021-.00675h.00021v-18.99673Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M485.78816,958.5266h6.40614v9.85937h-.00113l.00113.01711c0,1.03892-1.43414,1.87392-3.20318,1.87392-1.76882,0-3.20296-.83501-3.20296-1.86515l.00114-.02588h-.00114v-9.85937Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M483.2397,944.58537h11.50305v13.10352h-.00203l.00203.04614c0,1.84984-2.575,3.34948-5.75164,3.34948-3.1764,0-5.75141-1.49964-5.75141-3.34948l.00203-.04614h-.00203v-13.10352Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M494.74276,944.60855c0,1.84984-2.575,3.34925-5.75164,3.34925-3.1764,0-5.75141-1.49941-5.75141-3.34925s2.57501-3.34925,5.75141-3.34925c3.17664,0,5.75164,1.49941,5.75164,3.34925Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-169",
    cx: 488.99112,
    cy: 944.55971,
    rx: 4.11584,
    ry: 2.39676
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 488.99112,
    cy: 944.55971,
    rx: 4.11584,
    ry: 2.39676
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M484.8674,952.70451c0,1.80843-1.27749,2.53675-2.85343,1.62702-1.57593-.90995-2.85343-3.11338-2.85343-4.92181s1.27749-2.53675,2.85343-1.6268c1.57593.90973,2.85343,3.11338,2.85343,4.92158Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-419",
    d: "M482.15105,947.71428c-.75556-.43618-1.44202-.49493-1.95246-.2397.47601-.13302,1.06636-.03354,1.70578.33558,1.57593.90995,2.85365,3.11338,2.85365,4.92181,0,.94146-.34683,1.58944-.9014,1.8665.69681-.19468,1.14785-.8879,1.14785-1.96238,0-1.80843-1.27772-4.01186-2.85343-4.92181Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "410.04073 887.40321 410.04073 907.48477 374.33286 886.85336 374.33286 867.08645 410.04073 887.40321"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "410.00877 887.40321 410.00877 907.48477 426.89998 898.36339 426.89998 878.05969 410.00877 887.40321"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "426.89998 878.05946 410.00877 887.40321 374.33286 867.08645 391.27942 857.82148 426.89998 878.05946"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "427.93101 897.65443 427.93101 913.84567 411.53856 904.27348 411.53856 888.33589 427.93101 897.65443"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "427.90536 897.65443 427.90536 913.84567 441.52406 906.49131 441.52406 890.12091 427.90536 897.65443"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "441.52406 890.12091 427.90536 897.65443 411.53856 888.33589 425.20228 880.86585 441.52406 890.12091"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-355",
    d: "M428.90489,905.8197c0,3.80569,2.68845,5.33841,6.00507,3.42375,3.31639-1.91489,6.00508-6.55221,6.00508-10.3579s-2.68869-5.33864-6.00508-3.42375c-3.31662,1.91489-6.00507,6.55221-6.00507,10.3579Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M430.06062,905.25433c0,1.57413.54332,2.68912,1.42627,3.22884.02655.0162,47.2251,26.97137,47.25233,26.98645.91873.51383.33108-.65203,1.7265-1.45755,2.80841-1.62162,5.08521-5.5484,5.08521-8.77117,0-1.59349,1.4733-1.60654.57078-2.13861-.02521-.01485-47.40044-26.99771-47.4261-27.01166-.91648-.49628-2.16877-.4049-3.54979.39252-2.80841,1.6214-5.08521,5.5484-5.08521,8.77117Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M430.06062,905.25433c0,1.57413.54332,2.68912,1.42627,3.22884.02655.0162,47.2251,26.97137,47.25233,26.98645.91873.51383.33108-.65203,1.7265-1.45755,2.80841-1.62162,5.08521-5.5484,5.08521-8.77117,0-1.59349,1.4733-1.60654.57078-2.13861-.02521-.01485-47.40044-26.99771-47.4261-27.01166-.91648-.49628-2.16877-.4049-3.54979.39252-2.80841,1.6214-5.08521,5.5484-5.08521,8.77117Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M477.44058,932.28152c0,3.22276,2.2768,4.52074,5.08522,2.89934,2.8084-1.6214,5.0852-5.5484,5.0852-8.77117,0-3.22254-2.2768-4.52074-5.0852-2.89911-2.80842,1.6214-5.08522,5.5484-5.08522,8.77094Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M479.05455,931.31913c0,2.18497,1.54352,3.06499,3.44783,1.96575,1.90408-1.09946,3.44783-3.76203,3.44783-5.94722,0-2.18497-1.54375-3.06499-3.44783-1.96575-1.90431,1.09946-3.44783,3.76203-3.44783,5.94722Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M479.05455,931.31913c0,2.18497,1.54352,3.06499,3.44783,1.96575,1.90408-1.09946,3.44783-3.76203,3.44783-5.94722,0-2.18497-1.54375-3.06499-3.44783-1.96575-1.90431,1.09946-3.44783,3.76203-3.44783,5.94722Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M482.28181,923.38837c1.34636-.77716,2.56939-.88205,3.47912-.42696-.84806-.23722-1.90003-.06009-3.03978.59778-2.80864,1.62162-5.08521,5.5484-5.08521,8.77117,0,1.67789.61805,2.83249,1.60611,3.32652-1.24149-.34728-2.04544-1.58246-2.04544-3.49735,0-3.22254,2.2768-7.14954,5.08521-8.77117Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M459.39949,912.55535c-.65157,1.11882-6.63526-1.47015,3.20048,4.25696,9.83574,5.72733,18.33727,9.46303,18.98862,8.34421.65157-1.11882-6.79371-6.6688-16.62944-12.3959-9.83552-5.72733-4.90809-1.32431-5.55967-.20526Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M385.29101,878.56902l-.22642-.56492,1.43325-.7245c.34637-.24758.72876-.44271,1.14604-.57955l.21809-.11028.0153.03961c.49539-.13279,1.03487-.18861,1.6169-.15642h.00023c4.52434.2487,9.86164,5.6229,11.92123,12.00338l20.43019,70.04239c1.66326,5.15273.67926,9.38448-2.14311,10.69213l-1.38911.79697-.15914-.39702c-.24848.02048-.50528.02566-.77131.01103h0c-4.52411-.2487-9.86161-5.62312-11.921-12.00361l-20.43043-70.04239c-1.20907-3.7456-1.01821-7.0037.25928-9.00681Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M415.6733,970.54213h0c4.52434.2487,6.52228-4.72217,4.46267-11.10288l-20.43042-70.04239c-2.05961-6.38071-7.39689-11.75491-11.92101-12.00361h0c-4.52434-.2487-6.5225,4.72217-4.46289,11.10288l20.43042,70.04239c2.05961,6.38071,7.39689,11.75491,11.92123,12.00361Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M419.93476,959.69088l-20.43042-70.04239c-2.05961-6.38071-7.39689-11.75491-11.92123-12.00361-1.1456-.06302-2.12825.20976-2.925.75421.87102-.8098,2.02832-1.23383,3.42848-1.15685,4.52412.2487,9.8614,5.6229,11.92101,12.00361l20.43042,70.04239c1.53812,4.76494.8125,8.74281-1.53767,10.34867,1.94325-1.8073,2.45663-5.54007,1.03442-9.94603Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-501",
    d: "M416.82364,963.14186c0,2.73346-1.93109,3.8345-4.31346,2.4591-2.38234-1.3754-4.31344-4.70642-4.31344-7.43988,0-2.73369,1.93109-3.83473,4.31344-2.45933,2.38237,1.3754,4.31346,4.70642,4.31346,7.44011Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-501",
    d: "M394.87266,890.50376c0,2.73369-1.93133,3.83473-4.31346,2.45933-2.38234-1.3754-4.31344-4.70642-4.31344-7.44011,0-2.73346,1.93109-3.83473,4.31344-2.45933,2.38213,1.3754,4.31346,4.70642,4.31346,7.44011Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M393.74033,890.31335c0,1.09901-.37924,1.8773-.99571,2.25407-.01868.01148-1.78232,1.04612-1.80123,1.0567-.64145.35853-.23115-.45531-1.20547-1.01776-1.96058-1.1321-3.55024-3.87366-3.55024-6.12345,0-1.11252-1.02857-1.12152-.39837-1.49311.01757-.01035,1.90453-1.06435,1.92254-1.07403.63987-.34638,1.51426-.28269,2.47824.27391,1.9608,1.1321,3.55024,3.87366,3.55024,6.12368Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M391.84998,891.39818c0,2.25002-1.58945,3.15614-3.55025,2.02405-1.9608-1.13187-3.55024-3.87344-3.55024-6.12345,0-2.24979,1.58944-3.15614,3.55024-2.02405s3.55025,3.87366,3.55025,6.12345Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M388.47011,885.18965c-.93989-.54264-1.7938-.61601-2.42895-.29844.59193-.16543,1.32656-.04186,2.12219.4175,1.96079,1.1321,3.55023,3.87366,3.55023,6.12368,0,1.17126-.43146,1.97723-1.12129,2.32226.86674-.2424,1.42806-1.10486,1.42806-2.44155,0-2.25002-1.58966-4.99158-3.55024-6.12345Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M415.61569,963.02573c0,1.09901-.37924,1.87753-.99571,2.25429-.01868.01125-1.78231,1.0459-1.80123,1.05647-.64145.35876-.23115-.45509-1.20546-1.01754-1.96059-1.1321-3.55025-3.87366-3.55025-6.12368,0-1.11252-1.02834-1.12152-.39837-1.49288,0,0,1.90476-1.06435,1.92254-1.07403.63987-.34661,1.51426-.28269,2.47824.27391,1.9608,1.1321,3.55024,3.87366,3.55024,6.12345Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M413.72533,964.11079c0,2.24979-1.58944,3.15614-3.55023,2.02405-1.96081-1.13187-3.55025-3.87344-3.55025-6.12345,0-2.24979,1.58944-3.15614,3.55025-2.02405,1.96079,1.13187,3.55023,3.87344,3.55023,6.12345Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M410.34547,957.90203c-.93989-.54264-1.7938-.61579-2.42895-.29822.59193-.16543,1.32656-.04186,2.1224.4175,1.96058,1.1321,3.55001,3.87366,3.55001,6.12345,0,1.17148-.43146,1.97746-1.12129,2.32249.86674-.2424,1.42806-1.10486,1.42806-2.44155,0-2.25002-1.58944-4.99158-3.55024-6.12368Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M478.83038,934.05799c0,1.80843-1.27772,2.53675-2.85365,1.62702-1.57592-.90995-2.85343-3.11361-2.85343-4.92181,0-1.80843,1.27751-2.53675,2.85343-1.62702,1.57593.90995,2.85365,3.11361,2.85365,4.92181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-419",
    d: "M476.11379,929.06776c-.75556-.43618-1.44179-.49493-1.95225-.2397.4758-.13302,1.06615-.03376,1.7058.33558,1.57593.90995,2.85343,3.11338,2.85343,4.92181,0,.94146-.34683,1.58944-.90116,1.8665.69658-.19468,1.14761-.8879,1.14761-1.96238,0-1.80843-1.27749-4.01186-2.85343-4.92181Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M471.88228,928.74164l-.11615-.28944.73418-.37114c.17758-.12671,1.1393-.51068,1.35334-.5809l.11163-.05649.00789.02048c.25364-.0682.53002-.09678.82825-.08035h0c2.31775.12739,5.05211,2.88066,6.10724,6.14934l5.41133,16.63845c.85211,2.63961.34796,4.80747-1.09811,5.47728l-1.47758.69231-.08147-.20346c-.12739.01058-.25883.01328-.395.00563h-.00023c-2.31754-.12739-5.05189-2.88043-6.10702-6.14934l-5.41133-16.63823c-.61939-1.91894-.52171-3.58783.13303-4.61414Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M482.39164,956.61486h0c2.31776.12739,3.34139-2.41904,2.28625-5.68794l-5.4111-16.63823c-1.05514-3.2689-3.7895-6.02195-6.10726-6.14934h0c-2.31776-.12739-3.34137,2.41904-2.28625,5.68794l5.41135,16.63823c1.05511,3.2689,3.78925,6.02195,6.10701,6.14934Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M484.57481,951.05588l-5.41133-16.63823c-1.05512-3.2689-3.78926-6.02195-6.10702-6.14934-.58698-.03241-1.09023.10736-1.49851.38622.44609-.4148,1.03892-.63199,1.75621-.59261,2.31777.12739,5.05212,2.88066,6.10725,6.14934l5.41135,16.63823c.78795,2.44132.41614,4.4791-.78774,5.30173.99547-.92593,1.25835-2.83812.5298-5.09534Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M474.48092,928.63585l-58.28972-33.85421c-1.86718-1.07808-3.38077.06617-3.38077,2.55588v1.16226c0,2.48949,1.51359,5.38163,3.38077,6.45971l58.28972,33.85421c1.86717,1.07808,3.38076-.0664,3.38076-2.55588v-1.16226c0-2.48971-1.51359-5.38163-3.38076-6.45971Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M476.22295,927.61427l-58.28928-33.85399c-.79967-.46184-1.5334-.51316-2.11227-.22845l-.01823-.02003-1.84782,1.08461.00675.02273c.59553-.35426,1.37405-.3313,2.2291.1625l58.28972,33.85399c1.86717,1.07808,3.38076,3.97022,3.38076,6.45993v1.16226c0,1.20997-.35942,2.09854-.94146,2.57231l1.03037-.67858c.86608-.4965,1.65336-1.26826,1.65336-2.91532v-1.16226c0-2.48949-1.51381-5.38163-3.38099-6.45971Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M474.67065,928.47763l-58.2895-33.85421c-.92751-.53544-1.76724-.52171-2.37808-.06797.55457-.21021,1.23225-.13459,1.96688.28944l58.2895,33.85399c1.86717,1.07808,3.38076,3.97022,3.38076,6.45993v1.16226c0,1.25296-.38397,2.16426-1.00291,2.62385.85526-.32432,1.41412-1.33511,1.41412-2.84532v-1.16203c0-2.48994-1.5136-5.38185-3.38078-6.45993Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-501",
    d: "M475.46492,934.49103c0,1.51967-1.0738,2.13185-2.39811,1.36707-1.32431-.76456-2.39811-2.61643-2.39811-4.13609,0-1.51989,1.0738-2.13185,2.39811-1.36729s2.39811,2.61643,2.39811,4.13632Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-399",
    d: "M487.2923,946.73321h3.2554c0-4.55495,3.09672-7.19141,6.09149-9.74099,3.16177-2.69205,7.09598-6.0422,3.59729-11.29104-1.29551-1.94415-2.8136-3.03776-4.51287-3.25-2.91847-.37902-5.41426,1.88765-7.6206,3.87479-.84087.75736-2.82643,2.53608-3.28265,2.3477-3.06792-1.1492-3.80389-1.69612-3.83404-1.71908l-2.20321,2.39158c.55796.55862,2.29705,1.40286,4.89435,2.3765,2.32721.86697,4.50341-1.08573,6.60488-2.97811,1.68667-1.51967,3.57815-3.24212,5.0375-3.06319.71686.0898,1.4607.70402,2.20793,1.82553,1.74699,2.62048.69794,3.85881-2.9995,7.00617-3.22389,2.74539-7.23597,6.16149-7.23597,12.22012Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M474.66817,934.35936c0,.61894-.21359,1.05715-.56065,1.26939,0,0-1.00358.58901-1.01416.59486-.36124.20211-.13031-.25635-.67881-.57303-1.10395-.6374-1.99906-2.18114-1.99906-3.44783,0-.62659-.57909-.63154-.22439-.84086l1.08258-.60476c.36034-.19491.85256-.15912,1.39543.1544,1.10396.6374,1.99906,2.18114,1.99906,3.44783Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M473.6036,934.97042c0,1.26691-.89487,1.77715-1.99884,1.13975-1.10419-.6374-1.99906-2.18114-1.99906-3.44806s.89487-1.77715,1.99906-1.13975c1.10396.6374,1.99884,2.18114,1.99884,3.44806Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M471.70064,931.47442c-.52914-.30542-1.01011-.34661-1.36774-.1679.33333-.09318.747-.02363,1.19512.23497,1.10396.63762,1.99906,2.18114,1.99906,3.44806,0,.65968-.24307,1.11342-.63154,1.30765.48817-.13639.80417-.62209.80417-1.37472,0-1.26691-.8951-2.81066-1.99906-3.44806Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-501",
    d: "M483.3986,953.51634c0,1.51967-1.0738,2.13185-2.39811,1.36729-1.32431-.76478-2.39811-2.61665-2.39811-4.13632s1.0738-2.13185,2.39811-1.36707c1.32431.76456,2.39811,2.61643,2.39811,4.13609Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M482.60186,953.3849c0,.61871-.21359,1.05715-.56065,1.26939l-1.00358.58878c-.37181.20796-.14089-.25028-.68939-.56695-1.10395-.6374-1.99906-2.18114-1.99906-3.44806,0-.62637-.57909-.63154-.22439-.84063.00992-.00585,1.07245-.59936,1.07245-.59936.37046-.20054.86269-.16453,1.40556.14877,1.10396.6374,1.99906,2.18114,1.99906,3.44806Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M481.53728,953.99573c0,1.26691-.89487,1.77715-1.99884,1.13975-1.10419-.6374-1.99906-2.18114-1.99906-3.44783,0-1.26691.89487-1.77715,1.99906-1.13975,1.10396.6374,1.99884,2.18114,1.99884,3.44783Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M479.63432,950.49996c-.52914-.30564-1.01011-.34683-1.36774-.1679.33333-.0934.747-.02363,1.19512.23497,1.10396.6374,1.99906,2.18114,1.99906,3.44806,0,.65945-.24307,1.11342-.63154,1.30765.48817-.13662.80417-.62209.80417-1.37495,0-1.26669-.8951-2.81044-1.99906-3.44783Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-501",
    d: "M420.07048,902.0399c0,1.51967-1.0738,2.13185-2.39811,1.36729-1.32431-.76478-2.39789-2.61643-2.39789-4.13632,0-1.51967,1.07358-2.13185,2.39789-1.36707,1.32431.76456,2.39811,2.61643,2.39811,4.13609Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M419.27373,901.90846c0,.61894-.21359,1.05715-.56065,1.26939-.01058.0063-1.00358.58878-1.00358.58878-.37181.20796-.14088-.25028-.68939-.56695-1.10396-.6374-1.99906-2.18114-1.99906-3.44806,0-.62637-.5791-.63154-.22439-.84063.0099-.00585,1.07245-.59936,1.07245-.59936.37046-.20054.86269-.16453,1.40556.14877,1.1042.6374,1.99906,2.18114,1.99906,3.44806Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M418.20938,902.51929c0,1.26691-.89509,1.77715-1.99906,1.13975-1.10395-.6374-1.99906-2.18114-1.99906-3.44783,0-1.26691.89511-1.77715,1.99906-1.13975,1.10398.6374,1.99906,2.18114,1.99906,3.44783Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M416.3062,899.02352c-.52913-.30564-1.01011-.34683-1.36774-.1679.33333-.0934.747-.02363,1.19512.23497,1.10396.6374,1.99906,2.18114,1.99906,3.44806,0,.65945-.24307,1.11342-.63132,1.30765.48795-.13662.80395-.62209.80395-1.37495,0-1.26669-.8951-2.81044-1.99906-3.44783Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-457",
    d: "M1048.65611,755.49249c-11.69661-6.87248-26.7501-2.96191-33.62261,8.73493-6.87271,11.69661-2.96191,26.75013,8.7347,33.62261,11.69684,6.87271,26.75013,2.96213,33.62284-8.7347,6.87248-11.69661,2.96191-26.75013-8.73493-33.62284Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-540",
    d: "M1029.09041,747.55768c-10.23456-6.01362-23.40628-2.59167-29.4199,7.64289s-2.59167,23.40628,7.64289,29.4199c10.23456,6.01362,23.4065,2.59167,29.4199-7.64289,6.01362-10.23456,2.59167-23.40651-7.64289-29.4199Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-407",
    d: "M1011.32571,740.68092c-8.77252-5.15453-20.06265-2.22143-25.21718,6.55108-5.15431,8.77252-2.22143,20.06265,6.55108,25.21696,8.77252,5.15453,20.06265,2.22166,25.21718-6.55108,5.15456-8.77252,2.22143-20.06243-6.55108-25.21696Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-488",
    d: "M996.56253,735.5678c-7.31047-4.29522-16.7188-1.85119-21.01425,5.45927-4.29522,7.31047-1.85119,16.7188,5.45927,21.01425,7.31047,4.29544,16.7188,1.85119,21.01425-5.45927s1.85119-16.7188-5.45927-21.01425Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-438",
    d: "M983.60058,731.51318c-5.84842-3.43635-13.37493-1.48095-16.81131,4.36724-3.43635,5.84842-1.48095,13.37518,4.36724,16.81153,5.84842,3.43635,13.37518,1.48095,16.81153-4.36746s1.48095-13.37495-4.36746-16.81131Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-462",
    d: "M813.25055,778.21434c-11.69661-6.87271-26.75013-2.96191-33.62284,8.7347-6.87248,11.69684-2.96191,26.75013,8.73493,33.62284,11.69661,6.87271,26.75013,2.96191,33.62261-8.7347,6.87271-11.69684,2.96191-26.75013-8.7347-33.62284Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-539",
    d: "M793.68485,770.2793c-10.23479-6.01339-23.4065-2.59167-29.42012,7.64312-6.01339,10.23456-2.59167,23.40628,7.64312,29.4199,10.23456,6.01339,23.40628,2.59167,29.4199-7.64289,6.01339-10.23479,2.59167-23.40651-7.64289-29.42012Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-400",
    d: "M775.91993,763.40277c-8.77252-5.15453-20.06265-2.22166-25.21696,6.55108-5.15453,8.77252-2.22143,20.06243,6.5511,25.21696,8.7725,5.15453,20.06265,2.22143,25.21694-6.55108,5.15453-8.77252,2.22143-20.06265-6.55108-25.21696Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-493",
    d: "M761.15698,758.28965c-7.31045-4.29544-16.7188-1.85119-21.01425,5.45927-4.29544,7.31047-1.85119,16.7188,5.45927,21.01425,7.31049,4.29544,16.7188,1.85119,21.01425-5.45927,4.29522-7.31047,1.85119-16.7188-5.45927-21.01425Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-439",
    d: "M748.19505,754.2348c-5.84844-3.43613-13.3752-1.48095-16.81155,4.36746-3.43635,5.84842-1.48095,13.37518,4.36748,16.81131,5.8484,3.43635,13.37493,1.48095,16.81129-4.36724,3.43635-5.84842,1.48095-13.37518-4.36722-16.81153Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-461",
    cx: 341.0529,
    cy: 452.14252,
    r: 24.56407,
    transform: "translate(-100.59989 97.61078) rotate(-14.21725)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-537",
    d: "M370.01647,444.4329c10.1846,6.09825,13.49717,19.29787,7.39914,29.48224-6.09825,10.1846-19.29787,13.49717-29.48224,7.39914-10.1846-6.09825-13.49717-19.29787-7.39913-29.48224,6.09824-10.1846,19.29786-13.49717,29.48223-7.39914Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-401",
    d: "M384.569,456.72527c8.72952,5.227,11.56899,16.541,6.34198,25.27053s-16.541,11.569-25.27053,6.342c-8.72953-5.227-11.569-16.54077-6.342-25.2703,5.227-8.72975,16.541-11.569,25.27054-6.34222Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-490",
    d: "M396.13439,467.22924c7.27468,4.35576,9.64083,13.78413,5.28507,21.05881-4.35576,7.27446-13.78413,9.64061-21.05881,5.28485-7.27446-4.35576-9.64083-13.78413-5.28485-21.05858,4.35576-7.27468,13.7839-9.64083,21.05858-5.28507Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-437",
    d: "M405.9078,476.65986c5.8196,3.48474,7.71243,11.02748,4.22791,16.84709-3.48474,5.81961-11.02725,7.71267-16.84709,4.22792-5.81961-3.48452-7.71244-11.02726-4.22792-16.84687,3.48476-5.81984,11.02726-7.71267,16.8471-4.22815Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-459",
    d: "M556.9784,899.85515c11.81411-6.66902,26.79739-2.49804,33.46642,9.31583,6.66902,11.8141,2.49827,26.79762-9.31583,33.46642-11.8141,6.66902-26.79739,2.49827-33.46642-9.31583-6.66902-11.81387-2.49827-26.7974,9.31583-33.46642Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-541",
    cx: 587.24456,
    cy: 910.97761,
    r: 21.49352,
    transform: "translate(-446.06915 1238.08488) rotate(-74.75869)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-406",
    d: "M594.55997,885.69246c8.86052-5.00193,20.09799-1.8737,25.0997,6.98682,5.00193,8.86052,1.8737,20.09799-6.98682,25.0997-8.86052,5.00193-20.09799,1.8737-25.09992-6.98682-5.00169-8.86052-1.87347-20.09799,6.98704-25.0997Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-492",
    d: "M609.40935,880.83592c7.38363-4.16828,16.74829-1.5613,20.91657,5.82231,4.16805,7.38384,1.5613,16.74851-5.82254,20.91657-7.38361,4.16805-16.74829,1.5613-20.91657-5.82254-4.16805-7.38361-1.5613-16.74829,5.82254-20.91634Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-435",
    d: "M622.43973,877.00614c5.90694-3.3344,13.3986-1.24891,16.73321,4.65803,3.3344,5.90694,1.24891,13.39859-4.65801,16.73321-5.90695,3.3344-13.3986,1.24913-16.73322-4.65803-3.3344-5.90694-1.24913-13.39859,4.65803-16.73321Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-460",
    cx: 394.49982,
    cy: 752.43324,
    r: 24.56408,
    transform: "translate(-435.42252 934.13299) rotate(-74.68128)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-538",
    d: "M402.12482,723.44716c10.33742-5.83537,23.44792-2.18587,29.28329,8.15133,5.83535,10.33742,2.18586,23.44792-8.15156,29.28328-10.3372,5.83537-23.44769,2.18587-29.28306-8.15133-5.83536-10.33742-2.18587-23.44792,8.15133-29.28328Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M420.00612,716.8792c8.86051-5.00171,20.09798-1.87347,25.09991,6.98682,5.00171,8.86052,1.87347,20.09822-6.98704,25.09992s-20.09798,1.8737-25.0997-6.98682c-5.00171-8.86052-1.8737-20.09822,6.98683-25.09992Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-489",
    d: "M434.85549,712.02266c7.38384-4.16805,16.74851-1.5613,20.91657,5.82254,4.16807,7.38361,1.5613,16.74829-5.82254,20.91634-7.38361,4.16828-16.74829,1.56153-20.91634-5.82231-4.16828-7.38384-1.56152-16.74829,5.82231-20.91657Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-440",
    d: "M447.88586,708.19311c5.90694-3.33462,13.39858-1.24913,16.73321,4.6578,3.3344,5.90716,1.24913,13.39881-4.65803,16.73321-5.90694,3.33462-13.39858,1.24913-16.73321-4.6578-3.3344-5.90694-1.24891-13.39881,4.65803-16.73321Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-456",
    cx: 465.77002,
    cy: 219.45337,
    r: 24.56414,
    transform: "translate(50.10689 523.30475) rotate(-61.39501)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-535",
    d: "M494.71507,211.67437c10.199,6.07371,13.5433,19.26546,7.46959,29.46446-6.07349,10.199-19.26523,13.5433-29.46424,7.46959-10.19923-6.07349-13.54329-19.26523-7.46982-29.46424,6.07371-10.19923,19.26546-13.54353,29.46446-7.46982Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-405",
    d: "M509.29707,223.93185c8.74191,5.20607,11.60839,16.51309,6.40254,25.25522-5.20607,8.74191-16.51309,11.60861-25.25522,6.40254-8.74213-5.20607-11.60861-16.51309-6.40254-25.25522,5.20585-8.74191,16.51309-11.60861,25.25522-6.40254Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-491",
    d: "M520.88768,234.40792c7.28503,4.33843,9.67369,13.76095,5.33549,21.04598-4.33843,7.28503-13.76093,9.67392-21.04598,5.33549-7.28526-4.33821-9.6739-13.76095-5.33549-21.04598,4.33821-7.28503,13.76095-9.67392,21.04598-5.33549Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-434",
    d: "M530.68336,243.81513c5.82816,3.47079,7.73922,11.0088,4.26843,16.83674-3.47056,5.82816-11.00879,7.73922-16.83674,4.26843-5.82816-3.47056-7.739-11.00858-4.26843-16.83674,3.47056-5.82794,11.0088-7.739,16.83674-4.26843Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-463",
    d: "M1150.47895,380.69289c-11.65613,6.94135-15.47825,22.0176-8.53687,33.6737,6.94132,11.6561,22.01757,15.478,33.67367,8.53664,11.6561-6.94113,15.478-22.01738,8.53687-33.67348-6.94135-11.6561-22.0176-15.47822-33.67367-8.53687Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-536",
    cx: 1145.09961,
    cy: 412.48626,
    r: 21.49358,
    transform: "translate(233.86501 1219.36266) rotate(-61.33409)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-402",
    d: "M1119.52045,406.27672c-8.74213,5.20585-11.60861,16.51309-6.40276,25.255,5.20607,8.74213,16.51332,11.60861,25.25522,6.40276,8.74213-5.20607,11.60864-16.51309,6.40254-25.25522-5.20585-8.74213-16.51306-11.60861-25.255-6.40254Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-495",
    d: "M1107.92984,416.75278c-7.28503,4.33821-9.67392,13.76095-5.33549,21.04598,4.33823,7.28503,13.76095,9.67369,21.04598,5.33549,7.28503-4.33843,9.67369-13.76095,5.33552-21.04598-4.33846-7.28503-13.76098-9.67392-21.04601-5.33549Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-436",
    d: "M1098.13394,426.15999c-5.82816,3.47056-7.739,11.0088-4.26843,16.83674,3.47079,5.82816,11.0088,7.739,16.83674,4.26843,5.82816-3.47056,7.73922-11.0088,4.26843-16.83674-3.47056-5.82816-11.0088-7.739-16.83674-4.26843Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-458",
    d: "M942.78544,367.43813c-11.6561,6.94135-15.4782,22.0176-8.53687,33.67348,6.94135,11.6561,22.0176,15.47822,33.6737,8.53687,11.6561-6.94135,15.478-22.0176,8.53664-33.67348-6.94135-11.6561-22.01735-15.47822-33.67348-8.53687Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-542",
    d: "M926.40874,380.76424c-10.199,6.07371-13.5433,19.26546-7.46957,29.46446,6.07346,10.199,19.26521,13.5433,29.46421,7.46982,10.19923-6.07371,13.5433-19.26546,7.46982-29.46446-6.07371-10.199-19.26546-13.5433-29.46446-7.46982Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-403",
    d: "M911.82674,393.02172c-8.74191,5.20607-11.60839,16.51309-6.40254,25.25522,5.20607,8.74213,16.51309,11.60861,25.25522,6.40254,8.74213-5.20585,11.60861-16.51309,6.40256-25.25522-5.20585-8.74191-16.51312-11.60839-25.25525-6.40254Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-494",
    d: "M900.23614,403.49779c-7.28503,4.33843-9.67367,13.76095-5.33549,21.04598,4.33843,7.28503,13.76095,9.67392,21.04598,5.33549,7.28526-4.33821,9.67392-13.76095,5.33571-21.04598-4.33843-7.28503-13.76092-9.67369-21.04621-5.33549Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-441",
    d: "M890.44046,412.90522c-5.82816,3.47056-7.73922,11.00858-4.26843,16.83674,3.47056,5.82794,11.0088,7.739,16.83676,4.26843,5.82814-3.47079,7.73897-11.0088,4.26841-16.83696-3.47056-5.82794-11.0088-7.739-16.83674-4.26821Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-506",
    points: "1211.79808 211.94423 1211.79808 320.47747 1224.61869 312.80577 1224.61869 204.27252 1211.79808 211.94423"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-183",
    points: "1211.81608 211.94423 1211.81608 320.47747 1208.47291 318.53422 1208.47291 210.02124 1211.81608 211.94423"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "1208.47291 210.02124 1211.81608 211.94423 1224.61869 204.27252 1221.2404 202.32905 1208.47291 210.02124"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-417",
    d: "M1225.48633,227.92368l-4.20249,2.4555v-14.71389h-2.65154v16.26326l-.93606.54692v18.34133l.93606-.54692v54.75075h.00045l-.00045.0108c0,.42628.59351.77199,1.32566.77199.73237,0,1.32588-.34571,1.32588-.77199l-.00042-.0072.00042-.0036v-56.30012l4.20249-2.45528v-18.34155Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-179",
    points: "1282.13759 310.78285 1282.13759 320.63412 1285.61554 318.59859 1285.61554 308.74732 1282.13759 310.78285"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-185",
    points: "1282.17199 310.78285 1282.17199 320.63412 1267.3692 312.06124 1267.3692 302.24845 1282.17199 310.78285"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-184",
    points: "1267.3692 302.24845 1282.17199 310.78285 1285.61554 308.74732 1270.74568 300.17422 1267.3692 302.24845"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "1210.32095 314.52912 1210.32095 325.03377 1228.96162 314.2138 1228.96162 303.70938 1210.32095 314.52912"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-181",
    points: "1210.33896 314.52912 1210.33896 325.03377 1206.35234 322.81346 1206.35234 312.3293 1210.33896 314.52912"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-182",
    points: "1206.35234 312.3293 1210.33896 314.52912 1228.96162 303.70938 1224.93986 301.48885 1206.35234 312.3293"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-507",
    points: "1210.32095 314.0369 1210.32095 316.49893 1228.96162 305.67896 1228.96162 303.21693 1210.32095 314.0369"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-192",
    points: "1210.33896 314.0369 1210.33896 316.49893 1206.35234 314.27862 1206.35234 311.83685 1210.33896 314.0369"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-193",
    points: "1206.35234 311.83685 1210.33896 314.0369 1228.96162 303.21693 1224.93986 300.99662 1206.35234 311.83685"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "1266.10521 351.25791 1266.10521 353.37424 1281.26969 344.67802 1281.26969 342.5617 1266.10521 351.25791"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "1266.11579 351.25791 1266.11579 353.37424 1216.00169 324.49563 1216.00169 322.39123 1266.11579 351.25791"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-105",
    points: "1216.00169 322.39123 1266.11579 351.25791 1281.26969 342.5617 1231.13511 313.68309 1216.00169 322.39123"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-417",
    points: "1271.9525 337.1947 1231.13511 313.68309 1216.00169 322.39123 1256.79838 345.89114 1271.9525 337.1947"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-509",
    points: "1227.24367 230.29073 1227.24367 248.63206 1229.75386 247.26589 1229.75386 228.92456 1227.24367 230.29073"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-219",
    points: "1227.2781 230.29073 1227.2781 248.63206 1221.27146 245.30306 1221.27146 227.00045 1227.2781 230.29073"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-220",
    points: "1221.27146 227.00045 1227.2781 230.29073 1229.75386 228.92456 1223.6804 225.59556 1221.27146 227.00045"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "1269.90213 348.99777 1269.90213 359.50242 1288.54305 348.68245 1288.54305 338.1778 1269.90213 348.99777"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "1269.92036 348.99777 1269.92036 359.50242 1265.93371 357.28189 1265.93371 346.79772 1269.92036 348.99777"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1265.93371 346.79772 1269.92036 348.99777 1288.54305 338.1778 1284.52126 335.95749 1265.93371 346.79772"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-189",
    points: "1269.90213 348.25909 1269.90213 350.72112 1288.54305 339.90115 1288.54305 337.43912 1269.90213 348.25909"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-194",
    points: "1269.92036 348.25909 1269.92036 350.72112 1265.93371 348.50082 1265.93371 346.05904 1269.92036 348.25909"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-195",
    points: "1265.93371 346.05904 1269.92036 348.25909 1288.54305 337.43912 1284.52126 335.21882 1265.93371 346.05904"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M1224.68981,217.63487h-2.65176v86.89331h.00045c0,.0036-.00045.0072-.00045.0072,0,.42988.59354.77559,1.32588.77559.73215,0,1.32588-.34571,1.32588-.77199,0,0-.00045-.0072-.00045-.0108h.00045v-86.89331Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-508",
    d: "M1246.3365,269.82703h-1.94524v4.78812h.00019l-.00019.00788c0,.31285.43525.5665.97249.5665s.97275-.25365.97275-.5665l-.00023-.00788h.00023v-4.78812Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M1247.89735,258.21685h-5.06698v12.4713h.0009s-.0009.0135-.0009.02026c0,.81475,1.13412,1.47533,2.53338,1.47533s2.5336-.66058,2.5336-1.47533c0-.00675-.00068-.0135-.00068-.0135l.00068-.00675v-12.4713Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-224",
    points: "1221.96377 233.47613 1221.96377 251.81746 1229.75386 247.26589 1229.75386 228.92456 1221.96377 233.47613"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-223",
    points: "1221.99821 233.47613 1221.99821 251.81746 1219.40184 250.25863 1219.40184 231.95602 1221.99821 233.47613"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "1219.40184 231.95602 1221.99821 233.47613 1229.75386 228.92456 1227.09062 227.36573 1219.40184 231.95602"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "1277.84819 247.65391 1277.84819 255.26372 1284.48525 251.44204 1284.48525 243.83223 1277.84819 247.65391"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "1277.86619 247.65391 1277.86619 255.26372 1214.36094 218.91259 1214.36094 211.32304 1277.86619 247.65391"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-104",
    points: "1214.36094 211.32304 1277.86619 247.65391 1284.48525 243.83223 1220.94488 207.48111 1214.36094 211.32304"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-188",
    points: "1250.0049 249.65432 1250.0049 251.02026 1225.53877 237.06778 1225.53877 235.70207 1250.0049 249.65432"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "1250.00175 249.65432 1250.00175 251.02026 1251.36589 250.20506 1251.36589 248.84295 1250.00175 249.65432"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-144",
    points: "1251.36589 248.84295 1250.00175 249.65432 1225.53877 235.70207 1226.90921 234.88687 1251.36589 248.84295"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "1250.0049 257.37374 1250.0049 258.73946 1225.53877 244.7872 1225.53877 243.42126 1250.0049 257.37374"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-146",
    points: "1250.00175 257.37374 1250.00175 258.73946 1251.36589 257.92426 1251.36589 256.56214 1250.00175 257.37374"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "1251.36589 256.56214 1250.00175 257.37374 1225.53877 243.42126 1226.90921 242.60606 1251.36589 256.56214"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "1224.13186 350.51406 1224.13186 352.63016 1284.73845 317.39312 1284.73845 315.2768 1224.13186 350.51406"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "1207.35274 340.85882 1224.14244 350.51406 1284.73845 315.2768 1267.92849 305.60986 1207.35274 340.85882"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-417",
    points: "1233.82288 344.88463 1284.73845 315.2768 1267.92849 305.60963 1217.03003 335.2276 1233.82288 344.88463"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "1214.04449 342.54909 1214.04449 343.99336 1274.70105 308.9931 1274.70105 307.54883 1214.04449 342.54909"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "1214.04787 342.54909 1214.04787 343.99336 1212.6054 343.13135 1212.6054 341.6909 1214.04787 342.54909"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-151",
    points: "1212.6054 341.6909 1214.04787 342.54909 1274.70105 307.54883 1273.25186 306.68682 1212.6054 341.6909"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "1219.64083 345.78153 1219.64083 347.2258 1280.29761 312.22554 1280.29761 310.78127 1219.64083 345.78153"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-143",
    points: "1219.64443 345.78153 1219.64443 347.2258 1218.20197 346.36379 1218.20197 344.92334 1219.64443 345.78153"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "1218.20197 344.92334 1219.64443 345.78153 1280.29761 310.78127 1278.84839 309.91926 1218.20197 344.92334"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "1245.73871 346.10473 1245.73871 348.22106 1281.63497 327.36976 1281.63497 325.25344 1245.73871 346.10473"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-117",
    points: "1245.74929 346.10473 1245.74929 348.22106 1208.76283 327.04949 1208.76283 324.94509 1245.74929 346.10473"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "1208.76283 324.94509 1245.74929 346.10473 1281.63497 325.25344 1244.628 304.08187 1208.76283 324.94509"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "1245.73871 344.1984 1245.73871 346.31472 1281.63497 325.46343 1281.63497 323.3471 1245.73871 344.1984"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-226",
    points: "1245.74929 344.1984 1245.74929 346.31472 1208.76283 325.14315 1208.76283 323.03876 1245.74929 344.1984"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-225",
    points: "1208.76283 323.03876 1245.74929 344.1984 1281.63497 323.3471 1244.628 302.17553 1208.76283 323.03876"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-271",
    points: "1208.76283 323.03876 1245.74929 344.1984 1281.63497 323.3471 1245.87446 343.41718 1208.76283 323.03876"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "1254.96767 254.39225 1254.96767 268.88782 1263.27317 263.92527 1263.27317 249.42948 1254.96767 254.39225"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "1255.0021 254.39225 1255.0021 268.88782 1240.19954 260.31472 1240.19954 245.85786 1255.0021 254.39225"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "1240.19954 245.85786 1255.0021 254.39225 1263.27317 249.42948 1248.40353 240.85637 1240.19954 245.85786"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "1221.29149 347.00591 1221.29149 356.85718 1224.76926 354.82166 1224.76926 344.97038 1221.29149 347.00591"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "1221.32593 347.00591 1221.32593 356.85718 1206.52313 348.28408 1206.52313 338.47152 1221.32593 347.00591"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "1206.52313 338.47152 1221.32593 347.00591 1224.76948 344.97038 1209.89962 336.39728 1206.52313 338.47152"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "1221.29149 345.15944 1221.29149 347.87085 1224.76926 345.8351 1224.76926 343.12369 1221.29149 345.15944"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "1221.32593 345.15944 1221.32593 347.87085 1206.52313 339.29774 1206.52313 336.62505 1221.32593 345.15944"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "1206.52313 336.62505 1221.32593 345.15944 1224.76948 343.12369 1209.89962 334.55081 1206.52313 336.62505"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "1282.13759 308.35188 1282.13759 311.06328 1285.61554 309.02776 1285.61554 306.31635 1282.13759 308.35188"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "1282.17199 308.35188 1282.17199 311.06328 1267.3692 302.49018 1267.3692 299.81748 1282.17199 308.35188"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "1267.3692 299.81748 1282.17199 308.35188 1285.61554 306.31635 1270.74568 297.74325 1267.3692 299.81748"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "1284.93471 270.01407 1284.93471 271.37978 1258.39525 256.07712 1258.39525 254.7114 1284.93471 270.01407"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "1284.93156 270.01407 1284.93156 271.37978 1286.2957 270.56458 1286.2957 269.20247 1284.93156 270.01407"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "1286.2957 269.20247 1284.93156 270.01407 1258.39525 254.7114 1259.76572 253.8962 1286.2957 269.20247"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "1284.93471 277.73326 1284.93471 279.09898 1258.39525 263.79653 1258.39525 262.43059 1284.93471 277.73326"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "1284.93156 277.73326 1284.93156 279.09898 1286.2957 278.284 1286.2957 276.92166 1284.93156 277.73326"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "1286.2957 276.92166 1284.93156 277.73326 1258.39525 262.43059 1259.76572 261.61539 1286.2957 276.92166"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-155",
    points: "1245.47223 262.72543 1245.47223 270.33524 1252.10929 266.51379 1252.10929 258.90398 1245.47223 262.72543"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-156",
    points: "1245.49024 262.72543 1245.49024 270.33524 1237.71928 265.83453 1237.71928 258.24521 1245.49024 262.72543"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "1237.71928 258.24521 1245.49024 262.72543 1252.10929 258.90376 1244.30322 254.40328 1237.71928 258.24521"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "1245.47223 262.35609 1245.47223 265.21829 1252.10929 261.39662 1252.10929 258.53464 1245.47223 262.35609"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "1245.49024 262.35609 1245.49024 265.21829 1237.71928 260.71759 1237.71928 257.87587 1245.49024 262.35609"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "1237.71928 257.87587 1245.49024 262.35609 1252.10929 258.53464 1244.30322 254.03394 1237.71928 257.87587"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "1278.51934 250.10581 1278.51934 358.63905 1291.33995 350.96735 1291.33995 242.43411 1278.51934 250.10581"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "1278.53735 250.10581 1278.53735 358.63905 1275.19421 356.69581 1275.19421 248.18282 1278.53735 250.10581"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "1275.19421 248.18282 1278.53735 250.10581 1291.33995 242.43411 1287.96166 240.49086 1275.19421 248.18282"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M1212.48656,344.82949c0,.6383-.45081.8951-1.00673.57415-.55615-.32117-1.00696-1.09856-1.00696-1.73686,0-.63807.45081-.8951,1.00696-.57393.55592.32095,1.00673,1.09856,1.00673,1.73663Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M1217.36966,347.6199c0,.63807-.45081.8951-1.00696.57415-.55592-.32117-1.00673-1.09879-1.00673-1.73686s.45081-.8951,1.00673-.57415c.55615.32117,1.00696,1.09879,1.00696,1.73686Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M1286.2912,250.37949c0,.63807.45081.8951,1.00696.57415.55618-.32117,1.00696-1.09879,1.00696-1.73686s-.45078-.8951-1.00696-.57415c-.55615.32117-1.00696,1.09879-1.00696,1.73686Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M1282.29037,252.73889c0,.63807.45081.8951,1.00696.57415.55615-.32117,1.00696-1.09879,1.00696-1.73686s-.45081-.8951-1.00696-.57393c-.55615.32095-1.00696,1.09856-1.00696,1.73663Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M1286.2912,255.2214c0,.6383.45081.8951,1.00696.57415.55618-.32117,1.00696-1.09856,1.00696-1.73686,0-.63807-.45078-.8951-1.00696-.57393-.55615.32095-1.00696,1.09856-1.00696,1.73663Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M1282.29037,257.58103c0,.63807.45081.8951,1.00696.57393.55615-.32095,1.00696-1.09856,1.00696-1.73663,0-.6383-.45081-.89532-1.00696-.57415-.55615.32095-1.00696,1.09856-1.00696,1.73686Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M1286.2912,344.81914c0,.63807.45081.8951,1.00696.57415.55618-.32117,1.00696-1.09879,1.00696-1.73686s-.45078-.8951-1.00696-.57393c-.55615.32095-1.00696,1.09856-1.00696,1.73663Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M1282.29037,347.17854c0,.6383.45081.89532,1.00696.57415.55615-.32095,1.00696-1.09856,1.00696-1.73663,0-.6383-.45081-.89532-1.00696-.57415-.55615.32095-1.00696,1.09856-1.00696,1.73663Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M1286.2912,349.66127c0,.63807.45081.8951,1.00696.57393.55618-.32095,1.00696-1.09856,1.00696-1.73663,0-.6383-.45078-.8951-1.00696-.57415-.55615.32117-1.00696,1.09856-1.00696,1.73686Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M1282.29037,352.02067c0,.63807.45081.8951,1.00696.57415.55615-.32117,1.00696-1.09879,1.00696-1.73686s-.45081-.8951-1.00696-.57415c-.55615.32117-1.00696,1.09879-1.00696,1.73686Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-285",
    points: "1291.33995 242.43411 1278.57854 249.61336 1275.19421 248.18282 1278.12705 250.39322 1278.49639 355.48111 1278.86572 250.35203 1291.33995 242.43411"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "1263.27317 249.42948 1255.10699 253.97902 1240.19954 245.85786 1254.65572 254.75866 1255.02484 268.83335 1255.39418 254.7177 1263.27317 249.42948"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-284",
    points: "1252.10929 258.53464 1245.58702 261.85756 1237.71928 257.87587 1245.13575 262.6372 1245.50509 270.33524 1245.87446 262.59624 1252.10929 258.53464"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-273",
    points: "1224.7418 343.21192 1221.33605 344.7712 1206.68698 336.64643 1220.88456 345.55084 1221.33605 356.58912 1221.62327 345.50987 1224.7418 343.21192"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-272",
    points: "1224.5982 204.27252 1211.83656 211.45178 1208.45243 210.02124 1211.3853 212.23142 1211.75464 317.31953 1212.12398 212.19045 1224.5982 204.27252"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M1328.57402,893.94529l-91.34022,52.12216c-15.58851,8.8954-34.7268,8.84904-50.2721-.12131l-21.32079-12.30317c-2.16246-1.24778-2.16539-4.36791-.00495-5.61975l114.23919-66.18875c1.00879-.58428,2.25342-.58293,3.2608.00383l45.46305,26.48342c2.16044,1.25859,2.14648,4.38434-.02498,5.62358Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-532",
    d: "M1324.80907,885.72914l-10.82421-6.15699,4.86348-6.36945s7.94471,7.69263,7.69263,8.32305c-.2523.63064-1.73191,4.20339-1.73191,4.20339Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-532",
    d: "M1245.1655,931.54037l-16.35873-9.5337s11.22374-5.80093,11.72812-5.80093,7.31429,4.4136,7.31429,4.4136l-2.68369,10.92103Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-358",
    d: "M1220.03335,937.64942c0,2.92815,1.01056,5.00216,2.65334,6.00619.04929.03016,5.18942,3.00512,5.24006,3.03348,1.70898.95564.61601-1.21312,3.21174-2.71163,5.22385-3.01615,9.45898-10.32054,9.45898-16.31525,0-2.96416,2.74022-2.98802,1.06165-3.97787-.04659-.02746-5.51599-3.05441-5.56371-3.08029-1.70467-.92301-4.03414-.75308-6.60308.73012-5.22408,3.01615-9.45898,10.32054-9.45898,16.31525Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "M1225.51131,940.75875c0,5.99449,4.23512,8.40903,9.45898,5.39288,5.22408-3.01615,9.45898-10.32054,9.45898-16.31525s-4.2349-8.40903-9.45898-5.39288c-5.22385,3.01615-9.45898,10.32077-9.45898,16.31525Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-449",
    d: "M1234.51655,924.21662c2.50412-1.44584,4.77934-1.64075,6.47141-.79472-1.57728-.44114-3.53426-.11163-5.65441,1.11229-5.22408,3.01615-9.45898,10.32077-9.45898,16.31525,0,3.12103,1.14965,5.26864,2.98734,6.1876-2.30921-.64595-3.80434-2.94345-3.80434-6.5054,0-5.99449,4.2349-13.2991,9.45898-16.31503Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1227.37195,939.65906c0,4.61639,3.26125,6.47569,7.28436,4.15297,4.02311-2.32271,7.28436-7.94786,7.28436-12.56448s-3.26125-6.47591-7.28436-4.1532-7.28436,7.94809-7.28436,12.5647ZM1232.18078,936.74712c-.00203.04591-.00293.0916-.00293.13707s.0009.09025.00293.13392c.0108.25095-.11205.56222-.30632.80305l-2.25992,2.80188c-.33873.41998-.77604.47355-.87889.09993-.13999-.50911-.21517-1.08618-.21517-1.72718,0-.64077.07517-1.30473.21517-1.97543.10286-.49245.54017-.94394.87889-.91513l2.25992.19243c.19427.01666.31712.18613.30632.44946ZM1230.30123,933.0103c.75668-1.31193,1.7121-2.51155,2.7823-3.45413.38194-.33648.75668-.22327.75668.23025v2.98622c0,.26063-.12109.57595-.32275.81227-.06906.08102-.13617.16453-.20121.25005-.18816.2478-.43052.38622-.62457.36979l-2.25902-.19243c-.33895-.02881-.40692-.52396-.13144-1.00201ZM1236.22932,927.73985c1.0702-.29304,2.0254-.19649,2.78208.24172.27571.1598.20751.7335-.13144,1.1537l-2.25902,2.80076c-.19378.2406-.43618.38194-.62434.35156-.06504-.01058-.13234-.01643-.20121-.01778-.20166-.0036-.32297-.17893-.32297-.43933v-2.98644c0-.45351.37474-.99953.75691-1.10419ZM1240.57698,930.18365c.14022.50911.21517,1.08618.21517,1.72718,0,.64077-.07495,1.30473-.21517,1.97543-.10286.49245-.54017.94394-.87889.91491l-2.25969-.19243c-.19423-.01643-.31735-.18591-.30632-.44924.0018-.04591.0027-.09183.0027-.13729,0-.04524-.0009-.09003-.0027-.13369-.01103-.25095.11208-.56222.30632-.80305l2.25969-2.80188c.33873-.41998.77604-.47355.87889-.09993ZM1239.0114,937.89632c-.75668,1.31193-1.71188,2.51132-2.78208,3.45391-.38217.3367-.75691.22349-.75691-.23002v-2.98644c0-.26063.12131-.57595.32297-.81227.06887-.0808.13617-.1643.20099-.25005.18838-.2478.43056-.38599.62457-.36956l2.25902.19243c.33895.02881.40715.52396.13144,1.00201ZM1233.08353,943.16654c-1.0702.29326-2.02562.19671-2.78208-.2415-.27571-.1598-.20751-.7335.13144-1.1537l2.25879-2.80098c.19404-.24037.43641-.38194.62457-.35133.06504.01058.13215.01643.20121.01778.20166.00338.32275.1787.32275.43933v2.98644c0,.45351-.37474.99931-.75668,1.10396Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-362",
    d: "M1227.82569,939.84047c0,4.61662,3.26148,6.47591,7.28458,4.1532,4.02311-2.32271,7.28436-7.94809,7.28436-12.56448s-3.26125-6.47591-7.28436-4.1532-7.28458,7.94809-7.28458,12.56448ZM1232.63452,936.92875c-.0018.04591-.0027.0916-.0027.13707s.0009.09003.0027.13392c.0108.25073-.11208.56222-.30632.80305l-2.25969,2.80188c-.33873.41975-.77604.47332-.87889.09971-.14022-.50888-.21517-1.08618-.21517-1.72695,0-.641.07495-1.30473.21517-1.97566.10286-.49223.54017-.94371.87889-.91491l2.25969.19243c.19423.01666.31712.18591.30632.44946ZM1230.75519,933.19193c.75668-1.31193,1.71191-2.51155,2.78208-3.45413.38217-.33648.75691-.22349.75691.23002v2.98644c0,.26063-.12131.57595-.32275.81227-.0691.08102-.13617.1643-.20118.25005-.18842.2478-.43059.38622-.6246.36956l-2.25902-.19243c-.33895-.02881-.40715-.52374-.13144-1.00178ZM1236.68329,927.92148c1.0702-.29304,2.0254-.19671,2.78208.24172.27548.15957.20751.7335-.13141,1.1537l-2.25905,2.80076c-.19401.24037-.43641.38194-.62457.35156-.06504-.01058-.13212-.01666-.20121-.01778-.20144-.0036-.32272-.17893-.32272-.43956v-2.98644c0-.45351.37471-.99931.75687-1.10396ZM1241.03098,930.36528c.13996.50888.21513,1.08618.21513,1.72695,0,.641-.07517,1.30495-.21513,1.97566-.10289.49245-.54017.94371-.87893.91491l-2.25992-.19243c-.19423-.01643-.31712-.18591-.30632-.44924.00203-.04614.00293-.09183.00293-.13729s-.0009-.09003-.00293-.13392c-.0108-.25073.11208-.562.30632-.80282l2.25992-2.80188c.33876-.41998.77604-.47355.87893-.09993ZM1239.46536,938.07773c-.75668,1.31193-1.71188,2.51155-2.78208,3.45413-.38217.33648-.75687.22349-.75687-.23002v-2.98644c0-.26063.12128-.57595.32272-.81227.0691-.08102.13617-.1643.20121-.25005.18816-.2478.43056-.38599.62457-.36956l2.25905.19243c.33892.02881.40689.52396.13141,1.00178ZM1233.53727,943.34817c-1.07017.29304-2.0254.19671-2.78208-.24172-.27545-.15957-.20751-.73327.13144-1.1537l2.25902-2.80076c.19401-.24037.43618-.38194.6246-.35133.06501.01035.13208.01643.20118.01756.20144.0036.32275.17893.32275.43956v2.98644c0,.45351-.37474.99931-.75691,1.10396Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-363",
    d: "M1299.50185,893.00495c0,2.92815,1.01056,5.00216,2.65311,6.00619.04929.03016,5.18964,3.00535,5.24006,3.03348,1.70917.95564.61624-1.2129,3.21174-2.71141,5.22408-3.01615,9.45898-10.32077,9.45898-16.31525,0-2.96416,2.74044-2.98824,1.06188-3.97787-.04681-.02768-5.51599-3.05441-5.56371-3.08029-1.70467-.92323-4.03436-.75308-6.60308.7299-5.22408,3.01615-9.45898,10.32077-9.45898,16.31525Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-364",
    d: "M1304.97984,896.11428c0,5.99449,4.23486,8.40903,9.45894,5.3931,5.22408-3.01615,9.45898-10.32077,9.45898-16.31525s-4.2349-8.40903-9.45898-5.3931c-5.22408,3.01615-9.45894,10.32077-9.45894,16.31525Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-448",
    d: "M1313.98486,879.57215c2.50431-1.44584,4.77953-1.64075,6.4716-.79449-1.57728-.44114-3.53445-.11186-5.6546,1.11229-5.22385,3.01615-9.45879,10.32054-9.45879,16.31525,0,3.12081,1.14943,5.26842,2.98734,6.18737-2.30921-.64572-3.80434-2.94345-3.80434-6.50517,0-5.99449,4.23493-13.2991,9.45879-16.31525Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1306.84046,895.01459c0,4.61639,3.26125,6.47591,7.28436,4.1532s7.28436-7.94809,7.28436-12.56448-3.26125-6.47591-7.28436-4.1532c-4.02311,2.32271-7.28436,7.94809-7.28436,12.56448ZM1311.64906,892.10265c-.0018.04614-.00267.09183-.00267.13729s.00087.09003.00267.13392c.01103.25073-.11208.56222-.30632.80305l-2.25969,2.80166c-.33873.41998-.77604.47355-.87889.09993-.14022-.50888-.21513-1.08618-.21513-1.72695,0-.641.07491-1.30495.21513-1.97566.10286-.49245.54017-.94371.87889-.91491l2.25969.19243c.19446.01643.31735.18591.30632.44924ZM1309.76973,888.36605c.75668-1.31193,1.71188-2.51155,2.78208-3.45413.38217-.3367.75691-.22349.75691.23002v2.98644c0,.26063-.12131.57595-.32275.81227-.0691.0808-.13617.1643-.20121.25005-.18838.2478-.43056.38599-.62457.36956l-2.25902-.19243c-.33892-.02881-.40692-.52396-.13144-1.00178ZM1315.69782,883.09561c1.0702-.29304,2.02543-.19671,2.78208.24172.27548.15957.20751.73327-.13144,1.1537l-2.25902,2.80076c-.19401.24037-.43641.38194-.62457.35133-.06504-.01035-.13212-.01643-.20121-.01756-.20144-.0036-.32275-.17893-.32275-.43956v-2.98644c0-.45351.37474-.99931.75691-1.10396ZM1320.04548,885.53941c.14003.50888.21517,1.08618.21517,1.72695s-.07514,1.30473-.21517,1.97566c-.10286.49223-.54017.94371-.87889.91491l-2.25992-.19243c-.19423-.01666-.31712-.18613-.30632-.44946.00206-.04591.00293-.0916.00293-.13707s-.00087-.09003-.00293-.13392c-.0108-.25073.11208-.56222.30632-.80305l2.25992-2.80166c.33873-.41998.77604-.47355.87889-.09993ZM1318.4799,893.25185c-.75665,1.31193-1.71188,2.51155-2.78208,3.45413-.38217.33648-.75691.22327-.75691-.23025v-2.98644c0-.2604.12131-.57573.32275-.81205.0691-.08102.13617-.16453.20121-.25005.18816-.2478.43056-.38622.62457-.36956l2.25902.19221c.33895.02903.40692.52396.13144,1.00201ZM1312.55181,898.52229c-1.0702.29304-2.0254.19671-2.78208-.24172-.27548-.15957-.20748-.7335.13144-1.1537l2.25902-2.80076c.19401-.24037.43641-.38194.62457-.35156.06504.01058.13212.01666.20121.01778.20144.0036.32275.17893.32275.43956v2.98622c0,.45351-.37474.99953-.75691,1.10419Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-366",
    d: "M1307.29419,895.19622c0,4.61639,3.26148,6.47591,7.28458,4.15297,4.02288-2.32271,7.28436-7.94786,7.28436-12.56448s-3.26148-6.47591-7.28436-4.1532c-4.02311,2.32294-7.28458,7.94809-7.28458,12.5647ZM1312.10302,892.28428c-.0018.04591-.00293.09183-.00293.13707,0,.04546.00113.09025.00293.13392.0108.25095-.11208.56222-.30632.80305l-2.25969,2.80188c-.33873.41998-.776.47355-.87889.09993-.14018-.50911-.21517-1.08618-.21517-1.72718,0-.64077.07498-1.30473.21517-1.97543.10289-.49245.54017-.94394.87889-.91513l2.25969.19243c.19423.01666.31712.18613.30632.44946ZM1310.22369,888.54746c.75649-1.31193,1.71188-2.51155,2.78211-3.45413.38213-.33648.75687-.22327.75687.23025v2.98622c0,.26063-.12131.57595-.32297.81227-.06887.08102-.13617.16453-.20121.25005-.18816.2478-.43056.38622-.62431.36979l-2.25905-.19243c-.33895-.02881-.40715-.52396-.13144-1.00201ZM1316.15156,883.27724c1.0702-.29326,2.02562-.19671,2.78208.2415.27571.1598.20755.7335-.13144,1.1537l-2.25902,2.80098c-.19378.24037-.43618.38194-.62434.35133-.06504-.01058-.13212-.01643-.20121-.01778-.20166-.00338-.32275-.1787-.32275-.43933v-2.98644c0-.45351.37477-.99931.75668-1.10396ZM1320.49945,885.72081c.13999.50911.21517,1.08618.21517,1.72718,0,.64077-.07517,1.30473-.21517,1.97543-.10286.49245-.54039.94394-.87912.91491l-2.25969-.19243c-.19423-.01643-.31709-.18591-.30632-.44924.00203-.04591.00293-.09183.00293-.13707,0-.04546-.0009-.09025-.00293-.13392-.01077-.25095.11208-.56222.30632-.80305l2.25995-2.80188c.33847-.41998.776-.47355.87886-.09993ZM1318.93364,893.43348c-.75646,1.31193-1.71188,2.51132-2.78208,3.45391-.38191.3367-.75668.22349-.75668-.23002v-2.98644c0-.26063.12109-.57595.32275-.81227.0691-.0808.13617-.1643.20121-.24983.18816-.2478.43056-.38622.62434-.36979l2.25902.19243c.33899.02881.40715.52396.13144,1.00201ZM1313.00581,898.7037c-1.07024.29326-2.02543.19671-2.78211-.2415-.27571-.1598-.20751-.7335.13144-1.1537l2.25905-2.80076c.19375-.2406.43615-.38194.62431-.35156.06504.01058.13234.01643.20121.01778.20166.00338.32297.1787.32297.43933v2.98644c0,.45351-.37474.99931-.75687,1.10396Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-428",
    d: "M1203.96342,870.17597s-1.93829-5.3922-3.81605-3.20161c-1.87753,2.19037-.99773,10.26382-.99773,10.26382l4.81378-7.06222Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-376",
    d: "M1166.3832,905.73868c3.0265-5.67489,34.61607-33.52651,51.32613-46.66019,16.70999-13.13368,39.54595-22.9692,44.93658-24.80126,5.39085-1.83206,20.20872-2.99837,27.70195-2.81651,8.65931.21021,34.25011,16.89121,37.62232,19.71492,0,0,4.7922,18.91638,4.7922,20.93412,0,1.93739-3.96418,10.37951-7.9533,13.61938.01823-.30834.03087-.61511.03087-.91828,0-6.96431-4.92001-9.76957-10.98948-6.26547-6.06921,3.5041-10.98945,11.99055-10.98945,18.95509,0,.38239.01733.7497.04636,1.10666-16.8014,9.64826-40.15254,22.94241-57.74188,32.93323.2822-1.27952.43638-2.54756.43638-3.76856,0-6.96431-4.92023-9.76957-10.98945-6.26547-6.06944,3.5041-10.98945,11.99055-10.98945,18.95509,0,1.142.13459,2.16989.38262,3.07872-1.35064.76366-2.36525,1.33646-2.98551,1.68532-8.91862,5.01409-27.10397-2.32969-44.67444-12.12132-17.14486-9.55463-12.98918-21.69058-9.96246-27.36547Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-368",
    d: "M1237.63443,906.6214c8.07098-8.19701,13.49401-21.4394,20.42952-32.0316,6.93573-10.5922,32.0316-21.06016,37.20211-21.81662,4.73365-.69276,23.60074.11028,32.63614-1.65291.02228.01823.04749.03826.06797.05537,0,0,4.7922,18.91638,4.7922,20.93412,0,1.93739-3.96418,10.37951-7.9533,13.61938.01823-.30834.03087-.61511.03087-.91828,0-6.96431-4.92001-9.76957-10.98948-6.26547-6.06921,3.5041-10.98945,11.99055-10.98945,18.95509,0,.38239.01733.7497.04636,1.10666-16.8014,9.64826-40.15254,22.94241-57.74188,32.93323.2822-1.27952.43638-2.54756.43638-3.76856,0-6.96431-4.92023-9.76957-10.98945-6.26547-6.06944,3.5041-10.98945,11.99055-10.98945,18.95509,0,1.142.13459,2.16989.38262,3.07872-1.35064.76366-2.36525,1.33646-2.98551,1.68532-2.58945,1.45575-5.96391,1.86402-9.87404,1.47893-.46072-5.18402-.6554-12.66869,1.64503-15.36569,3.65715-4.28779,16.77237-16.52029,24.84335-24.71731Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-451",
    d: "M1211.54082,930.75668c3.65715-4.28779,16.77237-16.52029,24.84335-24.71731,8.07098-8.19701,14.48994-22.13239,21.42545-32.72459,6.9355-10.5922,31.03567-20.36695,36.20618-21.12363,4.73343-.69276,23.60074.11028,32.63614-1.65291.02206.01823-25.1751,1.36482-29.44147,1.98916-5.17054.75668-30.36342,10.27913-37.29892,20.87155-6.93573,10.5922-12.35877,23.83436-20.42974,32.03138-8.07098,8.19701-21.08919,21.37503-24.74634,25.6626-2.2696,2.66099-2.1098,9.97799-1.66255,15.1521-1.01442.02386-2.07157-.01373-3.17711-.12266-.46094-5.18402-.6554-12.66869,1.64503-15.36569Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-503",
    d: "M1296.1909,850.04084l-26.65091-15.17506s11.85416-3.48902,23.45602.4202c11.60208,3.90945,21.98497,11.77021,21.48059,13.78795-.5046,2.01774-15.38527,1.72335-18.2857.9669Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-408",
    d: "M1289.11829,835.21487c-2.81018-.94687-5.6337-1.49648-8.32755-1.77985,3.71116-.01418,7.97375.42516,12.20527,1.85097,11.60208,3.90945,21.98497,11.77021,21.48059,13.78795-.10106.40377-.78392.71347-1.82486.94687-.36596-2.5955-11.33088-10.69416-23.53344-14.80594Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-408",
    d: "M1252.66029,875.80112c-.94577-3.84643-26.88-17.73139-29.40215-17.85765-2.52212-.12604-27.99611,19.67306-27.11339,24.465.88272,4.79217,29.63555,23.33021,39.17102,19.4714,10.56497-4.27564,18.14462-22.82493,17.34453-26.07875Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M1251.59186,876.14503c-.91963-3.7393-26.13232-17.23826-28.58422-17.3607-2.45213-.12266-27.21715,19.12547-26.35896,23.7844.85819,4.6587,28.81086,22.68088,38.08101,18.92943,10.27103-4.15658,17.64001-22.18978,16.86217-25.35313Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-408",
    d: "M1200.15503,876.00593c-.53634.92841-.79314,1.70827-.68755,2.28175.90565,4.91663,29.71966,23.59556,40.41607,20.71175-1.42424,1.22685-2.94795,2.22481-4.56778,2.88021-9.53547,3.85903-38.28829-14.679-39.17102-19.47117-.23632-1.28244,1.41613-3.64004,4.01028-6.40254Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-408",
    d: "M1247.47084,902.71195l67.88847-39.55588s-15.17505-9.87851-26.77714-5.84302c-11.60186,4.03549-29.00487,16.26799-32.15764,23.58228-3.15254,7.31429-8.9537,21.81662-8.9537,21.81662Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-504",
    d: "M1249.31731,901.19881l64.19554-37.40445s-14.3495-9.34104-25.32049-5.52522c-10.97077,3.81605-27.42714,15.38302-30.4084,22.29962-2.98126,6.91637-8.46665,20.63005-8.46665,20.63005Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-532",
    d: "M1200.13818,927.93364s-3.50998,6.36855-5.29658,6.43157-6.46286-1.58449-15.79489-7.0073c-5.965-3.46629-8.60709-5.85562-9.19565-7.74733-.58833-1.89171.90388-8.57536.90388-8.57536,0,0,3.53111,4.16153,13.11525,9.58412,7.58209,4.29004,16.26799,7.31429,16.26799,7.31429Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-452",
    d: "M1170.75494,911.03523s.18006.21156.56515.59868c-.39792,2.02135-1.07943,5.9632-.64932,7.34603.58856,1.89171,3.23064,4.28126,9.19565,7.74755,9.33204,5.42259,14.0083,7.07032,15.79489,7.0073.16205-.00585.33873-.06482.52531-.16475-.49354.47355-.95944.78166-1.34501.79517-1.7866.06302-6.46286-1.58449-15.79489-7.0073-5.965-3.46629-8.60709-5.85562-9.19565-7.74733-.58833-1.89171.90388-8.57536.90388-8.57536Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-365",
    d: "M1202.61844,928.35407l-4.5399,7.14617s5.71675,1.34524,9.50016,1.13502c3.78319-.21021,6.80969-2.73234,7.9868-4.75008,1.17689-2.01774,1.42919-5.71698,1.42919-5.71698,0,0-4.62401,2.10192-8.15493,2.6063-3.53111.50438-6.22133-.42043-6.22133-.42043Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1202.61844,928.35407l-4.5399,7.14617s6.55559-.86201,11.64282-3.45751c5.08746-2.59572,7.27333-5.87453,7.27333-5.87453,0,0-4.62401,2.10192-8.15493,2.6063-3.53111.50438-6.22133-.42043-6.22133-.42043Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-361",
    d: "M1169.18238,910.56011l-.87552,7.91545s-4.28776-3.44693-4.54009-6.30531c-.25208-2.8586,2.04903-5.9587,2.04903-5.9587,0,0,.75421,2.20568,3.36658,4.34856Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1169.18238,910.56011l-.87552,7.91545s-2.09179-4.58196-2.34409-7.44033c-.25208-2.85838-.14697-4.82368-.14697-4.82368,0,0,.75421,2.20568,3.36658,4.34856Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-505",
    d: "M1326.37285,849.57833s2.10169.92481,2.7742,2.10192c.67273,1.17689,1.68149,11.43373,1.68149,11.43373,0,0-5.85607-9.62868-6.30531-10.5931s1.84962-2.94255,1.84962-2.94255Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1202.15049,931.45507l1.79222,3.79286s5.45995-3.37604,4.91821-4.54302-6.71043.75016-6.71043.75016Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1204.52632,934.14689c0,.95609-.67566,1.34119-1.50886.86021-.83321-.4812-1.50861-1.64615-1.50861-2.60247,0-.95609.6754-1.34119,1.50861-.85999.83321.48097,1.50886,1.64615,1.50886,2.60225Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1206.39102,931.34906l1.80753,3.8255s5.5068-3.40507,4.9603-4.58196c-.54647-1.17711-6.76783.75646-6.76783.75646Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1208.7871,934.06384c0,.96442-.68128,1.35289-1.52147.86764-.84041-.48525-1.52169-1.66033-1.52169-2.62453,0-.96442.68128-1.35289,1.52169-.86764.84018.48525,1.52147,1.66033,1.52147,2.62453Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M1209.75088,929.14383l1.59349,3.37221s4.85448-3.00152,4.37283-4.03931c-.48187-1.03757-5.96632.6671-5.96632.6671Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M1211.86312,931.53699c0,.85009-.60048,1.19264-1.34141.76478-.7407-.42763-1.34141-1.46362-1.34141-2.31371s.60071-1.19242,1.34141-.76478c.74093.42786,1.34141,1.46362,1.34141,2.31371Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1165.78046,911.43428l1.59349,3.37221s2.04475-2.32384,1.56291-3.36141c-.48165-1.03757-3.1564-.0108-3.1564-.0108Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M1167.89274,913.82744c0,.85009-.60048,1.19242-1.34141.76478-.74093-.42786-1.34141-1.46362-1.34141-2.31371s.60048-1.19264,1.34141-.76478c.74093.42763,1.34141,1.46362,1.34141,2.31371Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1164.89211,908.5759l1.22595,2.59437s1.77062-1.25994,1.40015-2.05826c-.37066-.79832-2.62611-.53611-2.62611-.53611Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1166.51737,910.41697c0,.65405-.4621.91761-1.03197.58856-.5701-.32905-1.03217-1.12602-1.03217-1.78007s.46207-.91761,1.03217-.58856c.56987.32928,1.03197,1.12625,1.03197,1.78007Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-464",
    points: "1315.18737 863.90667 1246.50192 903.32864 1234.26942 916.19156 1235.53048 917.45285 1246.12358 913.7957 1323.38599 869.61555 1315.18737 863.90667"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-545"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1324.80907,885.72914c.01823-.30834.03087-.61511.03087-.91828,0-4.1604-1.7567-6.8349-4.4645-7.5684,5.10884-2.97451,9.27423-5.40143,12.09769-7.04669.18096.93179.28925,1.61352.28925,1.91399,0,1.93739-3.96418,10.37951-7.9533,13.61938Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1164.72826,921.41474c3.03416,2.8685,7.28079,6.66632,11.57553,9.79771,8.07098,5.88511,28.16379,12.25096,35.64666,8.57558,1.36257-.66936,6.36405-3.48339,13.62928-7.63614-1.23248,2.74944-1.95675,5.64091-1.95675,8.30955,0,1.142.13459,2.16989.38262,3.07872-1.35064.76366-2.36525,1.33646-2.98551,1.68532-8.91862,5.01409-27.10397-2.32969-44.67444-12.12132-6.6132-3.68528-10.05518-7.75475-11.61739-11.68941Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M1245.1655,931.54037c.2822-1.27952.43638-2.54756.43638-3.76856,0-2.64839-.71302-4.69336-1.92884-6.0206,19.61342-11.31692,44.50335-25.77446,63.58043-36.87194-2.66707,3.84058-4.39245,8.49748-4.39245,12.6212,0,.38239.01733.7497.04636,1.10666-16.8014,9.64826-40.15254,22.94241-57.74188,32.93323Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-377",
    d: "M1218.84431,932.59977s-8.19814,4.96322-11.60208,5.04425c-5.29655.12626-15.89524-2.47306-26.57413-9.05655-16.47078-10.15399-17.05933-16.66951-17.05933-16.66951,0,0-1.25769,7.87764-.75668,11.60208.50123,3.72422,3.78682,8.48668,18.15973,16.01569,13.84149,7.25082,25.09562,8.70139,30.5182,8.07098,5.42259-.63064,9.49007-2.38123,9.49007-2.38123l-2.17577-12.6257Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1206.65393,938.73695c-5.29658.12626-15.89553-2.47306-26.57438-9.05655-12.64663-7.79639-15.92679-13.4436-16.76967-15.6477.16385-1.26714.29889-2.11475.29889-2.11475,0,0,.58856,6.51552,17.05933,16.66951,10.67888,6.58349,21.27758,9.18282,26.57413,9.05655,3.40394-.08102,11.60208-5.04425,11.60208-5.04425l.17443,1.01169c-3.61911,1.90228-9.98541,5.069-12.36481,5.1255Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-486",
    d: "M1162.85209,923.52003c-.14449-1.0747-.14224-2.49512-.06636-3.97224,2.95985,2.89169,8.20194,7.78851,13.51807,11.66465,8.07098,5.88511,28.16379,12.25096,35.64666,8.57558.92908-.45644,3.54979-1.90994,7.42525-4.10436l1.64439,9.5418s-4.06748,1.75059-9.49007,2.38123c-5.42259.63042-16.67672-.82015-30.5182-8.07098-14.37291-7.52901-17.6585-12.29147-18.15973-16.01569Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-485",
    d: "M1162.85209,923.52003c-.14449-1.0747-.14224-2.49512-.06636-3.97224,2.95985,2.89169,8.20194,7.78851,13.51807,11.66465,8.07098,5.88511,28.16379,12.25096,35.64666,8.57558.92908-.45644,3.54979-1.90994,7.42525-4.10436l1.64439,9.5418s-4.06748,1.75059-9.49007,2.38123c-5.42259.63042-16.67672-.82015-30.5182-8.07098-14.37291-7.52901-17.6585-12.29147-18.15973-16.01569Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-408",
    d: "M1255.31923,898.139l-7.84838,4.57295s3.23964-8.09843,6.19255-15.24415l1.65583,10.6712Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-408",
    d: "M1295.17333,856.35313c10.04168.20324,20.18599,6.80294,20.18599,6.80294l-13.09831,7.63187c-.30545-1.61194-.72813-3.74943-1.19403-5.82434-.74093-3.30086-4.44846-7.19298-5.89366-8.61047Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-467",
    d: "M1248.99996,872.11562c-18.64967,5.51082-38.18769,5.36137-49.68692,4.81085,6.75005-7.58685,22.02143-19.0791,23.94509-18.983,1.97408.09881,18.29049,8.62645,25.74182,14.17215Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-476",
    d: "M1182.8614,939.28342c-12.69502-6.30531-17.99449-11.66758-18.58305-13.5172-.58856-1.84939.55457-.13594,3.02676,1.76567,3.27877,2.52212,8.31537,5.56371,16.56508,9.90191,13.92431,7.3224,23.03582,6.89409,23.45621,7.73472.42043.84086-5.93234,3.31999-24.465-5.88511Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-466",
    d: "M1192.83219,883.11542s-24.38578,19.3834-20.88416,24.38556c3.50162,5.00238,26.88675,20.50897,36.14091,17.63281,9.25394-2.87616,23.38512-19.50853,23.38512-19.50853,0,0-16.50724-3.87681-27.1368-11.12989-10.62979-7.25307-11.50508-11.37994-11.50508-11.37994Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-453",
    d: "M1202.61844,928.35407s2.33303,6.81554,10.6329,3.76923c2.19285-.80485,3.74335-5.9551,3.74335-5.9551,0,0-4.62401,2.10192-8.15493,2.6063-3.53111.50438-6.22133-.42043-6.22133-.42043Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-468",
    d: "M1253.47996,871.46517s-26.60901-14.88066-26.86109-15.76361c-.2523-.88272,34.42749-19.92514,39.09359-19.92514s24.59104,13.61983,23.58232,14.75485c-1.00902,1.1348-16.42422,7.30417-21.43853,10.46684-6.59632,4.16063-10.37613,6.93258-14.37628,10.46706Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-408",
    points: "1282.65525 882.19848 1275.593 886.23397 1273.15508 865.38403 1277.02241 862.94585 1282.65525 882.19848"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-465",
    d: "M1247.30789,903.111c.07832.19423,1.92749,4.82413,2.30583,11.76413.28224,5.17434.35474,9.1961.37294,10.88614l29.44893-16.97111c.06482-2.15031.25883-10.93363-.51991-20.49794-.8906-10.93926-4.60896-23.4792-4.64652-23.60457l.96664-.28876c.03781.12649,3.78611,12.76457,4.68526,23.81163.72206,8.86885.61241,17.06744.53975,19.98883l16.85246-9.71195c.4785-1.03802,3.43928-7.46599,6.65619-14.64547,3.39697-7.58168.61826-13.89891.58968-13.96193l.91851-.4175c.12424.27323,3.00332,6.77795-.58743,14.79154-3.4996,7.8108-6.69622,14.73279-6.72821,14.80189l-.0673.14584-49.11051,28.30198v-.87304c0-.04771-.0045-4.85767-.37741-11.70044-.36892-6.76107-2.21516-11.39412-2.23384-11.44048l.93494-.37879Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-487",
    d: "M1248.10149,902.33361s8.76441,7.12524,13.30451,4.72915c4.53987-2.39609-8.70162-7.75565-8.70162-7.75565l-4.60289,3.0265Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M1253.47729,895.53855c1.32945-.12334,7.70093.40692,8.76055,3.21038,1.0594,2.80369-14.01392,4.35801-14.50007,3.75505-.48589-.60319,2.82642-6.69558,5.73952-6.96544Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-469",
    d: "M1253.71606,896.02065c1.04387-.10128,6.03568.20841,6.83741,2.18835.80144,1.97993-11.03739,3.24189-11.41216,2.81876-.37497-.42335,2.28693-4.78474,4.57475-5.00711Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-470",
    d: "M1312.08254,862.93843c-14.69877,3.91553-29.67963,4.49643-40.62564,4.28441,5.51262-3.8174,11.70066-7.20243,16.73546-8.9537,8.88955-3.092,19.99558,2.4537,23.89018,4.66928Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 969.49573,
    cy: 222.35598,
    r: 62.05057,
    transform: "translate(387.34529 1028.87009) rotate(-67.09536)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 1225.78077,
    cy: 336.16951,
    r: 62.05061
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 1111.96737,
    cy: 616.19996,
    r: 62.05063
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 1178.29025,
    cy: 934.71407,
    r: 62.05063
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 873.69578,
    cy: 920.79445,
    r: 62.05063
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 206.8259,
    cy: 730.64442,
    r: 62.05063
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 438.91174,
    cy: 1006.76863,
    r: 62.05055,
    transform: "translate(-583.33865 605.23317) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 436.45534,
    cy: 178.95946,
    r: 62.0506
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 208.82834,
    cy: 346.81392,
    r: 62.05063
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-424",
    d: "M272.77697,277.13615h-12.75039v8.90621c0,2.05038,2.85433,3.71251,6.37531,3.71251s6.37508-1.66213,6.37508-3.71251l-.0018-.03399.0018-.01711v-8.85512Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-427",
    d: "M260.02659,277.16181c0,2.05038,2.85433,3.71251,6.37531,3.71251s6.37508-1.66213,6.37508-3.71251-2.8541-3.71251-6.37508-3.71251-6.37531,1.66213-6.37531,3.71251Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M266.40189,280.85947c-3.48271,0-6.31139-1.62657-6.37238-3.64612,0,0-.00293.04411-.00293.0664,0,2.05038,2.85433,3.71251,6.37531,3.71251s6.37508-1.66213,6.37508-3.71251c0-.02228-.00202-.04411-.00202-.04411-.0619,1.99726-2.89034,3.62384-6.37306,3.62384Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-386",
    d: "M143.37669,277.13615h12.75039v8.90621c0,2.05038-2.8541,3.71251-6.37508,3.71251s-6.37531-1.66213-6.37531-3.71251l.0018-.03399-.0018-.01711v-8.85512Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-396",
    d: "M156.12707,277.16181c0,2.05038-2.8541,3.71251-6.37508,3.71251s-6.37531-1.66213-6.37531-3.71251,2.85433-3.71251,6.37531-3.71251,6.37508,1.66213,6.37508,3.71251Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M149.75199,280.85947c3.48272,0,6.31116-1.62657,6.37238-3.64612,0,0,.00293.04411.00293.0664,0,2.05038-2.85433,3.71251-6.37531,3.71251s-6.37531-1.66213-6.37531-3.71251c0-.02228.00225-.04411.00225-.04411.06167,1.99726,2.89034,3.62384,6.37305,3.62384Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-388",
    d: "M272.77697,342.96277h-12.75039v8.90621c0,2.05038,2.85433,3.71251,6.37531,3.71251s6.37508-1.66213,6.37508-3.71251l-.0018-.03399.0018-.01711v-8.85512Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-397",
    d: "M260.02659,342.98843c0,2.05015,2.85433,3.71229,6.37531,3.71229s6.37508-1.66213,6.37508-3.71229c0-2.05038-2.8541-3.71251-6.37508-3.71251s-6.37531,1.66213-6.37531,3.71251Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M266.40189,346.68609c-3.48271,0-6.31139-1.62657-6.37238-3.64612,0,0-.00293.04411-.00293.0664,0,2.05038,2.85433,3.71251,6.37531,3.71251s6.37508-1.66213,6.37508-3.71251c0-.02228-.00202-.04434-.00202-.04434-.0619,1.99749-2.89034,3.62406-6.37306,3.62406Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-391",
    points: "231.38565 298.02931 231.38565 304.22884 223.25818 299.52017 223.25818 293.25357 231.38565 298.02931"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-392",
    points: "231.37597 298.02931 231.37597 304.22884 272.08286 278.19668 272.08286 274.34574 231.37597 298.02931"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-390",
    points: "272.08286 274.34574 231.37597 298.02931 223.25818 293.25357 263.98195 269.59364 272.08286 274.34574"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-393",
    points: "184.94783 298.02931 184.94783 304.22884 193.0753 299.52017 193.0753 293.25357 184.94783 298.02931"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-394",
    points: "184.95752 298.02931 184.95752 304.22884 144.25063 278.19668 144.25063 274.34574 184.95752 298.02931"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-395",
    points: "144.25063 274.34574 184.95752 298.02931 193.0753 293.25357 152.35154 269.59364 144.25063 274.34574"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-387",
    d: "M234.47405,314.10644h-52.9009v13.20998c0,8.50693,11.84223,15.40305,26.45034,15.40305s26.45056-6.89612,26.45056-15.40305c0-.07112-.00765-.14134-.00923-.21247h.00923v-12.99751Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-425",
    d: "M238.19579,303.63848h-60.34461v15.06905c0,9.70363,13.50864,17.57001,30.1723,17.57001s30.1723-7.86639,30.1723-17.57001c0-.08125-.00855-.16137-.01058-.2424h.01058v-14.82665Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-199",
    cx: 208.02349,
    cy: 303.75979,
    rx: 30.1723,
    ry: 17.57024
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-258",
    d: "M208.02349,321.26004c-16.4827,0-29.86959-7.69759-30.15858-17.25604-.00338.10511-.01373.20909-.01373.3142,0,9.70385,13.50887,17.57024,30.1723,17.57024s30.1723-7.86639,30.1723-17.57024c0-.10511-.01035-.20909-.01373-.3142-.28876,9.55846-13.67564,17.25604-30.15858,17.25604Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-500",
    cx: 210.31947,
    cy: 302.50751,
    rx: 15.26311,
    ry: 7.78289
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-384",
    d: "M220.09755,297.93771h-24.14811v4.78947c0,3.88312,5.40571,7.03116,12.07405,7.03116s12.07406-3.14804,12.07406-7.03116c0-.03264-.00338-.06459-.00406-.097h.00406v-4.69246Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M195.94943,297.9861c0,3.88334,5.40571,7.03116,12.07405,7.03116s12.07406-3.14782,12.07406-7.03116c0-3.88312-5.40571-7.03093-12.07406-7.03093s-12.07405,3.14782-12.07405,7.03093Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-426",
    d: "M202.66527,298.10898c0,1.72335,2.39901,3.12036,5.35822,3.12036s5.35822-1.397,5.35822-3.12036c0-1.72313-2.39901-3.12013-5.35822-3.12013s-5.35822,1.397-5.35822,3.12013Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M208.02349,304.98934c-6.59587,0-11.95297-3.08052-12.06865-6.90534-.00135.04186-.0054.0835-.0054.12559,0,3.88334,5.40571,7.03116,12.07405,7.03116s12.07406-3.14782,12.07406-7.03116c0-.04209-.00406-.08373-.00541-.12559-.11569,3.82482-5.47255,6.90534-12.06865,6.90534Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-200",
    points: "266.06744 344.68635 266.06744 348.46998 274.19468 343.76131 274.19468 339.91038 266.06744 344.68635"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-197",
    points: "266.07712 344.68635 266.07712 348.46998 223.91426 328.60044 223.91426 319.91817 266.07712 344.68635"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-201",
    points: "223.91426 319.91817 266.07712 344.68635 274.19468 339.91038 232.01517 315.16607 223.91426 319.91817"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-385",
    d: "M272.14746,330.31906h-11.49112v8.02664c0,1.84782,2.57231,3.34588,5.74556,3.34588s5.74556-1.49806,5.74556-3.34588l-.00158-.03083.00158-.0153v-7.9805Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-202",
    cx: 266.40189,
    cy: 330.34202,
    rx: 5.74556,
    ry: 3.34588
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M266.40189,333.67462c-3.13881,0-5.68794-1.46587-5.74309-3.28601-.00068.02003-.00248.03984-.00248.03984,0,1.86785,2.57231,3.36591,5.74556,3.36591s5.74556-1.49806,5.74556-3.34588c0,0-.00203-.03984-.00269-.05987-.05492,1.82013-2.60405,3.28601-5.74287,3.28601Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-383",
    d: "M269.47138,325.55053h-6.13921v4.28824c0,.98715,1.3745,1.7875,3.06972,1.7875s3.06949-.80035,3.06949-1.7875l-.0009-.01643.0009-.00833v-4.26348Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M263.33218,325.56291c0,.98715,1.3745,1.7875,3.06972,1.7875s3.06949-.80035,3.06949-1.7875-1.37427-1.7875-3.06949-1.7875-3.06972.80035-3.06972,1.7875Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M266.40189,327.3432c-1.67699,0-3.03888-.78302-3.06814-1.75554l-.00158.03196c0,.98738,1.3745,1.7875,3.06972,1.7875s3.06949-.80012,3.06949-1.7875l-.00135-.03196c-.02948.97252-1.39138,1.75554-3.06814,1.75554Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-544"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-444",
    d: "M230.44981,329.81446c0-11.5627,16.09559-20.93525,35.95163-20.93525,10.09547,0,19.20492,2.43097,25.73484,6.33277l-51.12151,29.4244c-6.52632-3.78971-10.56497-9.03045-10.56497-14.82192Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-534",
    d: "M302.3533,329.81446c0,11.56292-16.09694,20.93525-35.95185,20.93525-9.91137,0-18.88397-2.33532-25.38666-6.11333l51.12151-29.4244c6.31386,3.77216,10.21701,8.91971,10.21701,14.60248Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-544"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-444",
    d: "M302.3533,329.81446c0-11.5627-16.09581-20.93525-35.95185-20.93525-10.09547,0-19.20492,2.43097-25.73462,6.33277l51.12151,29.4244c6.5261-3.78971,10.56497-9.03045,10.56497-14.82192Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-534",
    d: "M230.44981,329.81446c0,11.56292,16.09671,20.93525,35.95163,20.93525,9.9116,0,18.88419-2.33532,25.38689-6.11333l-51.12151-29.4244c-6.31409,3.77216-10.21701,8.91971-10.21701,14.60248Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-389",
    d: "M143.37669,342.96277h12.75039v8.90621c0,2.05038-2.8541,3.71251-6.37508,3.71251s-6.37531-1.66213-6.37531-3.71251l.0018-.03399-.0018-.01711v-8.85512Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M156.12707,342.98843c0,2.05015-2.8541,3.71229-6.37508,3.71229s-6.37531-1.66213-6.37531-3.71229c0-2.05038,2.85433-3.71251,6.37531-3.71251s6.37508,1.66213,6.37508,3.71251Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M149.75199,346.68609c3.48272,0,6.31116-1.62657,6.37238-3.64612,0,0,.00293.04411.00293.0664,0,2.05038-2.85433,3.71251-6.37531,3.71251s-6.37531-1.66213-6.37531-3.71251c0-.02228.00225-.04434.00225-.04434.06167,1.99749,2.89034,3.62406,6.37305,3.62406Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "150.08644 344.68635 150.08644 348.46998 141.95898 343.76131 141.95898 339.91038 150.08644 344.68635"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-196",
    points: "150.07677 344.68635 150.07677 348.46998 192.23962 328.60044 192.23962 319.91817 150.07677 344.68635"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-204",
    points: "192.23962 319.91817 150.07677 344.68635 141.95898 339.91038 184.13871 315.16607 192.23962 319.91817"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-382",
    d: "M144.00643,330.31906h11.49113v8.02664c0,1.84782-2.57231,3.34588-5.74556,3.34588s-5.74556-1.49806-5.74556-3.34588l.00158-.03083-.00158-.0153v-7.9805Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-210",
    cx: 149.75199,
    cy: 330.34202,
    rx: 5.74556,
    ry: 3.34588
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M149.75199,333.67462c3.13859,0,5.68794-1.46587,5.74286-3.28601.00068.02003.0027.03984.0027.03984,0,1.86785-2.57254,3.36591-5.74556,3.36591-3.17325,0-5.74556-1.49806-5.74556-3.34588,0,0,.00203-.03984.00248-.05987.05514,1.82013,2.60427,3.28601,5.74309,3.28601Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-381",
    d: "M146.68228,325.55053h6.13921v4.28824c0,.98715-1.37427,1.7875-3.06949,1.7875s-3.06972-.80035-3.06972-1.7875l.0009-.01643-.0009-.00833v-4.26348Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M152.82148,325.56291c0,.98715-1.37427,1.7875-3.06949,1.7875s-3.06972-.80035-3.06972-1.7875,1.3745-1.7875,3.06972-1.7875,3.06949.80035,3.06949,1.7875Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M149.75199,327.3432c1.67676,0,3.03866-.78302,3.06814-1.75554l.00135.03196c0,.98738-1.37427,1.7875-3.06949,1.7875s-3.06949-.80012-3.06949-1.7875l.00135-.03196c.02926.97252,1.39115,1.75554,3.06814,1.75554Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-544"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-444",
    d: "M185.70406,329.81446c0-11.5627-16.09581-20.93525-35.95185-20.93525-10.09547,0-19.20492,2.43097-25.73462,6.33277l51.12151,29.4244c6.52632-3.78971,10.56496-9.03045,10.56496-14.82192Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-534",
    d: "M113.80059,329.81446c0,11.56292,16.09694,20.93525,35.95163,20.93525,9.91159,0,18.88419-2.33532,25.38689-6.11333l-51.12151-29.4244c-6.31409,3.77216-10.21701,8.91971-10.21701,14.60248Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-544"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-444",
    d: "M113.80059,329.81446c0-11.5627,16.09559-20.93525,35.95163-20.93525,10.0957,0,19.20492,2.43097,25.73484,6.33277l-51.12151,29.4244c-6.52633-3.78971-10.56497-9.03045-10.56497-14.82192Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-534",
    d: "M185.70406,329.81446c0,11.56292-16.09693,20.93525-35.95185,20.93525-9.91137,0-18.88397-2.33532-25.38666-6.11333l51.12151-29.4244c6.31386,3.77216,10.217,8.91971,10.217,14.60248Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-378",
    d: "M272.14746,264.49245h-11.49112v8.02664c0,1.84782,2.57231,3.34588,5.74556,3.34588s5.74556-1.49806,5.74556-3.34588l-.00158-.03083.00158-.0153v-7.9805Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M260.65633,264.5154c0,1.84782,2.57231,3.34588,5.74556,3.34588s5.74556-1.49806,5.74556-3.34588-2.57231-3.34565-5.74556-3.34565-5.74556,1.49783-5.74556,3.34565Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M266.40189,267.848c-3.13881,0-5.68794-1.46587-5.74309-3.28601-.00068.02003-.00248.03984-.00248.03984,0,1.86785,2.57231,3.36591,5.74556,3.36591s5.74556-1.49806,5.74556-3.34588c0,0-.00203-.03984-.00269-.05987-.05492,1.82013-2.60405,3.28601-5.74287,3.28601Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-379",
    d: "M269.47138,259.72391h-6.13921v4.28824c0,.98715,1.3745,1.7875,3.06972,1.7875s3.06949-.80035,3.06949-1.7875l-.0009-.01643.0009-.0081v-4.26371Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M263.33218,259.73629c0,.98715,1.3745,1.7875,3.06972,1.7875s3.06949-.80035,3.06949-1.7875-1.37427-1.7875-3.06949-1.7875-3.06972.80035-3.06972,1.7875Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M266.40189,261.51658c-1.67699,0-3.03888-.78302-3.06814-1.75554l-.00158.03196c0,.98738,1.3745,1.7875,3.06972,1.7875s3.06949-.80012,3.06949-1.7875l-.00135-.03196c-.02948.97252-1.39138,1.75554-3.06814,1.75554Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-544"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-444",
    d: "M230.44981,263.98784c0-11.5627,16.09559-20.93525,35.95163-20.93525,10.09547,0,19.20492,2.43097,25.73484,6.33277l-51.12151,29.4244c-6.52632-3.78971-10.56497-9.03045-10.56497-14.82192Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-534",
    d: "M302.3533,263.98784c0,11.56292-16.09694,20.93547-35.95185,20.93547-9.91137,0-18.88397-2.33554-25.38666-6.11355l51.12151-29.4244c6.31386,3.77216,10.21701,8.91971,10.21701,14.60248Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-544"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-444",
    d: "M302.3533,263.98784c0-11.5627-16.09581-20.93525-35.95185-20.93525-10.09547,0-19.20492,2.43097-25.73462,6.33277l51.12151,29.4244c6.5261-3.78971,10.56497-9.03045,10.56497-14.82192Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-534",
    d: "M230.44981,263.98784c0,11.56292,16.09671,20.93547,35.95163,20.93547,9.9116,0,18.88419-2.33554,25.38689-6.11355l-51.12151-29.4244c-6.31409,3.77216-10.21701,8.91971-10.21701,14.60248Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-380",
    d: "M144.00643,264.49245h11.49113v8.02664c0,1.84782-2.57231,3.34588-5.74556,3.34588s-5.74556-1.49806-5.74556-3.34588l.00158-.03083-.00158-.0153v-7.9805Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M155.49755,264.5154c0,1.84782-2.57231,3.34588-5.74556,3.34588s-5.74556-1.49806-5.74556-3.34588,2.57231-3.34565,5.74556-3.34565,5.74556,1.49783,5.74556,3.34565Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M149.75199,267.848c3.13859,0,5.68794-1.46587,5.74286-3.28601.00068.02003.0027.03984.0027.03984,0,1.86785-2.57254,3.36591-5.74556,3.36591-3.17325,0-5.74556-1.49806-5.74556-3.34588,0,0,.00203-.03984.00248-.05987.05514,1.82013,2.60427,3.28601,5.74309,3.28601Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M146.68228,259.72391h6.13921v4.28824c0,.98715-1.37427,1.7875-3.06949,1.7875s-3.06972-.80035-3.06972-1.7875l.0009-.01643-.0009-.0081v-4.26371Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M152.82148,259.73629c0,.98715-1.37427,1.7875-3.06949,1.7875s-3.06972-.80035-3.06972-1.7875,1.3745-1.7875,3.06972-1.7875,3.06949.80035,3.06949,1.7875Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M149.75199,261.51658c1.67676,0,3.03866-.78302,3.06814-1.75554l.00135.03196c0,.98738-1.37427,1.7875-3.06949,1.7875s-3.06949-.80012-3.06949-1.7875l.00135-.03196c.02926.97252,1.39115,1.75554,3.06814,1.75554Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-544"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-444",
    d: "M185.70406,263.98784c0-11.5627-16.09581-20.93525-35.95185-20.93525-10.09547,0-19.20492,2.43097-25.73462,6.33277l51.12151,29.4244c6.52632-3.78971,10.56496-9.03045,10.56496-14.82192Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-534",
    d: "M113.80059,263.98784c0,11.56292,16.09694,20.93547,35.95163,20.93547,9.91159,0,18.88419-2.33554,25.38689-6.11355l-51.12151-29.4244c-6.31409,3.77216-10.21701,8.91971-10.21701,14.60248Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-544"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-444",
    d: "M113.80059,263.98784c0-11.5627,16.09559-20.93525,35.95163-20.93525,10.0957,0,19.20492,2.43097,25.73484,6.33277l-51.12151,29.4244c-6.52633-3.78971-10.56497-9.03045-10.56497-14.82192Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-534",
    d: "M185.70406,263.98784c0,11.56292-16.09693,20.93547-35.95185,20.93547-9.91137,0-18.88397-2.33554-25.38666-6.11355l51.12151-29.4244c6.31386,3.77216,10.217,8.91971,10.217,14.60248Z"
  })))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-28",
    cx: 623.8512,
    cy: 795.46335,
    r: 21.49458,
    transform: "translate(-385.79696 744.83882) rotate(-49.02383)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 766.32282,
    cy: 950.21699,
    r: 21.49457,
    transform: "translate(-447.45412 820.18417) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-25",
    cx: 920.25766,
    cy: 729.54968,
    r: 21.49457
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 1063.38435,
    cy: 657.49512,
    r: 21.49459,
    transform: "translate(178.30543 1540.51348) rotate(-76.66191)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 337.10666,
    cy: 804.06076,
    r: 21.49453,
    transform: "translate(-280.56478 188.72622) rotate(-22.36247)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-27",
    cx: 400.97331,
    cy: 659.13273,
    r: 21.49459,
    transform: "translate(-332.88299 897.23033) rotate(-76.66191)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 324.82464,
    cy: 536.31238,
    r: 21.49454
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 1047.8272,
    cy: 449.51929,
    r: 21.49472,
    transform: "translate(424.07009 1403.94922) rotate(-80.05322)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 404.24852,
    cy: 338.98102,
    r: 21.49459,
    transform: "translate(-17.18493 656.34333) rotate(-76.96312)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 1100.63986,
    cy: 890.44434,
    r: 21.49454
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAisvg);
export default __webpack_public_path__ + "static/media/aisvg.f66c377a9cc9ad0bdc330e846c87403c.svg";
export { ForwardRef as ReactComponent };